import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A valid URL, transported as a string */
  File: any;
  /** An ISO 8601-encoded date */
  ISO8601Date: any;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: any;
  /** Represents untyped JSON */
  JSON: any;
};

export type AbilityRule = {
  __typename?: 'AbilityRule';
  action: Array<Scalars['String']>;
  conditions?: Maybe<Scalars['JSON']>;
  fields?: Maybe<Array<Scalars['String']>>;
  inverted: Scalars['Boolean'];
  subject: Array<Scalars['String']>;
};

export type Account = {
  __typename?: 'Account';
  allowedTcCreationTime?: Maybe<Scalars['Int']>;
  amlRecurrency?: Maybe<Scalars['Int']>;
  autoSyncContactsWithMailchimp?: Maybe<Scalars['Boolean']>;
  availableDateFormats: Array<Scalars['String']>;
  badDebtStatusAfter?: Maybe<Scalars['Int']>;
  caseNumberingByClient?: Maybe<Scalars['Boolean']>;
  caseNumberingShown?: Maybe<Scalars['Boolean']>;
  clientInactiveAfter?: Maybe<Scalars['Int']>;
  creditNoteMark?: Maybe<Scalars['String']>;
  creditNoteMarkPosition?: Maybe<Scalars['Boolean']>;
  currency?: Maybe<Currency>;
  dateFormat: Scalars['String'];
  dbResetAllowed: Scalars['Boolean'];
  defaultCaseDescriptions: Scalars['JSON'];
  familyNameFirst: Scalars['Boolean'];
  featureFlags?: Maybe<Scalars['String']>;
  firstApprover?: Maybe<Scalars['String']>;
  footnotes: Scalars['JSON'];
  id: Scalars['ID'];
  invoiceApprovers: Array<Maybe<InvoiceApprover>>;
  invoiceNumberLength?: Maybe<Scalars['Int']>;
  invoiceNumberMask?: Maybe<Scalars['String']>;
  invoiceNumberResetFrequency?: Maybe<InvoiceNumberResetFrequency>;
  legalCaseNumberLength?: Maybe<Scalars['Int']>;
  locale?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  mailchimpApiKeyPresent: Scalars['Boolean'];
  mailchimpApiListId?: Maybe<Scalars['String']>;
  mailchimpServerId?: Maybe<Scalars['String']>;
  monthlyUserCountEstimate?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  notificationEmailFromAddressExternal?: Maybe<Scalars['String']>;
  notificationEmailFromAddressInternal?: Maybe<Scalars['String']>;
  otherLocales: Array<Scalars['String']>;
  paymentTerm?: Maybe<PaymentTerm>;
  reportSchedules: Array<ReportSchedule>;
  showFinishSetupFrom: Scalars['ISO8601Date'];
  smtpHost?: Maybe<Scalars['String']>;
  smtpPasswordPresent: Scalars['Boolean'];
  smtpPort?: Maybe<Scalars['String']>;
  smtpUser?: Maybe<Scalars['String']>;
  subdomain?: Maybe<Scalars['String']>;
  subscriptionDefaultPlan?: Maybe<SubscriptionPlan>;
  timeFormat: TimeFormat;
  timeZoneName: Scalars['String'];
  unpaidInvoiceNotificationIntervalDays?: Maybe<Scalars['Int']>;
};

/** The connection type for Account. */
export type AccountConnection = {
  __typename?: 'AccountConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AccountEdge>>>;
  /** A list of nodes. */
  nodes: Array<Account>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type AccountEdge = {
  __typename?: 'AccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Account;
};

export type AccountInput = {
  locale: Locale;
  name: Scalars['String'];
  userAttributes?: InputMaybe<UserInput>;
};

export type AccountSettingsInput = {
  allowedTcCreationTime?: InputMaybe<Scalars['Int']>;
  amlRecurrency?: InputMaybe<Scalars['Int']>;
  autoSyncContactsWithMailchimp?: InputMaybe<Scalars['Boolean']>;
  badDebtStatusAfter?: InputMaybe<Scalars['Int']>;
  caseNumberingByClient?: InputMaybe<Scalars['Boolean']>;
  caseNumberingShown?: InputMaybe<Scalars['Boolean']>;
  clientInactiveAfter?: InputMaybe<Scalars['Int']>;
  creditNoteMark?: InputMaybe<Scalars['String']>;
  creditNoteMarkPosition?: InputMaybe<Scalars['Boolean']>;
  currencyId?: InputMaybe<Scalars['ID']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  defaultCaseDescriptions?: InputMaybe<Scalars['JSON']>;
  familyNameFirst?: InputMaybe<Scalars['Boolean']>;
  featureFlags?: InputMaybe<Scalars['String']>;
  firstApprover?: InputMaybe<Scalars['String']>;
  footnotes?: InputMaybe<Scalars['JSON']>;
  fourthApprover?: InputMaybe<Scalars['String']>;
  invoiceNumberLength?: InputMaybe<Scalars['Int']>;
  invoiceNumberMask?: InputMaybe<Scalars['String']>;
  invoiceNumberResetFrequency?: InputMaybe<InvoiceNumberResetFrequency>;
  legalCaseNumberLength?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['File']>;
  mailchimpApiKey?: InputMaybe<Scalars['String']>;
  mailchimpApiListId?: InputMaybe<Scalars['String']>;
  mailchimpServerId?: InputMaybe<Scalars['String']>;
  monthlyUserCountEstimate?: InputMaybe<Scalars['Int']>;
  notificationEmailFromAddressExternal?: InputMaybe<Scalars['String']>;
  notificationEmailFromAddressInternal?: InputMaybe<Scalars['String']>;
  otherLocales?: InputMaybe<Array<Scalars['String']>>;
  paymentTermId?: InputMaybe<Scalars['ID']>;
  reportSchedules?: InputMaybe<Array<ReportScheduleInput>>;
  secondApprover?: InputMaybe<Scalars['String']>;
  smtpHost?: InputMaybe<Scalars['String']>;
  smtpPassword?: InputMaybe<Scalars['String']>;
  smtpPort?: InputMaybe<Scalars['String']>;
  smtpUser?: InputMaybe<Scalars['String']>;
  thirdApprover?: InputMaybe<Scalars['String']>;
  timeFormat?: InputMaybe<TimeFormat>;
  timeZoneName?: InputMaybe<Scalars['String']>;
  unpaidInvoiceNotificationIntervalDays?: InputMaybe<Scalars['Int']>;
};

export type AccountSubscriptionSettings = {
  __typename?: 'AccountSubscriptionSettings';
  id: Scalars['ID'];
  subscriptionDefaultPlan?: Maybe<SubscriptionPlan>;
  subscriptionInvoiceEmail?: Maybe<Scalars['String']>;
  subscriptionLawFirmAddress?: Maybe<Scalars['String']>;
  subscriptionLawFirmCountry?: Maybe<Scalars['String']>;
  subscriptionLawFirmName?: Maybe<Scalars['String']>;
  subscriptionLawFirmPostalCode?: Maybe<Scalars['String']>;
  subscriptionLawFirmRegistrationNumber?: Maybe<Scalars['String']>;
  subscriptionLawFirmVatRegistrationNumber?: Maybe<Scalars['String']>;
  subscriptionRequestedLongTermCommitments?: Maybe<Scalars['Int']>;
};

export type AccountSubscriptionSettingsInput = {
  subscriptionDefaultPlan?: InputMaybe<Scalars['String']>;
  subscriptionInvoiceEmail?: InputMaybe<Scalars['String']>;
  subscriptionLawFirmAddress?: InputMaybe<Scalars['String']>;
  subscriptionLawFirmCountry?: InputMaybe<Scalars['String']>;
  subscriptionLawFirmName?: InputMaybe<Scalars['String']>;
  subscriptionLawFirmPostalCode?: InputMaybe<Scalars['String']>;
  subscriptionLawFirmRegistrationNumber?: InputMaybe<Scalars['String']>;
  subscriptionLawFirmVatRegistrationNumber?: InputMaybe<Scalars['String']>;
  subscriptionRequestedLongTermCommitments?: InputMaybe<Scalars['Int']>;
};

/** Answer from the Ask AI assistant: Markdown text plus any charts it rendered. */
export type AiAnswer = {
  __typename?: 'AiAnswer';
  /** Chart specs to render (may be empty). */
  charts: Array<Scalars['JSON']>;
  /** Error message when the assistant could not answer. */
  error?: Maybe<Scalars['String']>;
  /** Markdown answer. Null when the request errored. */
  text?: Maybe<Scalars['String']>;
};

export type AuditEvent = {
  __typename?: 'AuditEvent';
  action: AuditEventAction;
  auditableType: Scalars['String'];
  changes?: Maybe<Scalars['JSON']>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  user?: Maybe<User>;
};

export enum AuditEventAction {
  Create = 'create',
  Destroy = 'destroy',
  Update = 'update'
}

/** The connection type for AuditEvent. */
export type AuditEventConnection = {
  __typename?: 'AuditEventConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AuditEventEdge>>>;
  /** A list of nodes. */
  nodes: Array<AuditEvent>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type AuditEventEdge = {
  __typename?: 'AuditEventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AuditEvent;
};

export type AuditEventFilterInput = {
  createdAtFrom?: InputMaybe<Scalars['ISO8601Date']>;
  createdAtTo?: InputMaybe<Scalars['ISO8601Date']>;
  userId?: InputMaybe<Array<Scalars['ID']>>;
};

export enum AuditableType {
  Client = 'Client',
  Invoice = 'Invoice',
  LegalCase = 'LegalCase',
  TimeCard = 'TimeCard'
}

/** Client Billing Address Type Types */
export enum BillingAddressType {
  /** Different address */
  DifferentAddress = 'different_address',
  /** Other Invoice receiver */
  OtherInvoiceReceiver = 'other_invoice_receiver',
  /** Same as client address */
  SameAsClientAddress = 'same_as_client_address'
}

export type Calendar = {
  __typename?: 'Calendar';
  id: Scalars['ID'];
  name: Scalars['String'];
  primary: Scalars['Boolean'];
  provider: CalendarProvider;
  synchronize: Scalars['Boolean'];
};

export type CalendarEvent = {
  __typename?: 'CalendarEvent';
  endTime: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  startTime: Scalars['ISO8601DateTime'];
  status?: Maybe<Scalars['String']>;
};

export type CalendarInput = {
  synchronize: Scalars['Boolean'];
};

/** Calendar Providers */
export enum CalendarProvider {
  Google = 'Google',
  Outlook = 'Outlook'
}

/** Case Outcome Types */
export enum CaseOutcome {
  /** Lost */
  Lost = 'lost',
  /** Negative */
  Negative = 'negative',
  /** Neutral */
  Neutral = 'neutral',
  /** Positive */
  Positive = 'positive',
  /** Settled */
  Settled = 'settled',
  /** Won */
  Won = 'won'
}

export type Client = {
  __typename?: 'Client';
  address?: Maybe<Scalars['String']>;
  amlExpectedDate?: Maybe<Scalars['ISO8601Date']>;
  amlStatus: ClientAmlStatus;
  antiMoneyLaundering: ClientAml;
  antiMoneyLaunderingDate?: Maybe<Scalars['ISO8601Date']>;
  billingAddress?: Maybe<Scalars['String']>;
  billingAddressType: BillingAddressType;
  billingContact?: Maybe<Contact>;
  billingCountry?: Maybe<Scalars['String']>;
  billingEmails: Array<Scalars['String']>;
  billingPhone?: Maybe<Scalars['String']>;
  billingPostalCode?: Maybe<Scalars['String']>;
  billingToName?: Maybe<Scalars['String']>;
  billingToRegistrationNumber?: Maybe<Scalars['String']>;
  billingToVatRegistrationNumber?: Maybe<Scalars['String']>;
  clientManagers: Array<Maybe<ClientManager>>;
  clientOwners: Array<Maybe<ClientOwner>>;
  clientOwnershipPeriods: Array<Maybe<ClientOwnershipPeriod>>;
  clientStatus: ClientStatus;
  country?: Maybe<Scalars['String']>;
  creditRating?: Maybe<CreditRating>;
  currency?: Maybe<Currency>;
  customizedPriceList?: Maybe<PriceList>;
  discountPercentage?: Maybe<Scalars['Float']>;
  engagementLetterDate?: Maybe<Scalars['ISO8601Date']>;
  engagementLetterExecuted: Scalars['Boolean'];
  entityType: EntityType;
  flatRate?: Maybe<Scalars['Float']>;
  formattedInvoicedMinutes: Scalars['String'];
  formattedNonBillableMinutes: Scalars['String'];
  formattedTotalMinutes?: Maybe<Scalars['String']>;
  formattedUninvoicedMinutes: Scalars['String'];
  fullName?: Maybe<Scalars['String']>;
  hasInvoicing: Scalars['Boolean'];
  hourlyFeeType?: Maybe<HourlyFeeType>;
  id: Scalars['ID'];
  identificationNumber?: Maybe<Scalars['String']>;
  inactivatedAt?: Maybe<Scalars['ISO8601Date']>;
  industry?: Maybe<Industry>;
  invoiceByPost: Scalars['Boolean'];
  invoiceIssuer?: Maybe<Entity>;
  invoicingCurrency?: Maybe<Currency>;
  language?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  lastTcDate?: Maybe<Scalars['ISO8601Date']>;
  lastYearSales?: Maybe<Scalars['Float']>;
  latePaymentReminder: Scalars['Boolean'];
  lawyerRate?: Maybe<Scalars['Float']>;
  legalCases: Array<Maybe<LegalCase>>;
  legalCasesCount?: Maybe<Scalars['Int']>;
  linkedinProfileUrl?: Maybe<Scalars['String']>;
  manager?: Maybe<User>;
  marketingEffortTypes: Array<Maybe<MarketingEffortType>>;
  marketingEfforts: Array<Maybe<MarketingEffort>>;
  matterStatusReports: Scalars['Boolean'];
  name: Scalars['String'];
  nonLawyerRate?: Maybe<Scalars['Float']>;
  number?: Maybe<Scalars['Int']>;
  openedOn?: Maybe<Scalars['ISO8601Date']>;
  ownershipStory?: Maybe<Scalars['String']>;
  paymentTerm?: Maybe<PaymentTerm>;
  paymentType?: Maybe<PaymentType>;
  postalCode?: Maybe<Scalars['String']>;
  serviceLevel?: Maybe<ClientServiceLevel>;
  shareholders?: Maybe<Array<Maybe<Contact>>>;
  standardPriceList?: Maybe<PriceList>;
  supplierIdentifier?: Maybe<Scalars['String']>;
  syncContact?: Maybe<Contact>;
  userNotes: Array<Maybe<UserNote>>;
  vatPercentage?: Maybe<VatPercentage>;
  vatRegistrationNumber?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
};

/** Client AML Types */
export enum ClientAml {
  /** Completed - AML check is current */
  Completed = 'completed',
  /** No (legacy) */
  No = 'no',
  /** Not applicable - AML not required */
  NotApplicable = 'not_applicable',
  /** Outdated - AML check has expired */
  Outdated = 'outdated',
  /** Pending - AML check required but no date set */
  Pending = 'pending',
  /** Yes (legacy) */
  Yes = 'yes'
}

/** Client AML Status Types */
export enum ClientAmlStatus {
  /** Completed - AML check is current */
  Completed = 'completed',
  /** Not applicable - AML not required */
  NotApplicable = 'not_applicable',
  /** Outdated - AML check has expired */
  Outdated = 'outdated',
  /** Pending - AML check required but no date set */
  Pending = 'pending'
}

export type ClientBaseInput = {
  entityType: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
};

/** The connection type for Client. */
export type ClientConnection = {
  __typename?: 'ClientConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ClientEdge>>>;
  /** A list of nodes. */
  nodes: Array<Client>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
  xlsxExport: XlsxExport;
};

/** An edge in a connection. */
export type ClientEdge = {
  __typename?: 'ClientEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Client;
};

export type ClientFilterInput = {
  country?: InputMaybe<Scalars['String']>;
  creditRatingId?: InputMaybe<Array<Scalars['ID']>>;
  entityType?: InputMaybe<Array<EntityType>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  industryId?: InputMaybe<Array<Scalars['ID']>>;
  invoiceIssuerId?: InputMaybe<Array<Scalars['ID']>>;
  lastName?: InputMaybe<Scalars['String']>;
  lastTcDateFrom?: InputMaybe<Scalars['ISO8601Date']>;
  lastTcDateTo?: InputMaybe<Scalars['ISO8601Date']>;
  name?: InputMaybe<Scalars['String']>;
  openedOnFrom?: InputMaybe<Scalars['ISO8601Date']>;
  openedOnTo?: InputMaybe<Scalars['ISO8601Date']>;
  owners?: InputMaybe<UserFilterInput>;
  serviceLevel?: InputMaybe<Array<ClientServiceLevel>>;
  totalMinutesFrom?: InputMaybe<Scalars['Int']>;
  totalMinutesTo?: InputMaybe<Scalars['Int']>;
};

export type ClientInput = {
  address?: InputMaybe<Scalars['String']>;
  antiMoneyLaundering: Scalars['String'];
  antiMoneyLaunderingDate?: InputMaybe<Scalars['ISO8601Date']>;
  billingAddress?: InputMaybe<Scalars['String']>;
  billingAddressType: Scalars['String'];
  billingContactId?: InputMaybe<Scalars['ID']>;
  billingCountry?: InputMaybe<Scalars['String']>;
  billingEmails: Array<Scalars['String']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  billingPostalCode?: InputMaybe<Scalars['String']>;
  billingToName?: InputMaybe<Scalars['String']>;
  billingToRegistrationNumber?: InputMaybe<Scalars['String']>;
  billingToVatRegistrationNumber?: InputMaybe<Scalars['String']>;
  clientManagersAttributes?: InputMaybe<Array<ClientManagerInput>>;
  clientOwnersAttributes?: InputMaybe<Array<OwnerInput>>;
  clientOwnershipPeriodsAttributes?: InputMaybe<Array<ClientOwnershipPeriodInput>>;
  country: Scalars['String'];
  creditRatingId?: InputMaybe<Scalars['ID']>;
  currencyId?: InputMaybe<Scalars['ID']>;
  customizedPriceListId?: InputMaybe<Scalars['ID']>;
  discountPercentage?: InputMaybe<Scalars['Float']>;
  engagementLetterDate?: InputMaybe<Scalars['ISO8601Date']>;
  engagementLetterExecuted: Scalars['Boolean'];
  entityType: Scalars['String'];
  flatRate?: InputMaybe<Scalars['Float']>;
  fullName?: InputMaybe<Scalars['String']>;
  hasInvoicing: Scalars['Boolean'];
  hourlyFeeType?: InputMaybe<HourlyFeeType>;
  id?: InputMaybe<Scalars['ID']>;
  identificationNumber?: InputMaybe<Scalars['String']>;
  industryId?: InputMaybe<Scalars['ID']>;
  invoiceByPost: Scalars['Boolean'];
  invoiceIssuerId?: InputMaybe<Scalars['ID']>;
  invoicingCurrencyId?: InputMaybe<Scalars['ID']>;
  language: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  lastYearSales?: InputMaybe<Scalars['Float']>;
  latePaymentReminder: Scalars['Boolean'];
  lawyerRate?: InputMaybe<Scalars['Float']>;
  linkedinProfileUrl?: InputMaybe<Scalars['String']>;
  managerId?: InputMaybe<Scalars['ID']>;
  marketingEffortTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  matterStatusReports: Scalars['Boolean'];
  name: Scalars['String'];
  newBillingContact?: InputMaybe<ContactBaseInput>;
  newShareholders?: InputMaybe<Array<ContactInput>>;
  nonLawyerRate?: InputMaybe<Scalars['Float']>;
  number?: InputMaybe<Scalars['Int']>;
  openedOn?: InputMaybe<Scalars['ISO8601Date']>;
  ownershipStory?: InputMaybe<Scalars['String']>;
  paymentTermId?: InputMaybe<Scalars['ID']>;
  postalCode?: InputMaybe<Scalars['String']>;
  priceListRates?: InputMaybe<Array<PriceListRateInput>>;
  serviceLevel: Scalars['String'];
  shareholderIds?: InputMaybe<Array<Scalars['ID']>>;
  standardPriceListId?: InputMaybe<Scalars['ID']>;
  supplierIdentifier?: InputMaybe<Scalars['String']>;
  vatPercentageId?: InputMaybe<Scalars['ID']>;
  vatRegistrationNumber?: InputMaybe<Scalars['String']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
};

export type ClientManager = {
  __typename?: 'ClientManager';
  client?: Maybe<Client>;
  createdAt: Scalars['ISO8601DateTime'];
  createdBy?: Maybe<User>;
  fromDate: Scalars['ISO8601Date'];
  id?: Maybe<Scalars['ID']>;
  manager?: Maybe<User>;
  toDate?: Maybe<Scalars['ISO8601Date']>;
};

export type ClientManagerInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  fromDate: Scalars['ISO8601Date'];
  id?: InputMaybe<Scalars['ID']>;
  managerId: Scalars['ID'];
  toDate?: InputMaybe<Scalars['ISO8601Date']>;
};

export type ClientOwner = {
  __typename?: 'ClientOwner';
  client?: Maybe<Client>;
  id?: Maybe<Scalars['ID']>;
  ownershipPercentage: Scalars['Int'];
  user?: Maybe<User>;
};

/** The connection type for ClientOwner. */
export type ClientOwnerConnection = {
  __typename?: 'ClientOwnerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ClientOwnerEdge>>>;
  /** A list of nodes. */
  nodes: Array<ClientOwner>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ClientOwnerEdge = {
  __typename?: 'ClientOwnerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ClientOwner;
};

export type ClientOwnershipPeriod = {
  __typename?: 'ClientOwnershipPeriod';
  createdAt: Scalars['ISO8601DateTime'];
  createdBy?: Maybe<User>;
  fromDate: Scalars['ISO8601Date'];
  id: Scalars['ID'];
  owners: Array<ClientOwnershipPeriodOwner>;
  toDate?: Maybe<Scalars['ISO8601Date']>;
};

export type ClientOwnershipPeriodInput = {
  fromDate?: InputMaybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  toDate?: InputMaybe<Scalars['ISO8601Date']>;
};

export type ClientOwnershipPeriodOwner = {
  __typename?: 'ClientOwnershipPeriodOwner';
  ownershipPercentage: Scalars['Int'];
  user?: Maybe<User>;
};

/** Service Level Type */
export enum ClientServiceLevel {
  /** Economy */
  Economy = 'economy',
  /** Premium */
  Premium = 'premium',
  /** Standard */
  Standard = 'standard'
}

/** Client Status Types */
export enum ClientStatus {
  /** Active - Client has cases and is not deactivated */
  Active = 'active',
  /** Inactive - Client has been deactivated */
  Inactive = 'inactive',
  /** New - Client has no cases */
  New = 'new'
}

export type Contact = {
  __typename?: 'Contact';
  address?: Maybe<Scalars['String']>;
  birthdayDate?: Maybe<Scalars['ISO8601Date']>;
  company?: Maybe<Contact>;
  contactCategories?: Maybe<Array<Maybe<ContactCategory>>>;
  country?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  employees?: Maybe<Array<Maybe<Contact>>>;
  entityType: EntityType;
  fullName: Scalars['String'];
  id: Scalars['ID'];
  identificationNumber?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  linkedinProfileUrl?: Maybe<Scalars['String']>;
  mailchimpSync: Scalars['Boolean'];
  marketingEffortTypes?: Maybe<Array<Maybe<MarketingEffortType>>>;
  middleName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  opponent: Scalars['Boolean'];
  owner?: Maybe<User>;
  owners?: Maybe<Array<Maybe<Contact>>>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  registrationNumber?: Maybe<Scalars['String']>;
  relatedLegalCases: Array<ContactRelatedLegalCase>;
  shareholders?: Maybe<Array<Maybe<Contact>>>;
  syncSourceId?: Maybe<Scalars['ID']>;
  syncSourceType?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  vatRegistrationNumber?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
};

export type ContactBaseInput = {
  entityType: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
};

export type ContactCategory = {
  __typename?: 'ContactCategory';
  altNameTranslations: Scalars['JSON'];
  createdAt: Scalars['ISO8601Date'];
  discardedAt?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  nameWithoutFallback: Scalars['String'];
  updatedAt: Scalars['ISO8601Date'];
};

/** The connection type for ContactCategory. */
export type ContactCategoryConnection = {
  __typename?: 'ContactCategoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ContactCategoryEdge>>>;
  /** A list of nodes. */
  nodes: Array<ContactCategory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ContactCategoryEdge = {
  __typename?: 'ContactCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContactCategory;
};

export type ContactCategoryInput = {
  altNameTranslations?: InputMaybe<Scalars['JSON']>;
  name: Scalars['String'];
};

/** The connection type for Contact. */
export type ContactConnection = {
  __typename?: 'ContactConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ContactEdge>>>;
  /** A list of nodes. */
  nodes: Array<Contact>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
  xlsxExport: XlsxExport;
};

/** An edge in a connection. */
export type ContactEdge = {
  __typename?: 'ContactEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Contact;
};

export type ContactFilterInput = {
  contactId?: InputMaybe<Scalars['ID']>;
  entityType?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  opponent?: InputMaybe<Scalars['Boolean']>;
};

export type ContactInput = {
  address?: InputMaybe<Scalars['String']>;
  birthdayDate?: InputMaybe<Scalars['ISO8601Date']>;
  contactCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  contactId?: InputMaybe<Scalars['ID']>;
  country?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['ID']>>;
  entityType: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  identificationNumber?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  linkedinProfileUrl?: InputMaybe<Scalars['String']>;
  mailchimpSync?: InputMaybe<Scalars['Boolean']>;
  marketingEffortTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  middleName?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  newCompany?: InputMaybe<ContactBaseInput>;
  opponent?: InputMaybe<Scalars['Boolean']>;
  ownerId?: InputMaybe<Scalars['ID']>;
  ownerIds?: InputMaybe<Array<Scalars['ID']>>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  registrationNumber?: InputMaybe<Scalars['String']>;
  shareholderIds?: InputMaybe<Array<Scalars['ID']>>;
  title?: InputMaybe<Scalars['String']>;
  vatRegistrationNumber?: InputMaybe<Scalars['String']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
};

/** Why a legal case is related to a contact */
export enum ContactLegalCaseRole {
  /** Contact is the case's billing contact */
  CaseBillingContact = 'CASE_BILLING_CONTACT',
  /** Contact is a sync-mirror of the case's client */
  Client = 'CLIENT',
  /** Contact is linked to the case's client via clients_contacts */
  ClientContact = 'CLIENT_CONTACT',
  /** Contact is an opponent on the case */
  Opponent = 'OPPONENT'
}

export type ContactRelatedLegalCase = {
  __typename?: 'ContactRelatedLegalCase';
  legalCase: LegalCase;
  roles: Array<ContactLegalCaseRole>;
};

export type CreditNoteInput = {
  billingEmails: Array<Scalars['String']>;
  creditAmount: Scalars['Float'];
  creditableAmountType?: InputMaybe<CreditableAmountType>;
  id?: InputMaybe<Scalars['ID']>;
  issuedAt: Scalars['ISO8601Date'];
};

export type CreditRating = {
  __typename?: 'CreditRating';
  createdAt: Scalars['ISO8601Date'];
  discardedAt?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['ISO8601Date'];
};

/** The connection type for CreditRating. */
export type CreditRatingConnection = {
  __typename?: 'CreditRatingConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CreditRatingEdge>>>;
  /** A list of nodes. */
  nodes: Array<CreditRating>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CreditRatingEdge = {
  __typename?: 'CreditRatingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CreditRating;
};

export type CreditRatingInput = {
  name: Scalars['String'];
};

/** Credit Note Credited Amount Type */
export enum CreditableAmountType {
  /** Fees */
  Fees = 'fees',
  /** Invoice Total */
  Total = 'total'
}

export type Currency = {
  __typename?: 'Currency';
  createdAt: Scalars['ISO8601Date'];
  discardedAt?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['ISO8601Date'];
};

/** The connection type for Currency. */
export type CurrencyConnection = {
  __typename?: 'CurrencyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CurrencyEdge>>>;
  /** A list of nodes. */
  nodes: Array<Currency>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CurrencyEdge = {
  __typename?: 'CurrencyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Currency;
};

export type CurrencyInput = {
  name: Scalars['String'];
};

export type DbResetInput = {
  dataset: Scalars['String'];
};

export type DisableTwoFactorInput = {
  otp: Scalars['String'];
};

export type Disbursement = {
  __typename?: 'Disbursement';
  client?: Maybe<Client>;
  currency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  disbursementType?: Maybe<DisbursementType>;
  expenseAmount: Scalars['Float'];
  id: Scalars['ID'];
  invoice?: Maybe<Invoice>;
  legalCase?: Maybe<LegalCase>;
  onDate: Scalars['ISO8601Date'];
  owner?: Maybe<User>;
  state: DisbursementState;
  taxable: Scalars['Boolean'];
};

/** The connection type for Disbursement. */
export type DisbursementConnection = {
  __typename?: 'DisbursementConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DisbursementEdge>>>;
  /** A list of nodes. */
  nodes: Array<Disbursement>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type DisbursementEdge = {
  __typename?: 'DisbursementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Disbursement;
};

export type DisbursementFilterInput = {
  client?: InputMaybe<ClientFilterInput>;
  disbursementTypeId?: InputMaybe<Array<Scalars['ID']>>;
  invoiceId?: InputMaybe<Scalars['String']>;
  legalCaseId?: InputMaybe<Array<Scalars['ID']>>;
  onDateFrom?: InputMaybe<Scalars['ISO8601Date']>;
  onDateTo?: InputMaybe<Scalars['ISO8601Date']>;
  state?: InputMaybe<Array<DisbursementState>>;
  taxable?: InputMaybe<Scalars['Boolean']>;
};

export type DisbursementInput = {
  auditComment?: InputMaybe<Scalars['String']>;
  currencyId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  disbursementTypeId?: InputMaybe<Scalars['ID']>;
  expenseAmount?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['ID']>;
  invoiceId?: InputMaybe<Scalars['ID']>;
  legalCaseId?: InputMaybe<Scalars['ID']>;
  onDate?: InputMaybe<Scalars['ISO8601Date']>;
  ownerId?: InputMaybe<Scalars['ID']>;
  taxable?: InputMaybe<Scalars['Boolean']>;
};

/** Disbursement States */
export enum DisbursementState {
  /** invoiced */
  Invoiced = 'invoiced',
  /** new */
  New = 'new',
  /** non_billable */
  NonBillable = 'non_billable'
}

export type DisbursementType = {
  __typename?: 'DisbursementType';
  altNameTranslations: Scalars['JSON'];
  createdAt: Scalars['ISO8601Date'];
  discardedAt?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  nameWithoutFallback: Scalars['String'];
  updatedAt: Scalars['ISO8601Date'];
};

/** The connection type for DisbursementType. */
export type DisbursementTypeConnection = {
  __typename?: 'DisbursementTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DisbursementTypeEdge>>>;
  /** A list of nodes. */
  nodes: Array<DisbursementType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type DisbursementTypeEdge = {
  __typename?: 'DisbursementTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: DisbursementType;
};

export type DisbursementTypeInput = {
  altNameTranslations?: InputMaybe<Scalars['JSON']>;
  name: Scalars['String'];
};

/** Employment Types */
export enum EmploymentType {
  /** External */
  External = 'external',
  /** Internal */
  Internal = 'internal'
}

export type Entity = {
  __typename?: 'Entity';
  address?: Maybe<Scalars['String']>;
  altAddressTranslations?: Maybe<Scalars['JSON']>;
  altBankDetailsTranslations?: Maybe<Scalars['JSON']>;
  altNameTranslations?: Maybe<Scalars['JSON']>;
  bankDetails?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  discardedAt?: Maybe<Scalars['ISO8601Date']>;
  email?: Maybe<Scalars['String']>;
  faxNumber?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoiceCode?: Maybe<Scalars['String']>;
  invoiceInitialNumberSequence?: Maybe<Scalars['Int']>;
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  nameWithoutFallback: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  registrationNumber?: Maybe<Scalars['String']>;
  vatRegistrationNumber?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
};

/** The connection type for Entity. */
export type EntityConnection = {
  __typename?: 'EntityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EntityEdge>>>;
  /** A list of nodes. */
  nodes: Array<Entity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type EntityEdge = {
  __typename?: 'EntityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Entity;
};

export type EntityInput = {
  address?: InputMaybe<Scalars['String']>;
  altAddressTranslations?: InputMaybe<Scalars['JSON']>;
  altBankDetailsTranslations?: InputMaybe<Scalars['JSON']>;
  altNameTranslations?: InputMaybe<Scalars['JSON']>;
  bankDetails?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  faxNumber?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  invoiceCode?: InputMaybe<Scalars['String']>;
  invoiceInitialNumberSequence?: InputMaybe<Scalars['Int']>;
  logo?: InputMaybe<Scalars['File']>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  registrationNumber?: InputMaybe<Scalars['String']>;
  vatRegistrationNumber?: InputMaybe<Scalars['String']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
};

/** Entity Types */
export enum EntityType {
  /** Legal entities */
  Legal = 'legal',
  /** Private individuals */
  Private = 'private'
}

export type Feedback = {
  __typename?: 'Feedback';
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601Date'];
  id: Scalars['ID'];
  rating?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  userId: Scalars['String'];
};

export type FeedbackInput = {
  comment?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  rating: Scalars['Int'];
  userId: Scalars['ID'];
};

export enum GlobalSearchRecord {
  Client = 'Client',
  Contact = 'Contact',
  Disbursement = 'Disbursement',
  Invoice = 'Invoice',
  LegalCase = 'LegalCase',
  Task = 'Task',
  TimeCard = 'TimeCard',
  User = 'User'
}

export type GlobalSearchResult = {
  __typename?: 'GlobalSearchResult';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  recordId: Scalars['ID'];
  recordType: GlobalSearchRecord;
};

/** Client Hourly Fee Types */
export enum HourlyFeeType {
  /** Blended */
  Blended = 'blended',
  /** Custom */
  Custom = 'custom',
  /** Default */
  Default = 'default'
}

/** Icon Pack Types */
export enum IconPack {
  /** Default icon pack */
  IconPack_1 = 'icon_pack_1',
  /** Alternative icon pack */
  IconPack_2 = 'icon_pack_2'
}

export type ImportAttempt = {
  __typename?: 'ImportAttempt';
  createdAt: Scalars['ISO8601DateTime'];
  destination: ImportAttemptDestination;
  id: Scalars['ID'];
  insertedCount?: Maybe<Scalars['Int']>;
  invalidCount?: Maybe<Scalars['Int']>;
  parsedCount?: Maybe<Scalars['Int']>;
  processingErrors?: Maybe<Scalars['JSON']>;
  sourceUrl?: Maybe<Scalars['String']>;
  state: ImportAttemptState;
  updatedAt: Scalars['ISO8601DateTime'];
  updatedCount?: Maybe<Scalars['Int']>;
};

/** The connection type for ImportAttempt. */
export type ImportAttemptConnection = {
  __typename?: 'ImportAttemptConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ImportAttemptEdge>>>;
  /** A list of nodes. */
  nodes: Array<ImportAttempt>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** Import types */
export enum ImportAttemptDestination {
  Client = 'Client',
  Contact = 'Contact',
  LegalCase = 'LegalCase'
}

/** An edge in a connection. */
export type ImportAttemptEdge = {
  __typename?: 'ImportAttemptEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ImportAttempt;
};

export type ImportAttemptFilterInput = {
  destination?: InputMaybe<Scalars['String']>;
};

export type ImportAttemptInput = {
  destination: ImportAttemptDestination;
  source?: InputMaybe<Scalars['File']>;
};

/** Import States */
export enum ImportAttemptState {
  Draft = 'draft',
  ImportFailed = 'import_failed',
  Imported = 'imported',
  Importing = 'importing',
  InvalidData = 'invalid_data',
  Parsed = 'parsed'
}

export type Industry = {
  __typename?: 'Industry';
  altNameTranslations: Scalars['JSON'];
  createdAt: Scalars['ISO8601Date'];
  discardedAt?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  nameWithoutFallback: Scalars['String'];
  updatedAt: Scalars['ISO8601Date'];
};

/** The connection type for Industry. */
export type IndustryConnection = {
  __typename?: 'IndustryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IndustryEdge>>>;
  /** A list of nodes. */
  nodes: Array<Industry>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type IndustryEdge = {
  __typename?: 'IndustryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Industry;
};

export type IndustryInput = {
  altNameTranslations?: InputMaybe<Scalars['JSON']>;
  name: Scalars['String'];
};

export type Invoice = {
  __typename?: 'Invoice';
  allocatedPrepaymentTotalValue?: Maybe<Scalars['Float']>;
  alternateCaseName?: Maybe<Scalars['String']>;
  anyDisbursementsWithoutPrice: Scalars['Boolean'];
  anyTimeCardsWithoutRate?: Maybe<Scalars['Boolean']>;
  approvable: Scalars['Boolean'];
  approvalState: Scalars['String'];
  approvedAt?: Maybe<Scalars['ISO8601Date']>;
  approveeRole?: Maybe<UserRole>;
  billableTime: Array<InvoiceBillableTime>;
  billingAddress?: Maybe<Scalars['String']>;
  billingContact?: Maybe<Contact>;
  billingCountry?: Maybe<Scalars['String']>;
  billingEmails: Array<Scalars['String']>;
  billingInformationFromLegalCase: Scalars['Boolean'];
  billingPhone?: Maybe<Scalars['String']>;
  billingPostalCode?: Maybe<Scalars['String']>;
  billingToName?: Maybe<Scalars['String']>;
  billingToRegistrationNumber?: Maybe<Scalars['String']>;
  billingToVatRegistrationNumber?: Maybe<Scalars['String']>;
  caseManager?: Maybe<User>;
  caseNameOnInvoice?: Maybe<Scalars['String']>;
  client?: Maybe<Client>;
  clientReferenceNumber?: Maybe<Scalars['String']>;
  copiedTo?: Maybe<Invoice>;
  copyOf?: Maybe<Invoice>;
  creditAmount?: Maybe<Scalars['Float']>;
  creditNote?: Maybe<Invoice>;
  creditableAmountType?: Maybe<CreditableAmountType>;
  creditedInvoice?: Maybe<Invoice>;
  currency?: Maybe<Currency>;
  customizedPriceList?: Maybe<PriceList>;
  defaultInvoiceTemplate?: Maybe<InvoiceTemplate>;
  disbursementTotal?: Maybe<Scalars['Float']>;
  disbursements: Array<Maybe<Disbursement>>;
  discountPercentage?: Maybe<Scalars['Float']>;
  feeTotal?: Maybe<Scalars['Float']>;
  feeValue?: Maybe<Scalars['Float']>;
  feesAfterDiscount?: Maybe<Scalars['Float']>;
  fixedFee?: Maybe<Scalars['Float']>;
  flatRate?: Maybe<Scalars['Float']>;
  formattedMinutesSpent: Scalars['String'];
  hourlyFeeType?: Maybe<HourlyFeeType>;
  id: Scalars['ID'];
  includedRecordsPeriodFromDate?: Maybe<Scalars['ISO8601Date']>;
  includedRecordsPeriodToDate?: Maybe<Scalars['ISO8601Date']>;
  inheritedBillingToName?: Maybe<Scalars['String']>;
  inheritedClientReferenceNumber?: Maybe<Scalars['String']>;
  inheritedCurrency?: Maybe<Currency>;
  inheritedDiscountPercentage?: Maybe<Scalars['Float']>;
  inheritedFixedFee?: Maybe<Scalars['Float']>;
  inheritedHourlyFeeType?: Maybe<HourlyFeeType>;
  inheritedInvoiceIssuer?: Maybe<Entity>;
  inheritedLanguage?: Maybe<Scalars['String']>;
  inheritedLawyerRate?: Maybe<Scalars['Float']>;
  inheritedNonLawyerRate?: Maybe<Scalars['Float']>;
  inheritedPaymentTerm?: Maybe<PaymentTerm>;
  inheritedPaymentType?: Maybe<PaymentType>;
  inheritedStandardPriceList?: Maybe<PriceList>;
  inheritedVatPercentage?: Maybe<VatPercentage>;
  invoicableRecordsPeriodFromDate?: Maybe<Scalars['ISO8601Date']>;
  invoicableRecordsPeriodToDate?: Maybe<Scalars['ISO8601Date']>;
  invoiceDiscount?: Maybe<Scalars['Float']>;
  invoiceIssuer?: Maybe<Entity>;
  invoiceItems: Array<InvoiceItem>;
  invoiceSubtotal?: Maybe<Scalars['Float']>;
  invoiceType: InvoiceType;
  invoicesAllocatedFrom?: Maybe<Array<Maybe<Invoice>>>;
  invoicesAllocatedTo?: Maybe<Array<Maybe<Invoice>>>;
  issuedAt?: Maybe<Scalars['ISO8601Date']>;
  language?: Maybe<Scalars['String']>;
  lawyerRate?: Maybe<Scalars['Float']>;
  legalCase?: Maybe<LegalCase>;
  minutesSpent?: Maybe<Scalars['Int']>;
  nextApproverStateRole?: Maybe<Scalars['String']>;
  nextStateEvent?: Maybe<InvoiceEvent>;
  nonLawyerRate?: Maybe<Scalars['Float']>;
  number?: Maybe<Scalars['String']>;
  paidAt?: Maybe<Scalars['ISO8601Date']>;
  paymentTerm?: Maybe<PaymentTerm>;
  paymentType?: Maybe<PaymentType>;
  periodFromDate?: Maybe<Scalars['ISO8601Date']>;
  periodToDate?: Maybe<Scalars['ISO8601Date']>;
  prepaymentIntendedUse?: Maybe<InvoicePrepaymentIntendedUse>;
  previousRejectEvent?: Maybe<InvoiceApprovalEvent>;
  printoutUrl?: Maybe<Scalars['String']>;
  recordsExistBeforePeriod?: Maybe<Scalars['Boolean']>;
  rejectable: Scalars['Boolean'];
  standardPriceList?: Maybe<PriceList>;
  state: InvoiceState;
  subtotal?: Maybe<Scalars['Float']>;
  timeCardTotal?: Maybe<Scalars['Float']>;
  timeCards: Array<Maybe<TimeCard>>;
  totalValue?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['ISO8601Date'];
  vat?: Maybe<Scalars['Float']>;
  vatPercentage?: Maybe<VatPercentage>;
};

/** Invoice Approval Events */
export enum InvoiceApprovalEvent {
  /** first_approve */
  FirstApprove = 'first_approve',
  /** first_reject */
  FirstReject = 'first_reject',
  /** fourth_approve */
  FourthApprove = 'fourth_approve',
  /** fourth_reject */
  FourthReject = 'fourth_reject',
  /** reject_completely */
  RejectCompletely = 'reject_completely',
  /** second_approve */
  SecondApprove = 'second_approve',
  /** second_reject */
  SecondReject = 'second_reject',
  /** third_approve */
  ThirdApprove = 'third_approve',
  /** third_reject */
  ThirdReject = 'third_reject'
}

export type InvoiceApprover = {
  __typename?: 'InvoiceApprover';
  group?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type InvoiceBillableTime = {
  __typename?: 'InvoiceBillableTime';
  minutesSpent: Scalars['Int'];
  positionName: Scalars['String'];
  positionSequence?: Maybe<Scalars['Int']>;
  rate: Scalars['Float'];
  total: Scalars['Float'];
  userFullName: Scalars['String'];
};

/** The connection type for Invoice. */
export type InvoiceConnection = {
  __typename?: 'InvoiceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InvoiceEdge>>>;
  /** A list of nodes. */
  nodes: Array<Invoice>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
  xlsxExport: XlsxExport;
};

/** An edge in a connection. */
export type InvoiceEdge = {
  __typename?: 'InvoiceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Invoice;
};

/** Invoice Events */
export enum InvoiceEvent {
  /** approve_invoice */
  ApproveInvoice = 'approve_invoice',
  /** assign_invoice_number */
  AssignInvoiceNumber = 'assign_invoice_number',
  /** invoice_to_send */
  InvoiceToSend = 'invoice_to_send',
  /** invoice_unpaid */
  InvoiceUnpaid = 'invoice_unpaid',
  /** pay_for_invoice */
  PayForInvoice = 'pay_for_invoice',
  /** send_invoice */
  SendInvoice = 'send_invoice',
  /** start_approval */
  StartApproval = 'start_approval',
  /** turn_bad */
  TurnBad = 'turn_bad'
}

export type InvoiceFilterInput = {
  approvalState?: InputMaybe<Scalars['String']>;
  caseOwners?: InputMaybe<UserFilterInput>;
  id?: InputMaybe<Scalars['ID']>;
  invoiceType?: InputMaybe<Array<InvoiceType>>;
  issuedAtFrom?: InputMaybe<Scalars['ISO8601Date']>;
  issuedAtTo?: InputMaybe<Scalars['ISO8601Date']>;
  legalCase?: InputMaybe<LegalCaseFilterInput>;
  legalCaseId?: InputMaybe<Array<Scalars['ID']>>;
  paidAtFrom?: InputMaybe<Scalars['ISO8601Date']>;
  paidAtTo?: InputMaybe<Scalars['ISO8601Date']>;
  state?: InputMaybe<Array<InvoiceState>>;
};

export type InvoiceInput = {
  alternateCaseName?: InputMaybe<Scalars['String']>;
  billingAddress?: InputMaybe<Scalars['String']>;
  billingContactId?: InputMaybe<Scalars['ID']>;
  billingCountry?: InputMaybe<Scalars['String']>;
  billingEmails?: InputMaybe<Array<Scalars['String']>>;
  billingInformationFromLegalCase?: InputMaybe<Scalars['Boolean']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  billingPostalCode?: InputMaybe<Scalars['String']>;
  billingToName?: InputMaybe<Scalars['String']>;
  billingToRegistrationNumber?: InputMaybe<Scalars['String']>;
  billingToVatRegistrationNumber?: InputMaybe<Scalars['String']>;
  clientReferenceNumber?: InputMaybe<Scalars['String']>;
  creditAmount?: InputMaybe<Scalars['Float']>;
  creditableAmountType?: InputMaybe<CreditableAmountType>;
  currencyId?: InputMaybe<Scalars['ID']>;
  customizedPriceListId?: InputMaybe<Scalars['ID']>;
  discountPercentage?: InputMaybe<Scalars['Float']>;
  fixedFee?: InputMaybe<Scalars['Float']>;
  flatRate?: InputMaybe<Scalars['Float']>;
  hourlyFeeType?: InputMaybe<HourlyFeeType>;
  id?: InputMaybe<Scalars['ID']>;
  invoiceIssuerId?: InputMaybe<Scalars['String']>;
  invoiceType?: InputMaybe<Scalars['String']>;
  issuedAt?: InputMaybe<Scalars['ISO8601Date']>;
  language?: InputMaybe<Scalars['String']>;
  lawyerRate?: InputMaybe<Scalars['Float']>;
  legalCaseId?: InputMaybe<Scalars['String']>;
  newBillingContact?: InputMaybe<ContactBaseInput>;
  nonLawyerRate?: InputMaybe<Scalars['Float']>;
  paidAt?: InputMaybe<Scalars['ISO8601Date']>;
  paymentTermId?: InputMaybe<Scalars['ID']>;
  paymentType?: InputMaybe<PaymentType>;
  periodFromDate?: InputMaybe<Scalars['ISO8601Date']>;
  periodToDate?: InputMaybe<Scalars['ISO8601Date']>;
  prepaymentIntendedUse?: InputMaybe<InvoicePrepaymentIntendedUse>;
  priceListRates?: InputMaybe<Array<PriceListRateInput>>;
  standardPriceListId?: InputMaybe<Scalars['ID']>;
  vatPercentageId?: InputMaybe<Scalars['ID']>;
};

export type InvoiceItem = {
  __typename?: 'InvoiceItem';
  quantity: Scalars['Float'];
  quantityType: Scalars['String'];
  total: Scalars['Float'];
  type?: Maybe<InvoiceItemType>;
};

/** Invoice Items Type */
export enum InvoiceItemType {
  /** blended */
  Blended = 'blended',
  /** custom */
  Custom = 'custom',
  /** default */
  Default = 'default',
  /** disbursements_no_vat */
  DisbursementsNoVat = 'disbursements_no_vat',
  /** disbursements_vat */
  DisbursementsVat = 'disbursements_vat',
  /** fixed_fee */
  FixedFee = 'fixed_fee'
}

/** Invoice number frequency reset */
export enum InvoiceNumberResetFrequency {
  /** Monthly */
  Monthly = 'monthly',
  /** Never */
  Never = 'never',
  /** Yearly */
  Yearly = 'yearly'
}

export type InvoicePdfInput = {
  caseNameOnInvoice?: InputMaybe<Scalars['String']>;
  detailLevel: Scalars['String'];
  invoiceTemplateId?: InputMaybe<Scalars['ID']>;
};

/** Prepayment invoice intended use */
export enum InvoicePrepaymentIntendedUse {
  Any = 'any',
  Disbursements = 'disbursements',
  Fees = 'fees'
}

/** Invoice States */
export enum InvoiceState {
  /** approval */
  Approval = 'approval',
  /** approved */
  Approved = 'approved',
  /** bad_debt */
  BadDebt = 'bad_debt',
  /** draft */
  Draft = 'draft',
  /** paid */
  Paid = 'paid',
  /** unpaid */
  Unpaid = 'unpaid'
}

export type InvoiceStateChangeInput = {
  paidAt?: InputMaybe<Scalars['ISO8601Date']>;
};

export type InvoiceTemplate = {
  __typename?: 'InvoiceTemplate';
  detailLevel: InvoiceTemplateDetail;
  entity?: Maybe<Entity>;
  id: Scalars['ID'];
  language?: Maybe<Scalars['String']>;
  layout: InvoiceTemplateLayout;
  name: Scalars['String'];
};

/** The connection type for InvoiceTemplate. */
export type InvoiceTemplateConnection = {
  __typename?: 'InvoiceTemplateConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InvoiceTemplateEdge>>>;
  /** A list of nodes. */
  nodes: Array<InvoiceTemplate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** Invoice Template Detail */
export enum InvoiceTemplateDetail {
  /** exclude_time_cards */
  ExcludeTimeCards = 'exclude_time_cards',
  /** full */
  Full = 'full',
  /** full_exclude_fee_detail */
  FullExcludeFeeDetail = 'full_exclude_fee_detail',
  /** no_specification */
  NoSpecification = 'no_specification',
  /** title_page */
  TitlePage = 'title_page'
}

/** An edge in a connection. */
export type InvoiceTemplateEdge = {
  __typename?: 'InvoiceTemplateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: InvoiceTemplate;
};

export type InvoiceTemplateFilterInput = {
  entityId?: InputMaybe<Scalars['ID']>;
  language?: InputMaybe<Scalars['String']>;
};

export type InvoiceTemplateInput = {
  detailLevel: InvoiceTemplateDetail;
  entityId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  language?: InputMaybe<Scalars['String']>;
  layout: InvoiceTemplateLayout;
  name: Scalars['String'];
};

export enum InvoiceTemplateLayout {
  Center = 'center',
  CenterCompact = 'center_compact',
  Left = 'left',
  LeftCompact = 'left_compact'
}

/** Invoice Type */
export enum InvoiceType {
  /** Credit Note */
  CreditNote = 'credit_note',
  /** Invoice */
  Invoice = 'invoice',
  /** Prepayment */
  Prepayment = 'prepayment'
}

export type InvoiceableCaseChangeInput = {
  legalCaseId?: InputMaybe<Scalars['ID']>;
};

export type LegalCase = {
  __typename?: 'LegalCase';
  billingAddress?: Maybe<Scalars['String']>;
  billingContact?: Maybe<Contact>;
  billingCountry?: Maybe<Scalars['String']>;
  billingEmails: Array<Scalars['String']>;
  billingInformationFromClient: Scalars['Boolean'];
  billingPhone?: Maybe<Scalars['String']>;
  billingPostalCode?: Maybe<Scalars['String']>;
  billingToName?: Maybe<Scalars['String']>;
  billingToRegistrationNumber?: Maybe<Scalars['String']>;
  billingToVatRegistrationNumber?: Maybe<Scalars['String']>;
  client?: Maybe<Client>;
  clientReferenceNumber?: Maybe<Scalars['String']>;
  closedOn?: Maybe<Scalars['ISO8601Date']>;
  connectedLawyers: Array<Maybe<User>>;
  currency?: Maybe<Currency>;
  customizedPriceList?: Maybe<PriceList>;
  deadline?: Maybe<Scalars['ISO8601Date']>;
  disbursements: Array<Maybe<Disbursement>>;
  discountPercentage?: Maybe<Scalars['Float']>;
  draftInvoice?: Maybe<Invoice>;
  estimatedCaseValue?: Maybe<Scalars['Float']>;
  feedbacks: Array<Maybe<Feedback>>;
  fixedFee?: Maybe<Scalars['Float']>;
  flatRate?: Maybe<Scalars['Float']>;
  formattedInvoicedMinutes: Scalars['String'];
  formattedNonBillableMinutes: Scalars['String'];
  formattedTotalMinutes: Scalars['String'];
  formattedUninvoicedMinutes: Scalars['String'];
  frequency?: Maybe<LegalCaseFrequency>;
  fullName?: Maybe<Scalars['String']>;
  hasInvoicing: Scalars['Boolean'];
  hourlyFeeType?: Maybe<HourlyFeeType>;
  id: Scalars['ID'];
  invoiceIssuer?: Maybe<Entity>;
  invoicingCurrency?: Maybe<Currency>;
  language?: Maybe<Scalars['String']>;
  lastExpenseRecordDate?: Maybe<Scalars['ISO8601Date']>;
  lastTcDate?: Maybe<Scalars['ISO8601Date']>;
  lawyerRate?: Maybe<Scalars['Float']>;
  legalCaseOwners: Array<Maybe<LegalCaseOwner>>;
  manager?: Maybe<User>;
  name?: Maybe<Scalars['String']>;
  nameOnInvoice?: Maybe<Scalars['String']>;
  nonLawyerRate?: Maybe<Scalars['Float']>;
  openedOn?: Maybe<Scalars['ISO8601Date']>;
  opponents: Array<Maybe<Contact>>;
  outcome?: Maybe<CaseOutcome>;
  outcomeComment?: Maybe<Scalars['String']>;
  paymentTerm?: Maybe<PaymentTerm>;
  paymentType?: Maybe<PaymentType>;
  primaryPracticeArea?: Maybe<PracticeArea>;
  proBono: Scalars['Boolean'];
  proBonoNotes?: Maybe<Scalars['String']>;
  recurringDate?: Maybe<Scalars['ISO8601Date']>;
  secondaryPracticeArea?: Maybe<PracticeArea>;
  standardPriceList?: Maybe<PriceList>;
  state: LegalCaseState;
  successFee: Scalars['Boolean'];
  successFeeNotes?: Maybe<Scalars['String']>;
  timeCards: Array<Maybe<TimeCard>>;
  unsentInvoicesPresent: Scalars['Boolean'];
  userNotes: Array<Maybe<UserNote>>;
  vatPercentage?: Maybe<VatPercentage>;
};

export type LegalCaseClosingInput = {
  closedOn: Scalars['ISO8601Date'];
  feedbacksAttributes?: InputMaybe<Array<FeedbackInput>>;
  outcome: CaseOutcome;
  outcomeComment?: InputMaybe<Scalars['String']>;
};

/** The connection type for LegalCase. */
export type LegalCaseConnection = {
  __typename?: 'LegalCaseConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LegalCaseEdge>>>;
  /** A list of nodes. */
  nodes: Array<LegalCase>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
  xlsxExport: XlsxExport;
};

/** An edge in a connection. */
export type LegalCaseEdge = {
  __typename?: 'LegalCaseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: LegalCase;
};

export type LegalCaseFilterInput = {
  clientId?: InputMaybe<Array<Scalars['ID']>>;
  invoiceIssuerId?: InputMaybe<Array<Scalars['ID']>>;
  managerId?: InputMaybe<Array<Scalars['ID']>>;
  openedOnFrom?: InputMaybe<Scalars['ISO8601Date']>;
  openedOnTo?: InputMaybe<Scalars['ISO8601Date']>;
  owners?: InputMaybe<UserFilterInput>;
  primaryPracticeAreaId?: InputMaybe<Array<Scalars['ID']>>;
  state?: InputMaybe<Scalars['String']>;
  totalMinutesFrom?: InputMaybe<Scalars['Int']>;
  totalMinutesTo?: InputMaybe<Scalars['Int']>;
};

/** Case Frequency Types */
export enum LegalCaseFrequency {
  /** half_a_yearly */
  HalfAYearly = 'half_a_yearly',
  /** monthly */
  Monthly = 'monthly',
  /** quarterly */
  Quarterly = 'quarterly',
  /** yearly */
  Yearly = 'yearly'
}

export type LegalCaseInput = {
  billingAddress?: InputMaybe<Scalars['String']>;
  billingContactId?: InputMaybe<Scalars['ID']>;
  billingCountry?: InputMaybe<Scalars['String']>;
  billingEmails: Array<Scalars['String']>;
  billingInformationFromClient: Scalars['Boolean'];
  billingPhone?: InputMaybe<Scalars['String']>;
  billingPostalCode?: InputMaybe<Scalars['String']>;
  billingToName?: InputMaybe<Scalars['String']>;
  billingToRegistrationNumber?: InputMaybe<Scalars['String']>;
  billingToVatRegistrationNumber?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['ID']>;
  clientReferenceNumber?: InputMaybe<Scalars['String']>;
  connectedLawyerIds: Array<Scalars['ID']>;
  currencyId?: InputMaybe<Scalars['ID']>;
  customizedPriceListId?: InputMaybe<Scalars['ID']>;
  deadline?: InputMaybe<Scalars['ISO8601Date']>;
  discountPercentage?: InputMaybe<Scalars['Float']>;
  estimatedCaseValue?: InputMaybe<Scalars['Float']>;
  fixedFee?: InputMaybe<Scalars['Float']>;
  flatRate?: InputMaybe<Scalars['Float']>;
  frequency?: InputMaybe<LegalCaseFrequency>;
  hasInvoicing: Scalars['Boolean'];
  hourlyFeeType?: InputMaybe<HourlyFeeType>;
  invoiceIssuerId?: InputMaybe<Scalars['ID']>;
  invoicingCurrencyId?: InputMaybe<Scalars['ID']>;
  language: Scalars['String'];
  lawyerRate?: InputMaybe<Scalars['Float']>;
  legalCaseOwnersAttributes: Array<OwnerInput>;
  managerId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  nameOnInvoice?: InputMaybe<Scalars['String']>;
  newBillingContact?: InputMaybe<ContactBaseInput>;
  newClient?: InputMaybe<ClientBaseInput>;
  newOpponents?: InputMaybe<Array<ContactInput>>;
  nonLawyerRate?: InputMaybe<Scalars['Float']>;
  openedOn?: InputMaybe<Scalars['ISO8601Date']>;
  opponentIds?: InputMaybe<Array<Scalars['ID']>>;
  paymentTermId?: InputMaybe<Scalars['ID']>;
  paymentType?: InputMaybe<PaymentType>;
  priceListRates?: InputMaybe<Array<PriceListRateInput>>;
  primaryPracticeAreaId?: InputMaybe<Scalars['ID']>;
  proBono: Scalars['Boolean'];
  proBonoNotes?: InputMaybe<Scalars['String']>;
  recurringDate?: InputMaybe<Scalars['ISO8601Date']>;
  secondaryPracticeAreaId?: InputMaybe<Scalars['ID']>;
  standardPriceListId?: InputMaybe<Scalars['ID']>;
  successFee: Scalars['Boolean'];
  successFeeNotes?: InputMaybe<Scalars['String']>;
  vatPercentageId?: InputMaybe<Scalars['ID']>;
};

export type LegalCaseOwner = {
  __typename?: 'LegalCaseOwner';
  client?: Maybe<LegalCase>;
  id?: Maybe<Scalars['ID']>;
  ownershipPercentage: Scalars['Int'];
  user?: Maybe<User>;
};

/** The connection type for LegalCaseOwner. */
export type LegalCaseOwnerConnection = {
  __typename?: 'LegalCaseOwnerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LegalCaseOwnerEdge>>>;
  /** A list of nodes. */
  nodes: Array<LegalCaseOwner>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type LegalCaseOwnerEdge = {
  __typename?: 'LegalCaseOwnerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: LegalCaseOwner;
};

/** Case States */
export enum LegalCaseState {
  /** closed */
  Closed = 'closed',
  /** open */
  Open = 'open'
}

export enum Locale {
  Cs = 'cs',
  De = 'de',
  En = 'en',
  Es = 'es',
  Et = 'et',
  Fi = 'fi',
  Fr = 'fr',
  Lt = 'lt',
  Lv = 'lv',
  Nl = 'nl',
  No = 'no',
  Pl = 'pl',
  Ro = 'ro',
  Ru = 'ru',
  Sv = 'sv'
}

export type MarketingEffort = {
  __typename?: 'MarketingEffort';
  clientId: Scalars['ID'];
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  createdBy: User;
  id: Scalars['ID'];
  marketingEffortNeedTypes: Array<MarketingEffortNeedType>;
  marketingEffortResponseType?: Maybe<MarketingEffortResponseType>;
  marketingEffortType: MarketingEffortType;
  nextStepComment?: Maybe<Scalars['String']>;
  startedAt: Scalars['ISO8601Date'];
  updatedAt: Scalars['ISO8601DateTime'];
  updatedBy: User;
};

/** The connection type for MarketingEffort. */
export type MarketingEffortConnection = {
  __typename?: 'MarketingEffortConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MarketingEffortEdge>>>;
  /** A list of nodes. */
  nodes: Array<MarketingEffort>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
  xlsxExport: XlsxExport;
};

/** An edge in a connection. */
export type MarketingEffortEdge = {
  __typename?: 'MarketingEffortEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: MarketingEffort;
};

export type MarketingEffortFilterInput = {
  clientId: Array<Scalars['ID']>;
};

export type MarketingEffortInput = {
  clientId?: InputMaybe<Scalars['ID']>;
  comment?: InputMaybe<Scalars['String']>;
  marketingEffortNeedTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  marketingEffortResponseTypeId?: InputMaybe<Scalars['ID']>;
  marketingEffortTypeId: Scalars['ID'];
  nextStepComment?: InputMaybe<Scalars['String']>;
  startedAt: Scalars['ISO8601Date'];
};

export type MarketingEffortNeedType = {
  __typename?: 'MarketingEffortNeedType';
  altNameTranslations: Scalars['JSON'];
  createdAt: Scalars['ISO8601Date'];
  discardedAt?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  nameWithoutFallback: Scalars['String'];
  updatedAt: Scalars['ISO8601Date'];
};

/** The connection type for MarketingEffortNeedType. */
export type MarketingEffortNeedTypeConnection = {
  __typename?: 'MarketingEffortNeedTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MarketingEffortNeedTypeEdge>>>;
  /** A list of nodes. */
  nodes: Array<MarketingEffortNeedType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type MarketingEffortNeedTypeEdge = {
  __typename?: 'MarketingEffortNeedTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: MarketingEffortNeedType;
};

export type MarketingEffortNeedTypeInput = {
  altNameTranslations?: InputMaybe<Scalars['JSON']>;
  name: Scalars['String'];
};

export type MarketingEffortResponseType = {
  __typename?: 'MarketingEffortResponseType';
  altNameTranslations: Scalars['JSON'];
  createdAt: Scalars['ISO8601Date'];
  discardedAt?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  nameWithoutFallback: Scalars['String'];
  updatedAt: Scalars['ISO8601Date'];
};

/** The connection type for MarketingEffortResponseType. */
export type MarketingEffortResponseTypeConnection = {
  __typename?: 'MarketingEffortResponseTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MarketingEffortResponseTypeEdge>>>;
  /** A list of nodes. */
  nodes: Array<MarketingEffortResponseType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type MarketingEffortResponseTypeEdge = {
  __typename?: 'MarketingEffortResponseTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: MarketingEffortResponseType;
};

export type MarketingEffortResponseTypeInput = {
  altNameTranslations?: InputMaybe<Scalars['JSON']>;
  name: Scalars['String'];
};

export type MarketingEffortType = {
  __typename?: 'MarketingEffortType';
  altNameTranslations: Scalars['JSON'];
  createdAt: Scalars['ISO8601Date'];
  discardedAt?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  nameWithoutFallback: Scalars['String'];
  updatedAt: Scalars['ISO8601Date'];
};

/** The connection type for MarketingEffortType. */
export type MarketingEffortTypeConnection = {
  __typename?: 'MarketingEffortTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MarketingEffortTypeEdge>>>;
  /** A list of nodes. */
  nodes: Array<MarketingEffortType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type MarketingEffortTypeEdge = {
  __typename?: 'MarketingEffortTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: MarketingEffortType;
};

export type MarketingEffortTypeInput = {
  altNameTranslations?: InputMaybe<Scalars['JSON']>;
  name: Scalars['String'];
};

export type MonthlyUserEstimateInfo = {
  __typename?: 'MonthlyUserEstimateInfo';
  currentCount?: Maybe<Scalars['Int']>;
  estimatedCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  showAlert: Scalars['Boolean'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acknowledgeNotification: Notification;
  approvalStateSwitch: Invoice;
  approveTask: Task;
  assignInvoiceNumber: Invoice;
  bulkStateSwitch: Scalars['Boolean'];
  cancelSubscriptionInvoicePayment: SubscriptionInvoice;
  cancelTask: Task;
  changePassword: Scalars['Boolean'];
  clearNotification: Scalars['Boolean'];
  closeLegalCase: Scalars['Boolean'];
  confirmSubscriptionInvoicePayment: SubscriptionInvoice;
  createAccount: Account;
  createClient: Client;
  createContact: Contact;
  createContactCategory: ContactCategory;
  createCreditNote: Invoice;
  createCreditRating: CreditRating;
  createCurrency: Currency;
  createDisbursement: Disbursement;
  createDisbursementType: DisbursementType;
  createEntity: Entity;
  createImportAttempt: ImportAttempt;
  createIndustry: Industry;
  createInvoiceCopy: Invoice;
  createInvoiceTemplate: InvoiceTemplate;
  createLegalCase: LegalCase;
  createLegalCaseDraftInvoice: Invoice;
  createMarketingEffort: MarketingEffort;
  createMarketingEffortNeedType: MarketingEffortNeedType;
  createMarketingEffortResponseType: MarketingEffortResponseType;
  createMarketingEffortType: MarketingEffortType;
  createPaymentTerm: PaymentTerm;
  createPerformanceTarget: PerformanceTarget;
  createPosition: Position;
  createPracticeArea: PracticeArea;
  createPrepaymentInvoice: Invoice;
  createPriceList: PriceList;
  createTask: Task;
  createTeam: Team;
  createTeamMembership: TeamMembership;
  createTimeCard: TimeCard;
  createUser: User;
  createUserApiToken: UserApiToken;
  createUserCost: UserCost;
  createUserCostType: UserCostType;
  createUserHourlyRate: UserHourlyRate;
  createUserNote: UserNote;
  createUserNoteCategory: UserNoteCategory;
  createUserRole: UserRole;
  createUserSalary: UserSalary;
  createVatPercentage: VatPercentage;
  deleteAccount: Scalars['Boolean'];
  deleteClient: Scalars['Boolean'];
  deleteContact: Scalars['Boolean'];
  deleteContactCategory: Scalars['Boolean'];
  deleteCreditRating: Scalars['Boolean'];
  deleteCurrency: Scalars['Boolean'];
  deleteDisbursement: Scalars['Boolean'];
  deleteDisbursementType: Scalars['Boolean'];
  deleteEntity: Scalars['Boolean'];
  deleteIndustry: Scalars['Boolean'];
  deleteInvoice: Scalars['Boolean'];
  deleteInvoiceTemplate: Scalars['Boolean'];
  deleteLegalCase: Scalars['Boolean'];
  deleteMarketingEffort: Scalars['Boolean'];
  deleteMarketingEffortNeedType: Scalars['Boolean'];
  deleteMarketingEffortResponseType: Scalars['Boolean'];
  deleteMarketingEffortType: Scalars['Boolean'];
  deletePaymentTerm: Scalars['Boolean'];
  deletePerformanceTarget: Scalars['Boolean'];
  deletePosition: Scalars['Boolean'];
  deletePracticeArea: Scalars['Boolean'];
  deletePriceList: Scalars['Boolean'];
  deleteTask: Scalars['Boolean'];
  deleteTeam: Scalars['Boolean'];
  deleteTeamMembership: Scalars['Boolean'];
  deleteTimeCard: User;
  deleteUser: Scalars['Boolean'];
  deleteUserApiToken: Scalars['Boolean'];
  deleteUserCost: Scalars['Boolean'];
  deleteUserCostType: Scalars['Boolean'];
  deleteUserHourlyRate: Scalars['Boolean'];
  deleteUserNote: Scalars['Boolean'];
  deleteUserNoteCategory: Scalars['Boolean'];
  deleteUserRole: Scalars['Boolean'];
  deleteUserSalary: Scalars['Boolean'];
  deleteVatPercentage: Scalars['Boolean'];
  disableTwoFactor: Scalars['Boolean'];
  finishTask: Task;
  generateInvoicePdf: Scalars['String'];
  initializeTwoFactor: Scalars['String'];
  inviteUser: Scalars['Boolean'];
  linkDisbursements: Scalars['Boolean'];
  linkTimeCards: Scalars['Boolean'];
  massCaseChangeDisbursement: Scalars['Boolean'];
  massCaseChangeTimeCard: Scalars['Boolean'];
  massInvite: Scalars['Boolean'];
  paySubscriptionInvoice: SubscriptionPayInvoiceResponse;
  postponeTask: Task;
  prohibitCurrentAccountDbReset: Account;
  refreshInvoice: Invoice;
  refreshSubscriptionInvoicePdf: SubscriptionInvoice;
  rejectInvoice: Invoice;
  rejectTask: Task;
  reportGlobalProfitability: ReportExport;
  reportMatterStatus: XlsxExport;
  reportPersonalPractice: XlsxExport;
  reportPracticeAreas: XlsxExport;
  reportProfitability: XlsxExport;
  reportReceivables: XlsxExport;
  reportTimeCardsByLegalCase: XlsxExport;
  reportTotalTime: XlsxExport;
  reportUninvoicedTimeCards: XlsxExport;
  resendUserInvitation: User;
  resetCurrentAccountDb: Scalars['Boolean'];
  restoreContactCategory: ContactCategory;
  restoreCreditRating: CreditRating;
  restoreCurrency: Currency;
  restoreDisbursementType: DisbursementType;
  restoreEntity: Entity;
  restoreIndustry: Industry;
  restoreLegalCase: Scalars['Boolean'];
  restoreMarketingEffortNeedType: MarketingEffortNeedType;
  restoreMarketingEffortResponseType: MarketingEffortResponseType;
  restoreMarketingEffortType: MarketingEffortType;
  restorePaymentTerm: PaymentTerm;
  restorePosition: Position;
  restorePracticeArea: PracticeArea;
  restoreUser: User;
  restoreUserCostType: UserCostType;
  restoreUserNoteCategory: UserNoteCategory;
  restoreVatPercentage: VatPercentage;
  resumeSubscription: SubscriptionInfo;
  revertInvoiceState: Invoice;
  scheduleImportAttempt: ImportAttempt;
  startStripeCardRegistration: StripeCardInitParams;
  startTask: Task;
  stateSwitch: Invoice;
  switchDefaultPriceList: PriceList;
  switchPaymentType: LegalCase;
  syncContactsWithMailchimp: Scalars['Boolean'];
  terminateSubscription: SubscriptionInfo;
  testCurrentAccountEmailSettings: Scalars['Boolean'];
  toReviewTask: Task;
  unlinkDisbursement: Scalars['Boolean'];
  unlinkTimeCard: Scalars['Boolean'];
  unlockUser: User;
  updateAccountSubscriptionSettings: AccountSubscriptionSettings;
  updateCalendar: Calendar;
  updateClient: Client;
  updateContact: Contact;
  updateContactCategory: ContactCategory;
  updateCreditRating: CreditRating;
  updateCurrency: Currency;
  updateCurrentAccountSettings: Account;
  updateDisbursement: Disbursement;
  updateDisbursementType: DisbursementType;
  updateEntity: Entity;
  updateIndustry: Industry;
  updateInvoice: Invoice;
  updateInvoiceTemplate: InvoiceTemplate;
  updateLegalCase: LegalCase;
  updateMarketingEffort: MarketingEffort;
  updateMarketingEffortNeedType: MarketingEffortNeedType;
  updateMarketingEffortResponseType: MarketingEffortResponseType;
  updateMarketingEffortType: MarketingEffortType;
  updateNotificationConfiguration: NotificationConfiguration;
  updatePaymentTerm: PaymentTerm;
  updatePerformanceTarget: PerformanceTarget;
  updatePosition: Position;
  updatePracticeArea: PracticeArea;
  updatePriceList: PriceList;
  updateTask: Task;
  updateTeam: Team;
  updateTeamMembership: TeamMembership;
  updateTimeCard: TimeCard;
  updateUser: User;
  updateUserCost: UserCost;
  updateUserCostType: UserCostType;
  updateUserHourlyRate: UserHourlyRate;
  updateUserNote: UserNote;
  updateUserNoteCategory: UserNoteCategory;
  updateUserRole: UserRole;
  updateUserSalary: UserSalary;
  updateVatPercentage: VatPercentage;
  validateTwoFactor: Array<Scalars['String']>;
};


export type MutationAcknowledgeNotificationArgs = {
  id: Scalars['ID'];
};


export type MutationApprovalStateSwitchArgs = {
  id: Scalars['ID'];
};


export type MutationApproveTaskArgs = {
  id: Scalars['ID'];
};


export type MutationAssignInvoiceNumberArgs = {
  id: Scalars['ID'];
};


export type MutationBulkStateSwitchArgs = {
  ids: Array<Scalars['ID']>;
  input?: InputMaybe<InvoiceStateChangeInput>;
};


export type MutationCancelSubscriptionInvoicePaymentArgs = {
  errorMessage: Scalars['String'];
  subscriptionPaymentId: Scalars['ID'];
};


export type MutationCancelTaskArgs = {
  id: Scalars['ID'];
  reason: Scalars['String'];
};


export type MutationChangePasswordArgs = {
  id: Scalars['ID'];
  input: UserCredentialInput;
  userId: Scalars['ID'];
};


export type MutationCloseLegalCaseArgs = {
  id: Scalars['ID'];
  input: LegalCaseClosingInput;
};


export type MutationConfirmSubscriptionInvoicePaymentArgs = {
  subscriptionPaymentId: Scalars['ID'];
};


export type MutationCreateAccountArgs = {
  input: AccountInput;
};


export type MutationCreateClientArgs = {
  input: ClientInput;
};


export type MutationCreateContactArgs = {
  input: ContactInput;
};


export type MutationCreateContactCategoryArgs = {
  input: ContactCategoryInput;
};


export type MutationCreateCreditNoteArgs = {
  input: CreditNoteInput;
  invoiceId: Scalars['ID'];
};


export type MutationCreateCreditRatingArgs = {
  input: CreditRatingInput;
};


export type MutationCreateCurrencyArgs = {
  input: CurrencyInput;
};


export type MutationCreateDisbursementArgs = {
  input: DisbursementInput;
};


export type MutationCreateDisbursementTypeArgs = {
  input: DisbursementTypeInput;
};


export type MutationCreateEntityArgs = {
  input: EntityInput;
};


export type MutationCreateImportAttemptArgs = {
  input: ImportAttemptInput;
};


export type MutationCreateIndustryArgs = {
  input: IndustryInput;
};


export type MutationCreateInvoiceCopyArgs = {
  id: Scalars['ID'];
};


export type MutationCreateInvoiceTemplateArgs = {
  input: InvoiceTemplateInput;
};


export type MutationCreateLegalCaseArgs = {
  input: LegalCaseInput;
};


export type MutationCreateLegalCaseDraftInvoiceArgs = {
  legalCaseId: Scalars['ID'];
};


export type MutationCreateMarketingEffortArgs = {
  input: MarketingEffortInput;
};


export type MutationCreateMarketingEffortNeedTypeArgs = {
  input: MarketingEffortNeedTypeInput;
};


export type MutationCreateMarketingEffortResponseTypeArgs = {
  input: MarketingEffortResponseTypeInput;
};


export type MutationCreateMarketingEffortTypeArgs = {
  input: MarketingEffortTypeInput;
};


export type MutationCreatePaymentTermArgs = {
  input: PaymentTermInput;
};


export type MutationCreatePerformanceTargetArgs = {
  input: PerformanceTargetInput;
};


export type MutationCreatePositionArgs = {
  input: PositionInput;
};


export type MutationCreatePracticeAreaArgs = {
  input: PracticeAreaInput;
};


export type MutationCreatePrepaymentInvoiceArgs = {
  input: InvoiceInput;
};


export type MutationCreatePriceListArgs = {
  input: PriceListInput;
};


export type MutationCreateTaskArgs = {
  input: TaskInput;
};


export type MutationCreateTeamArgs = {
  input: TeamInput;
};


export type MutationCreateTeamMembershipArgs = {
  input: TeamMembershipInput;
};


export type MutationCreateTimeCardArgs = {
  input: TimeCardInput;
};


export type MutationCreateUserArgs = {
  input: UserInput;
};


export type MutationCreateUserCostArgs = {
  input: UserCostInput;
};


export type MutationCreateUserCostTypeArgs = {
  input: UserCostTypeInput;
};


export type MutationCreateUserHourlyRateArgs = {
  input: UserHourlyRateInput;
};


export type MutationCreateUserNoteArgs = {
  input: UserNoteInput;
};


export type MutationCreateUserNoteCategoryArgs = {
  input: UserNoteCategoryInput;
};


export type MutationCreateUserRoleArgs = {
  input: UserRoleInput;
};


export type MutationCreateUserSalaryArgs = {
  input: UserSalaryInput;
};


export type MutationCreateVatPercentageArgs = {
  input: VatPercentageInput;
};


export type MutationDeleteAccountArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteClientArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteContactArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteContactCategoryArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCreditRatingArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCurrencyArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDisbursementArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDisbursementTypeArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteEntityArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteIndustryArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteInvoiceArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteInvoiceTemplateArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteLegalCaseArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteMarketingEffortArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteMarketingEffortNeedTypeArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteMarketingEffortResponseTypeArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteMarketingEffortTypeArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePaymentTermArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePerformanceTargetArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePositionArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePracticeAreaArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePriceListArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTaskArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTeamArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTeamMembershipArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTimeCardArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserApiTokenArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserCostArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserCostTypeArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserHourlyRateArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserNoteArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserNoteCategoryArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserRoleArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserSalaryArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteVatPercentageArgs = {
  id: Scalars['ID'];
};


export type MutationDisableTwoFactorArgs = {
  id: Scalars['ID'];
  input: DisableTwoFactorInput;
};


export type MutationFinishTaskArgs = {
  id: Scalars['ID'];
};


export type MutationGenerateInvoicePdfArgs = {
  id: Scalars['ID'];
  input: InvoicePdfInput;
};


export type MutationInitializeTwoFactorArgs = {
  id: Scalars['ID'];
};


export type MutationInviteUserArgs = {
  input: UserInput;
};


export type MutationLinkDisbursementsArgs = {
  ids: Array<Scalars['ID']>;
  invoiceId: Scalars['ID'];
};


export type MutationLinkTimeCardsArgs = {
  ids: Array<Scalars['ID']>;
  invoiceId: Scalars['ID'];
};


export type MutationMassCaseChangeDisbursementArgs = {
  ids: Array<Scalars['ID']>;
  input: InvoiceableCaseChangeInput;
};


export type MutationMassCaseChangeTimeCardArgs = {
  ids: Array<Scalars['ID']>;
  input: InvoiceableCaseChangeInput;
};


export type MutationMassInviteArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationPaySubscriptionInvoiceArgs = {
  id: Scalars['ID'];
};


export type MutationPostponeTaskArgs = {
  id: Scalars['ID'];
};


export type MutationRefreshInvoiceArgs = {
  id: Scalars['ID'];
};


export type MutationRefreshSubscriptionInvoicePdfArgs = {
  id: Scalars['ID'];
};


export type MutationRejectInvoiceArgs = {
  eventName: InvoiceApprovalEvent;
  id: Scalars['ID'];
};


export type MutationRejectTaskArgs = {
  id: Scalars['ID'];
};


export type MutationReportGlobalProfitabilityArgs = {
  dateFrom: Scalars['ISO8601Date'];
  dateTo: Scalars['ISO8601Date'];
};


export type MutationReportMatterStatusArgs = {
  clientId: Scalars['ID'];
};


export type MutationReportPersonalPracticeArgs = {
  dateFrom: Scalars['ISO8601Date'];
  dateTo: Scalars['ISO8601Date'];
  excludeExternals?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type MutationReportPracticeAreasArgs = {
  dateFrom: Scalars['ISO8601Date'];
  dateTo: Scalars['ISO8601Date'];
  excludeExternals?: InputMaybe<Scalars['Boolean']>;
};


export type MutationReportProfitabilityArgs = {
  dateFrom: Scalars['ISO8601Date'];
  dateTo: Scalars['ISO8601Date'];
  scopeId: Scalars['ID'];
  scopeType: Scalars['String'];
};


export type MutationReportTimeCardsByLegalCaseArgs = {
  dateFrom: Scalars['ISO8601Date'];
  dateTo: Scalars['ISO8601Date'];
  excludeExternals?: InputMaybe<Scalars['Boolean']>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationReportTotalTimeArgs = {
  dateFrom: Scalars['ISO8601Date'];
  dateTo: Scalars['ISO8601Date'];
  excludeExternals?: InputMaybe<Scalars['Boolean']>;
};


export type MutationReportUninvoicedTimeCardsArgs = {
  invoiceStates: Array<InvoiceState>;
};


export type MutationResendUserInvitationArgs = {
  id: Scalars['ID'];
};


export type MutationResetCurrentAccountDbArgs = {
  input: DbResetInput;
};


export type MutationRestoreContactCategoryArgs = {
  id: Scalars['ID'];
};


export type MutationRestoreCreditRatingArgs = {
  id: Scalars['ID'];
};


export type MutationRestoreCurrencyArgs = {
  id: Scalars['ID'];
};


export type MutationRestoreDisbursementTypeArgs = {
  id: Scalars['ID'];
};


export type MutationRestoreEntityArgs = {
  id: Scalars['ID'];
};


export type MutationRestoreIndustryArgs = {
  id: Scalars['ID'];
};


export type MutationRestoreLegalCaseArgs = {
  id: Scalars['ID'];
};


export type MutationRestoreMarketingEffortNeedTypeArgs = {
  id: Scalars['ID'];
};


export type MutationRestoreMarketingEffortResponseTypeArgs = {
  id: Scalars['ID'];
};


export type MutationRestoreMarketingEffortTypeArgs = {
  id: Scalars['ID'];
};


export type MutationRestorePaymentTermArgs = {
  id: Scalars['ID'];
};


export type MutationRestorePositionArgs = {
  id: Scalars['ID'];
};


export type MutationRestorePracticeAreaArgs = {
  id: Scalars['ID'];
};


export type MutationRestoreUserArgs = {
  id: Scalars['ID'];
};


export type MutationRestoreUserCostTypeArgs = {
  id: Scalars['ID'];
};


export type MutationRestoreUserNoteCategoryArgs = {
  id: Scalars['ID'];
};


export type MutationRestoreVatPercentageArgs = {
  id: Scalars['ID'];
};


export type MutationRevertInvoiceStateArgs = {
  id: Scalars['ID'];
};


export type MutationScheduleImportAttemptArgs = {
  id: Scalars['ID'];
};


export type MutationStartTaskArgs = {
  id: Scalars['ID'];
};


export type MutationStateSwitchArgs = {
  eventName: InvoiceEvent;
  id: Scalars['ID'];
  input: InvoiceStateChangeInput;
};


export type MutationSwitchDefaultPriceListArgs = {
  default: Scalars['Boolean'];
  id: Scalars['ID'];
};


export type MutationSwitchPaymentTypeArgs = {
  id: Scalars['ID'];
  input: SwitchPaymentTypeInput;
};


export type MutationToReviewTaskArgs = {
  id: Scalars['ID'];
};


export type MutationUnlinkDisbursementArgs = {
  id: Scalars['ID'];
};


export type MutationUnlinkTimeCardArgs = {
  id: Scalars['ID'];
};


export type MutationUnlockUserArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateAccountSubscriptionSettingsArgs = {
  input: AccountSubscriptionSettingsInput;
};


export type MutationUpdateCalendarArgs = {
  id: Scalars['ID'];
  input: CalendarInput;
};


export type MutationUpdateClientArgs = {
  id: Scalars['ID'];
  input: ClientInput;
};


export type MutationUpdateContactArgs = {
  id: Scalars['ID'];
  input: ContactInput;
};


export type MutationUpdateContactCategoryArgs = {
  id: Scalars['ID'];
  input: ContactCategoryInput;
};


export type MutationUpdateCreditRatingArgs = {
  id: Scalars['ID'];
  input: CreditRatingInput;
};


export type MutationUpdateCurrencyArgs = {
  id: Scalars['ID'];
  input: CurrencyInput;
};


export type MutationUpdateCurrentAccountSettingsArgs = {
  input: AccountSettingsInput;
};


export type MutationUpdateDisbursementArgs = {
  id: Scalars['ID'];
  input: DisbursementInput;
};


export type MutationUpdateDisbursementTypeArgs = {
  id: Scalars['ID'];
  input: DisbursementTypeInput;
};


export type MutationUpdateEntityArgs = {
  id: Scalars['ID'];
  input: EntityInput;
};


export type MutationUpdateIndustryArgs = {
  id: Scalars['ID'];
  input: IndustryInput;
};


export type MutationUpdateInvoiceArgs = {
  id: Scalars['ID'];
  input: InvoiceInput;
};


export type MutationUpdateInvoiceTemplateArgs = {
  id: Scalars['ID'];
  input: InvoiceTemplateInput;
};


export type MutationUpdateLegalCaseArgs = {
  id: Scalars['ID'];
  input: LegalCaseInput;
};


export type MutationUpdateMarketingEffortArgs = {
  id: Scalars['ID'];
  input: MarketingEffortInput;
};


export type MutationUpdateMarketingEffortNeedTypeArgs = {
  id: Scalars['ID'];
  input: MarketingEffortNeedTypeInput;
};


export type MutationUpdateMarketingEffortResponseTypeArgs = {
  id: Scalars['ID'];
  input: MarketingEffortResponseTypeInput;
};


export type MutationUpdateMarketingEffortTypeArgs = {
  id: Scalars['ID'];
  input: MarketingEffortTypeInput;
};


export type MutationUpdateNotificationConfigurationArgs = {
  input: NotificationConfigurationInput;
  kind: NotificationKind;
};


export type MutationUpdatePaymentTermArgs = {
  id: Scalars['ID'];
  input: PaymentTermInput;
};


export type MutationUpdatePerformanceTargetArgs = {
  id: Scalars['ID'];
  input: PerformanceTargetInput;
};


export type MutationUpdatePositionArgs = {
  id: Scalars['ID'];
  input: PositionInput;
};


export type MutationUpdatePracticeAreaArgs = {
  id: Scalars['ID'];
  input: PracticeAreaInput;
};


export type MutationUpdatePriceListArgs = {
  id: Scalars['ID'];
  input: PriceListInput;
};


export type MutationUpdateTaskArgs = {
  id: Scalars['ID'];
  input: TaskInput;
};


export type MutationUpdateTeamArgs = {
  id: Scalars['ID'];
  input: TeamInput;
};


export type MutationUpdateTeamMembershipArgs = {
  id: Scalars['ID'];
  input: TeamMembershipInput;
};


export type MutationUpdateTimeCardArgs = {
  id: Scalars['ID'];
  input: TimeCardInput;
};


export type MutationUpdateUserArgs = {
  id: Scalars['ID'];
  input: UserInput;
};


export type MutationUpdateUserCostArgs = {
  id: Scalars['ID'];
  input: UserCostInput;
};


export type MutationUpdateUserCostTypeArgs = {
  id: Scalars['ID'];
  input: UserCostTypeInput;
};


export type MutationUpdateUserHourlyRateArgs = {
  id: Scalars['ID'];
  input: UserHourlyRateInput;
};


export type MutationUpdateUserNoteArgs = {
  id: Scalars['ID'];
  input: UserNoteInput;
};


export type MutationUpdateUserNoteCategoryArgs = {
  id: Scalars['ID'];
  input: UserNoteCategoryInput;
};


export type MutationUpdateUserRoleArgs = {
  id: Scalars['ID'];
  input: UserRoleInput;
};


export type MutationUpdateUserSalaryArgs = {
  id: Scalars['ID'];
  input: UserSalaryInput;
};


export type MutationUpdateVatPercentageArgs = {
  id: Scalars['ID'];
  input: VatPercentageInput;
};


export type MutationValidateTwoFactorArgs = {
  id: Scalars['ID'];
  input: ValidateTwoFactorInput;
};

/** Notable type */
export enum Notable {
  /** Client */
  Client = 'Client',
  /** Contact */
  Contact = 'Contact',
  /** Invoice */
  Invoice = 'Invoice',
  /** Case */
  LegalCase = 'LegalCase',
  /** Task */
  Task = 'Task'
}

export type Notification = {
  __typename?: 'Notification';
  clearedAt: Scalars['ISO8601DateTime'];
  createdAt: Scalars['ISO8601DateTime'];
  deliveryMethod: NotificationDeliveryMethod;
  id: Scalars['ID'];
  kind: NotificationKind;
  relatedId?: Maybe<Scalars['ID']>;
  relatedType?: Maybe<NotificationRelatedType>;
  seenAt?: Maybe<Scalars['ISO8601DateTime']>;
  translationData?: Maybe<Scalars['JSON']>;
  translationKey?: Maybe<Scalars['String']>;
};

export type NotificationConfiguration = {
  __typename?: 'NotificationConfiguration';
  emailBodyTranslations: Scalars['JSON'];
  emailSubjectTranslations: Scalars['JSON'];
  id?: Maybe<Scalars['ID']>;
  kind?: Maybe<NotificationKind>;
};

export type NotificationConfigurationInput = {
  emailBodyTranslations?: InputMaybe<Scalars['JSON']>;
  emailSubjectTranslations?: InputMaybe<Scalars['JSON']>;
};

/** The connection type for Notification. */
export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NotificationEdge>>>;
  /** A list of nodes. */
  nodes: Array<Notification>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum NotificationDeliveryMethod {
  Email = 'email',
  System = 'system'
}

export enum NotificationDeliveryPreference {
  Both = 'both',
  Email = 'email',
  None = 'none',
  System = 'system'
}

/** An edge in a connection. */
export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Notification;
};

export type NotificationFilterInput = {
  clearedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  createdAtFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  deliveryMethod?: InputMaybe<NotificationDeliveryMethod>;
};

export enum NotificationKind {
  BadDebtInvoice = 'bad_debt_invoice',
  ClientOwner = 'client_owner',
  ClientOwnershipChange = 'client_ownership_change',
  InvoiceReviewRequest = 'invoice_review_request',
  LegalCaseConnectedLawyer = 'legal_case_connected_lawyer',
  LegalCaseCostCap = 'legal_case_cost_cap',
  LegalCaseDeadline = 'legal_case_deadline',
  LegalCaseManager = 'legal_case_manager',
  LegalCaseOwner = 'legal_case_owner',
  LegalCaseOwnershipChange = 'legal_case_ownership_change',
  OutdatedAml = 'outdated_aml',
  ScheduledReportTotalTime = 'scheduled_report_total_time',
  SubscriptionsEndOfTrial = 'subscriptions_end_of_trial',
  SubscriptionsGoodbye = 'subscriptions_goodbye',
  SubscriptionsPaymentFailed = 'subscriptions_payment_failed',
  SubscriptionsWelcome = 'subscriptions_welcome',
  UninvoicedClient = 'uninvoiced_client',
  UnpaidInvoice = 'unpaid_invoice',
  UnpaidInvoiceInternal = 'unpaid_invoice_internal'
}

export enum NotificationRelatedType {
  Client = 'Client',
  Invoice = 'Invoice',
  LegalCase = 'LegalCase'
}

export type OwnerInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  ownershipPercentage: Scalars['Int'];
  userId: Scalars['ID'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PaymentTerm = {
  __typename?: 'PaymentTerm';
  createdAt: Scalars['ISO8601Date'];
  days: Scalars['Int'];
  discardedAt?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  updatedAt: Scalars['ISO8601Date'];
};

/** The connection type for PaymentTerm. */
export type PaymentTermConnection = {
  __typename?: 'PaymentTermConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PaymentTermEdge>>>;
  /** A list of nodes. */
  nodes: Array<PaymentTerm>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type PaymentTermEdge = {
  __typename?: 'PaymentTermEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PaymentTerm;
};

export type PaymentTermInput = {
  days: Scalars['Int'];
};

/** Client Invoicing Payment Types */
export enum PaymentType {
  /** Fixed */
  Fixed = 'fixed',
  /** Hourly Fee */
  HourlyFee = 'hourly_fee'
}

export type PerformanceTarget = {
  __typename?: 'PerformanceTarget';
  formattedTimeCardMinutes?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  periodFromDate: Scalars['ISO8601Date'];
  periodToDate: Scalars['ISO8601Date'];
  timeCardMinutes?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
};

/** The connection type for PerformanceTarget. */
export type PerformanceTargetConnection = {
  __typename?: 'PerformanceTargetConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PerformanceTargetEdge>>>;
  /** A list of nodes. */
  nodes: Array<PerformanceTarget>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type PerformanceTargetEdge = {
  __typename?: 'PerformanceTargetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceTarget;
};

export type PerformanceTargetFilterInput = {
  userId?: InputMaybe<Array<Scalars['ID']>>;
};

export type PerformanceTargetInput = {
  periodFromDate?: InputMaybe<Scalars['ISO8601Date']>;
  periodToDate?: InputMaybe<Scalars['ISO8601Date']>;
  timeCardMinutes?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type Position = {
  __typename?: 'Position';
  altNameTranslations: Scalars['JSON'];
  createdAt: Scalars['ISO8601Date'];
  discardedAt?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  isLawyer: Scalars['Boolean'];
  name: Scalars['String'];
  nameWithoutFallback: Scalars['String'];
  sequence?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601Date'];
};

/** The connection type for Position. */
export type PositionConnection = {
  __typename?: 'PositionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PositionEdge>>>;
  maximumPositionSequence: Scalars['Int'];
  /** A list of nodes. */
  nodes: Array<Position>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type PositionEdge = {
  __typename?: 'PositionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Position;
};

export type PositionFilterInput = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<Array<PositionFilterInput>>;
};

export type PositionInput = {
  altNameTranslations?: InputMaybe<Scalars['JSON']>;
  isLawyer: Scalars['Boolean'];
  name: Scalars['String'];
  sequence?: InputMaybe<Scalars['Int']>;
};

export type PracticeArea = {
  __typename?: 'PracticeArea';
  altNameTranslations: Scalars['JSON'];
  createdAt: Scalars['ISO8601Date'];
  discardedAt?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  nameWithoutFallback: Scalars['String'];
  updatedAt: Scalars['ISO8601Date'];
};

/** The connection type for PracticeArea. */
export type PracticeAreaConnection = {
  __typename?: 'PracticeAreaConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PracticeAreaEdge>>>;
  /** A list of nodes. */
  nodes: Array<PracticeArea>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type PracticeAreaEdge = {
  __typename?: 'PracticeAreaEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PracticeArea;
};

export type PracticeAreaFilterInput = {
  id?: InputMaybe<Array<Scalars['ID']>>;
};

export type PracticeAreaInput = {
  altNameTranslations?: InputMaybe<Scalars['JSON']>;
  name: Scalars['String'];
};

export type PriceList = {
  __typename?: 'PriceList';
  default: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  priceListRates: Array<Maybe<PriceListRate>>;
};

/** The connection type for PriceList. */
export type PriceListConnection = {
  __typename?: 'PriceListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PriceListEdge>>>;
  /** A list of nodes. */
  nodes: Array<PriceList>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type PriceListEdge = {
  __typename?: 'PriceListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PriceList;
};

export type PriceListFilterInput = {
  customRecordId?: InputMaybe<Array<Scalars['ID']>>;
  default?: InputMaybe<Scalars['Boolean']>;
};

export type PriceListInput = {
  default?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  priceListRatesAttributes?: InputMaybe<Array<PriceListRateInput>>;
};

export type PriceListRate = {
  __typename?: 'PriceListRate';
  currency?: Maybe<Currency>;
  id?: Maybe<Scalars['ID']>;
  priceList?: Maybe<PriceList>;
  priced?: Maybe<Priced>;
  pricedType: Scalars['String'];
  rate?: Maybe<Scalars['Float']>;
};

/** The connection type for PriceListRate. */
export type PriceListRateConnection = {
  __typename?: 'PriceListRateConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PriceListRateEdge>>>;
  /** A list of nodes. */
  nodes: Array<PriceListRate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type PriceListRateEdge = {
  __typename?: 'PriceListRateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PriceListRate;
};

export type PriceListRateFilterInput = {
  currencyId: Scalars['ID'];
  priceListId: Scalars['ID'];
};

export type PriceListRateInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  currencyId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  pricedId: Scalars['ID'];
  pricedType: Scalars['String'];
  rate?: InputMaybe<Scalars['Float']>;
};

export type Priced = {
  __typename?: 'Priced';
  id: Scalars['ID'];
  name: Scalars['String'];
  positionName?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['Int']>;
};

export type ProfitabilityInvoice = {
  __typename?: 'ProfitabilityInvoice';
  invoice: Invoice;
  totalValue: Scalars['Float'];
};

export type ProfitabilityResult = {
  __typename?: 'ProfitabilityResult';
  currency?: Maybe<Currency>;
  invoices: Array<ProfitabilityInvoice>;
  profitability: Scalars['Float'];
  revenue: Scalars['Float'];
  rows: Array<ProfitabilityRow>;
  totalDirectCost: Scalars['Float'];
  totalIndirectCost: Scalars['Float'];
};

export type ProfitabilityRow = {
  __typename?: 'ProfitabilityRow';
  directCost: Scalars['Float'];
  indirectCost: Scalars['Float'];
  invoicedMinutes: Scalars['Int'];
  missingCostData: Scalars['Boolean'];
  profitability: Scalars['Float'];
  revenue: Scalars['Float'];
  totalRow: Scalars['Boolean'];
  user?: Maybe<User>;
};

export type Query = {
  __typename?: 'Query';
  abilities: Array<AbilityRule>;
  account: Account;
  accountSubscriptionSettings: AccountSubscriptionSettings;
  accounts: AccountConnection;
  /** Ask a natural-language question; the assistant queries the database and returns Markdown text plus any charts it rendered. */
  askAi: AiAnswer;
  auditEvents: AuditEventConnection;
  client: Client;
  clientOwner: ClientOwner;
  clientOwners: ClientOwnerConnection;
  clientPresence: Scalars['Boolean'];
  clientProfitability: ProfitabilityResult;
  clients: ClientConnection;
  contact: Contact;
  contactCategories: ContactCategoryConnection;
  contactCategory: ContactCategory;
  contactPresence: Scalars['Boolean'];
  contacts: ContactConnection;
  creditRating: CreditRating;
  creditRatings: CreditRatingConnection;
  currencies: CurrencyConnection;
  currency: Currency;
  currentAccount: Account;
  currentRelease: Scalars['String'];
  currentUser: User;
  currentUserUnseenNotificationsCount: Scalars['Int'];
  disbursement: Disbursement;
  disbursementType: DisbursementType;
  disbursementTypes: DisbursementTypeConnection;
  disbursements: DisbursementConnection;
  entities: EntityConnection;
  entity: Entity;
  globalSearch: Array<GlobalSearchResult>;
  importAttempt: ImportAttempt;
  importAttemptSample?: Maybe<Scalars['String']>;
  importAttempts: ImportAttemptConnection;
  industries: IndustryConnection;
  industry: Industry;
  invoice: Invoice;
  invoiceTemplate: InvoiceTemplate;
  invoiceTemplates: InvoiceTemplateConnection;
  invoices: InvoiceConnection;
  legalCase: LegalCase;
  legalCaseOwner: LegalCaseOwner;
  legalCaseOwners: LegalCaseOwnerConnection;
  legalCaseProfitability: ProfitabilityResult;
  legalCases: LegalCaseConnection;
  marketingEffort: MarketingEffort;
  marketingEffortNeedType: MarketingEffortNeedType;
  marketingEffortNeedTypes: MarketingEffortNeedTypeConnection;
  marketingEffortResponseType: MarketingEffortResponseType;
  marketingEffortResponseTypes: MarketingEffortResponseTypeConnection;
  marketingEffortType: MarketingEffortType;
  marketingEffortTypes: MarketingEffortTypeConnection;
  marketingEfforts: MarketingEffortConnection;
  monthlyUserEstimateInfo: MonthlyUserEstimateInfo;
  notificationConfiguration: NotificationConfiguration;
  notifications: NotificationConnection;
  paymentTerm: PaymentTerm;
  paymentTerms: PaymentTermConnection;
  performanceTarget: PerformanceTarget;
  performanceTargets: PerformanceTargetConnection;
  position: Position;
  positions: PositionConnection;
  practiceArea: PracticeArea;
  practiceAreas: PracticeAreaConnection;
  priceList: PriceList;
  priceListRate: PriceListRate;
  priceListRates: PriceListRateConnection;
  priceLists: PriceListConnection;
  recentUserCases: LegalCaseConnection;
  reportExport: ReportExport;
  subscriptionCommitments: SubscriptionCommitmentConnection;
  subscriptionInfo: SubscriptionInfo;
  subscriptionInvoices: SubscriptionInvoiceConnection;
  task: Task;
  tasks: TaskConnection;
  team: Team;
  teamMembership: TeamMembership;
  teamMemberships: TeamMembershipConnection;
  teams: TeamConnection;
  timeCard: TimeCard;
  timeCards: TimeCardConnection;
  timeZones: Array<TimeZone>;
  user: User;
  userApiToken: UserApiToken;
  userApiTokens: UserApiTokenConnection;
  userCost: UserCost;
  userCostType: UserCostType;
  userCostTypes: UserCostTypeConnection;
  userCosts: UserCostConnection;
  userHourlyRate: UserHourlyRate;
  userHourlyRates: UserHourlyRateConnection;
  userNote: UserNote;
  userNoteCategories: UserNoteCategoryConnection;
  userNoteCategory: UserNoteCategory;
  userNotes: UserNoteConnection;
  userRole: UserRole;
  userRoles: UserRoleConnection;
  userSalaries: UserSalaryConnection;
  userSalary: UserSalary;
  users: UserConnection;
  vatPercentage: VatPercentage;
  vatPercentages: VatPercentageConnection;
};


export type QueryAccountArgs = {
  id: Scalars['ID'];
};


export type QueryAccountsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryAskAiArgs = {
  question: Scalars['String'];
};


export type QueryAuditEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  auditableId: Scalars['ID'];
  auditableType: AuditableType;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AuditEventFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
};


export type QueryClientArgs = {
  id: Scalars['ID'];
};


export type QueryClientOwnerArgs = {
  id: Scalars['ID'];
};


export type QueryClientOwnersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryClientPresenceArgs = {
  filter?: InputMaybe<ClientFilterInput>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryClientProfitabilityArgs = {
  clientId: Scalars['ID'];
  dateFrom: Scalars['ISO8601Date'];
  dateTo: Scalars['ISO8601Date'];
  invoiceFilter?: InputMaybe<Scalars['String']>;
};


export type QueryClientsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ClientFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryContactArgs = {
  id: Scalars['ID'];
};


export type QueryContactCategoriesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryContactCategoryArgs = {
  id: Scalars['ID'];
};


export type QueryContactPresenceArgs = {
  filter?: InputMaybe<ContactFilterInput>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryContactsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ContactFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryCreditRatingArgs = {
  id: Scalars['ID'];
};


export type QueryCreditRatingsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryCurrenciesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryCurrencyArgs = {
  id: Scalars['ID'];
};


export type QueryDisbursementArgs = {
  id: Scalars['ID'];
};


export type QueryDisbursementTypeArgs = {
  id: Scalars['ID'];
};


export type QueryDisbursementTypesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryDisbursementsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DisbursementFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryEntitiesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryEntityArgs = {
  id: Scalars['ID'];
};


export type QueryGlobalSearchArgs = {
  q: Scalars['String'];
  recordTypes?: InputMaybe<Array<GlobalSearchRecord>>;
};


export type QueryImportAttemptArgs = {
  id: Scalars['ID'];
};


export type QueryImportAttemptSampleArgs = {
  destination: ImportAttemptDestination;
};


export type QueryImportAttemptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ImportAttemptFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryIndustriesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryIndustryArgs = {
  id: Scalars['ID'];
};


export type QueryInvoiceArgs = {
  id: Scalars['ID'];
};


export type QueryInvoiceTemplateArgs = {
  id: Scalars['ID'];
};


export type QueryInvoiceTemplatesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<InvoiceTemplateFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryInvoicesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<InvoiceFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryLegalCaseArgs = {
  id: Scalars['ID'];
};


export type QueryLegalCaseOwnerArgs = {
  id: Scalars['ID'];
};


export type QueryLegalCaseOwnersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryLegalCaseProfitabilityArgs = {
  dateFrom: Scalars['ISO8601Date'];
  dateTo: Scalars['ISO8601Date'];
  invoiceFilter?: InputMaybe<Scalars['String']>;
  legalCaseId: Scalars['ID'];
};


export type QueryLegalCasesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LegalCaseFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryMarketingEffortArgs = {
  id: Scalars['ID'];
};


export type QueryMarketingEffortNeedTypeArgs = {
  id: Scalars['ID'];
};


export type QueryMarketingEffortNeedTypesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryMarketingEffortResponseTypeArgs = {
  id: Scalars['ID'];
};


export type QueryMarketingEffortResponseTypesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryMarketingEffortTypeArgs = {
  id: Scalars['ID'];
};


export type QueryMarketingEffortTypesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryMarketingEffortsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MarketingEffortFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryNotificationConfigurationArgs = {
  kind: NotificationKind;
};


export type QueryNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<NotificationFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
};


export type QueryPaymentTermArgs = {
  id: Scalars['ID'];
};


export type QueryPaymentTermsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryPerformanceTargetArgs = {
  id: Scalars['ID'];
};


export type QueryPerformanceTargetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PerformanceTargetFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryPositionArgs = {
  id: Scalars['ID'];
};


export type QueryPositionsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PositionFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryPracticeAreaArgs = {
  id: Scalars['ID'];
};


export type QueryPracticeAreasArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PracticeAreaFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryPriceListArgs = {
  id: Scalars['ID'];
};


export type QueryPriceListRateArgs = {
  id: Scalars['ID'];
};


export type QueryPriceListRatesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PriceListRateFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryPriceListsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PriceListFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryRecentUserCasesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryReportExportArgs = {
  id: Scalars['ID'];
};


export type QuerySubscriptionCommitmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QuerySubscriptionInvoicesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryTaskArgs = {
  id: Scalars['ID'];
};


export type QueryTasksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TaskFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryTeamArgs = {
  id: Scalars['ID'];
};


export type QueryTeamMembershipArgs = {
  id: Scalars['ID'];
};


export type QueryTeamMembershipsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TeamMembershipFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryTeamsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryTimeCardArgs = {
  id: Scalars['ID'];
};


export type QueryTimeCardsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TimeCardFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryUserApiTokenArgs = {
  id: Scalars['ID'];
};


export type QueryUserApiTokensArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserApiTokenFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryUserCostArgs = {
  id: Scalars['ID'];
};


export type QueryUserCostTypeArgs = {
  id: Scalars['ID'];
};


export type QueryUserCostTypesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryUserCostsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserCostFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryUserHourlyRateArgs = {
  id: Scalars['ID'];
};


export type QueryUserHourlyRatesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserHourlyRateFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryUserNoteArgs = {
  id: Scalars['ID'];
};


export type QueryUserNoteCategoriesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserNoteCategoryFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryUserNoteCategoryArgs = {
  id: Scalars['ID'];
};


export type QueryUserNotesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserNoteFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryUserRoleArgs = {
  id: Scalars['ID'];
};


export type QueryUserRolesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryUserSalariesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserSalaryFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryUserSalaryArgs = {
  id: Scalars['ID'];
};


export type QueryUsersArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryVatPercentageArgs = {
  id: Scalars['ID'];
};


export type QueryVatPercentagesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};

export type ReportExport = {
  __typename?: 'ReportExport';
  completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  errorMessage?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  kind: Scalars['String'];
  state: Scalars['String'];
};

export enum ReportFrequencyEnum {
  /** Daily - report sent every day */
  Daily = 'daily',
  /** Disabled - report will not be sent */
  Disabled = 'disabled',
  /** Monthly - report sent every month */
  Monthly = 'monthly',
  /** Weekly - report sent every week */
  Weekly = 'weekly'
}

export type ReportSchedule = {
  __typename?: 'ReportSchedule';
  dayOfMonth?: Maybe<Scalars['Int']>;
  dayOfWeek?: Maybe<Scalars['Int']>;
  excludeExternals?: Maybe<Scalars['Boolean']>;
  frequency: ReportFrequencyEnum;
  lastSentAt?: Maybe<Scalars['ISO8601DateTime']>;
  reportType: ReportTypeEnum;
};

export type ReportScheduleInput = {
  dayOfMonth?: InputMaybe<Scalars['Int']>;
  dayOfWeek?: InputMaybe<Scalars['Int']>;
  excludeExternals?: InputMaybe<Scalars['Boolean']>;
  frequency: ReportFrequencyEnum;
  lastSentAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  reportType: ReportTypeEnum;
};

export enum ReportTypeEnum {
  /** Invoice Summary Report */
  InvoiceSummary = 'invoice_summary',
  /** Total Time Report */
  TotalTime = 'total_time'
}

export type StripeCard = {
  __typename?: 'StripeCard';
  cardNumber?: Maybe<Scalars['String']>;
  expiration?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  ownerName?: Maybe<Scalars['String']>;
};

export type StripeCardInitParams = {
  __typename?: 'StripeCardInitParams';
  callbackPath: Scalars['String'];
  intentSecret?: Maybe<Scalars['String']>;
};

export type StripePaymentResult = {
  __typename?: 'StripePaymentResult';
  paymentSecret?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  subscriptionPaymentId?: Maybe<Scalars['ID']>;
};

export type SubscriptionCommitment = {
  __typename?: 'SubscriptionCommitment';
  currency?: Maybe<Scalars['String']>;
  fromDate?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  priceExVat: Scalars['Float'];
  tillDate?: Maybe<Scalars['ISO8601Date']>;
};

/** The connection type for SubscriptionCommitment. */
export type SubscriptionCommitmentConnection = {
  __typename?: 'SubscriptionCommitmentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SubscriptionCommitmentEdge>>>;
  /** A list of nodes. */
  nodes: Array<SubscriptionCommitment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type SubscriptionCommitmentEdge = {
  __typename?: 'SubscriptionCommitmentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: SubscriptionCommitment;
};

export type SubscriptionInfo = {
  __typename?: 'SubscriptionInfo';
  card?: Maybe<StripeCard>;
  currentCurrency: Scalars['String'];
  currentIntervalTillDate?: Maybe<Scalars['ISO8601Date']>;
  currentUserDayPrice: Scalars['Float'];
  currentUserMonthPrice: Scalars['Float'];
  currentUserMonthPriceLongTermCommitment: Scalars['Float'];
  id: Scalars['ID'];
  terminationDate?: Maybe<Scalars['ISO8601Date']>;
  upcomingInvoice: SubscriptionUpcomingInvoice;
};

export type SubscriptionInvoice = {
  __typename?: 'SubscriptionInvoice';
  currency: Scalars['String'];
  date: Scalars['ISO8601Date'];
  description: Scalars['String'];
  dueDate?: Maybe<Scalars['ISO8601Date']>;
  grossAmount: Scalars['Float'];
  id: Scalars['ID'];
  number: Scalars['String'];
  paidAt?: Maybe<Scalars['ISO8601Date']>;
  paymentError?: Maybe<Scalars['String']>;
  printoutPdfUrl?: Maybe<Scalars['String']>;
  state: SubscriptionInvoiceState;
};

/** The connection type for SubscriptionInvoice. */
export type SubscriptionInvoiceConnection = {
  __typename?: 'SubscriptionInvoiceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SubscriptionInvoiceEdge>>>;
  /** A list of nodes. */
  nodes: Array<SubscriptionInvoice>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type SubscriptionInvoiceEdge = {
  __typename?: 'SubscriptionInvoiceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: SubscriptionInvoice;
};

/** Subscription Invoice States */
export enum SubscriptionInvoiceState {
  /** overdue */
  Overdue = 'overdue',
  /** paid */
  Paid = 'paid',
  /** unpaid */
  Unpaid = 'unpaid'
}

export type SubscriptionPayInvoiceResponse = {
  __typename?: 'SubscriptionPayInvoiceResponse';
  invoice: SubscriptionInvoice;
  paymentResult: StripePaymentResult;
};

/** Subscription Plans */
export enum SubscriptionPlan {
  /** Daily */
  Daily = 'daily',
  /** Monthly */
  Monthly = 'monthly'
}

export type SubscriptionUpcomingInvoice = {
  __typename?: 'SubscriptionUpcomingInvoice';
  applicableCommitments: Array<SubscriptionCommitment>;
  correctionAmount: Scalars['Float'];
  currency: Scalars['String'];
  dailyCount: Scalars['Int'];
  dailyIntervalText?: Maybe<Scalars['String']>;
  dailyNetAmount: Scalars['Float'];
  grossAmount: Scalars['Float'];
  id: Scalars['ID'];
  monthlyCount: Scalars['Int'];
  monthlyIntervalText?: Maybe<Scalars['String']>;
  monthlyNetAmount: Scalars['Float'];
  netAmount: Scalars['Float'];
  userDayPrice: Scalars['Float'];
  userMonthPrice: Scalars['Float'];
  vatAmount: Scalars['Float'];
  vatPercentage: Scalars['Int'];
  willTryPayAt?: Maybe<Scalars['ISO8601Date']>;
};

export type SwitchPaymentTypeInput = {
  paymentType: PaymentType;
};

export type Task = {
  __typename?: 'Task';
  assignee: User;
  author: User;
  client?: Maybe<Client>;
  description: Scalars['String'];
  dueDate: Scalars['ISO8601Date'];
  id: Scalars['ID'];
  legalCase?: Maybe<LegalCase>;
  needsApproval: Scalars['Boolean'];
  personal: Scalars['Boolean'];
  priority: TaskPriority;
  state: TaskState;
  team?: Maybe<Team>;
  title: Scalars['String'];
};

/** The connection type for Task. */
export type TaskConnection = {
  __typename?: 'TaskConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TaskEdge>>>;
  /** A list of nodes. */
  nodes: Array<Task>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type TaskEdge = {
  __typename?: 'TaskEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Task;
};

export type TaskFilterInput = {
  assigneeId?: InputMaybe<Array<Scalars['ID']>>;
  authorId?: InputMaybe<Array<Scalars['ID']>>;
  dueDateFrom?: InputMaybe<Scalars['ISO8601Date']>;
  dueDateTo?: InputMaybe<Scalars['ISO8601Date']>;
  not?: InputMaybe<Array<TaskFilterInput>>;
  priority?: InputMaybe<Array<TaskPriority>>;
  state?: InputMaybe<Array<TaskState>>;
  teamId?: InputMaybe<Array<Scalars['ID']>>;
};

export type TaskInput = {
  assigneeId?: InputMaybe<Scalars['ID']>;
  authorId?: InputMaybe<Scalars['ID']>;
  clientId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  dueDate: Scalars['ISO8601Date'];
  legalCaseId?: InputMaybe<Scalars['ID']>;
  needsApproval: Scalars['Boolean'];
  personal: Scalars['Boolean'];
  priority: TaskPriority;
  teamId?: InputMaybe<Scalars['ID']>;
  title: Scalars['String'];
};

/** Task Priorities */
export enum TaskPriority {
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

/** Task States */
export enum TaskState {
  Canceled = 'canceled',
  Done = 'done',
  InProgress = 'in_progress',
  InReview = 'in_review',
  Todo = 'todo'
}

export type Team = {
  __typename?: 'Team';
  altNameTranslations: Scalars['JSON'];
  id: Scalars['ID'];
  name: Scalars['String'];
  nameWithoutFallback: Scalars['String'];
  supervisor?: Maybe<User>;
  teamMembers: Array<Maybe<User>>;
  teamMembersCount: Scalars['Int'];
};

/** The connection type for Team. */
export type TeamConnection = {
  __typename?: 'TeamConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TeamEdge>>>;
  /** A list of nodes. */
  nodes: Array<Team>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type TeamEdge = {
  __typename?: 'TeamEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Team;
};

export type TeamInput = {
  altNameTranslations?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  supervisorId?: InputMaybe<Scalars['ID']>;
};

export type TeamMembership = {
  __typename?: 'TeamMembership';
  id: Scalars['ID'];
  supervisor?: Maybe<User>;
  team?: Maybe<Team>;
  teamId?: Maybe<Scalars['ID']>;
  user?: Maybe<User>;
};

/** The connection type for TeamMembership. */
export type TeamMembershipConnection = {
  __typename?: 'TeamMembershipConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TeamMembershipEdge>>>;
  /** A list of nodes. */
  nodes: Array<TeamMembership>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
  xlsxExport: XlsxExport;
};

/** An edge in a connection. */
export type TeamMembershipEdge = {
  __typename?: 'TeamMembershipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TeamMembership;
};

export type TeamMembershipFilterInput = {
  teamId?: InputMaybe<Scalars['ID']>;
  user?: InputMaybe<UserFilterInput>;
};

export type TeamMembershipInput = {
  id?: InputMaybe<Scalars['ID']>;
  supervisorId?: InputMaybe<Scalars['ID']>;
  teamId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type TimeCard = {
  __typename?: 'TimeCard';
  client?: Maybe<Client>;
  description: Scalars['String'];
  formattedMinutesSpent: Scalars['String'];
  id: Scalars['ID'];
  legalCase?: Maybe<LegalCase>;
  minutesSpent?: Maybe<Scalars['Int']>;
  onDate?: Maybe<Scalars['ISO8601Date']>;
  owner?: Maybe<User>;
  state?: Maybe<TimeCardState>;
};

/** The connection type for TimeCard. */
export type TimeCardConnection = {
  __typename?: 'TimeCardConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TimeCardEdge>>>;
  /** A list of nodes. */
  nodes: Array<TimeCard>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
  xlsxExport: XlsxExport;
};

/** An edge in a connection. */
export type TimeCardEdge = {
  __typename?: 'TimeCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TimeCard;
};

export type TimeCardFilterInput = {
  client?: InputMaybe<ClientFilterInput>;
  invoiceId?: InputMaybe<Scalars['ID']>;
  legalCase?: InputMaybe<LegalCaseFilterInput>;
  legalCaseId?: InputMaybe<Array<Scalars['ID']>>;
  onDate?: InputMaybe<Scalars['ISO8601Date']>;
  onDateFrom?: InputMaybe<Scalars['ISO8601Date']>;
  onDateTo?: InputMaybe<Scalars['ISO8601Date']>;
  ownerId?: InputMaybe<Array<Scalars['ID']>>;
  state?: InputMaybe<Scalars['String']>;
};

export type TimeCardInput = {
  auditComment?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  invoiceId?: InputMaybe<Scalars['ID']>;
  legalCaseId?: InputMaybe<Scalars['ID']>;
  minutesSpent?: InputMaybe<Scalars['Int']>;
  onDate?: InputMaybe<Scalars['ISO8601Date']>;
  ownerId?: InputMaybe<Scalars['ID']>;
  state?: InputMaybe<TimeCardState>;
};

/** Time Card States */
export enum TimeCardState {
  /** invoiced */
  Invoiced = 'invoiced',
  /** new */
  New = 'new',
  /** non_billable */
  NonBillable = 'non_billable'
}

/** Time format */
export enum TimeFormat {
  /** Decimal */
  Decimal = 'decimal',
  /** With label */
  HhMmWithLabel = 'hh_mm_with_label',
  /** With seperator */
  HhMmWithSeperator = 'hh_mm_with_seperator'
}

export type TimeZone = {
  __typename?: 'TimeZone';
  canonicalName: Scalars['String'];
  id: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  accessLocked: Scalars['Boolean'];
  admin?: Maybe<Scalars['Boolean']>;
  altFirstNameTranslations: Scalars['JSON'];
  altLastNameTranslations: Scalars['JSON'];
  backgroundPictureUrl?: Maybe<Scalars['String']>;
  backgroundPictureVariant?: Maybe<Scalars['String']>;
  calendarEvents: Array<CalendarEvent>;
  calendars: Array<Calendar>;
  clockTimeZones: Array<TimeZone>;
  configuredCalendarProviders: Array<CalendarProvider>;
  current: Scalars['Boolean'];
  currentPerformanceTargetTimeCardMinutesPerDay?: Maybe<Scalars['Int']>;
  dateOfBirth?: Maybe<Scalars['ISO8601Date']>;
  discardedAt?: Maybe<Scalars['ISO8601Date']>;
  email?: Maybe<Scalars['String']>;
  employmentType: EmploymentType;
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  iconPack?: Maybe<IconPack>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  lastWorkingDay?: Maybe<Scalars['ISO8601Date']>;
  linkedinProfileUrl?: Maybe<Scalars['String']>;
  minutesSpentThisMonth?: Maybe<Scalars['Int']>;
  minutesSpentToday?: Maybe<Scalars['Int']>;
  notifyBadDebtInvoiceVia: NotificationDeliveryPreference;
  notifyClientOwnerVia: NotificationDeliveryPreference;
  notifyClientOwnershipChangeVia: NotificationDeliveryPreference;
  notifyInvoiceReviewRequestVia: NotificationDeliveryPreference;
  notifyLegalCaseConnectedLawyerVia: NotificationDeliveryPreference;
  notifyLegalCaseCostCapVia: NotificationDeliveryPreference;
  notifyLegalCaseDeadlineVia: NotificationDeliveryPreference;
  notifyLegalCaseManagerVia: NotificationDeliveryPreference;
  notifyLegalCaseOwnerVia: NotificationDeliveryPreference;
  notifyLegalCaseOwnershipChangeVia: NotificationDeliveryPreference;
  notifyOutdatedAmlVia: NotificationDeliveryPreference;
  notifyScheduledReportTotalTimeVia: NotificationDeliveryPreference;
  notifyUninvoicedClientVia: NotificationDeliveryPreference;
  notifyUnpaidInvoiceInternalVia: NotificationDeliveryPreference;
  phone?: Maybe<Scalars['String']>;
  position?: Maybe<Position>;
  positionName?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['ISO8601Date']>;
  statistic?: Maybe<UserStatistic>;
  subscriptionPlan: SubscriptionPlan;
  subscriptionPlanAtIntervalStart?: Maybe<SubscriptionPlan>;
  teams?: Maybe<Array<Maybe<Team>>>;
  twoFactorEnabled: Scalars['Boolean'];
  userCredential?: Maybe<UserCredential>;
  userRole?: Maybe<UserRole>;
};

export type UserApiToken = {
  __typename?: 'UserAPIToken';
  accessedAt?: Maybe<Scalars['ISO8601DateTime']>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  token?: Maybe<Scalars['String']>;
};

/** The connection type for UserAPIToken. */
export type UserApiTokenConnection = {
  __typename?: 'UserAPITokenConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserApiTokenEdge>>>;
  /** A list of nodes. */
  nodes: Array<UserApiToken>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type UserApiTokenEdge = {
  __typename?: 'UserAPITokenEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: UserApiToken;
};

export type UserApiTokenFilterInput = {
  userId?: InputMaybe<Scalars['String']>;
};

/** The connection type for User. */
export type UserConnection = {
  __typename?: 'UserConnection';
  allUsersTeamXlsxExport: XlsxExport;
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  /** A list of nodes. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type UserCost = {
  __typename?: 'UserCost';
  amount: Scalars['Float'];
  createdBy?: Maybe<User>;
  currency?: Maybe<Currency>;
  frequency: UserCostFrequencyEnum;
  fromDate: Scalars['ISO8601Date'];
  id: Scalars['ID'];
  notes?: Maybe<Scalars['String']>;
  toDate?: Maybe<Scalars['ISO8601Date']>;
  user?: Maybe<User>;
  userCostType?: Maybe<UserCostType>;
};

/** The connection type for UserCost. */
export type UserCostConnection = {
  __typename?: 'UserCostConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserCostEdge>>>;
  /** A list of nodes. */
  nodes: Array<UserCost>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type UserCostEdge = {
  __typename?: 'UserCostEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: UserCost;
};

export type UserCostFilterInput = {
  userId?: InputMaybe<Array<Scalars['ID']>>;
};

export enum UserCostFrequencyEnum {
  /** daily */
  Daily = 'daily',
  /** monthly */
  Monthly = 'monthly',
  /** one_time */
  OneTime = 'one_time',
  /** weekly */
  Weekly = 'weekly',
  /** yearly */
  Yearly = 'yearly'
}

export type UserCostInput = {
  amount?: InputMaybe<Scalars['Float']>;
  currencyId?: InputMaybe<Scalars['ID']>;
  frequency?: InputMaybe<Scalars['String']>;
  fromDate?: InputMaybe<Scalars['ISO8601Date']>;
  notes?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['ISO8601Date']>;
  userCostTypeId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type UserCostType = {
  __typename?: 'UserCostType';
  altNameTranslations: Scalars['JSON'];
  createdAt: Scalars['ISO8601Date'];
  discardedAt?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  nameWithoutFallback: Scalars['String'];
  updatedAt: Scalars['ISO8601Date'];
};

/** The connection type for UserCostType. */
export type UserCostTypeConnection = {
  __typename?: 'UserCostTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserCostTypeEdge>>>;
  /** A list of nodes. */
  nodes: Array<UserCostType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type UserCostTypeEdge = {
  __typename?: 'UserCostTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: UserCostType;
};

export type UserCostTypeInput = {
  altNameTranslations?: InputMaybe<Scalars['JSON']>;
  name: Scalars['String'];
};

export type UserCredential = {
  __typename?: 'UserCredential';
  email: Scalars['String'];
  id: Scalars['ID'];
  lastSignInAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type UserCredentialInput = {
  currentPassword?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  password?: InputMaybe<Scalars['String']>;
  passwordConfirmation?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: User;
};

export type UserFilterInput = {
  employmentType?: InputMaybe<EmploymentType>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<Array<UserFilterInput>>;
  subscriptionPlan?: InputMaybe<SubscriptionPlan>;
  userRoleId?: InputMaybe<Scalars['ID']>;
};

export type UserHourlyRate = {
  __typename?: 'UserHourlyRate';
  createdBy?: Maybe<User>;
  currency?: Maybe<Currency>;
  fromDate: Scalars['ISO8601Date'];
  id: Scalars['ID'];
  rate: Scalars['Float'];
  toDate?: Maybe<Scalars['ISO8601Date']>;
  user?: Maybe<User>;
};

/** The connection type for UserHourlyRate. */
export type UserHourlyRateConnection = {
  __typename?: 'UserHourlyRateConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserHourlyRateEdge>>>;
  /** A list of nodes. */
  nodes: Array<UserHourlyRate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type UserHourlyRateEdge = {
  __typename?: 'UserHourlyRateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: UserHourlyRate;
};

export type UserHourlyRateFilterInput = {
  userId?: InputMaybe<Array<Scalars['ID']>>;
};

export type UserHourlyRateInput = {
  currencyId?: InputMaybe<Scalars['ID']>;
  fromDate?: InputMaybe<Scalars['ISO8601Date']>;
  rate?: InputMaybe<Scalars['Float']>;
  toDate?: InputMaybe<Scalars['ISO8601Date']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type UserInput = {
  admin?: InputMaybe<Scalars['Boolean']>;
  altFirstNameTranslations?: InputMaybe<Scalars['JSON']>;
  altLastNameTranslations?: InputMaybe<Scalars['JSON']>;
  backgroundPicture?: InputMaybe<Scalars['File']>;
  backgroundPictureVariant?: InputMaybe<Scalars['String']>;
  clockTimeZones?: InputMaybe<Array<Scalars['String']>>;
  dateOfBirth?: InputMaybe<Scalars['ISO8601Date']>;
  email?: InputMaybe<Scalars['String']>;
  employmentType?: InputMaybe<EmploymentType>;
  firstName?: InputMaybe<Scalars['String']>;
  iconPack?: InputMaybe<IconPack>;
  lastName?: InputMaybe<Scalars['String']>;
  lastWorkingDay?: InputMaybe<Scalars['ISO8601Date']>;
  linkedinProfileUrl?: InputMaybe<Scalars['String']>;
  notifyBadDebtInvoiceVia?: InputMaybe<NotificationDeliveryPreference>;
  notifyClientOwnerVia?: InputMaybe<NotificationDeliveryPreference>;
  notifyClientOwnershipChangeVia?: InputMaybe<NotificationDeliveryPreference>;
  notifyInvoiceReviewRequestVia?: InputMaybe<NotificationDeliveryPreference>;
  notifyLegalCaseConnectedLawyerVia?: InputMaybe<NotificationDeliveryPreference>;
  notifyLegalCaseCostCapVia?: InputMaybe<NotificationDeliveryPreference>;
  notifyLegalCaseDeadlineVia?: InputMaybe<NotificationDeliveryPreference>;
  notifyLegalCaseManagerVia?: InputMaybe<NotificationDeliveryPreference>;
  notifyLegalCaseOwnerVia?: InputMaybe<NotificationDeliveryPreference>;
  notifyLegalCaseOwnershipChangeVia?: InputMaybe<NotificationDeliveryPreference>;
  notifyOutdatedAmlVia?: InputMaybe<NotificationDeliveryPreference>;
  notifyScheduledReportTotalTimeVia?: InputMaybe<NotificationDeliveryPreference>;
  notifyUninvoicedClientVia?: InputMaybe<NotificationDeliveryPreference>;
  notifyUnpaidInvoiceInternalVia?: InputMaybe<NotificationDeliveryPreference>;
  phone?: InputMaybe<Scalars['String']>;
  positionId?: InputMaybe<Scalars['ID']>;
  profilePicture?: InputMaybe<Scalars['File']>;
  sendInvite?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  subscriptionPlan?: InputMaybe<Scalars['String']>;
  userRoleId?: InputMaybe<Scalars['ID']>;
};

export type UserNote = {
  __typename?: 'UserNote';
  createdAt: Scalars['ISO8601DateTime'];
  createdBy?: Maybe<User>;
  id: Scalars['ID'];
  notableId: Scalars['ID'];
  notableType: Notable;
  text: Scalars['String'];
  userNoteCategory?: Maybe<UserNoteCategory>;
};

export type UserNoteCategory = {
  __typename?: 'UserNoteCategory';
  altNameTranslations: Scalars['JSON'];
  createdAt: Scalars['ISO8601Date'];
  discardedAt?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  invoiceApprovalSpecific: Scalars['Boolean'];
  isMatterStatus: Scalars['Boolean'];
  name: Scalars['String'];
  nameWithoutFallback: Scalars['String'];
  updatedAt: Scalars['ISO8601Date'];
};

/** The connection type for UserNoteCategory. */
export type UserNoteCategoryConnection = {
  __typename?: 'UserNoteCategoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserNoteCategoryEdge>>>;
  /** A list of nodes. */
  nodes: Array<UserNoteCategory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type UserNoteCategoryEdge = {
  __typename?: 'UserNoteCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: UserNoteCategory;
};

export type UserNoteCategoryFilterInput = {
  invoiceApprovalSpecific?: InputMaybe<Scalars['Boolean']>;
};

export type UserNoteCategoryInput = {
  altNameTranslations?: InputMaybe<Scalars['JSON']>;
  invoiceApprovalSpecific: Scalars['Boolean'];
  isMatterStatus: Scalars['Boolean'];
  name: Scalars['String'];
};

/** The connection type for UserNote. */
export type UserNoteConnection = {
  __typename?: 'UserNoteConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserNoteEdge>>>;
  /** A list of nodes. */
  nodes: Array<UserNote>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type UserNoteEdge = {
  __typename?: 'UserNoteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: UserNote;
};

export type UserNoteFilterInput = {
  notableId: Array<Scalars['ID']>;
  notableType: Array<Notable>;
  userNoteCategoryId?: InputMaybe<Array<Scalars['ID']>>;
};

export type UserNoteInput = {
  notableId?: InputMaybe<Scalars['ID']>;
  notableType?: InputMaybe<Notable>;
  text: Scalars['String'];
  userNoteCategoryId?: InputMaybe<Scalars['ID']>;
};

export type UserRole = {
  __typename?: 'UserRole';
  adminInviteUsers?: Maybe<Scalars['Boolean']>;
  adminManageClassifiers?: Maybe<Scalars['Boolean']>;
  adminManageEntities?: Maybe<Scalars['Boolean']>;
  adminManageInvoiceTemplates?: Maybe<Scalars['Boolean']>;
  adminManageInvoicing?: Maybe<Scalars['Boolean']>;
  adminManageRates?: Maybe<Scalars['Boolean']>;
  adminManageSubscription?: Maybe<Scalars['Boolean']>;
  adminManageTeams?: Maybe<Scalars['Boolean']>;
  adminManageUserRoles?: Maybe<Scalars['Boolean']>;
  adminManageUsers?: Maybe<Scalars['Boolean']>;
  adminMassInvite?: Maybe<Scalars['Boolean']>;
  caseChangeInvoicing?: Maybe<Scalars['Boolean']>;
  caseChangeOwnership?: Maybe<Scalars['Boolean']>;
  caseClose?: Maybe<Scalars['Boolean']>;
  caseCreate?: Maybe<Scalars['Boolean']>;
  caseDeleteAll?: Maybe<Scalars['Boolean']>;
  caseExportAll?: Maybe<Scalars['Boolean']>;
  caseHistory?: Maybe<Scalars['Boolean']>;
  caseReadAll?: Maybe<Scalars['Boolean']>;
  caseUpdateAll?: Maybe<Scalars['Boolean']>;
  clientChangeOwnership?: Maybe<Scalars['Boolean']>;
  clientCreate?: Maybe<Scalars['Boolean']>;
  clientDeleteAll?: Maybe<Scalars['Boolean']>;
  clientExportAll?: Maybe<Scalars['Boolean']>;
  clientHistory?: Maybe<Scalars['Boolean']>;
  clientReadAll?: Maybe<Scalars['Boolean']>;
  clientUpdateAll?: Maybe<Scalars['Boolean']>;
  clientViewStatistics?: Maybe<Scalars['Boolean']>;
  contactCreate?: Maybe<Scalars['Boolean']>;
  contactDelete?: Maybe<Scalars['Boolean']>;
  contactExportAll?: Maybe<Scalars['Boolean']>;
  contactRead?: Maybe<Scalars['Boolean']>;
  contactUpdate?: Maybe<Scalars['Boolean']>;
  createDraftInvoice?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['ISO8601Date'];
  description?: Maybe<Scalars['String']>;
  disbursementCreate?: Maybe<Scalars['Boolean']>;
  disbursementDeleteAll?: Maybe<Scalars['Boolean']>;
  disbursementExportAll?: Maybe<Scalars['Boolean']>;
  disbursementReadAll?: Maybe<Scalars['Boolean']>;
  disbursementUpdateAll?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  invoiceBulkStateChange?: Maybe<Scalars['Boolean']>;
  invoiceChangeStates?: Maybe<Scalars['Boolean']>;
  invoiceCreateCreditNotes?: Maybe<Scalars['Boolean']>;
  invoiceCreatePrepayments?: Maybe<Scalars['Boolean']>;
  invoiceDeleteAllUnsent?: Maybe<Scalars['Boolean']>;
  invoiceExportAll?: Maybe<Scalars['Boolean']>;
  invoiceHistory?: Maybe<Scalars['Boolean']>;
  invoiceReadAll?: Maybe<Scalars['Boolean']>;
  invoiceReadAllInRelatedCases?: Maybe<Scalars['Boolean']>;
  invoiceReverseStateChange?: Maybe<Scalars['Boolean']>;
  invoiceUpdateAll?: Maybe<Scalars['Boolean']>;
  invoiceUpdateAllUnsent?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  otherRequireTwoFactorAuth?: Maybe<Scalars['Boolean']>;
  reportMatterStatus?: Maybe<Scalars['Boolean']>;
  reportPersonalPractice?: Maybe<Scalars['Boolean']>;
  reportPracticeAreas?: Maybe<Scalars['Boolean']>;
  reportProfitability?: Maybe<Scalars['Boolean']>;
  reportReceivables?: Maybe<Scalars['Boolean']>;
  reportTimeCardsByLegalCase?: Maybe<Scalars['Boolean']>;
  reportTotalTime?: Maybe<Scalars['Boolean']>;
  reportUninvoicedTimeCards?: Maybe<Scalars['Boolean']>;
  summaryReadFirmData?: Maybe<Scalars['Boolean']>;
  summaryUpdateFirmData?: Maybe<Scalars['Boolean']>;
  taskCreate?: Maybe<Scalars['Boolean']>;
  taskCreateAll?: Maybe<Scalars['Boolean']>;
  taskDeleteAll?: Maybe<Scalars['Boolean']>;
  taskReadAll?: Maybe<Scalars['Boolean']>;
  taskReadTeam?: Maybe<Scalars['Boolean']>;
  taskUpdateAll?: Maybe<Scalars['Boolean']>;
  taskUpdateTeam?: Maybe<Scalars['Boolean']>;
  teamRead?: Maybe<Scalars['Boolean']>;
  timeCardCreate?: Maybe<Scalars['Boolean']>;
  timeCardCreationDayLimit?: Maybe<Scalars['Boolean']>;
  timeCardDeleteAll?: Maybe<Scalars['Boolean']>;
  timeCardExportAll?: Maybe<Scalars['Boolean']>;
  timeCardHistory?: Maybe<Scalars['Boolean']>;
  timeCardReadAll?: Maybe<Scalars['Boolean']>;
  timeCardUpdateAll?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['ISO8601Date'];
  userSalaryManage?: Maybe<Scalars['Boolean']>;
  userSalaryRead?: Maybe<Scalars['Boolean']>;
  users: Array<Maybe<User>>;
  usersCount: Scalars['Int'];
};

/** The connection type for UserRole. */
export type UserRoleConnection = {
  __typename?: 'UserRoleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserRoleEdge>>>;
  /** A list of nodes. */
  nodes: Array<UserRole>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type UserRoleEdge = {
  __typename?: 'UserRoleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: UserRole;
};

export type UserRoleInput = {
  adminInviteUsers?: InputMaybe<Scalars['Boolean']>;
  adminManageClassifiers?: InputMaybe<Scalars['Boolean']>;
  adminManageEntities?: InputMaybe<Scalars['Boolean']>;
  adminManageInvoiceTemplates?: InputMaybe<Scalars['Boolean']>;
  adminManageInvoicing?: InputMaybe<Scalars['Boolean']>;
  adminManageRates?: InputMaybe<Scalars['Boolean']>;
  adminManageSubscription?: InputMaybe<Scalars['Boolean']>;
  adminManageTeams?: InputMaybe<Scalars['Boolean']>;
  adminManageUserRoles?: InputMaybe<Scalars['Boolean']>;
  adminManageUsers?: InputMaybe<Scalars['Boolean']>;
  adminMassInvite?: InputMaybe<Scalars['Boolean']>;
  caseChangeInvoicing?: InputMaybe<Scalars['Boolean']>;
  caseChangeOwnership?: InputMaybe<Scalars['Boolean']>;
  caseClose?: InputMaybe<Scalars['Boolean']>;
  caseCreate?: InputMaybe<Scalars['Boolean']>;
  caseDeleteAll?: InputMaybe<Scalars['Boolean']>;
  caseExportAll?: InputMaybe<Scalars['Boolean']>;
  caseHistory?: InputMaybe<Scalars['Boolean']>;
  caseReadAll?: InputMaybe<Scalars['Boolean']>;
  caseUpdateAll?: InputMaybe<Scalars['Boolean']>;
  clientChangeOwnership?: InputMaybe<Scalars['Boolean']>;
  clientCreate?: InputMaybe<Scalars['Boolean']>;
  clientDeleteAll?: InputMaybe<Scalars['Boolean']>;
  clientExportAll?: InputMaybe<Scalars['Boolean']>;
  clientHistory?: InputMaybe<Scalars['Boolean']>;
  clientReadAll?: InputMaybe<Scalars['Boolean']>;
  clientUpdateAll?: InputMaybe<Scalars['Boolean']>;
  clientViewStatistics?: InputMaybe<Scalars['Boolean']>;
  contactCreate?: InputMaybe<Scalars['Boolean']>;
  contactDelete?: InputMaybe<Scalars['Boolean']>;
  contactExportAll?: InputMaybe<Scalars['Boolean']>;
  contactRead?: InputMaybe<Scalars['Boolean']>;
  contactUpdate?: InputMaybe<Scalars['Boolean']>;
  createDraftInvoice?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  disbursementCreate?: InputMaybe<Scalars['Boolean']>;
  disbursementDeleteAll?: InputMaybe<Scalars['Boolean']>;
  disbursementExportAll?: InputMaybe<Scalars['Boolean']>;
  disbursementReadAll?: InputMaybe<Scalars['Boolean']>;
  disbursementUpdateAll?: InputMaybe<Scalars['Boolean']>;
  invoiceBulkStateChange?: InputMaybe<Scalars['Boolean']>;
  invoiceChangeStates?: InputMaybe<Scalars['Boolean']>;
  invoiceCreateCreditNotes?: InputMaybe<Scalars['Boolean']>;
  invoiceCreatePrepayments?: InputMaybe<Scalars['Boolean']>;
  invoiceDeleteAllUnsent?: InputMaybe<Scalars['Boolean']>;
  invoiceExportAll?: InputMaybe<Scalars['Boolean']>;
  invoiceHistory?: InputMaybe<Scalars['Boolean']>;
  invoiceReadAll?: InputMaybe<Scalars['Boolean']>;
  invoiceReadAllInRelatedCases?: InputMaybe<Scalars['Boolean']>;
  invoiceReverseStateChange?: InputMaybe<Scalars['Boolean']>;
  invoiceUpdateAll?: InputMaybe<Scalars['Boolean']>;
  invoiceUpdateAllUnsent?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  otherRequireTwoFactorAuth?: InputMaybe<Scalars['Boolean']>;
  reportMatterStatus?: InputMaybe<Scalars['Boolean']>;
  reportPersonalPractice?: InputMaybe<Scalars['Boolean']>;
  reportPracticeAreas?: InputMaybe<Scalars['Boolean']>;
  reportProfitability?: InputMaybe<Scalars['Boolean']>;
  reportReceivables?: InputMaybe<Scalars['Boolean']>;
  reportTimeCardsByLegalCase?: InputMaybe<Scalars['Boolean']>;
  reportTotalTime?: InputMaybe<Scalars['Boolean']>;
  reportUninvoicedTimeCards?: InputMaybe<Scalars['Boolean']>;
  summaryReadFirmData?: InputMaybe<Scalars['Boolean']>;
  summaryUpdateFirmData?: InputMaybe<Scalars['Boolean']>;
  taskCreate?: InputMaybe<Scalars['Boolean']>;
  taskCreateAll?: InputMaybe<Scalars['Boolean']>;
  taskDeleteAll?: InputMaybe<Scalars['Boolean']>;
  taskReadAll?: InputMaybe<Scalars['Boolean']>;
  taskReadTeam?: InputMaybe<Scalars['Boolean']>;
  taskUpdateAll?: InputMaybe<Scalars['Boolean']>;
  taskUpdateTeam?: InputMaybe<Scalars['Boolean']>;
  teamRead?: InputMaybe<Scalars['Boolean']>;
  timeCardCreate?: InputMaybe<Scalars['Boolean']>;
  timeCardCreationDayLimit?: InputMaybe<Scalars['Boolean']>;
  timeCardDeleteAll?: InputMaybe<Scalars['Boolean']>;
  timeCardExportAll?: InputMaybe<Scalars['Boolean']>;
  timeCardHistory?: InputMaybe<Scalars['Boolean']>;
  timeCardReadAll?: InputMaybe<Scalars['Boolean']>;
  timeCardUpdateAll?: InputMaybe<Scalars['Boolean']>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
  userSalaryManage?: InputMaybe<Scalars['Boolean']>;
  userSalaryRead?: InputMaybe<Scalars['Boolean']>;
};

export type UserSalary = {
  __typename?: 'UserSalary';
  amount: Scalars['Float'];
  createdBy?: Maybe<User>;
  currency?: Maybe<Currency>;
  fromDate: Scalars['ISO8601Date'];
  id: Scalars['ID'];
  toDate?: Maybe<Scalars['ISO8601Date']>;
  user?: Maybe<User>;
};

/** The connection type for UserSalary. */
export type UserSalaryConnection = {
  __typename?: 'UserSalaryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserSalaryEdge>>>;
  /** A list of nodes. */
  nodes: Array<UserSalary>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type UserSalaryEdge = {
  __typename?: 'UserSalaryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: UserSalary;
};

export type UserSalaryFilterInput = {
  userId?: InputMaybe<Array<Scalars['ID']>>;
};

export type UserSalaryInput = {
  amount?: InputMaybe<Scalars['Float']>;
  currencyId?: InputMaybe<Scalars['ID']>;
  fromDate?: InputMaybe<Scalars['ISO8601Date']>;
  toDate?: InputMaybe<Scalars['ISO8601Date']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type UserStatistic = {
  __typename?: 'UserStatistic';
  casesManaged: Scalars['JSON'];
  casesRelated: Scalars['JSON'];
  id: Scalars['ID'];
  invoicedMinutesSpent: Scalars['JSON'];
  minutesSpent: Scalars['JSON'];
  minutesSpentByPracticeArea: Scalars['JSON'];
  nonBillableMinutesSpent: Scalars['JSON'];
  uninvoicedMinutesSpent: Scalars['JSON'];
};

export type ValidateTwoFactorInput = {
  otp: Scalars['String'];
};

export type VatPercentage = {
  __typename?: 'VatPercentage';
  createdAt: Scalars['ISO8601Date'];
  discardedAt?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  location: VatPercentageLocation;
  noticeTranslations: Scalars['JSON'];
  percentage: Scalars['Float'];
  updatedAt: Scalars['ISO8601Date'];
};

/** The connection type for VatPercentage. */
export type VatPercentageConnection = {
  __typename?: 'VatPercentageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<VatPercentageEdge>>>;
  /** A list of nodes. */
  nodes: Array<VatPercentage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type VatPercentageEdge = {
  __typename?: 'VatPercentageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: VatPercentage;
};

export type VatPercentageInput = {
  location: Scalars['String'];
  noticeTranslations?: InputMaybe<Scalars['JSON']>;
  percentage: Scalars['Float'];
};

/** Vat Percentage Location Types */
export enum VatPercentageLocation {
  /** Eu */
  Eu = 'eu',
  /** Outside Eu */
  OutsideEu = 'outside_eu',
  /** Regular */
  Regular = 'regular'
}

export type XlsxExport = {
  __typename?: 'XlsxExport';
  content: Scalars['String'];
  filename: Scalars['String'];
};

export type AuditHistoryQueryVariables = Exact<{
  auditableId: Scalars['ID'];
  auditableType: AuditableType;
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<AuditEventFilterInput>;
}>;


export type AuditHistoryQuery = { __typename?: 'Query', auditEvents: { __typename?: 'AuditEventConnection', totalCount: number, nodes: Array<{ __typename?: 'AuditEvent', id: string, action: AuditEventAction, auditableType: string, changes?: any | null, createdAt: any, user?: { __typename?: 'User', id: string, fullName: string } | null }> } };

export type AuditClientQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AuditClientQuery = { __typename?: 'Query', client: { __typename?: 'Client', id: string, fullName?: string | null } };

export type AuditUserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AuditUserQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, fullName: string } };

export type AuditContactQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AuditContactQuery = { __typename?: 'Query', contact: { __typename?: 'Contact', id: string, fullName: string } };

export type AuditPriceListQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AuditPriceListQuery = { __typename?: 'Query', priceList: { __typename?: 'PriceList', id: string, name: string } };

export type AuditVatPercentageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AuditVatPercentageQuery = { __typename?: 'Query', vatPercentage: { __typename?: 'VatPercentage', id: string, percentage: number } };

export type AuditEntityQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AuditEntityQuery = { __typename?: 'Query', entity: { __typename?: 'Entity', id: string, name: string } };

export type AuditLegalCaseQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AuditLegalCaseQuery = { __typename?: 'Query', legalCase: { __typename?: 'LegalCase', id: string, name?: string | null } };

export type AuditInvoiceQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AuditInvoiceQuery = { __typename?: 'Query', invoice: { __typename?: 'Invoice', id: string, number?: string | null, state: InvoiceState, invoiceType: InvoiceType } };

export type AuditPositionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AuditPositionQuery = { __typename?: 'Query', position: { __typename?: 'Position', id: string, name: string } };

export type CurrentUserHeaderDataQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserHeaderDataQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, minutesSpentToday?: number | null, minutesSpentThisMonth?: number | null, currentPerformanceTargetTimeCardMinutesPerDay?: number | null, clockTimeZones: Array<{ __typename?: 'TimeZone', id: string, canonicalName: string }> } };

export type CreateImportAttemptMutationVariables = Exact<{
  input: ImportAttemptInput;
}>;


export type CreateImportAttemptMutation = { __typename?: 'Mutation', createImportAttempt: { __typename?: 'ImportAttempt', id: string } };

export type ImportAttemptSampleQueryVariables = Exact<{
  destination: ImportAttemptDestination;
}>;


export type ImportAttemptSampleQuery = { __typename?: 'Query', importAttemptSample?: string | null };

export type ImportAttemptQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ImportAttemptQuery = { __typename?: 'Query', importAttempt: { __typename?: 'ImportAttempt', id: string, createdAt: any, state: ImportAttemptState, processingErrors?: any | null, parsedCount?: number | null, invalidCount?: number | null, insertedCount?: number | null, updatedCount?: number | null } };

export type ScheduleImportAttemptMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ScheduleImportAttemptMutation = { __typename?: 'Mutation', scheduleImportAttempt: { __typename?: 'ImportAttempt', id: string, state: ImportAttemptState } };

export type ImportAttemptsQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ImportAttemptFilterInput>;
}>;


export type ImportAttemptsQuery = { __typename?: 'Query', importAttempts: { __typename?: 'ImportAttemptConnection', totalCount: number, nodes: Array<{ __typename?: 'ImportAttempt', id: string, state: ImportAttemptState, createdAt: any }> } };

export type AskAiQueryVariables = Exact<{
  question: Scalars['String'];
}>;


export type AskAiQuery = { __typename?: 'Query', askAi: { __typename?: 'AiAnswer', text?: string | null, charts: Array<any>, error?: string | null } };

export type ResetCurrentAccountDbMutationVariables = Exact<{
  input: DbResetInput;
}>;


export type ResetCurrentAccountDbMutation = { __typename?: 'Mutation', resetCurrentAccountDb: boolean };

export type ProhibitCurrentAccountDbResetMutationVariables = Exact<{ [key: string]: never; }>;


export type ProhibitCurrentAccountDbResetMutation = { __typename?: 'Mutation', prohibitCurrentAccountDbReset: { __typename?: 'Account', id: string, dbResetAllowed: boolean } };

export type CurrentAccountResetStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentAccountResetStatusQuery = { __typename?: 'Query', currentAccount: { __typename?: 'Account', id: string, dbResetAllowed: boolean } };

export type GlobalSearchQueryQueryVariables = Exact<{
  q: Scalars['String'];
  recordTypes?: InputMaybe<Array<GlobalSearchRecord> | GlobalSearchRecord>;
}>;


export type GlobalSearchQueryQuery = { __typename?: 'Query', globalSearch: Array<{ __typename?: 'GlobalSearchResult', id: string, description?: string | null, recordId: string, recordType: GlobalSearchRecord }> };

export type CurrentAccountLogoQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentAccountLogoQuery = { __typename?: 'Query', currentAccount: { __typename?: 'Account', id: string, logoUrl?: string | null } };

export type LatestNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type LatestNotificationsQuery = { __typename?: 'Query', notifications: { __typename?: 'NotificationConnection', nodes: Array<{ __typename?: 'Notification', id: string, kind: NotificationKind, seenAt?: any | null, translationData?: any | null, translationKey?: string | null, relatedId?: string | null, relatedType?: NotificationRelatedType | null, createdAt: any }> } };

export type UserTwoFactorQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserTwoFactorQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, twoFactorEnabled: boolean } };

export type InitializeUserTwoFactorMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type InitializeUserTwoFactorMutation = { __typename?: 'Mutation', initializeTwoFactor: string };

export type ValidateUserTwoFactorMutationVariables = Exact<{
  id: Scalars['ID'];
  otp: Scalars['String'];
}>;


export type ValidateUserTwoFactorMutation = { __typename?: 'Mutation', validateTwoFactor: Array<string> };

export type DisableTwoFactorMutationVariables = Exact<{
  id: Scalars['ID'];
  otp: Scalars['String'];
}>;


export type DisableTwoFactorMutation = { __typename?: 'Mutation', disableTwoFactor: boolean };

export type UserNotesCountQueryVariables = Exact<{
  filter?: InputMaybe<UserNoteFilterInput>;
}>;


export type UserNotesCountQuery = { __typename?: 'Query', userNotes: { __typename?: 'UserNoteConnection', totalCount: number } };

export type UserNoteQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserNoteQuery = { __typename?: 'Query', userNote: { __typename?: 'UserNote', id: string, text: string, notableType: Notable, userNoteCategory?: { __typename?: 'UserNoteCategory', id: string, name: string } | null } };

export type UpdateUserNoteMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UserNoteInput;
}>;


export type UpdateUserNoteMutation = { __typename?: 'Mutation', updateUserNote: { __typename?: 'UserNote', id: string, text: string, notableType: Notable, userNoteCategory?: { __typename?: 'UserNoteCategory', id: string, name: string } | null } };

export type UserNotesQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<UserNoteFilterInput>;
}>;


export type UserNotesQuery = { __typename?: 'Query', userNotes: { __typename?: 'UserNoteConnection', totalCount: number, nodes: Array<{ __typename?: 'UserNote', id: string, text: string, createdAt: any, notableType: Notable, notableId: string, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, fullName: string, profilePictureUrl?: string | null } | null, userNoteCategory?: { __typename?: 'UserNoteCategory', id: string, name: string } | null }> } };

export type DeleteUserNoteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteUserNoteMutation = { __typename?: 'Mutation', deleteUserNote: boolean };

export type CurrentContextQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentContextQuery = { __typename?: 'Query', abilities: Array<{ __typename?: 'AbilityRule', action: Array<string>, subject: Array<string>, fields?: Array<string> | null, conditions?: any | null, inverted: boolean }>, currentUser: { __typename?: 'User', id: string, fullName: string, firstName: string, profilePictureUrl?: string | null, backgroundPictureVariant?: string | null, backgroundPictureUrl?: string | null, iconPack?: IconPack | null, positionName?: string | null, userCredential?: { __typename?: 'UserCredential', id: string, email: string } | null, teams?: Array<{ __typename?: 'Team', id: string, name: string } | null> | null }, currentAccount: { __typename?: 'Account', id: string, locale?: string | null, otherLocales: Array<string>, timeFormat: TimeFormat, dateFormat: string, allowedTcCreationTime?: number | null, firstApprover?: string | null, featureFlags?: string | null } };

export type CurrentReleaseQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentReleaseQuery = { __typename?: 'Query', currentRelease: string };

export type CreateContactCategoryMutationVariables = Exact<{
  input: ContactCategoryInput;
}>;


export type CreateContactCategoryMutation = { __typename?: 'Mutation', createContactCategory: { __typename?: 'ContactCategory', id: string } };

export type ContactCategoryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ContactCategoryQuery = { __typename?: 'Query', contactCategory: { __typename?: 'ContactCategory', id: string, altNameTranslations: any, name: string } };

export type UpdateContactCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
  input: ContactCategoryInput;
}>;


export type UpdateContactCategoryMutation = { __typename?: 'Mutation', updateContactCategory: { __typename?: 'ContactCategory', id: string, altNameTranslations: any, name: string } };

export type ContactCategoriesQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type ContactCategoriesQuery = { __typename?: 'Query', contactCategories: { __typename?: 'ContactCategoryConnection', totalCount: number, nodes: Array<{ __typename?: 'ContactCategory', id: string, name: string, createdAt: any, updatedAt: any, discardedAt?: any | null }> } };

export type AutocompleteContactCategoriesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type AutocompleteContactCategoriesQuery = { __typename?: 'Query', contactCategories: { __typename?: 'ContactCategoryConnection', nodes: Array<{ __typename?: 'ContactCategory', id: string, name: string }> } };

export type DeleteContactCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteContactCategoryMutation = { __typename?: 'Mutation', deleteContactCategory: boolean };

export type RestoreContactCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RestoreContactCategoryMutation = { __typename?: 'Mutation', restoreContactCategory: { __typename?: 'ContactCategory', id: string, discardedAt?: any | null } };

export type CreateCreditRatingMutationVariables = Exact<{
  input: CreditRatingInput;
}>;


export type CreateCreditRatingMutation = { __typename?: 'Mutation', createCreditRating: { __typename?: 'CreditRating', id: string } };

export type CreditRatingQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CreditRatingQuery = { __typename?: 'Query', creditRating: { __typename?: 'CreditRating', id: string, name: string } };

export type UpdateCreditRatingMutationVariables = Exact<{
  id: Scalars['ID'];
  input: CreditRatingInput;
}>;


export type UpdateCreditRatingMutation = { __typename?: 'Mutation', updateCreditRating: { __typename?: 'CreditRating', id: string, name: string } };

export type CreditRatingsQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreditRatingsQuery = { __typename?: 'Query', creditRatings: { __typename?: 'CreditRatingConnection', totalCount: number, nodes: Array<{ __typename?: 'CreditRating', id: string, name: string, createdAt: any, updatedAt: any, discardedAt?: any | null }> } };

export type AutocompleteCreditRatingsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type AutocompleteCreditRatingsQuery = { __typename?: 'Query', creditRatings: { __typename?: 'CreditRatingConnection', nodes: Array<{ __typename?: 'CreditRating', id: string, name: string }> } };

export type DeleteCreditRatingMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCreditRatingMutation = { __typename?: 'Mutation', deleteCreditRating: boolean };

export type RestoreCreditRatingMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RestoreCreditRatingMutation = { __typename?: 'Mutation', restoreCreditRating: { __typename?: 'CreditRating', id: string, discardedAt?: any | null } };

export type CreateCurrencyMutationVariables = Exact<{
  input: CurrencyInput;
}>;


export type CreateCurrencyMutation = { __typename?: 'Mutation', createCurrency: { __typename?: 'Currency', id: string } };

export type CurrencyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CurrencyQuery = { __typename?: 'Query', currency: { __typename?: 'Currency', id: string, name: string } };

export type UpdateCurrencyMutationVariables = Exact<{
  id: Scalars['ID'];
  input: CurrencyInput;
}>;


export type UpdateCurrencyMutation = { __typename?: 'Mutation', updateCurrency: { __typename?: 'Currency', id: string, name: string } };

export type CurrenciesQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type CurrenciesQuery = { __typename?: 'Query', currencies: { __typename?: 'CurrencyConnection', totalCount: number, nodes: Array<{ __typename?: 'Currency', id: string, name: string, createdAt: any, updatedAt: any, discardedAt?: any | null }> } };

export type AutocompleteCurrenciesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type AutocompleteCurrenciesQuery = { __typename?: 'Query', currencies: { __typename?: 'CurrencyConnection', nodes: Array<{ __typename?: 'Currency', id: string, name: string }> } };

export type DeleteCurrencyMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCurrencyMutation = { __typename?: 'Mutation', deleteCurrency: boolean };

export type RestoreCurrencyMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RestoreCurrencyMutation = { __typename?: 'Mutation', restoreCurrency: { __typename?: 'Currency', id: string, discardedAt?: any | null } };

export type CreateDisbursementTypeMutationVariables = Exact<{
  input: DisbursementTypeInput;
}>;


export type CreateDisbursementTypeMutation = { __typename?: 'Mutation', createDisbursementType: { __typename?: 'DisbursementType', id: string } };

export type DisbursementTypeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DisbursementTypeQuery = { __typename?: 'Query', disbursementType: { __typename?: 'DisbursementType', id: string, altNameTranslations: any, name: string } };

export type UpdateDisbursementTypeMutationVariables = Exact<{
  id: Scalars['ID'];
  input: DisbursementTypeInput;
}>;


export type UpdateDisbursementTypeMutation = { __typename?: 'Mutation', updateDisbursementType: { __typename?: 'DisbursementType', id: string, altNameTranslations: any, name: string } };

export type DisbursementTypesQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type DisbursementTypesQuery = { __typename?: 'Query', disbursementTypes: { __typename?: 'DisbursementTypeConnection', totalCount: number, nodes: Array<{ __typename?: 'DisbursementType', id: string, name: string, createdAt: any, updatedAt: any, discardedAt?: any | null }> } };

export type AutocompleteDisbursementTypesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type AutocompleteDisbursementTypesQuery = { __typename?: 'Query', disbursementTypes: { __typename?: 'DisbursementTypeConnection', nodes: Array<{ __typename?: 'DisbursementType', id: string, name: string }> } };

export type DeleteDisbursementTypeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteDisbursementTypeMutation = { __typename?: 'Mutation', deleteDisbursementType: boolean };

export type RestoreDisbursementTypeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RestoreDisbursementTypeMutation = { __typename?: 'Mutation', restoreDisbursementType: { __typename?: 'DisbursementType', id: string, discardedAt?: any | null } };

export type CreateIndustryMutationVariables = Exact<{
  input: IndustryInput;
}>;


export type CreateIndustryMutation = { __typename?: 'Mutation', createIndustry: { __typename?: 'Industry', id: string } };

export type IndustryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IndustryQuery = { __typename?: 'Query', industry: { __typename?: 'Industry', id: string, name: string, altNameTranslations: any } };

export type UpdateIndustryMutationVariables = Exact<{
  id: Scalars['ID'];
  input: IndustryInput;
}>;


export type UpdateIndustryMutation = { __typename?: 'Mutation', updateIndustry: { __typename?: 'Industry', id: string, name: string, altNameTranslations: any } };

export type IndustriesQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type IndustriesQuery = { __typename?: 'Query', industries: { __typename?: 'IndustryConnection', totalCount: number, nodes: Array<{ __typename?: 'Industry', id: string, name: string, createdAt: any, updatedAt: any, discardedAt?: any | null }> } };

export type AutocompleteIndustriesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type AutocompleteIndustriesQuery = { __typename?: 'Query', industries: { __typename?: 'IndustryConnection', nodes: Array<{ __typename?: 'Industry', id: string, name: string }> } };

export type DeleteIndustryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteIndustryMutation = { __typename?: 'Mutation', deleteIndustry: boolean };

export type RestoreIndustryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RestoreIndustryMutation = { __typename?: 'Mutation', restoreIndustry: { __typename?: 'Industry', id: string, discardedAt?: any | null } };

export type CreateMarketingEffortNeedTypeMutationVariables = Exact<{
  input: MarketingEffortNeedTypeInput;
}>;


export type CreateMarketingEffortNeedTypeMutation = { __typename?: 'Mutation', createMarketingEffortNeedType: { __typename?: 'MarketingEffortNeedType', id: string } };

export type MarketingEffortNeedTypeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MarketingEffortNeedTypeQuery = { __typename?: 'Query', marketingEffortNeedType: { __typename?: 'MarketingEffortNeedType', id: string, altNameTranslations: any, name: string } };

export type UpdateMarketingEffortNeedTypeMutationVariables = Exact<{
  id: Scalars['ID'];
  input: MarketingEffortNeedTypeInput;
}>;


export type UpdateMarketingEffortNeedTypeMutation = { __typename?: 'Mutation', updateMarketingEffortNeedType: { __typename?: 'MarketingEffortNeedType', id: string, altNameTranslations: any, name: string } };

export type MarketingEffortNeedTypesQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type MarketingEffortNeedTypesQuery = { __typename?: 'Query', marketingEffortNeedTypes: { __typename?: 'MarketingEffortNeedTypeConnection', totalCount: number, nodes: Array<{ __typename?: 'MarketingEffortNeedType', id: string, name: string, createdAt: any, updatedAt: any, discardedAt?: any | null }> } };

export type DeleteMarketingEffortNeedTypeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteMarketingEffortNeedTypeMutation = { __typename?: 'Mutation', deleteMarketingEffortNeedType: boolean };

export type RestoreMarketingEffortNeedTypeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RestoreMarketingEffortNeedTypeMutation = { __typename?: 'Mutation', restoreMarketingEffortNeedType: { __typename?: 'MarketingEffortNeedType', id: string, discardedAt?: any | null } };

export type CreateMarketingEffortResponseTypeMutationVariables = Exact<{
  input: MarketingEffortResponseTypeInput;
}>;


export type CreateMarketingEffortResponseTypeMutation = { __typename?: 'Mutation', createMarketingEffortResponseType: { __typename?: 'MarketingEffortResponseType', id: string } };

export type MarketingEffortResponseTypeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MarketingEffortResponseTypeQuery = { __typename?: 'Query', marketingEffortResponseType: { __typename?: 'MarketingEffortResponseType', id: string, altNameTranslations: any, name: string } };

export type UpdateMarketingEffortResponseTypeMutationVariables = Exact<{
  id: Scalars['ID'];
  input: MarketingEffortResponseTypeInput;
}>;


export type UpdateMarketingEffortResponseTypeMutation = { __typename?: 'Mutation', updateMarketingEffortResponseType: { __typename?: 'MarketingEffortResponseType', id: string, altNameTranslations: any, name: string } };

export type MarketingEffortResponseTypesQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type MarketingEffortResponseTypesQuery = { __typename?: 'Query', marketingEffortResponseTypes: { __typename?: 'MarketingEffortResponseTypeConnection', totalCount: number, nodes: Array<{ __typename?: 'MarketingEffortResponseType', id: string, name: string, createdAt: any, updatedAt: any, discardedAt?: any | null }> } };

export type DeleteMarketingEffortResponseTypeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteMarketingEffortResponseTypeMutation = { __typename?: 'Mutation', deleteMarketingEffortResponseType: boolean };

export type RestoreMarketingEffortResponseTypeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RestoreMarketingEffortResponseTypeMutation = { __typename?: 'Mutation', restoreMarketingEffortResponseType: { __typename?: 'MarketingEffortResponseType', id: string, discardedAt?: any | null } };

export type CreateMarketingEffortTypeMutationVariables = Exact<{
  input: MarketingEffortTypeInput;
}>;


export type CreateMarketingEffortTypeMutation = { __typename?: 'Mutation', createMarketingEffortType: { __typename?: 'MarketingEffortType', id: string } };

export type MarketingEffortTypeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MarketingEffortTypeQuery = { __typename?: 'Query', marketingEffortType: { __typename?: 'MarketingEffortType', id: string, altNameTranslations: any, name: string } };

export type UpdateMarketingEffortTypeMutationVariables = Exact<{
  id: Scalars['ID'];
  input: MarketingEffortTypeInput;
}>;


export type UpdateMarketingEffortTypeMutation = { __typename?: 'Mutation', updateMarketingEffortType: { __typename?: 'MarketingEffortType', id: string, altNameTranslations: any, name: string } };

export type MarketingEffortTypesQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type MarketingEffortTypesQuery = { __typename?: 'Query', marketingEffortTypes: { __typename?: 'MarketingEffortTypeConnection', totalCount: number, nodes: Array<{ __typename?: 'MarketingEffortType', id: string, name: string, createdAt: any, updatedAt: any, discardedAt?: any | null }> } };

export type DeleteMarketingEffortTypeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteMarketingEffortTypeMutation = { __typename?: 'Mutation', deleteMarketingEffortType: boolean };

export type RestoreMarketingEffortTypeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RestoreMarketingEffortTypeMutation = { __typename?: 'Mutation', restoreMarketingEffortType: { __typename?: 'MarketingEffortType', id: string, discardedAt?: any | null } };

export type CreatePaymentTermMutationVariables = Exact<{
  input: PaymentTermInput;
}>;


export type CreatePaymentTermMutation = { __typename?: 'Mutation', createPaymentTerm: { __typename?: 'PaymentTerm', id: string } };

export type PaymentTermQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PaymentTermQuery = { __typename?: 'Query', paymentTerm: { __typename?: 'PaymentTerm', id: string, days: number } };

export type UpdatePaymentTermMutationVariables = Exact<{
  id: Scalars['ID'];
  input: PaymentTermInput;
}>;


export type UpdatePaymentTermMutation = { __typename?: 'Mutation', updatePaymentTerm: { __typename?: 'PaymentTerm', id: string, days: number } };

export type PaymentTermsQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type PaymentTermsQuery = { __typename?: 'Query', paymentTerms: { __typename?: 'PaymentTermConnection', totalCount: number, nodes: Array<{ __typename?: 'PaymentTerm', id: string, days: number, createdAt: any, updatedAt: any, discardedAt?: any | null }> } };

export type AutocompletePaymentTermsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type AutocompletePaymentTermsQuery = { __typename?: 'Query', paymentTerms: { __typename?: 'PaymentTermConnection', nodes: Array<{ __typename?: 'PaymentTerm', id: string, days: number }> } };

export type DeletePaymentTermMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletePaymentTermMutation = { __typename?: 'Mutation', deletePaymentTerm: boolean };

export type RestorePaymentTermMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RestorePaymentTermMutation = { __typename?: 'Mutation', restorePaymentTerm: { __typename?: 'PaymentTerm', id: string, discardedAt?: any | null } };

export type CreatePositionMutationVariables = Exact<{
  input: PositionInput;
}>;


export type CreatePositionMutation = { __typename?: 'Mutation', createPosition: { __typename?: 'Position', id: string } };

export type MaximumPositionSequenceQueryVariables = Exact<{ [key: string]: never; }>;


export type MaximumPositionSequenceQuery = { __typename?: 'Query', positions: { __typename?: 'PositionConnection', maximumPositionSequence: number } };

export type PositionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PositionQuery = { __typename?: 'Query', position: { __typename?: 'Position', id: string, altNameTranslations: any, isLawyer: boolean, sequence?: number | null, name: string } };

export type UpdatePositionMutationVariables = Exact<{
  id: Scalars['ID'];
  input: PositionInput;
}>;


export type UpdatePositionMutation = { __typename?: 'Mutation', updatePosition: { __typename?: 'Position', id: string, altNameTranslations: any, isLawyer: boolean, sequence?: number | null, name: string } };

export type PositionsQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<PositionFilterInput>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type PositionsQuery = { __typename?: 'Query', positions: { __typename?: 'PositionConnection', totalCount: number, nodes: Array<{ __typename?: 'Position', id: string, name: string, isLawyer: boolean, createdAt: any, updatedAt: any, discardedAt?: any | null, sequence?: number | null }> } };

export type AutocompletePositionsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<PositionFilterInput>;
}>;


export type AutocompletePositionsQuery = { __typename?: 'Query', positions: { __typename?: 'PositionConnection', nodes: Array<{ __typename?: 'Position', id: string, name: string }> } };

export type DeletePositionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletePositionMutation = { __typename?: 'Mutation', deletePosition: boolean };

export type RestorePositionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RestorePositionMutation = { __typename?: 'Mutation', restorePosition: { __typename?: 'Position', id: string, discardedAt?: any | null } };

export type CreatePracticeAreaMutationVariables = Exact<{
  input: PracticeAreaInput;
}>;


export type CreatePracticeAreaMutation = { __typename?: 'Mutation', createPracticeArea: { __typename?: 'PracticeArea', id: string } };

export type PracticeAreaQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PracticeAreaQuery = { __typename?: 'Query', practiceArea: { __typename?: 'PracticeArea', id: string, altNameTranslations: any, name: string } };

export type UpdatePracticeAreaMutationVariables = Exact<{
  id: Scalars['ID'];
  input: PracticeAreaInput;
}>;


export type UpdatePracticeAreaMutation = { __typename?: 'Mutation', updatePracticeArea: { __typename?: 'PracticeArea', id: string, altNameTranslations: any, name: string } };

export type PracticeAreasQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type PracticeAreasQuery = { __typename?: 'Query', practiceAreas: { __typename?: 'PracticeAreaConnection', totalCount: number, nodes: Array<{ __typename?: 'PracticeArea', id: string, name: string, createdAt: any, updatedAt: any, discardedAt?: any | null }> } };

export type AutocompletePracticeAreasQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type AutocompletePracticeAreasQuery = { __typename?: 'Query', practiceAreas: { __typename?: 'PracticeAreaConnection', nodes: Array<{ __typename?: 'PracticeArea', id: string, name: string }> } };

export type DeletePracticeAreaMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletePracticeAreaMutation = { __typename?: 'Mutation', deletePracticeArea: boolean };

export type RestorePracticeAreaMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RestorePracticeAreaMutation = { __typename?: 'Mutation', restorePracticeArea: { __typename?: 'PracticeArea', id: string, discardedAt?: any | null } };

export type CreateUserCostTypeMutationVariables = Exact<{
  input: UserCostTypeInput;
}>;


export type CreateUserCostTypeMutation = { __typename?: 'Mutation', createUserCostType: { __typename?: 'UserCostType', id: string } };

export type UserCostTypeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserCostTypeQuery = { __typename?: 'Query', userCostType: { __typename?: 'UserCostType', id: string, altNameTranslations: any, name: string } };

export type UpdateUserCostTypeMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UserCostTypeInput;
}>;


export type UpdateUserCostTypeMutation = { __typename?: 'Mutation', updateUserCostType: { __typename?: 'UserCostType', id: string, altNameTranslations: any, name: string } };

export type UserCostTypesQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type UserCostTypesQuery = { __typename?: 'Query', userCostTypes: { __typename?: 'UserCostTypeConnection', totalCount: number, nodes: Array<{ __typename?: 'UserCostType', id: string, name: string, createdAt: any, updatedAt: any, discardedAt?: any | null }> } };

export type AutocompleteUserCostTypesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type AutocompleteUserCostTypesQuery = { __typename?: 'Query', userCostTypes: { __typename?: 'UserCostTypeConnection', nodes: Array<{ __typename?: 'UserCostType', id: string, name: string }> } };

export type DeleteUserCostTypeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteUserCostTypeMutation = { __typename?: 'Mutation', deleteUserCostType: boolean };

export type RestoreUserCostTypeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RestoreUserCostTypeMutation = { __typename?: 'Mutation', restoreUserCostType: { __typename?: 'UserCostType', id: string, discardedAt?: any | null } };

export type CreateUserNoteCategoryMutationVariables = Exact<{
  input: UserNoteCategoryInput;
}>;


export type CreateUserNoteCategoryMutation = { __typename?: 'Mutation', createUserNoteCategory: { __typename?: 'UserNoteCategory', id: string } };

export type UserNoteCategoryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserNoteCategoryQuery = { __typename?: 'Query', userNoteCategory: { __typename?: 'UserNoteCategory', id: string, altNameTranslations: any, invoiceApprovalSpecific: boolean, isMatterStatus: boolean, name: string } };

export type UpdateUserNoteCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UserNoteCategoryInput;
}>;


export type UpdateUserNoteCategoryMutation = { __typename?: 'Mutation', updateUserNoteCategory: { __typename?: 'UserNoteCategory', id: string, altNameTranslations: any, invoiceApprovalSpecific: boolean, isMatterStatus: boolean, name: string } };

export type UserNoteCategoriesQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserNoteCategoryFilterInput>;
}>;


export type UserNoteCategoriesQuery = { __typename?: 'Query', userNoteCategories: { __typename?: 'UserNoteCategoryConnection', totalCount: number, nodes: Array<{ __typename?: 'UserNoteCategory', id: string, name: string, createdAt: any, updatedAt: any, discardedAt?: any | null, invoiceApprovalSpecific: boolean, isMatterStatus: boolean }> } };

export type AutocompleteUserNoteCategoriesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<UserNoteCategoryFilterInput>;
}>;


export type AutocompleteUserNoteCategoriesQuery = { __typename?: 'Query', userNoteCategories: { __typename?: 'UserNoteCategoryConnection', nodes: Array<{ __typename?: 'UserNoteCategory', id: string, name: string }> } };

export type DeleteUserNoteCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteUserNoteCategoryMutation = { __typename?: 'Mutation', deleteUserNoteCategory: boolean };

export type RestoreUserNoteCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RestoreUserNoteCategoryMutation = { __typename?: 'Mutation', restoreUserNoteCategory: { __typename?: 'UserNoteCategory', id: string, discardedAt?: any | null } };

export type CreateVatPercentageMutationVariables = Exact<{
  input: VatPercentageInput;
}>;


export type CreateVatPercentageMutation = { __typename?: 'Mutation', createVatPercentage: { __typename?: 'VatPercentage', id: string } };

export type VatPercentageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type VatPercentageQuery = { __typename?: 'Query', vatPercentage: { __typename?: 'VatPercentage', id: string, percentage: number, location: VatPercentageLocation, noticeTranslations: any } };

export type UpdateVatPercentageMutationVariables = Exact<{
  id: Scalars['ID'];
  input: VatPercentageInput;
}>;


export type UpdateVatPercentageMutation = { __typename?: 'Mutation', updateVatPercentage: { __typename?: 'VatPercentage', id: string, percentage: number, location: VatPercentageLocation, noticeTranslations: any } };

export type VatPercentagesQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type VatPercentagesQuery = { __typename?: 'Query', vatPercentages: { __typename?: 'VatPercentageConnection', totalCount: number, nodes: Array<{ __typename?: 'VatPercentage', id: string, percentage: number, location: VatPercentageLocation, createdAt: any, updatedAt: any, discardedAt?: any | null }> } };

export type AutocompleteVatPercentagesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type AutocompleteVatPercentagesQuery = { __typename?: 'Query', vatPercentages: { __typename?: 'VatPercentageConnection', nodes: Array<{ __typename?: 'VatPercentage', id: string, percentage: number, location: VatPercentageLocation }> } };

export type DeleteVatPercentageMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteVatPercentageMutation = { __typename?: 'Mutation', deleteVatPercentage: boolean };

export type RestoreVatPercentageMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RestoreVatPercentageMutation = { __typename?: 'Mutation', restoreVatPercentage: { __typename?: 'VatPercentage', id: string, discardedAt?: any | null } };

export type CreateEntityMutationVariables = Exact<{
  input: EntityInput;
}>;


export type CreateEntityMutation = { __typename?: 'Mutation', createEntity: { __typename?: 'Entity', id: string } };

export type EntityFieldsFragment = { __typename?: 'Entity', id: string, name: string, registrationNumber?: string | null, vatRegistrationNumber?: string | null, address?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, faxNumber?: string | null, websiteUrl?: string | null, email?: string | null, logoUrl?: string | null, altNameTranslations?: any | null, altAddressTranslations?: any | null, discardedAt?: any | null, bankDetails?: string | null, altBankDetailsTranslations?: any | null };

export type EntityQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EntityQuery = { __typename?: 'Query', entity: { __typename?: 'Entity', id: string, registrationNumber?: string | null, vatRegistrationNumber?: string | null, address?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, faxNumber?: string | null, websiteUrl?: string | null, email?: string | null, logoUrl?: string | null, altNameTranslations?: any | null, altAddressTranslations?: any | null, discardedAt?: any | null, invoiceCode?: string | null, invoiceInitialNumberSequence?: number | null, bankDetails?: string | null, altBankDetailsTranslations?: any | null, name: string } };

export type UpdateEntityMutationVariables = Exact<{
  id: Scalars['ID'];
  input: EntityInput;
}>;


export type UpdateEntityMutation = { __typename?: 'Mutation', updateEntity: { __typename?: 'Entity', id: string, registrationNumber?: string | null, vatRegistrationNumber?: string | null, address?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, faxNumber?: string | null, websiteUrl?: string | null, email?: string | null, logoUrl?: string | null, altNameTranslations?: any | null, altAddressTranslations?: any | null, invoiceCode?: string | null, invoiceInitialNumberSequence?: number | null, bankDetails?: string | null, altBankDetailsTranslations?: any | null, name: string } };

export type EntitiesQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type EntitiesQuery = { __typename?: 'Query', entities: { __typename?: 'EntityConnection', totalCount: number, nodes: Array<{ __typename?: 'Entity', id: string, name: string, registrationNumber?: string | null, vatRegistrationNumber?: string | null, address?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, faxNumber?: string | null, websiteUrl?: string | null, email?: string | null, logoUrl?: string | null, altNameTranslations?: any | null, altAddressTranslations?: any | null, discardedAt?: any | null, bankDetails?: string | null, altBankDetailsTranslations?: any | null }> } };

export type DeleteEntityMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteEntityMutation = { __typename?: 'Mutation', deleteEntity: boolean };

export type AutocompleteEntitiesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type AutocompleteEntitiesQuery = { __typename?: 'Query', entities: { __typename?: 'EntityConnection', nodes: Array<{ __typename?: 'Entity', id: string, name: string }> } };

export type RestoreEntityMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RestoreEntityMutation = { __typename?: 'Mutation', restoreEntity: { __typename?: 'Entity', id: string, discardedAt?: any | null } };

export type CreateIndirectCostMutationVariables = Exact<{
  input: UserCostInput;
}>;


export type CreateIndirectCostMutation = { __typename?: 'Mutation', createUserCost: { __typename?: 'UserCost', id: string, amount: number, frequency: UserCostFrequencyEnum, fromDate: any, toDate?: any | null, notes?: string | null, userCostType?: { __typename?: 'UserCostType', id: string, name: string } | null } };

export type UpdateIndirectCostMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UserCostInput;
}>;


export type UpdateIndirectCostMutation = { __typename?: 'Mutation', updateUserCost: { __typename?: 'UserCost', id: string, amount: number, frequency: UserCostFrequencyEnum, fromDate: any, toDate?: any | null, notes?: string | null, userCostType?: { __typename?: 'UserCostType', id: string, name: string } | null } };

export type IndirectCostsQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<UserCostFilterInput>;
}>;


export type IndirectCostsQuery = { __typename?: 'Query', userCosts: { __typename?: 'UserCostConnection', totalCount: number, nodes: Array<{ __typename?: 'UserCost', id: string, amount: number, frequency: UserCostFrequencyEnum, fromDate: any, toDate?: any | null, notes?: string | null, userCostType?: { __typename?: 'UserCostType', id: string, name: string } | null }> } };

export type DeleteIndirectCostMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteIndirectCostMutation = { __typename?: 'Mutation', deleteUserCost: boolean };

export type SyncContactsWithMailchimpMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncContactsWithMailchimpMutation = { __typename?: 'Mutation', syncContactsWithMailchimp: boolean };

export type CreateInvoiceTemplateMutationVariables = Exact<{
  input: InvoiceTemplateInput;
}>;


export type CreateInvoiceTemplateMutation = { __typename?: 'Mutation', createInvoiceTemplate: { __typename?: 'InvoiceTemplate', id: string } };

export type InvoiceTemplateQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type InvoiceTemplateQuery = { __typename?: 'Query', invoiceTemplate: { __typename?: 'InvoiceTemplate', id: string, name: string, language?: string | null, detailLevel: InvoiceTemplateDetail, layout: InvoiceTemplateLayout, entity?: { __typename?: 'Entity', id: string, name: string } | null } };

export type UpdateInvoiceTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
  input: InvoiceTemplateInput;
}>;


export type UpdateInvoiceTemplateMutation = { __typename?: 'Mutation', updateInvoiceTemplate: { __typename?: 'InvoiceTemplate', id: string, name: string, language?: string | null, detailLevel: InvoiceTemplateDetail, layout: InvoiceTemplateLayout, entity?: { __typename?: 'Entity', id: string, name: string } | null } };

export type InvoiceTemplatesQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type InvoiceTemplatesQuery = { __typename?: 'Query', invoiceTemplates: { __typename?: 'InvoiceTemplateConnection', totalCount: number, nodes: Array<{ __typename?: 'InvoiceTemplate', id: string, name: string, language?: string | null, detailLevel: InvoiceTemplateDetail, entity?: { __typename?: 'Entity', id: string, name: string } | null }> } };

export type DeleteInvoiceTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteInvoiceTemplateMutation = { __typename?: 'Mutation', deleteInvoiceTemplate: boolean };

export type AutocompleteInvoiceTemplatesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<InvoiceTemplateFilterInput>;
}>;


export type AutocompleteInvoiceTemplatesQuery = { __typename?: 'Query', invoiceTemplates: { __typename?: 'InvoiceTemplateConnection', nodes: Array<{ __typename?: 'InvoiceTemplate', id: string, name: string, detailLevel: InvoiceTemplateDetail }> } };

export type AccountSettingsFieldsFragment = { __typename?: 'Account', id: string, invoiceNumberMask?: string | null, invoiceNumberLength?: number | null, creditNoteMark?: string | null, creditNoteMarkPosition?: boolean | null, invoiceNumberResetFrequency?: InvoiceNumberResetFrequency | null, badDebtStatusAfter?: number | null, locale?: string | null, otherLocales: Array<string>, timeZoneName: string, firstApprover?: string | null, timeFormat: TimeFormat, defaultCaseDescriptions: any, footnotes: any, clientInactiveAfter?: number | null, legalCaseNumberLength?: number | null, unpaidInvoiceNotificationIntervalDays?: number | null, smtpHost?: string | null, smtpPort?: string | null, smtpUser?: string | null, smtpPasswordPresent: boolean, notificationEmailFromAddressInternal?: string | null, notificationEmailFromAddressExternal?: string | null, caseNumberingByClient?: boolean | null, caseNumberingShown?: boolean | null, monthlyUserCountEstimate?: number | null, showFinishSetupFrom: any, logoUrl?: string | null, allowedTcCreationTime?: number | null, dateFormat: string, availableDateFormats: Array<string>, mailchimpApiKeyPresent: boolean, mailchimpApiListId?: string | null, mailchimpServerId?: string | null, autoSyncContactsWithMailchimp?: boolean | null, featureFlags?: string | null, familyNameFirst: boolean, amlRecurrency?: number | null, currency?: { __typename?: 'Currency', id: string, name: string } | null, paymentTerm?: { __typename?: 'PaymentTerm', id: string, days: number } | null, invoiceApprovers: Array<{ __typename?: 'InvoiceApprover', id?: string | null, name?: string | null, group?: string | null } | null>, reportSchedules: Array<{ __typename?: 'ReportSchedule', reportType: ReportTypeEnum, frequency: ReportFrequencyEnum, dayOfWeek?: number | null, dayOfMonth?: number | null, excludeExternals?: boolean | null }> };

export type AccountSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountSettingsQuery = { __typename?: 'Query', currentAccount: { __typename?: 'Account', id: string, invoiceNumberMask?: string | null, invoiceNumberLength?: number | null, creditNoteMark?: string | null, creditNoteMarkPosition?: boolean | null, invoiceNumberResetFrequency?: InvoiceNumberResetFrequency | null, badDebtStatusAfter?: number | null, locale?: string | null, otherLocales: Array<string>, timeZoneName: string, firstApprover?: string | null, timeFormat: TimeFormat, defaultCaseDescriptions: any, footnotes: any, clientInactiveAfter?: number | null, legalCaseNumberLength?: number | null, unpaidInvoiceNotificationIntervalDays?: number | null, smtpHost?: string | null, smtpPort?: string | null, smtpUser?: string | null, smtpPasswordPresent: boolean, notificationEmailFromAddressInternal?: string | null, notificationEmailFromAddressExternal?: string | null, caseNumberingByClient?: boolean | null, caseNumberingShown?: boolean | null, monthlyUserCountEstimate?: number | null, showFinishSetupFrom: any, logoUrl?: string | null, allowedTcCreationTime?: number | null, dateFormat: string, availableDateFormats: Array<string>, mailchimpApiKeyPresent: boolean, mailchimpApiListId?: string | null, mailchimpServerId?: string | null, autoSyncContactsWithMailchimp?: boolean | null, featureFlags?: string | null, familyNameFirst: boolean, amlRecurrency?: number | null, currency?: { __typename?: 'Currency', id: string, name: string } | null, paymentTerm?: { __typename?: 'PaymentTerm', id: string, days: number } | null, invoiceApprovers: Array<{ __typename?: 'InvoiceApprover', id?: string | null, name?: string | null, group?: string | null } | null>, reportSchedules: Array<{ __typename?: 'ReportSchedule', reportType: ReportTypeEnum, frequency: ReportFrequencyEnum, dayOfWeek?: number | null, dayOfMonth?: number | null, excludeExternals?: boolean | null }> } };

export type UpdateAccountSettingsMutationVariables = Exact<{
  input: AccountSettingsInput;
}>;


export type UpdateAccountSettingsMutation = { __typename?: 'Mutation', updateCurrentAccountSettings: { __typename?: 'Account', id: string, invoiceNumberMask?: string | null, invoiceNumberLength?: number | null, creditNoteMark?: string | null, creditNoteMarkPosition?: boolean | null, invoiceNumberResetFrequency?: InvoiceNumberResetFrequency | null, badDebtStatusAfter?: number | null, locale?: string | null, otherLocales: Array<string>, timeZoneName: string, firstApprover?: string | null, timeFormat: TimeFormat, defaultCaseDescriptions: any, footnotes: any, clientInactiveAfter?: number | null, legalCaseNumberLength?: number | null, unpaidInvoiceNotificationIntervalDays?: number | null, smtpHost?: string | null, smtpPort?: string | null, smtpUser?: string | null, smtpPasswordPresent: boolean, notificationEmailFromAddressInternal?: string | null, notificationEmailFromAddressExternal?: string | null, caseNumberingByClient?: boolean | null, caseNumberingShown?: boolean | null, monthlyUserCountEstimate?: number | null, showFinishSetupFrom: any, logoUrl?: string | null, allowedTcCreationTime?: number | null, dateFormat: string, availableDateFormats: Array<string>, mailchimpApiKeyPresent: boolean, mailchimpApiListId?: string | null, mailchimpServerId?: string | null, autoSyncContactsWithMailchimp?: boolean | null, featureFlags?: string | null, familyNameFirst: boolean, amlRecurrency?: number | null, currency?: { __typename?: 'Currency', id: string, name: string } | null, paymentTerm?: { __typename?: 'PaymentTerm', id: string, days: number } | null, invoiceApprovers: Array<{ __typename?: 'InvoiceApprover', id?: string | null, name?: string | null, group?: string | null } | null>, reportSchedules: Array<{ __typename?: 'ReportSchedule', reportType: ReportTypeEnum, frequency: ReportFrequencyEnum, dayOfWeek?: number | null, dayOfMonth?: number | null, excludeExternals?: boolean | null }> } };

export type NotificationTextConfigurationQueryVariables = Exact<{
  kind: NotificationKind;
}>;


export type NotificationTextConfigurationQuery = { __typename?: 'Query', notificationConfiguration: { __typename?: 'NotificationConfiguration', id?: string | null, kind?: NotificationKind | null, emailSubjectTranslations: any, emailBodyTranslations: any } };

export type UpdateNotificationConfigurationMutationVariables = Exact<{
  kind: NotificationKind;
  input: NotificationConfigurationInput;
}>;


export type UpdateNotificationConfigurationMutation = { __typename?: 'Mutation', updateNotificationConfiguration: { __typename?: 'NotificationConfiguration', id?: string | null, emailSubjectTranslations: any, emailBodyTranslations: any } };

export type CreatePriceListMutationVariables = Exact<{
  input: PriceListInput;
}>;


export type CreatePriceListMutation = { __typename?: 'Mutation', createPriceList: { __typename?: 'PriceList', id: string } };

export type UpdatePriceListMutationVariables = Exact<{
  id: Scalars['ID'];
  input: PriceListInput;
}>;


export type UpdatePriceListMutation = { __typename?: 'Mutation', updatePriceList: { __typename?: 'PriceList', id: string, name: string, default: boolean, priceListRates: Array<{ __typename?: 'PriceListRate', id?: string | null, pricedType: string, rate?: number | null, currency?: { __typename?: 'Currency', id: string, name: string } | null, priced?: { __typename?: 'Priced', id: string, name: string, positionName?: string | null, sequence?: number | null } | null } | null> } };

export type PriceListsFieldsFragment = { __typename?: 'PriceList', id: string, name: string, default: boolean };

export type PriceListFieldsFragment = { __typename?: 'PriceList', id: string, name: string, default: boolean, priceListRates: Array<{ __typename?: 'PriceListRate', id?: string | null, pricedType: string, rate?: number | null, currency?: { __typename?: 'Currency', id: string, name: string } | null, priced?: { __typename?: 'Priced', id: string, name: string, positionName?: string | null, sequence?: number | null } | null } | null> };

export type PriceListQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PriceListQuery = { __typename?: 'Query', priceList: { __typename?: 'PriceList', id: string, name: string, default: boolean, priceListRates: Array<{ __typename?: 'PriceListRate', id?: string | null, pricedType: string, rate?: number | null, currency?: { __typename?: 'Currency', id: string, name: string } | null, priced?: { __typename?: 'Priced', id: string, name: string, positionName?: string | null, sequence?: number | null } | null } | null> } };

export type PriceListMinimalQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PriceListMinimalQuery = { __typename?: 'Query', priceList: { __typename?: 'PriceList', id: string, name: string } };

export type DeletePriceListMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletePriceListMutation = { __typename?: 'Mutation', deletePriceList: boolean };

export type PriceListsQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<PriceListFilterInput>;
}>;


export type PriceListsQuery = { __typename?: 'Query', priceLists: { __typename?: 'PriceListConnection', totalCount: number, nodes: Array<{ __typename?: 'PriceList', id: string, name: string, default: boolean }> } };

export type PriceListRatesQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<PriceListRateFilterInput>;
}>;


export type PriceListRatesQuery = { __typename?: 'Query', priceListRates: { __typename?: 'PriceListRateConnection', totalCount: number, nodes: Array<{ __typename?: 'PriceListRate', id?: string | null, rate?: number | null, pricedType: string, priced?: { __typename?: 'Priced', id: string, name: string, positionName?: string | null, sequence?: number | null } | null, currency?: { __typename?: 'Currency', id: string } | null }> } };

export type SwitchDefaultPriceListMutationVariables = Exact<{
  id: Scalars['ID'];
  default: Scalars['Boolean'];
}>;


export type SwitchDefaultPriceListMutation = { __typename?: 'Mutation', switchDefaultPriceList: { __typename?: 'PriceList', id: string, name: string, default: boolean } };

export type AutocompletePriceListsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<PriceListFilterInput>;
}>;


export type AutocompletePriceListsQuery = { __typename?: 'Query', priceLists: { __typename?: 'PriceListConnection', nodes: Array<{ __typename?: 'PriceList', id: string, name: string }> } };

export type CreateUserRoleMutationVariables = Exact<{
  input: UserRoleInput;
}>;


export type CreateUserRoleMutation = { __typename?: 'Mutation', createUserRole: { __typename?: 'UserRole', id: string } };

export type UpdateUserRoleMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UserRoleInput;
}>;


export type UpdateUserRoleMutation = { __typename?: 'Mutation', updateUserRole: { __typename?: 'UserRole', id: string, name: string, description?: string | null } };

export type UserRoleQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserRoleQuery = { __typename?: 'Query', userRole: { __typename?: 'UserRole', id: string, name: string, description?: string | null } };

export type UserRolesQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type UserRolesQuery = { __typename?: 'Query', userRoles: { __typename?: 'UserRoleConnection', totalCount: number, nodes: Array<{ __typename?: 'UserRole', id: string, name: string, description?: string | null, usersCount: number, updatedAt: any }> } };

export type AutocompleteUserRolesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type AutocompleteUserRolesQuery = { __typename?: 'Query', userRoles: { __typename?: 'UserRoleConnection', nodes: Array<{ __typename?: 'UserRole', id: string, name: string }> } };

export type DeleteUserRoleMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteUserRoleMutation = { __typename?: 'Mutation', deleteUserRole: boolean };

export type StartStripeCardRegistrationMutationVariables = Exact<{ [key: string]: never; }>;


export type StartStripeCardRegistrationMutation = { __typename?: 'Mutation', startStripeCardRegistration: { __typename?: 'StripeCardInitParams', intentSecret?: string | null, callbackPath: string } };

export type SubscriptionInfoFieldsFragment = { __typename?: 'SubscriptionInfo', id: string, terminationDate?: any | null, currentIntervalTillDate?: any | null, upcomingInvoice: { __typename?: 'SubscriptionUpcomingInvoice', id: string, dailyCount: number, dailyIntervalText?: string | null, monthlyCount: number, monthlyIntervalText?: string | null, userDayPrice: number, userMonthPrice: number, dailyNetAmount: number, monthlyNetAmount: number, correctionAmount: number, netAmount: number, vatPercentage: number, vatAmount: number, grossAmount: number, willTryPayAt?: any | null, currency: string, applicableCommitments: Array<{ __typename?: 'SubscriptionCommitment', id: string, priceExVat: number }> }, card?: { __typename?: 'StripeCard', id: string, cardNumber?: string | null, expiration?: string | null, ownerName?: string | null } | null };

export type SubscriptionDataQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionDataQuery = { __typename?: 'Query', subscriptionInfo: { __typename?: 'SubscriptionInfo', id: string, terminationDate?: any | null, currentIntervalTillDate?: any | null, upcomingInvoice: { __typename?: 'SubscriptionUpcomingInvoice', id: string, dailyCount: number, dailyIntervalText?: string | null, monthlyCount: number, monthlyIntervalText?: string | null, userDayPrice: number, userMonthPrice: number, dailyNetAmount: number, monthlyNetAmount: number, correctionAmount: number, netAmount: number, vatPercentage: number, vatAmount: number, grossAmount: number, willTryPayAt?: any | null, currency: string, applicableCommitments: Array<{ __typename?: 'SubscriptionCommitment', id: string, priceExVat: number }> }, card?: { __typename?: 'StripeCard', id: string, cardNumber?: string | null, expiration?: string | null, ownerName?: string | null } | null } };

export type TerminateSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type TerminateSubscriptionMutation = { __typename?: 'Mutation', terminateSubscription: { __typename?: 'SubscriptionInfo', id: string, terminationDate?: any | null, currentIntervalTillDate?: any | null, upcomingInvoice: { __typename?: 'SubscriptionUpcomingInvoice', id: string, dailyCount: number, dailyIntervalText?: string | null, monthlyCount: number, monthlyIntervalText?: string | null, userDayPrice: number, userMonthPrice: number, dailyNetAmount: number, monthlyNetAmount: number, correctionAmount: number, netAmount: number, vatPercentage: number, vatAmount: number, grossAmount: number, willTryPayAt?: any | null, currency: string, applicableCommitments: Array<{ __typename?: 'SubscriptionCommitment', id: string, priceExVat: number }> }, card?: { __typename?: 'StripeCard', id: string, cardNumber?: string | null, expiration?: string | null, ownerName?: string | null } | null } };

export type ResumeSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type ResumeSubscriptionMutation = { __typename?: 'Mutation', resumeSubscription: { __typename?: 'SubscriptionInfo', id: string, terminationDate?: any | null, currentIntervalTillDate?: any | null, upcomingInvoice: { __typename?: 'SubscriptionUpcomingInvoice', id: string, dailyCount: number, dailyIntervalText?: string | null, monthlyCount: number, monthlyIntervalText?: string | null, userDayPrice: number, userMonthPrice: number, dailyNetAmount: number, monthlyNetAmount: number, correctionAmount: number, netAmount: number, vatPercentage: number, vatAmount: number, grossAmount: number, willTryPayAt?: any | null, currency: string, applicableCommitments: Array<{ __typename?: 'SubscriptionCommitment', id: string, priceExVat: number }> }, card?: { __typename?: 'StripeCard', id: string, cardNumber?: string | null, expiration?: string | null, ownerName?: string | null } | null } };

export type SubscriptionSettingsFieldsFragment = { __typename?: 'AccountSubscriptionSettings', id: string, subscriptionDefaultPlan?: SubscriptionPlan | null, subscriptionInvoiceEmail?: string | null, subscriptionLawFirmName?: string | null, subscriptionLawFirmAddress?: string | null, subscriptionLawFirmPostalCode?: string | null, subscriptionLawFirmCountry?: string | null, subscriptionLawFirmVatRegistrationNumber?: string | null, subscriptionLawFirmRegistrationNumber?: string | null };

export type AccountSubscriptionSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountSubscriptionSettingsQuery = { __typename?: 'Query', accountSubscriptionSettings: { __typename?: 'AccountSubscriptionSettings', id: string, subscriptionDefaultPlan?: SubscriptionPlan | null, subscriptionInvoiceEmail?: string | null, subscriptionLawFirmName?: string | null, subscriptionLawFirmAddress?: string | null, subscriptionLawFirmPostalCode?: string | null, subscriptionLawFirmCountry?: string | null, subscriptionLawFirmVatRegistrationNumber?: string | null, subscriptionLawFirmRegistrationNumber?: string | null } };

export type UpdateAccountSubscriptionSettingsMutationVariables = Exact<{
  input: AccountSubscriptionSettingsInput;
}>;


export type UpdateAccountSubscriptionSettingsMutation = { __typename?: 'Mutation', updateAccountSubscriptionSettings: { __typename?: 'AccountSubscriptionSettings', id: string, subscriptionDefaultPlan?: SubscriptionPlan | null, subscriptionInvoiceEmail?: string | null, subscriptionLawFirmName?: string | null, subscriptionLawFirmAddress?: string | null, subscriptionLawFirmPostalCode?: string | null, subscriptionLawFirmCountry?: string | null, subscriptionLawFirmVatRegistrationNumber?: string | null, subscriptionLawFirmRegistrationNumber?: string | null } };

export type SubscriptionCommitmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionCommitmentsQuery = { __typename?: 'Query', subscriptionCommitments: { __typename?: 'SubscriptionCommitmentConnection', nodes: Array<{ __typename?: 'SubscriptionCommitment', id: string, priceExVat: number, currency?: string | null, fromDate?: any | null, tillDate?: any | null }> } };

export type SubscriptionCommitmentChangeDataQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionCommitmentChangeDataQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', totalCount: number }, accountSubscriptionSettings: { __typename?: 'AccountSubscriptionSettings', id: string, subscriptionRequestedLongTermCommitments?: number | null }, subscriptionInfo: { __typename?: 'SubscriptionInfo', id: string, currentCurrency: string, currentUserMonthPrice: number, currentUserMonthPriceLongTermCommitment: number, currentIntervalTillDate?: any | null } };

export type UpdateAccountSubscriptionCommitmentsMutationVariables = Exact<{
  input: AccountSubscriptionSettingsInput;
}>;


export type UpdateAccountSubscriptionCommitmentsMutation = { __typename?: 'Mutation', updateAccountSubscriptionSettings: { __typename?: 'AccountSubscriptionSettings', id: string, subscriptionRequestedLongTermCommitments?: number | null } };

export type SubscriptionInvoiceFieldsFragment = { __typename?: 'SubscriptionInvoice', id: string, number: string, date: any, description: string, grossAmount: number, state: SubscriptionInvoiceState, dueDate?: any | null, paidAt?: any | null, printoutPdfUrl?: string | null, paymentError?: string | null, currency: string };

export type SubscriptionInvoicesQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionInvoicesQuery = { __typename?: 'Query', subscriptionInvoices: { __typename?: 'SubscriptionInvoiceConnection', nodes: Array<{ __typename?: 'SubscriptionInvoice', id: string, number: string, date: any, description: string, grossAmount: number, state: SubscriptionInvoiceState, dueDate?: any | null, paidAt?: any | null, printoutPdfUrl?: string | null, paymentError?: string | null, currency: string }> } };

export type RefreshSubscriptionInvoicePdfMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RefreshSubscriptionInvoicePdfMutation = { __typename?: 'Mutation', refreshSubscriptionInvoicePdf: { __typename?: 'SubscriptionInvoice', id: string, number: string, date: any, description: string, grossAmount: number, state: SubscriptionInvoiceState, dueDate?: any | null, paidAt?: any | null, printoutPdfUrl?: string | null, paymentError?: string | null, currency: string } };

export type PaySubscriptionInvoiceMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PaySubscriptionInvoiceMutation = { __typename?: 'Mutation', paySubscriptionInvoice: { __typename?: 'SubscriptionPayInvoiceResponse', paymentResult: { __typename?: 'StripePaymentResult', status: string, paymentSecret?: string | null, subscriptionPaymentId?: string | null }, invoice: { __typename?: 'SubscriptionInvoice', id: string, number: string, date: any, description: string, grossAmount: number, state: SubscriptionInvoiceState, dueDate?: any | null, paidAt?: any | null, printoutPdfUrl?: string | null, paymentError?: string | null, currency: string } } };

export type ConfirmSubscriptionInvoicePaymentMutationVariables = Exact<{
  subscriptionPaymentId: Scalars['ID'];
}>;


export type ConfirmSubscriptionInvoicePaymentMutation = { __typename?: 'Mutation', confirmSubscriptionInvoicePayment: { __typename?: 'SubscriptionInvoice', id: string, number: string, date: any, description: string, grossAmount: number, state: SubscriptionInvoiceState, dueDate?: any | null, paidAt?: any | null, printoutPdfUrl?: string | null, paymentError?: string | null, currency: string } };

export type CancelSubscriptionInvoicePaymentMutationVariables = Exact<{
  subscriptionPaymentId: Scalars['ID'];
  errorMessage: Scalars['String'];
}>;


export type CancelSubscriptionInvoicePaymentMutation = { __typename?: 'Mutation', cancelSubscriptionInvoicePayment: { __typename?: 'SubscriptionInvoice', id: string, number: string, date: any, description: string, grossAmount: number, state: SubscriptionInvoiceState, dueDate?: any | null, paidAt?: any | null, printoutPdfUrl?: string | null, paymentError?: string | null, currency: string } };

export type TestCurrentAccountEmailSettingsMutationVariables = Exact<{ [key: string]: never; }>;


export type TestCurrentAccountEmailSettingsMutation = { __typename?: 'Mutation', testCurrentAccountEmailSettings: boolean };

export type CreateTeamMutationVariables = Exact<{
  input: TeamInput;
}>;


export type CreateTeamMutation = { __typename?: 'Mutation', createTeam: { __typename?: 'Team', id: string } };

export type TeamQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TeamQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, altNameTranslations: any, name: string, supervisor?: { __typename?: 'User', id: string, fullName: string } | null } };

export type UpdateTeamMutationVariables = Exact<{
  id: Scalars['ID'];
  input: TeamInput;
}>;


export type UpdateTeamMutation = { __typename?: 'Mutation', updateTeam: { __typename?: 'Team', id: string, name: string, altNameTranslations: any, supervisor?: { __typename?: 'User', id: string, fullName: string } | null } };

export type CreateTeamMembershipMutationVariables = Exact<{
  input: TeamMembershipInput;
}>;


export type CreateTeamMembershipMutation = { __typename?: 'Mutation', createTeamMembership: { __typename?: 'TeamMembership', id: string } };

export type TeamsQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type TeamsQuery = { __typename?: 'Query', teams: { __typename?: 'TeamConnection', totalCount: number, nodes: Array<{ __typename?: 'Team', id: string, name: string, teamMembersCount: number, supervisor?: { __typename?: 'User', id: string, fullName: string } | null }> } };

export type DeleteTeamMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteTeamMutation = { __typename?: 'Mutation', deleteTeam: boolean };

export type TeamMembershipsQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<TeamMembershipFilterInput>;
}>;


export type TeamMembershipsQuery = { __typename?: 'Query', teamMemberships: { __typename?: 'TeamMembershipConnection', totalCount: number, nodes: Array<{ __typename?: 'TeamMembership', id: string, teamId?: string | null, user?: { __typename?: 'User', id: string, fullName: string } | null, supervisor?: { __typename?: 'User', id: string, fullName: string } | null }> } };

export type DeleteTeamMembershipMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteTeamMembershipMutation = { __typename?: 'Mutation', deleteTeamMembership: boolean };

export type UpdateTeamMembershipMutationVariables = Exact<{
  id: Scalars['ID'];
  input: TeamMembershipInput;
}>;


export type UpdateTeamMembershipMutation = { __typename?: 'Mutation', updateTeamMembership: { __typename?: 'TeamMembership', id: string, supervisor?: { __typename?: 'User', id: string, fullName: string } | null } };

export type CreateUserApiTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateUserApiTokenMutation = { __typename?: 'Mutation', createUserApiToken: { __typename?: 'UserAPIToken', id: string, name: string, token?: string | null } };

export type UserApiTokensQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<UserApiTokenFilterInput>;
}>;


export type UserApiTokensQuery = { __typename?: 'Query', userApiTokens: { __typename?: 'UserAPITokenConnection', totalCount: number, nodes: Array<{ __typename?: 'UserAPIToken', id: string, name: string, createdAt: any, accessedAt?: any | null }> } };

export type DeleteUserApiTokenMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteUserApiTokenMutation = { __typename?: 'Mutation', deleteUserApiToken: boolean };

export type UserCalendarsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserCalendarsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, configuredCalendarProviders: Array<CalendarProvider>, calendars: Array<{ __typename?: 'Calendar', id: string, provider: CalendarProvider, name: string, primary: boolean, synchronize: boolean }> } };

export type UpdateUserCalendarMutationVariables = Exact<{
  id: Scalars['ID'];
  input: CalendarInput;
}>;


export type UpdateUserCalendarMutation = { __typename?: 'Mutation', updateCalendar: { __typename?: 'Calendar', id: string, synchronize: boolean } };

export type InviteUserMutationVariables = Exact<{
  input: UserInput;
}>;


export type InviteUserMutation = { __typename?: 'Mutation', inviteUser: boolean };

export type AccountSubscriptionDefaultPlanQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountSubscriptionDefaultPlanQuery = { __typename?: 'Query', accountSubscriptionSettings: { __typename?: 'AccountSubscriptionSettings', id: string, subscriptionDefaultPlan?: SubscriptionPlan | null } };

export type ChangePasswordMutationVariables = Exact<{
  id: Scalars['ID'];
  userId: Scalars['ID'];
  input: UserCredentialInput;
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: boolean };

export type TimeZonesQueryVariables = Exact<{ [key: string]: never; }>;


export type TimeZonesQuery = { __typename?: 'Query', timeZones: Array<{ __typename?: 'TimeZone', id: string }> };

export type UnlockUserMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UnlockUserMutation = { __typename?: 'Mutation', unlockUser: { __typename?: 'User', id: string, accessLocked: boolean } };

export type FullUserFieldsFragment = { __typename?: 'User', id: string, firstName: string, altFirstNameTranslations: any, lastName?: string | null, altLastNameTranslations: any, linkedinProfileUrl?: string | null, phone?: string | null, fullName: string, dateOfBirth?: any | null, admin?: boolean | null, subscriptionPlan: SubscriptionPlan, employmentType: EmploymentType, subscriptionPlanAtIntervalStart?: SubscriptionPlan | null, startDate?: any | null, lastWorkingDay?: any | null, current: boolean, profilePictureUrl?: string | null, accessLocked: boolean, iconPack?: IconPack | null, userCredential?: { __typename?: 'UserCredential', id: string, email: string, lastSignInAt?: any | null } | null, position?: { __typename?: 'Position', id: string, name: string } | null, userRole?: { __typename?: 'UserRole', id: string, name: string } | null, clockTimeZones: Array<{ __typename?: 'TimeZone', id: string }> };

export type UserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, altFirstNameTranslations: any, lastName?: string | null, altLastNameTranslations: any, linkedinProfileUrl?: string | null, phone?: string | null, fullName: string, dateOfBirth?: any | null, admin?: boolean | null, subscriptionPlan: SubscriptionPlan, employmentType: EmploymentType, subscriptionPlanAtIntervalStart?: SubscriptionPlan | null, startDate?: any | null, lastWorkingDay?: any | null, current: boolean, profilePictureUrl?: string | null, accessLocked: boolean, iconPack?: IconPack | null, userCredential?: { __typename?: 'UserCredential', id: string, email: string, lastSignInAt?: any | null } | null, position?: { __typename?: 'Position', id: string, name: string } | null, userRole?: { __typename?: 'UserRole', id: string, name: string } | null, clockTimeZones: Array<{ __typename?: 'TimeZone', id: string }> } };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, firstName: string, altFirstNameTranslations: any, lastName?: string | null, altLastNameTranslations: any, linkedinProfileUrl?: string | null, phone?: string | null, fullName: string, dateOfBirth?: any | null, admin?: boolean | null, subscriptionPlan: SubscriptionPlan, employmentType: EmploymentType, subscriptionPlanAtIntervalStart?: SubscriptionPlan | null, startDate?: any | null, lastWorkingDay?: any | null, current: boolean, profilePictureUrl?: string | null, accessLocked: boolean, iconPack?: IconPack | null, userCredential?: { __typename?: 'UserCredential', id: string, email: string, lastSignInAt?: any | null } | null, position?: { __typename?: 'Position', id: string, name: string } | null, userRole?: { __typename?: 'UserRole', id: string, name: string } | null, clockTimeZones: Array<{ __typename?: 'TimeZone', id: string }> } };

export type ResendUserInvitationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ResendUserInvitationMutation = { __typename?: 'Mutation', resendUserInvitation: { __typename?: 'User', id: string } };

export type UsersQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<UserFilterInput>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type UsersQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', totalCount: number, nodes: Array<{ __typename?: 'User', id: string, firstName: string, lastName?: string | null, fullName: string, admin?: boolean | null, email?: string | null, subscriptionPlan: SubscriptionPlan, subscriptionPlanAtIntervalStart?: SubscriptionPlan | null, discardedAt?: any | null, startDate?: any | null, userCredential?: { __typename?: 'UserCredential', id: string, email: string, lastSignInAt?: any | null } | null, position?: { __typename?: 'Position', id: string, name: string } | null, userRole?: { __typename?: 'UserRole', id: string, name: string } | null }> } };

export type AutocompleteUsersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<UserFilterInput>;
}>;


export type AutocompleteUsersQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', totalCount: number, nodes: Array<{ __typename?: 'User', id: string, fullName: string, positionName?: string | null }> } };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: boolean };

export type RestoreUserMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RestoreUserMutation = { __typename?: 'Mutation', restoreUser: { __typename?: 'User', id: string, discardedAt?: any | null } };

export type MonthlyUserEstimateAlertQueryVariables = Exact<{ [key: string]: never; }>;


export type MonthlyUserEstimateAlertQuery = { __typename?: 'Query', monthlyUserEstimateInfo: { __typename?: 'MonthlyUserEstimateInfo', id: string, showAlert: boolean, estimatedCount?: number | null, currentCount?: number | null } };

export type MassInviteMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type MassInviteMutation = { __typename?: 'Mutation', massInvite: boolean };

export type NotificationFieldsFragment = { __typename?: 'User', notifyBadDebtInvoiceVia: NotificationDeliveryPreference, notifyClientOwnerVia: NotificationDeliveryPreference, notifyLegalCaseDeadlineVia: NotificationDeliveryPreference, notifyInvoiceReviewRequestVia: NotificationDeliveryPreference, notifyLegalCaseCostCapVia: NotificationDeliveryPreference, notifyUnpaidInvoiceInternalVia: NotificationDeliveryPreference, notifyLegalCaseManagerVia: NotificationDeliveryPreference, notifyLegalCaseConnectedLawyerVia: NotificationDeliveryPreference, notifyLegalCaseOwnerVia: NotificationDeliveryPreference, notifyLegalCaseOwnershipChangeVia: NotificationDeliveryPreference, notifyClientOwnershipChangeVia: NotificationDeliveryPreference, notifyUninvoicedClientVia: NotificationDeliveryPreference };

export type UserNotificationsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserNotificationsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, notifyBadDebtInvoiceVia: NotificationDeliveryPreference, notifyClientOwnerVia: NotificationDeliveryPreference, notifyLegalCaseDeadlineVia: NotificationDeliveryPreference, notifyInvoiceReviewRequestVia: NotificationDeliveryPreference, notifyLegalCaseCostCapVia: NotificationDeliveryPreference, notifyUnpaidInvoiceInternalVia: NotificationDeliveryPreference, notifyLegalCaseManagerVia: NotificationDeliveryPreference, notifyLegalCaseConnectedLawyerVia: NotificationDeliveryPreference, notifyLegalCaseOwnerVia: NotificationDeliveryPreference, notifyLegalCaseOwnershipChangeVia: NotificationDeliveryPreference, notifyClientOwnershipChangeVia: NotificationDeliveryPreference, notifyUninvoicedClientVia: NotificationDeliveryPreference } };

export type UpdateUserNotificationsMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UserInput;
}>;


export type UpdateUserNotificationsMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, notifyBadDebtInvoiceVia: NotificationDeliveryPreference, notifyClientOwnerVia: NotificationDeliveryPreference, notifyLegalCaseDeadlineVia: NotificationDeliveryPreference, notifyInvoiceReviewRequestVia: NotificationDeliveryPreference, notifyLegalCaseCostCapVia: NotificationDeliveryPreference, notifyUnpaidInvoiceInternalVia: NotificationDeliveryPreference, notifyLegalCaseManagerVia: NotificationDeliveryPreference, notifyLegalCaseConnectedLawyerVia: NotificationDeliveryPreference, notifyLegalCaseOwnerVia: NotificationDeliveryPreference, notifyLegalCaseOwnershipChangeVia: NotificationDeliveryPreference, notifyClientOwnershipChangeVia: NotificationDeliveryPreference, notifyUninvoicedClientVia: NotificationDeliveryPreference } };

export type CreateUserSalaryMutationVariables = Exact<{
  input: UserSalaryInput;
}>;


export type CreateUserSalaryMutation = { __typename?: 'Mutation', createUserSalary: { __typename?: 'UserSalary', id: string, amount: number, fromDate: any, toDate?: any | null } };

export type UserSalaryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserSalaryQuery = { __typename?: 'Query', userSalary: { __typename?: 'UserSalary', id: string, amount: number, fromDate: any, toDate?: any | null } };

export type UpdateUserSalaryMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UserSalaryInput;
}>;


export type UpdateUserSalaryMutation = { __typename?: 'Mutation', updateUserSalary: { __typename?: 'UserSalary', id: string, amount: number, fromDate: any, toDate?: any | null } };

export type CreateUserHourlyRateMutationVariables = Exact<{
  input: UserHourlyRateInput;
}>;


export type CreateUserHourlyRateMutation = { __typename?: 'Mutation', createUserHourlyRate: { __typename?: 'UserHourlyRate', id: string, rate: number, fromDate: any, toDate?: any | null } };

export type UserHourlyRateQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserHourlyRateQuery = { __typename?: 'Query', userHourlyRate: { __typename?: 'UserHourlyRate', id: string, rate: number, fromDate: any, toDate?: any | null } };

export type UpdateUserHourlyRateMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UserHourlyRateInput;
}>;


export type UpdateUserHourlyRateMutation = { __typename?: 'Mutation', updateUserHourlyRate: { __typename?: 'UserHourlyRate', id: string, rate: number, fromDate: any, toDate?: any | null } };

export type UserHourlyRatesQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<UserHourlyRateFilterInput>;
}>;


export type UserHourlyRatesQuery = { __typename?: 'Query', userHourlyRates: { __typename?: 'UserHourlyRateConnection', totalCount: number, nodes: Array<{ __typename?: 'UserHourlyRate', id: string, rate: number, fromDate: any, toDate?: any | null }> } };

export type DeleteUserHourlyRateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteUserHourlyRateMutation = { __typename?: 'Mutation', deleteUserHourlyRate: boolean };

export type CreateUserCostMutationVariables = Exact<{
  input: UserCostInput;
}>;


export type CreateUserCostMutation = { __typename?: 'Mutation', createUserCost: { __typename?: 'UserCost', id: string, amount: number, frequency: UserCostFrequencyEnum, fromDate: any, toDate?: any | null, notes?: string | null, userCostType?: { __typename?: 'UserCostType', id: string, name: string } | null } };

export type UserCostQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserCostQuery = { __typename?: 'Query', userCost: { __typename?: 'UserCost', id: string, amount: number, frequency: UserCostFrequencyEnum, fromDate: any, toDate?: any | null, notes?: string | null, userCostType?: { __typename?: 'UserCostType', id: string, name: string } | null } };

export type UpdateUserCostMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UserCostInput;
}>;


export type UpdateUserCostMutation = { __typename?: 'Mutation', updateUserCost: { __typename?: 'UserCost', id: string, amount: number, frequency: UserCostFrequencyEnum, fromDate: any, toDate?: any | null, notes?: string | null, userCostType?: { __typename?: 'UserCostType', id: string, name: string } | null } };

export type UserCostsQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<UserCostFilterInput>;
}>;


export type UserCostsQuery = { __typename?: 'Query', userCosts: { __typename?: 'UserCostConnection', totalCount: number, nodes: Array<{ __typename?: 'UserCost', id: string, amount: number, frequency: UserCostFrequencyEnum, fromDate: any, toDate?: any | null, notes?: string | null, userCostType?: { __typename?: 'UserCostType', id: string, name: string } | null }> } };

export type DeleteUserCostMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteUserCostMutation = { __typename?: 'Mutation', deleteUserCost: boolean };

export type UserSalariesQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<UserSalaryFilterInput>;
}>;


export type UserSalariesQuery = { __typename?: 'Query', userSalaries: { __typename?: 'UserSalaryConnection', totalCount: number, nodes: Array<{ __typename?: 'UserSalary', id: string, amount: number, fromDate: any, toDate?: any | null }> } };

export type DeleteUserSalaryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteUserSalaryMutation = { __typename?: 'Mutation', deleteUserSalary: boolean };

export type CreatePerformanceTargetMutationVariables = Exact<{
  input: PerformanceTargetInput;
}>;


export type CreatePerformanceTargetMutation = { __typename?: 'Mutation', createPerformanceTarget: { __typename?: 'PerformanceTarget', id: string, periodFromDate: any, periodToDate: any, formattedTimeCardMinutes?: string | null } };

export type PerformanceTargetQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PerformanceTargetQuery = { __typename?: 'Query', performanceTarget: { __typename?: 'PerformanceTarget', id: string, periodFromDate: any, periodToDate: any, formattedTimeCardMinutes?: string | null } };

export type UpdatePerformanceTargetMutationVariables = Exact<{
  id: Scalars['ID'];
  input: PerformanceTargetInput;
}>;


export type UpdatePerformanceTargetMutation = { __typename?: 'Mutation', updatePerformanceTarget: { __typename?: 'PerformanceTarget', id: string, periodFromDate: any, periodToDate: any, formattedTimeCardMinutes?: string | null } };

export type PerformanceTargetsQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<PerformanceTargetFilterInput>;
}>;


export type PerformanceTargetsQuery = { __typename?: 'Query', performanceTargets: { __typename?: 'PerformanceTargetConnection', totalCount: number, nodes: Array<{ __typename?: 'PerformanceTarget', id: string, periodFromDate: any, periodToDate: any, formattedTimeCardMinutes?: string | null }> } };

export type DeletePerformanceTargetMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletePerformanceTargetMutation = { __typename?: 'Mutation', deletePerformanceTarget: boolean };

export type ClientPresenceQueryVariables = Exact<{
  filter?: InputMaybe<ClientFilterInput>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type ClientPresenceQuery = { __typename?: 'Query', clientPresence: boolean };

export type CreateClientMutationVariables = Exact<{
  input: ClientInput;
}>;


export type CreateClientMutation = { __typename?: 'Mutation', createClient: { __typename?: 'Client', id: string } };

export type CreateUserNoteMutationVariables = Exact<{
  input: UserNoteInput;
}>;


export type CreateUserNoteMutation = { __typename?: 'Mutation', createUserNote: { __typename?: 'UserNote', id: string } };

export type CreateClientDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type CreateClientDetailsQuery = { __typename?: 'Query', priceLists: { __typename?: 'PriceListConnection', nodes: Array<{ __typename?: 'PriceList', id: string, name: string, default: boolean }> }, currentAccount: { __typename?: 'Account', id: string, locale?: string | null, currency?: { __typename?: 'Currency', id: string, name: string } | null, paymentTerm?: { __typename?: 'PaymentTerm', id: string, days: number } | null }, entities: { __typename?: 'EntityConnection', totalCount: number, nodes: Array<{ __typename?: 'Entity', id: string, name: string, registrationNumber?: string | null, vatRegistrationNumber?: string | null, address?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, faxNumber?: string | null, websiteUrl?: string | null, email?: string | null, logoUrl?: string | null, altNameTranslations?: any | null, altAddressTranslations?: any | null, discardedAt?: any | null, bankDetails?: string | null, altBankDetailsTranslations?: any | null }> } };

export type ClientBillingFieldsFragment = { __typename?: 'Client', id: string, fullName?: string | null, identificationNumber?: string | null, vatRegistrationNumber?: string | null, address?: string | null, country?: string | null, postalCode?: string | null, billingAddressType: BillingAddressType, billingAddress?: string | null, billingCountry?: string | null, billingPostalCode?: string | null, billingPhone?: string | null, paymentType?: PaymentType | null, hourlyFeeType?: HourlyFeeType | null, discountPercentage?: number | null, language?: string | null, billingEmails: Array<string>, flatRate?: number | null, lawyerRate?: number | null, nonLawyerRate?: number | null, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, billingContact?: { __typename?: 'Contact', id: string, fullName: string, opponent: boolean } | null, paymentTerm?: { __typename?: 'PaymentTerm', id: string, days: number } | null, invoicingCurrency?: { __typename?: 'Currency', id: string, name: string } | null, invoiceIssuer?: { __typename?: 'Entity', id: string, name: string } | null, vatPercentage?: { __typename?: 'VatPercentage', id: string, percentage: number, location: VatPercentageLocation } | null, standardPriceList?: { __typename?: 'PriceList', id: string, name: string } | null, customizedPriceList?: { __typename?: 'PriceList', id: string, name: string, priceListRates: Array<{ __typename?: 'PriceListRate', id?: string | null, pricedType: string, rate?: number | null, priced?: { __typename?: 'Priced', id: string, name: string, positionName?: string | null, sequence?: number | null } | null, currency?: { __typename?: 'Currency', id: string } | null } | null> } | null };

export type FullClientFieldsFragment = { __typename?: 'Client', id: string, name: string, entityType: EntityType, lastName?: string | null, address?: string | null, country?: string | null, identificationNumber?: string | null, language?: string | null, linkedinProfileUrl?: string | null, postalCode?: string | null, serviceLevel?: ClientServiceLevel | null, vatRegistrationNumber?: string | null, websiteUrl?: string | null, fullName?: string | null, ownershipStory?: string | null, antiMoneyLaundering: ClientAml, antiMoneyLaunderingDate?: any | null, engagementLetterExecuted: boolean, engagementLetterDate?: any | null, lastYearSales?: number | null, matterStatusReports: boolean, hasInvoicing: boolean, billingAddress?: string | null, billingCountry?: string | null, billingPostalCode?: string | null, billingPhone?: string | null, billingEmails: Array<string>, paymentType?: PaymentType | null, hourlyFeeType?: HourlyFeeType | null, discountPercentage?: number | null, supplierIdentifier?: string | null, invoiceByPost: boolean, latePaymentReminder: boolean, billingAddressType: BillingAddressType, flatRate?: number | null, lawyerRate?: number | null, nonLawyerRate?: number | null, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, formattedInvoicedMinutes: string, formattedUninvoicedMinutes: string, formattedNonBillableMinutes: string, formattedTotalMinutes?: string | null, openedOn?: any | null, number?: number | null, manager?: { __typename?: 'User', id: string, fullName: string } | null, industry?: { __typename?: 'Industry', id: string, name: string } | null, clientOwners: Array<{ __typename?: 'ClientOwner', id?: string | null, ownershipPercentage: number, user?: { __typename?: 'User', id: string, fullName: string } | null } | null>, shareholders?: Array<{ __typename?: 'Contact', id: string, fullName: string } | null> | null, marketingEffortTypes: Array<{ __typename?: 'MarketingEffortType', id: string, name: string } | null>, billingContact?: { __typename?: 'Contact', id: string, fullName: string, opponent: boolean } | null, invoicingCurrency?: { __typename?: 'Currency', id: string, name: string } | null, creditRating?: { __typename?: 'CreditRating', id: string, name: string } | null, paymentTerm?: { __typename?: 'PaymentTerm', id: string, days: number } | null, invoiceIssuer?: { __typename?: 'Entity', id: string, name: string } | null, currency?: { __typename?: 'Currency', id: string, name: string } | null, standardPriceList?: { __typename?: 'PriceList', id: string, name: string } | null, vatPercentage?: { __typename?: 'VatPercentage', id: string, percentage: number, location: VatPercentageLocation } | null, customizedPriceList?: { __typename?: 'PriceList', id: string, name: string, priceListRates: Array<{ __typename?: 'PriceListRate', id?: string | null, pricedType: string, rate?: number | null, priced?: { __typename?: 'Priced', id: string, name: string, positionName?: string | null, sequence?: number | null } | null, currency?: { __typename?: 'Currency', id: string } | null } | null> } | null, syncContact?: { __typename?: 'Contact', id: string, fullName: string, opponent: boolean, syncSourceType?: string | null } | null };

export type ClientQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ClientQuery = { __typename?: 'Query', client: { __typename?: 'Client', id: string, name: string, entityType: EntityType, lastName?: string | null, address?: string | null, country?: string | null, identificationNumber?: string | null, language?: string | null, linkedinProfileUrl?: string | null, postalCode?: string | null, serviceLevel?: ClientServiceLevel | null, vatRegistrationNumber?: string | null, websiteUrl?: string | null, fullName?: string | null, ownershipStory?: string | null, antiMoneyLaundering: ClientAml, antiMoneyLaunderingDate?: any | null, engagementLetterExecuted: boolean, engagementLetterDate?: any | null, lastYearSales?: number | null, matterStatusReports: boolean, hasInvoicing: boolean, billingAddress?: string | null, billingCountry?: string | null, billingPostalCode?: string | null, billingPhone?: string | null, billingEmails: Array<string>, paymentType?: PaymentType | null, hourlyFeeType?: HourlyFeeType | null, discountPercentage?: number | null, supplierIdentifier?: string | null, invoiceByPost: boolean, latePaymentReminder: boolean, billingAddressType: BillingAddressType, flatRate?: number | null, lawyerRate?: number | null, nonLawyerRate?: number | null, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, formattedInvoicedMinutes: string, formattedUninvoicedMinutes: string, formattedNonBillableMinutes: string, formattedTotalMinutes?: string | null, openedOn?: any | null, number?: number | null, manager?: { __typename?: 'User', id: string, fullName: string } | null, industry?: { __typename?: 'Industry', id: string, name: string } | null, clientOwners: Array<{ __typename?: 'ClientOwner', id?: string | null, ownershipPercentage: number, user?: { __typename?: 'User', id: string, fullName: string } | null } | null>, shareholders?: Array<{ __typename?: 'Contact', id: string, fullName: string } | null> | null, marketingEffortTypes: Array<{ __typename?: 'MarketingEffortType', id: string, name: string } | null>, billingContact?: { __typename?: 'Contact', id: string, fullName: string, opponent: boolean } | null, invoicingCurrency?: { __typename?: 'Currency', id: string, name: string } | null, creditRating?: { __typename?: 'CreditRating', id: string, name: string } | null, paymentTerm?: { __typename?: 'PaymentTerm', id: string, days: number } | null, invoiceIssuer?: { __typename?: 'Entity', id: string, name: string } | null, currency?: { __typename?: 'Currency', id: string, name: string } | null, standardPriceList?: { __typename?: 'PriceList', id: string, name: string } | null, vatPercentage?: { __typename?: 'VatPercentage', id: string, percentage: number, location: VatPercentageLocation } | null, customizedPriceList?: { __typename?: 'PriceList', id: string, name: string, priceListRates: Array<{ __typename?: 'PriceListRate', id?: string | null, pricedType: string, rate?: number | null, priced?: { __typename?: 'Priced', id: string, name: string, positionName?: string | null, sequence?: number | null } | null, currency?: { __typename?: 'Currency', id: string } | null } | null> } | null, syncContact?: { __typename?: 'Contact', id: string, fullName: string, opponent: boolean, syncSourceType?: string | null } | null } };

export type UpdateClientMutationVariables = Exact<{
  id: Scalars['ID'];
  input: ClientInput;
}>;


export type UpdateClientMutation = { __typename?: 'Mutation', updateClient: { __typename?: 'Client', id: string, name: string, entityType: EntityType, lastName?: string | null, address?: string | null, country?: string | null, identificationNumber?: string | null, language?: string | null, linkedinProfileUrl?: string | null, postalCode?: string | null, serviceLevel?: ClientServiceLevel | null, vatRegistrationNumber?: string | null, websiteUrl?: string | null, fullName?: string | null, ownershipStory?: string | null, antiMoneyLaundering: ClientAml, antiMoneyLaunderingDate?: any | null, engagementLetterExecuted: boolean, engagementLetterDate?: any | null, lastYearSales?: number | null, matterStatusReports: boolean, hasInvoicing: boolean, billingAddress?: string | null, billingCountry?: string | null, billingPostalCode?: string | null, billingPhone?: string | null, billingEmails: Array<string>, paymentType?: PaymentType | null, hourlyFeeType?: HourlyFeeType | null, discountPercentage?: number | null, supplierIdentifier?: string | null, invoiceByPost: boolean, latePaymentReminder: boolean, billingAddressType: BillingAddressType, flatRate?: number | null, lawyerRate?: number | null, nonLawyerRate?: number | null, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, formattedInvoicedMinutes: string, formattedUninvoicedMinutes: string, formattedNonBillableMinutes: string, formattedTotalMinutes?: string | null, openedOn?: any | null, number?: number | null, manager?: { __typename?: 'User', id: string, fullName: string } | null, industry?: { __typename?: 'Industry', id: string, name: string } | null, clientOwners: Array<{ __typename?: 'ClientOwner', id?: string | null, ownershipPercentage: number, user?: { __typename?: 'User', id: string, fullName: string } | null } | null>, shareholders?: Array<{ __typename?: 'Contact', id: string, fullName: string } | null> | null, marketingEffortTypes: Array<{ __typename?: 'MarketingEffortType', id: string, name: string } | null>, billingContact?: { __typename?: 'Contact', id: string, fullName: string, opponent: boolean } | null, invoicingCurrency?: { __typename?: 'Currency', id: string, name: string } | null, creditRating?: { __typename?: 'CreditRating', id: string, name: string } | null, paymentTerm?: { __typename?: 'PaymentTerm', id: string, days: number } | null, invoiceIssuer?: { __typename?: 'Entity', id: string, name: string } | null, currency?: { __typename?: 'Currency', id: string, name: string } | null, standardPriceList?: { __typename?: 'PriceList', id: string, name: string } | null, vatPercentage?: { __typename?: 'VatPercentage', id: string, percentage: number, location: VatPercentageLocation } | null, customizedPriceList?: { __typename?: 'PriceList', id: string, name: string, priceListRates: Array<{ __typename?: 'PriceListRate', id?: string | null, pricedType: string, rate?: number | null, priced?: { __typename?: 'Priced', id: string, name: string, positionName?: string | null, sequence?: number | null } | null, currency?: { __typename?: 'Currency', id: string } | null } | null> } | null, syncContact?: { __typename?: 'Contact', id: string, fullName: string, opponent: boolean, syncSourceType?: string | null } | null } };

export type ClientOwnershipQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ClientOwnershipQuery = { __typename?: 'Query', client: { __typename?: 'Client', id: string, clientOwners: Array<{ __typename?: 'ClientOwner', id?: string | null, ownershipPercentage: number, user?: { __typename?: 'User', id: string, fullName: string } | null } | null> } };

export type ClientManagersQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ClientManagersQuery = { __typename?: 'Query', client: { __typename?: 'Client', id: string, clientManagers: Array<{ __typename?: 'ClientManager', id?: string | null, fromDate: any, toDate?: any | null, createdAt: any, manager?: { __typename?: 'User', id: string, fullName: string } | null } | null> } };

export type ClientOwnershipPeriodsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ClientOwnershipPeriodsQuery = { __typename?: 'Query', client: { __typename?: 'Client', id: string, clientOwnershipPeriods: Array<{ __typename?: 'ClientOwnershipPeriod', id: string, fromDate: any, toDate?: any | null, createdAt: any, owners: Array<{ __typename?: 'ClientOwnershipPeriodOwner', ownershipPercentage: number, user?: { __typename?: 'User', id: string, fullName: string } | null }> } | null> } };

export type ClientBillingDataQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ClientBillingDataQuery = { __typename?: 'Query', client: { __typename?: 'Client', id: string, fullName?: string | null, identificationNumber?: string | null, vatRegistrationNumber?: string | null, address?: string | null, country?: string | null, postalCode?: string | null, billingAddressType: BillingAddressType, billingAddress?: string | null, billingCountry?: string | null, billingPostalCode?: string | null, billingPhone?: string | null, paymentType?: PaymentType | null, hourlyFeeType?: HourlyFeeType | null, discountPercentage?: number | null, language?: string | null, billingEmails: Array<string>, flatRate?: number | null, lawyerRate?: number | null, nonLawyerRate?: number | null, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, billingContact?: { __typename?: 'Contact', id: string, fullName: string, opponent: boolean } | null, paymentTerm?: { __typename?: 'PaymentTerm', id: string, days: number } | null, invoicingCurrency?: { __typename?: 'Currency', id: string, name: string } | null, invoiceIssuer?: { __typename?: 'Entity', id: string, name: string } | null, vatPercentage?: { __typename?: 'VatPercentage', id: string, percentage: number, location: VatPercentageLocation } | null, standardPriceList?: { __typename?: 'PriceList', id: string, name: string } | null, customizedPriceList?: { __typename?: 'PriceList', id: string, name: string, priceListRates: Array<{ __typename?: 'PriceListRate', id?: string | null, pricedType: string, rate?: number | null, priced?: { __typename?: 'Priced', id: string, name: string, positionName?: string | null, sequence?: number | null } | null, currency?: { __typename?: 'Currency', id: string } | null } | null> } | null } };

export type ClientsQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ClientFilterInput>;
  search?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
}>;


export type ClientsQuery = { __typename?: 'Query', clients: { __typename?: 'ClientConnection', totalCount: number, nodes: Array<{ __typename?: 'Client', id: string, fullName?: string | null, entityType: EntityType, country?: string | null, amlStatus: ClientAmlStatus, antiMoneyLaunderingDate?: any | null, legalCasesCount?: number | null, formattedTotalMinutes?: string | null, formattedInvoicedMinutes: string, formattedUninvoicedMinutes: string, formattedNonBillableMinutes: string, lastTcDate?: any | null, inactivatedAt?: any | null, clientStatus: ClientStatus, industry?: { __typename?: 'Industry', id: string, name: string } | null, clientOwners: Array<{ __typename?: 'ClientOwner', id?: string | null, ownershipPercentage: number, user?: { __typename?: 'User', id: string, fullName: string } | null } | null> }> } };

export type AutocompleteClientsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type AutocompleteClientsQuery = { __typename?: 'Query', clients: { __typename?: 'ClientConnection', nodes: Array<{ __typename?: 'Client', id: string, fullName?: string | null }> } };

export type AutocompleteClientsExpandedQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type AutocompleteClientsExpandedQuery = { __typename?: 'Query', clients: { __typename?: 'ClientConnection', nodes: Array<{ __typename?: 'Client', id: string, fullName?: string | null, language?: string | null, hasInvoicing: boolean, invoicingCurrency?: { __typename?: 'Currency', id: string, name: string } | null }> } };

export type DeleteClientMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteClientMutation = { __typename?: 'Mutation', deleteClient: boolean };

export type ClientsExportQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ClientFilterInput>;
  search?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
}>;


export type ClientsExportQuery = { __typename?: 'Query', clients: { __typename?: 'ClientConnection', xlsxExport: { __typename?: 'XlsxExport', filename: string, content: string } } };

export type MarketingEffortQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MarketingEffortQuery = { __typename?: 'Query', marketingEffort: { __typename?: 'MarketingEffort', id: string, clientId: string, startedAt: any, nextStepComment?: string | null, comment?: string | null, marketingEffortType: { __typename?: 'MarketingEffortType', id: string, name: string }, marketingEffortResponseType?: { __typename?: 'MarketingEffortResponseType', id: string, name: string } | null, marketingEffortNeedTypes: Array<{ __typename?: 'MarketingEffortNeedType', id: string, name: string }> } };

export type MarketingEffortsQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<MarketingEffortFilterInput>;
}>;


export type MarketingEffortsQuery = { __typename?: 'Query', marketingEfforts: { __typename?: 'MarketingEffortConnection', totalCount: number, nodes: Array<{ __typename?: 'MarketingEffort', id: string, startedAt: any, nextStepComment?: string | null, comment?: string | null, createdAt: any, marketingEffortType: { __typename?: 'MarketingEffortType', id: string, name: string }, marketingEffortResponseType?: { __typename?: 'MarketingEffortResponseType', id: string, name: string } | null, marketingEffortNeedTypes: Array<{ __typename?: 'MarketingEffortNeedType', id: string, name: string }>, createdBy: { __typename?: 'User', id: string, fullName: string } }> } };

export type CreateMarketingEffortMutationVariables = Exact<{
  input: MarketingEffortInput;
}>;


export type CreateMarketingEffortMutation = { __typename?: 'Mutation', createMarketingEffort: { __typename?: 'MarketingEffort', id: string } };

export type UpdateMarketingEffortMutationVariables = Exact<{
  id: Scalars['ID'];
  input: MarketingEffortInput;
}>;


export type UpdateMarketingEffortMutation = { __typename?: 'Mutation', updateMarketingEffort: { __typename?: 'MarketingEffort', id: string, startedAt: any, nextStepComment?: string | null, comment?: string | null, marketingEffortType: { __typename?: 'MarketingEffortType', id: string, name: string }, marketingEffortResponseType?: { __typename?: 'MarketingEffortResponseType', id: string, name: string } | null, marketingEffortNeedTypes: Array<{ __typename?: 'MarketingEffortNeedType', id: string, name: string }> } };

export type DeleteMarketingEffortMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteMarketingEffortMutation = { __typename?: 'Mutation', deleteMarketingEffort: boolean };

export type MarketingEffortsExportQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MarketingEffortFilterInput>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type MarketingEffortsExportQuery = { __typename?: 'Query', marketingEfforts: { __typename?: 'MarketingEffortConnection', xlsxExport: { __typename?: 'XlsxExport', filename: string, content: string } } };

export type ClientProfitabilityQueryVariables = Exact<{
  clientId: Scalars['ID'];
  dateFrom: Scalars['ISO8601Date'];
  dateTo: Scalars['ISO8601Date'];
  invoiceFilter?: InputMaybe<Scalars['String']>;
}>;


export type ClientProfitabilityQuery = { __typename?: 'Query', clientProfitability: { __typename?: 'ProfitabilityResult', revenue: number, totalDirectCost: number, totalIndirectCost: number, profitability: number, currency?: { __typename?: 'Currency', id: string, name: string } | null, invoices: Array<{ __typename?: 'ProfitabilityInvoice', totalValue: number, invoice: { __typename?: 'Invoice', id: string, number?: string | null, state: InvoiceState, includedRecordsPeriodFromDate?: any | null, includedRecordsPeriodToDate?: any | null } }>, rows: Array<{ __typename?: 'ProfitabilityRow', invoicedMinutes: number, revenue: number, directCost: number, indirectCost: number, profitability: number, missingCostData: boolean, totalRow: boolean, user?: { __typename?: 'User', id: string, fullName: string } | null }> } };

export type DownloadProfitabilityReportMutationVariables = Exact<{
  scopeType: Scalars['String'];
  scopeId: Scalars['ID'];
  dateFrom: Scalars['ISO8601Date'];
  dateTo: Scalars['ISO8601Date'];
}>;


export type DownloadProfitabilityReportMutation = { __typename?: 'Mutation', reportProfitability: { __typename?: 'XlsxExport', content: string, filename: string } };

export type ContactPresenceQueryVariables = Exact<{
  filter?: InputMaybe<ContactFilterInput>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type ContactPresenceQuery = { __typename?: 'Query', contactPresence: boolean };

export type CreateContactMutationVariables = Exact<{
  input: ContactInput;
}>;


export type CreateContactMutation = { __typename?: 'Mutation', createContact: { __typename?: 'Contact', id: string, fullName: string, entityType: EntityType } };

export type FullContactFieldsFragment = { __typename?: 'Contact', id: string, entityType: EntityType, name: string, middleName?: string | null, lastName?: string | null, title?: string | null, country?: string | null, phone?: string | null, email?: string | null, fullName: string, address?: string | null, postalCode?: string | null, websiteUrl?: string | null, linkedinProfileUrl?: string | null, vatRegistrationNumber?: string | null, registrationNumber?: string | null, birthdayDate?: any | null, language?: string | null, jobTitle?: string | null, identificationNumber?: string | null, opponent: boolean, syncSourceId?: string | null, syncSourceType?: string | null, mailchimpSync: boolean, contactCategories?: Array<{ __typename?: 'ContactCategory', id: string, name: string } | null> | null, owners?: Array<{ __typename?: 'Contact', id: string, fullName: string, syncSourceType?: string | null } | null> | null, shareholders?: Array<{ __typename?: 'Contact', id: string, fullName: string, syncSourceType?: string | null } | null> | null, company?: { __typename?: 'Contact', id: string, fullName: string, syncSourceType?: string | null } | null, employees?: Array<{ __typename?: 'Contact', id: string, fullName: string, syncSourceType?: string | null } | null> | null, marketingEffortTypes?: Array<{ __typename?: 'MarketingEffortType', id: string, name: string } | null> | null, owner?: { __typename?: 'User', id: string, fullName: string } | null };

export type ContactQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ContactQuery = { __typename?: 'Query', contact: { __typename?: 'Contact', id: string, entityType: EntityType, name: string, middleName?: string | null, lastName?: string | null, title?: string | null, country?: string | null, phone?: string | null, email?: string | null, fullName: string, address?: string | null, postalCode?: string | null, websiteUrl?: string | null, linkedinProfileUrl?: string | null, vatRegistrationNumber?: string | null, registrationNumber?: string | null, birthdayDate?: any | null, language?: string | null, jobTitle?: string | null, identificationNumber?: string | null, opponent: boolean, syncSourceId?: string | null, syncSourceType?: string | null, mailchimpSync: boolean, contactCategories?: Array<{ __typename?: 'ContactCategory', id: string, name: string } | null> | null, owners?: Array<{ __typename?: 'Contact', id: string, fullName: string, syncSourceType?: string | null } | null> | null, shareholders?: Array<{ __typename?: 'Contact', id: string, fullName: string, syncSourceType?: string | null } | null> | null, company?: { __typename?: 'Contact', id: string, fullName: string, syncSourceType?: string | null } | null, employees?: Array<{ __typename?: 'Contact', id: string, fullName: string, syncSourceType?: string | null } | null> | null, marketingEffortTypes?: Array<{ __typename?: 'MarketingEffortType', id: string, name: string } | null> | null, owner?: { __typename?: 'User', id: string, fullName: string } | null } };

export type UpdateContactMutationVariables = Exact<{
  id: Scalars['ID'];
  input: ContactInput;
}>;


export type UpdateContactMutation = { __typename?: 'Mutation', updateContact: { __typename?: 'Contact', id: string, entityType: EntityType, name: string, middleName?: string | null, lastName?: string | null, title?: string | null, country?: string | null, phone?: string | null, email?: string | null, fullName: string, address?: string | null, postalCode?: string | null, websiteUrl?: string | null, linkedinProfileUrl?: string | null, vatRegistrationNumber?: string | null, registrationNumber?: string | null, birthdayDate?: any | null, language?: string | null, jobTitle?: string | null, identificationNumber?: string | null, opponent: boolean, syncSourceId?: string | null, syncSourceType?: string | null, mailchimpSync: boolean, contactCategories?: Array<{ __typename?: 'ContactCategory', id: string, name: string } | null> | null, owners?: Array<{ __typename?: 'Contact', id: string, fullName: string, syncSourceType?: string | null } | null> | null, shareholders?: Array<{ __typename?: 'Contact', id: string, fullName: string, syncSourceType?: string | null } | null> | null, company?: { __typename?: 'Contact', id: string, fullName: string, syncSourceType?: string | null } | null, employees?: Array<{ __typename?: 'Contact', id: string, fullName: string, syncSourceType?: string | null } | null> | null, marketingEffortTypes?: Array<{ __typename?: 'MarketingEffortType', id: string, name: string } | null> | null, owner?: { __typename?: 'User', id: string, fullName: string } | null } };

export type ContactLegalCasesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ContactLegalCasesQuery = { __typename?: 'Query', contact: { __typename?: 'Contact', id: string, relatedLegalCases: Array<{ __typename?: 'ContactRelatedLegalCase', roles: Array<ContactLegalCaseRole>, legalCase: { __typename?: 'LegalCase', id: string, name?: string | null, state: LegalCaseState, estimatedCaseValue?: number | null, lastTcDate?: any | null, formattedTotalMinutes: string, fullName?: string | null, currency?: { __typename?: 'Currency', id: string, name: string } | null, client?: { __typename?: 'Client', id: string, fullName?: string | null } | null, legalCaseOwners: Array<{ __typename?: 'LegalCaseOwner', id?: string | null, ownershipPercentage: number, user?: { __typename?: 'User', id: string, fullName: string } | null } | null>, manager?: { __typename?: 'User', id: string, fullName: string } | null } }> } };

export type ContactsQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ContactFilterInput>;
}>;


export type ContactsQuery = { __typename?: 'Query', contacts: { __typename?: 'ContactConnection', totalCount: number, nodes: Array<{ __typename?: 'Contact', id: string, name: string, fullName: string, lastName?: string | null, country?: string | null, phone?: string | null, email?: string | null, vatRegistrationNumber?: string | null, registrationNumber?: string | null, opponent: boolean, identificationNumber?: string | null, syncSourceId?: string | null, syncSourceType?: string | null, jobTitle?: string | null, entityType: EntityType, company?: { __typename?: 'Contact', id: string, country?: string | null, name: string, syncSourceType?: string | null } | null, employees?: Array<{ __typename?: 'Contact', id: string, fullName: string } | null> | null, contactCategories?: Array<{ __typename?: 'ContactCategory', id: string, name: string } | null> | null, owner?: { __typename?: 'User', id: string, fullName: string } | null }> } };

export type AutocompleteContactsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ContactFilterInput>;
}>;


export type AutocompleteContactsQuery = { __typename?: 'Query', contacts: { __typename?: 'ContactConnection', nodes: Array<{ __typename?: 'Contact', id: string, fullName: string, opponent: boolean, syncSourceType?: string | null, entityType: EntityType }> } };

export type DeleteContactMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteContactMutation = { __typename?: 'Mutation', deleteContact: boolean };

export type ContactsExportQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ContactFilterInput>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type ContactsExportQuery = { __typename?: 'Query', contacts: { __typename?: 'ContactConnection', xlsxExport: { __typename?: 'XlsxExport', filename: string, content: string } } };

export type RecentUserCasesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
}>;


export type RecentUserCasesQuery = { __typename?: 'Query', recentUserCases: { __typename?: 'LegalCaseConnection', nodes: Array<{ __typename?: 'LegalCase', id: string, fullName?: string | null, client?: { __typename?: 'Client', id: string, fullName?: string | null, amlStatus: ClientAmlStatus, antiMoneyLaunderingDate?: any | null, amlExpectedDate?: any | null } | null }> } };

export type CurrentUserCalendarEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserCalendarEventsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, calendars: Array<{ __typename?: 'Calendar', id: string }>, calendarEvents: Array<{ __typename?: 'CalendarEvent', id: string, name: string, startTime: any, endTime: any, status?: string | null }> } };

export type CreateDisbursementMutationVariables = Exact<{
  input: DisbursementInput;
}>;


export type CreateDisbursementMutation = { __typename?: 'Mutation', createDisbursement: { __typename?: 'Disbursement', id: string, invoice?: { __typename?: 'Invoice', id: string, anyDisbursementsWithoutPrice: boolean } | null } };

export type DisbursementFieldsFragment = { __typename?: 'Disbursement', id: string, description?: string | null, expenseAmount: number, onDate: any, state: DisbursementState, taxable: boolean, client?: { __typename?: 'Client', id: string, fullName?: string | null } | null, legalCase?: { __typename?: 'LegalCase', id: string, language?: string | null, fullName?: string | null, legalCaseOwners: Array<{ __typename?: 'LegalCaseOwner', user?: { __typename?: 'User', id: string } | null } | null>, manager?: { __typename?: 'User', id: string } | null, client?: { __typename?: 'Client', id: string, clientOwners: Array<{ __typename?: 'ClientOwner', id?: string | null, user?: { __typename?: 'User', id: string } | null } | null> } | null } | null, disbursementType?: { __typename?: 'DisbursementType', id: string, name: string } | null, currency?: { __typename?: 'Currency', id: string, name: string } | null, owner?: { __typename?: 'User', id: string, fullName: string } | null, invoice?: { __typename?: 'Invoice', id: string, anyDisbursementsWithoutPrice: boolean } | null };

export type DisbursementQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DisbursementQuery = { __typename?: 'Query', disbursement: { __typename?: 'Disbursement', id: string, description?: string | null, expenseAmount: number, onDate: any, state: DisbursementState, taxable: boolean, client?: { __typename?: 'Client', id: string, fullName?: string | null } | null, legalCase?: { __typename?: 'LegalCase', id: string, language?: string | null, fullName?: string | null, legalCaseOwners: Array<{ __typename?: 'LegalCaseOwner', user?: { __typename?: 'User', id: string } | null } | null>, manager?: { __typename?: 'User', id: string } | null, client?: { __typename?: 'Client', id: string, clientOwners: Array<{ __typename?: 'ClientOwner', id?: string | null, user?: { __typename?: 'User', id: string } | null } | null> } | null } | null, disbursementType?: { __typename?: 'DisbursementType', id: string, name: string } | null, currency?: { __typename?: 'Currency', id: string, name: string } | null, owner?: { __typename?: 'User', id: string, fullName: string } | null, invoice?: { __typename?: 'Invoice', id: string, anyDisbursementsWithoutPrice: boolean } | null } };

export type UpdateDisbursementMutationVariables = Exact<{
  id: Scalars['ID'];
  input: DisbursementInput;
}>;


export type UpdateDisbursementMutation = { __typename?: 'Mutation', updateDisbursement: { __typename?: 'Disbursement', id: string, description?: string | null, expenseAmount: number, onDate: any, state: DisbursementState, taxable: boolean, client?: { __typename?: 'Client', id: string, fullName?: string | null } | null, legalCase?: { __typename?: 'LegalCase', id: string, language?: string | null, fullName?: string | null, legalCaseOwners: Array<{ __typename?: 'LegalCaseOwner', user?: { __typename?: 'User', id: string } | null } | null>, manager?: { __typename?: 'User', id: string } | null, client?: { __typename?: 'Client', id: string, clientOwners: Array<{ __typename?: 'ClientOwner', id?: string | null, user?: { __typename?: 'User', id: string } | null } | null> } | null } | null, disbursementType?: { __typename?: 'DisbursementType', id: string, name: string } | null, currency?: { __typename?: 'Currency', id: string, name: string } | null, owner?: { __typename?: 'User', id: string, fullName: string } | null, invoice?: { __typename?: 'Invoice', id: string, anyDisbursementsWithoutPrice: boolean } | null } };

export type DisbursementsQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<DisbursementFilterInput>;
  search?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
}>;


export type DisbursementsQuery = { __typename?: 'Query', disbursements: { __typename?: 'DisbursementConnection', totalCount: number, nodes: Array<{ __typename?: 'Disbursement', id: string, onDate: any, description?: string | null, expenseAmount: number, state: DisbursementState, taxable: boolean, disbursementType?: { __typename?: 'DisbursementType', id: string, name: string } | null, currency?: { __typename?: 'Currency', id: string, name: string } | null, owner?: { __typename?: 'User', id: string, fullName: string } | null, legalCase?: { __typename?: 'LegalCase', id: string, fullName?: string | null } | null, client?: { __typename?: 'Client', id: string, fullName?: string | null } | null }> } };

export type DeleteDisbursementMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteDisbursementMutation = { __typename?: 'Mutation', deleteDisbursement: boolean };

export type LinkDisbursementsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
  invoiceId: Scalars['ID'];
}>;


export type LinkDisbursementsMutation = { __typename?: 'Mutation', linkDisbursements: boolean };

export type LinkTimeCardsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
  invoiceId: Scalars['ID'];
}>;


export type LinkTimeCardsMutation = { __typename?: 'Mutation', linkTimeCards: boolean };

export type BulkStateSwitchMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
  input: InvoiceStateChangeInput;
}>;


export type BulkStateSwitchMutation = { __typename?: 'Mutation', bulkStateSwitch: boolean };

export type CreateCreditNoteMutationVariables = Exact<{
  invoiceId: Scalars['ID'];
  input: CreditNoteInput;
}>;


export type CreateCreditNoteMutation = { __typename?: 'Mutation', createCreditNote: { __typename?: 'Invoice', id: string } };

export type UnlinkDisbursementMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UnlinkDisbursementMutation = { __typename?: 'Mutation', unlinkDisbursement: boolean };

export type InvoiceFormQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type InvoiceFormQuery = { __typename?: 'Query', invoice: { __typename?: 'Invoice', id: string, number?: string | null, state: InvoiceState, alternateCaseName?: string | null, issuedAt?: any | null, caseNameOnInvoice?: string | null, paymentType?: PaymentType | null, hourlyFeeType?: HourlyFeeType | null, fixedFee?: number | null, discountPercentage?: number | null, inheritedDiscountPercentage?: number | null, clientReferenceNumber?: string | null, billingEmails: Array<string>, billingInformationFromLegalCase: boolean, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, billingAddress?: string | null, billingCountry?: string | null, billingPostalCode?: string | null, billingPhone?: string | null, paidAt?: any | null, periodFromDate?: any | null, periodToDate?: any | null, language?: string | null, inheritedLanguage?: string | null, invoicableRecordsPeriodFromDate?: any | null, invoicableRecordsPeriodToDate?: any | null, flatRate?: number | null, vat?: number | null, invoiceType: InvoiceType, totalValue?: number | null, creditAmount?: number | null, lawyerRate?: number | null, nonLawyerRate?: number | null, inheritedBillingToName?: string | null, invoiceDiscount?: number | null, creditableAmountType?: CreditableAmountType | null, prepaymentIntendedUse?: InvoicePrepaymentIntendedUse | null, standardPriceList?: { __typename?: 'PriceList', id: string, name: string } | null, paymentTerm?: { __typename?: 'PaymentTerm', id: string, days: number } | null, currency?: { __typename?: 'Currency', id: string, name: string } | null, invoiceIssuer?: { __typename?: 'Entity', id: string, name: string } | null, billingContact?: { __typename?: 'Contact', id: string, fullName: string, opponent: boolean } | null, vatPercentage?: { __typename?: 'VatPercentage', id: string, percentage: number, location: VatPercentageLocation } | null, creditedInvoice?: { __typename?: 'Invoice', id: string } | null, customizedPriceList?: { __typename?: 'PriceList', id: string, name: string, priceListRates: Array<{ __typename?: 'PriceListRate', id?: string | null, pricedType: string, rate?: number | null, priced?: { __typename?: 'Priced', id: string, name: string, positionName?: string | null, sequence?: number | null } | null, currency?: { __typename?: 'Currency', id: string } | null } | null> } | null, legalCase?: { __typename?: 'LegalCase', id: string, name?: string | null, fullName?: string | null, nameOnInvoice?: string | null, billingInformationFromClient: boolean, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, billingAddress?: string | null, billingCountry?: string | null, billingPostalCode?: string | null, billingPhone?: string | null, language?: string | null, paymentType?: PaymentType | null, hourlyFeeType?: HourlyFeeType | null, fixedFee?: number | null, flatRate?: number | null, discountPercentage?: number | null, clientReferenceNumber?: string | null, billingEmails: Array<string>, lawyerRate?: number | null, nonLawyerRate?: number | null, client?: { __typename?: 'Client', id: string, fullName?: string | null, identificationNumber?: string | null, vatRegistrationNumber?: string | null, address?: string | null, country?: string | null, postalCode?: string | null, billingAddressType: BillingAddressType, billingAddress?: string | null, billingCountry?: string | null, billingPostalCode?: string | null, billingPhone?: string | null, paymentType?: PaymentType | null, hourlyFeeType?: HourlyFeeType | null, discountPercentage?: number | null, language?: string | null, billingEmails: Array<string>, flatRate?: number | null, lawyerRate?: number | null, nonLawyerRate?: number | null, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, billingContact?: { __typename?: 'Contact', id: string, fullName: string, opponent: boolean } | null, paymentTerm?: { __typename?: 'PaymentTerm', id: string, days: number } | null, invoicingCurrency?: { __typename?: 'Currency', id: string, name: string } | null, invoiceIssuer?: { __typename?: 'Entity', id: string, name: string } | null, vatPercentage?: { __typename?: 'VatPercentage', id: string, percentage: number, location: VatPercentageLocation } | null, standardPriceList?: { __typename?: 'PriceList', id: string, name: string } | null, customizedPriceList?: { __typename?: 'PriceList', id: string, name: string, priceListRates: Array<{ __typename?: 'PriceListRate', id?: string | null, pricedType: string, rate?: number | null, priced?: { __typename?: 'Priced', id: string, name: string, positionName?: string | null, sequence?: number | null } | null, currency?: { __typename?: 'Currency', id: string } | null } | null> } | null } | null, billingContact?: { __typename?: 'Contact', id: string, fullName: string, opponent: boolean } | null, vatPercentage?: { __typename?: 'VatPercentage', id: string, percentage: number, location: VatPercentageLocation } | null, paymentTerm?: { __typename?: 'PaymentTerm', id: string, days: number } | null, standardPriceList?: { __typename?: 'PriceList', id: string, name: string } | null, invoiceIssuer?: { __typename?: 'Entity', id: string, name: string } | null, customizedPriceList?: { __typename?: 'PriceList', id: string, name: string, priceListRates: Array<{ __typename?: 'PriceListRate', id?: string | null, pricedType: string, rate?: number | null, priced?: { __typename?: 'Priced', id: string, name: string, positionName?: string | null, sequence?: number | null } | null, currency?: { __typename?: 'Currency', id: string } | null } | null> } | null, invoicingCurrency?: { __typename?: 'Currency', id: string, name: string } | null } | null } };

export type CreditedInvoiceQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CreditedInvoiceQuery = { __typename?: 'Query', invoice: { __typename?: 'Invoice', totalValue?: number | null, vat?: number | null, invoiceDiscount?: number | null, feeTotal?: number | null } };

export type FullInvoiceFieldsFragment = { __typename?: 'Invoice', id: string, state: InvoiceState, invoiceType: InvoiceType, number?: string | null, paidAt?: any | null, issuedAt?: any | null, approvedAt?: any | null, alternateCaseName?: string | null, discountPercentage?: number | null, clientReferenceNumber?: string | null, language?: string | null, vat?: number | null, billingEmails: Array<string>, billingInformationFromLegalCase: boolean, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, billingAddress?: string | null, billingCountry?: string | null, billingPostalCode?: string | null, billingPhone?: string | null, minutesSpent?: number | null, timeCardTotal?: number | null, totalValue?: number | null, disbursementTotal?: number | null, caseNameOnInvoice?: string | null, invoiceSubtotal?: number | null, invoiceDiscount?: number | null, nextStateEvent?: InvoiceEvent | null, inheritedDiscountPercentage?: number | null, inheritedClientReferenceNumber?: string | null, periodFromDate?: any | null, periodToDate?: any | null, inheritedPaymentType?: PaymentType | null, inheritedHourlyFeeType?: HourlyFeeType | null, inheritedFixedFee?: number | null, inheritedLawyerRate?: number | null, inheritedNonLawyerRate?: number | null, paymentType?: PaymentType | null, hourlyFeeType?: HourlyFeeType | null, fixedFee?: number | null, flatRate?: number | null, recordsExistBeforePeriod?: boolean | null, includedRecordsPeriodFromDate?: any | null, includedRecordsPeriodToDate?: any | null, approvable: boolean, nextApproverStateRole?: string | null, rejectable: boolean, previousRejectEvent?: InvoiceApprovalEvent | null, approvalState: string, feeTotal?: number | null, creditAmount?: number | null, feeValue?: number | null, creditableAmountType?: CreditableAmountType | null, prepaymentIntendedUse?: InvoicePrepaymentIntendedUse | null, allocatedPrepaymentTotalValue?: number | null, legalCase?: { __typename?: 'LegalCase', id: string, fullName?: string | null, state: LegalCaseState, billingInformationFromClient: boolean, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, billingAddress?: string | null, billingPostalCode?: string | null, billingCountry?: string | null, billingEmails: Array<string>, language?: string | null, client?: { __typename?: 'Client', id: string, fullName?: string | null, identificationNumber?: string | null, vatRegistrationNumber?: string | null, country?: string | null, address?: string | null, postalCode?: string | null, billingAddressType: BillingAddressType, billingAddress?: string | null, billingPostalCode?: string | null, billingCountry?: string | null, billingEmails: Array<string>, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, clientOwners: Array<{ __typename?: 'ClientOwner', id?: string | null, user?: { __typename?: 'User', id: string } | null } | null> } | null, manager?: { __typename?: 'User', id: string, fullName: string } | null, legalCaseOwners: Array<{ __typename?: 'LegalCaseOwner', id?: string | null, ownershipPercentage: number, user?: { __typename?: 'User', id: string, fullName: string } | null } | null>, connectedLawyers: Array<{ __typename?: 'User', id: string } | null> } | null, client?: { __typename?: 'Client', id: string, fullName?: string | null, amlStatus: ClientAmlStatus, antiMoneyLaunderingDate?: any | null, amlExpectedDate?: any | null, clientOwners: Array<{ __typename?: 'ClientOwner', id?: string | null, user?: { __typename?: 'User', id: string } | null } | null> } | null, currency?: { __typename?: 'Currency', id: string, name: string } | null, paymentTerm?: { __typename?: 'PaymentTerm', id: string, days: number } | null, invoiceIssuer?: { __typename?: 'Entity', id: string, name: string } | null, billingContact?: { __typename?: 'Contact', id: string, fullName: string, opponent: boolean } | null, vatPercentage?: { __typename?: 'VatPercentage', id: string, percentage: number, location: VatPercentageLocation } | null, inheritedInvoiceIssuer?: { __typename?: 'Entity', id: string, name: string } | null, inheritedCurrency?: { __typename?: 'Currency', id: string, name: string } | null, inheritedStandardPriceList?: { __typename?: 'PriceList', id: string, name: string } | null, standardPriceList?: { __typename?: 'PriceList', id: string, name: string } | null, creditedInvoice?: { __typename?: 'Invoice', id: string, number?: string | null } | null, creditNote?: { __typename?: 'Invoice', id: string, number?: string | null, state: InvoiceState } | null, customizedPriceList?: { __typename?: 'PriceList', id: string, name: string, priceListRates: Array<{ __typename?: 'PriceListRate', id?: string | null, pricedType: string, rate?: number | null, priced?: { __typename?: 'Priced', id: string, name: string, positionName?: string | null, sequence?: number | null } | null, currency?: { __typename?: 'Currency', id: string } | null } | null> } | null, approveeRole?: { __typename?: 'UserRole', id: string } | null, billableTime: Array<{ __typename?: 'InvoiceBillableTime', userFullName: string, positionName: string, minutesSpent: number, rate: number, total: number, positionSequence?: number | null }>, copiedTo?: { __typename?: 'Invoice', id: string, number?: string | null } | null, copyOf?: { __typename?: 'Invoice', id: string, number?: string | null } | null };

export type GenerateInvoicePdfMutationVariables = Exact<{
  id: Scalars['ID'];
  input: InvoicePdfInput;
}>;


export type GenerateInvoicePdfMutation = { __typename?: 'Mutation', generateInvoicePdf: string };

export type InvoicePdfDataQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type InvoicePdfDataQuery = { __typename?: 'Query', invoice: { __typename?: 'Invoice', id: string, caseNameOnInvoice?: string | null, printoutUrl?: string | null, inheritedLanguage?: string | null, invoiceType: InvoiceType, inheritedInvoiceIssuer?: { __typename?: 'Entity', id: string, name: string } | null, defaultInvoiceTemplate?: { __typename?: 'InvoiceTemplate', id: string, name: string, detailLevel: InvoiceTemplateDetail } | null }, currentAccount: { __typename?: 'Account', id: string, defaultCaseDescriptions: any } };

export type InvoiceCaseClientQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type InvoiceCaseClientQuery = { __typename?: 'Query', invoice: { __typename?: 'Invoice', id: string, invoiceType: InvoiceType, anyTimeCardsWithoutRate?: boolean | null, anyDisbursementsWithoutPrice: boolean, client?: { __typename?: 'Client', id: string, fullName?: string | null } | null, legalCase?: { __typename?: 'LegalCase', id: string, fullName?: string | null } | null, copiedTo?: { __typename?: 'Invoice', id: string, number?: string | null } | null } };

export type InvoiceQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type InvoiceQuery = { __typename?: 'Query', invoice: { __typename?: 'Invoice', id: string, state: InvoiceState, invoiceType: InvoiceType, number?: string | null, paidAt?: any | null, issuedAt?: any | null, approvedAt?: any | null, alternateCaseName?: string | null, discountPercentage?: number | null, clientReferenceNumber?: string | null, language?: string | null, vat?: number | null, billingEmails: Array<string>, billingInformationFromLegalCase: boolean, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, billingAddress?: string | null, billingCountry?: string | null, billingPostalCode?: string | null, billingPhone?: string | null, minutesSpent?: number | null, timeCardTotal?: number | null, totalValue?: number | null, disbursementTotal?: number | null, caseNameOnInvoice?: string | null, invoiceSubtotal?: number | null, invoiceDiscount?: number | null, nextStateEvent?: InvoiceEvent | null, inheritedDiscountPercentage?: number | null, inheritedClientReferenceNumber?: string | null, periodFromDate?: any | null, periodToDate?: any | null, inheritedPaymentType?: PaymentType | null, inheritedHourlyFeeType?: HourlyFeeType | null, inheritedFixedFee?: number | null, inheritedLawyerRate?: number | null, inheritedNonLawyerRate?: number | null, paymentType?: PaymentType | null, hourlyFeeType?: HourlyFeeType | null, fixedFee?: number | null, flatRate?: number | null, recordsExistBeforePeriod?: boolean | null, includedRecordsPeriodFromDate?: any | null, includedRecordsPeriodToDate?: any | null, approvable: boolean, nextApproverStateRole?: string | null, rejectable: boolean, previousRejectEvent?: InvoiceApprovalEvent | null, approvalState: string, feeTotal?: number | null, creditAmount?: number | null, feeValue?: number | null, creditableAmountType?: CreditableAmountType | null, prepaymentIntendedUse?: InvoicePrepaymentIntendedUse | null, allocatedPrepaymentTotalValue?: number | null, legalCase?: { __typename?: 'LegalCase', id: string, fullName?: string | null, state: LegalCaseState, billingInformationFromClient: boolean, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, billingAddress?: string | null, billingPostalCode?: string | null, billingCountry?: string | null, billingEmails: Array<string>, language?: string | null, client?: { __typename?: 'Client', id: string, fullName?: string | null, identificationNumber?: string | null, vatRegistrationNumber?: string | null, country?: string | null, address?: string | null, postalCode?: string | null, billingAddressType: BillingAddressType, billingAddress?: string | null, billingPostalCode?: string | null, billingCountry?: string | null, billingEmails: Array<string>, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, clientOwners: Array<{ __typename?: 'ClientOwner', id?: string | null, user?: { __typename?: 'User', id: string } | null } | null> } | null, manager?: { __typename?: 'User', id: string, fullName: string } | null, legalCaseOwners: Array<{ __typename?: 'LegalCaseOwner', id?: string | null, ownershipPercentage: number, user?: { __typename?: 'User', id: string, fullName: string } | null } | null>, connectedLawyers: Array<{ __typename?: 'User', id: string } | null> } | null, client?: { __typename?: 'Client', id: string, fullName?: string | null, amlStatus: ClientAmlStatus, antiMoneyLaunderingDate?: any | null, amlExpectedDate?: any | null, clientOwners: Array<{ __typename?: 'ClientOwner', id?: string | null, user?: { __typename?: 'User', id: string } | null } | null> } | null, currency?: { __typename?: 'Currency', id: string, name: string } | null, paymentTerm?: { __typename?: 'PaymentTerm', id: string, days: number } | null, invoiceIssuer?: { __typename?: 'Entity', id: string, name: string } | null, billingContact?: { __typename?: 'Contact', id: string, fullName: string, opponent: boolean } | null, vatPercentage?: { __typename?: 'VatPercentage', id: string, percentage: number, location: VatPercentageLocation } | null, inheritedInvoiceIssuer?: { __typename?: 'Entity', id: string, name: string } | null, inheritedCurrency?: { __typename?: 'Currency', id: string, name: string } | null, inheritedStandardPriceList?: { __typename?: 'PriceList', id: string, name: string } | null, standardPriceList?: { __typename?: 'PriceList', id: string, name: string } | null, creditedInvoice?: { __typename?: 'Invoice', id: string, number?: string | null } | null, creditNote?: { __typename?: 'Invoice', id: string, number?: string | null, state: InvoiceState } | null, customizedPriceList?: { __typename?: 'PriceList', id: string, name: string, priceListRates: Array<{ __typename?: 'PriceListRate', id?: string | null, pricedType: string, rate?: number | null, priced?: { __typename?: 'Priced', id: string, name: string, positionName?: string | null, sequence?: number | null } | null, currency?: { __typename?: 'Currency', id: string } | null } | null> } | null, approveeRole?: { __typename?: 'UserRole', id: string } | null, billableTime: Array<{ __typename?: 'InvoiceBillableTime', userFullName: string, positionName: string, minutesSpent: number, rate: number, total: number, positionSequence?: number | null }>, copiedTo?: { __typename?: 'Invoice', id: string, number?: string | null } | null, copyOf?: { __typename?: 'Invoice', id: string, number?: string | null } | null } };

export type UpdateInvoiceMutationVariables = Exact<{
  id: Scalars['ID'];
  input: InvoiceInput;
}>;


export type UpdateInvoiceMutation = { __typename?: 'Mutation', updateInvoice: { __typename?: 'Invoice', id: string, state: InvoiceState, invoiceType: InvoiceType, number?: string | null, paidAt?: any | null, issuedAt?: any | null, approvedAt?: any | null, alternateCaseName?: string | null, discountPercentage?: number | null, clientReferenceNumber?: string | null, language?: string | null, vat?: number | null, billingEmails: Array<string>, billingInformationFromLegalCase: boolean, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, billingAddress?: string | null, billingCountry?: string | null, billingPostalCode?: string | null, billingPhone?: string | null, minutesSpent?: number | null, timeCardTotal?: number | null, totalValue?: number | null, disbursementTotal?: number | null, caseNameOnInvoice?: string | null, invoiceSubtotal?: number | null, invoiceDiscount?: number | null, nextStateEvent?: InvoiceEvent | null, inheritedDiscountPercentage?: number | null, inheritedClientReferenceNumber?: string | null, periodFromDate?: any | null, periodToDate?: any | null, inheritedPaymentType?: PaymentType | null, inheritedHourlyFeeType?: HourlyFeeType | null, inheritedFixedFee?: number | null, inheritedLawyerRate?: number | null, inheritedNonLawyerRate?: number | null, paymentType?: PaymentType | null, hourlyFeeType?: HourlyFeeType | null, fixedFee?: number | null, flatRate?: number | null, recordsExistBeforePeriod?: boolean | null, includedRecordsPeriodFromDate?: any | null, includedRecordsPeriodToDate?: any | null, approvable: boolean, nextApproverStateRole?: string | null, rejectable: boolean, previousRejectEvent?: InvoiceApprovalEvent | null, approvalState: string, feeTotal?: number | null, creditAmount?: number | null, feeValue?: number | null, creditableAmountType?: CreditableAmountType | null, prepaymentIntendedUse?: InvoicePrepaymentIntendedUse | null, allocatedPrepaymentTotalValue?: number | null, legalCase?: { __typename?: 'LegalCase', id: string, fullName?: string | null, state: LegalCaseState, billingInformationFromClient: boolean, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, billingAddress?: string | null, billingPostalCode?: string | null, billingCountry?: string | null, billingEmails: Array<string>, language?: string | null, client?: { __typename?: 'Client', id: string, fullName?: string | null, identificationNumber?: string | null, vatRegistrationNumber?: string | null, country?: string | null, address?: string | null, postalCode?: string | null, billingAddressType: BillingAddressType, billingAddress?: string | null, billingPostalCode?: string | null, billingCountry?: string | null, billingEmails: Array<string>, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, clientOwners: Array<{ __typename?: 'ClientOwner', id?: string | null, user?: { __typename?: 'User', id: string } | null } | null> } | null, manager?: { __typename?: 'User', id: string, fullName: string } | null, legalCaseOwners: Array<{ __typename?: 'LegalCaseOwner', id?: string | null, ownershipPercentage: number, user?: { __typename?: 'User', id: string, fullName: string } | null } | null>, connectedLawyers: Array<{ __typename?: 'User', id: string } | null> } | null, client?: { __typename?: 'Client', id: string, fullName?: string | null, amlStatus: ClientAmlStatus, antiMoneyLaunderingDate?: any | null, amlExpectedDate?: any | null, clientOwners: Array<{ __typename?: 'ClientOwner', id?: string | null, user?: { __typename?: 'User', id: string } | null } | null> } | null, currency?: { __typename?: 'Currency', id: string, name: string } | null, paymentTerm?: { __typename?: 'PaymentTerm', id: string, days: number } | null, invoiceIssuer?: { __typename?: 'Entity', id: string, name: string } | null, billingContact?: { __typename?: 'Contact', id: string, fullName: string, opponent: boolean } | null, vatPercentage?: { __typename?: 'VatPercentage', id: string, percentage: number, location: VatPercentageLocation } | null, inheritedInvoiceIssuer?: { __typename?: 'Entity', id: string, name: string } | null, inheritedCurrency?: { __typename?: 'Currency', id: string, name: string } | null, inheritedStandardPriceList?: { __typename?: 'PriceList', id: string, name: string } | null, standardPriceList?: { __typename?: 'PriceList', id: string, name: string } | null, creditedInvoice?: { __typename?: 'Invoice', id: string, number?: string | null } | null, creditNote?: { __typename?: 'Invoice', id: string, number?: string | null, state: InvoiceState } | null, customizedPriceList?: { __typename?: 'PriceList', id: string, name: string, priceListRates: Array<{ __typename?: 'PriceListRate', id?: string | null, pricedType: string, rate?: number | null, priced?: { __typename?: 'Priced', id: string, name: string, positionName?: string | null, sequence?: number | null } | null, currency?: { __typename?: 'Currency', id: string } | null } | null> } | null, approveeRole?: { __typename?: 'UserRole', id: string } | null, billableTime: Array<{ __typename?: 'InvoiceBillableTime', userFullName: string, positionName: string, minutesSpent: number, rate: number, total: number, positionSequence?: number | null }>, copiedTo?: { __typename?: 'Invoice', id: string, number?: string | null } | null, copyOf?: { __typename?: 'Invoice', id: string, number?: string | null } | null } };

export type StateSwitchMutationVariables = Exact<{
  id: Scalars['ID'];
  eventName: InvoiceEvent;
  input: InvoiceStateChangeInput;
}>;


export type StateSwitchMutation = { __typename?: 'Mutation', stateSwitch: { __typename?: 'Invoice', id: string, state: InvoiceState, invoiceType: InvoiceType, number?: string | null, paidAt?: any | null, issuedAt?: any | null, approvedAt?: any | null, alternateCaseName?: string | null, discountPercentage?: number | null, clientReferenceNumber?: string | null, language?: string | null, vat?: number | null, billingEmails: Array<string>, billingInformationFromLegalCase: boolean, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, billingAddress?: string | null, billingCountry?: string | null, billingPostalCode?: string | null, billingPhone?: string | null, minutesSpent?: number | null, timeCardTotal?: number | null, totalValue?: number | null, disbursementTotal?: number | null, caseNameOnInvoice?: string | null, invoiceSubtotal?: number | null, invoiceDiscount?: number | null, nextStateEvent?: InvoiceEvent | null, inheritedDiscountPercentage?: number | null, inheritedClientReferenceNumber?: string | null, periodFromDate?: any | null, periodToDate?: any | null, inheritedPaymentType?: PaymentType | null, inheritedHourlyFeeType?: HourlyFeeType | null, inheritedFixedFee?: number | null, inheritedLawyerRate?: number | null, inheritedNonLawyerRate?: number | null, paymentType?: PaymentType | null, hourlyFeeType?: HourlyFeeType | null, fixedFee?: number | null, flatRate?: number | null, recordsExistBeforePeriod?: boolean | null, includedRecordsPeriodFromDate?: any | null, includedRecordsPeriodToDate?: any | null, approvable: boolean, nextApproverStateRole?: string | null, rejectable: boolean, previousRejectEvent?: InvoiceApprovalEvent | null, approvalState: string, feeTotal?: number | null, creditAmount?: number | null, feeValue?: number | null, creditableAmountType?: CreditableAmountType | null, prepaymentIntendedUse?: InvoicePrepaymentIntendedUse | null, allocatedPrepaymentTotalValue?: number | null, legalCase?: { __typename?: 'LegalCase', id: string, fullName?: string | null, state: LegalCaseState, billingInformationFromClient: boolean, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, billingAddress?: string | null, billingPostalCode?: string | null, billingCountry?: string | null, billingEmails: Array<string>, language?: string | null, client?: { __typename?: 'Client', id: string, fullName?: string | null, identificationNumber?: string | null, vatRegistrationNumber?: string | null, country?: string | null, address?: string | null, postalCode?: string | null, billingAddressType: BillingAddressType, billingAddress?: string | null, billingPostalCode?: string | null, billingCountry?: string | null, billingEmails: Array<string>, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, clientOwners: Array<{ __typename?: 'ClientOwner', id?: string | null, user?: { __typename?: 'User', id: string } | null } | null> } | null, manager?: { __typename?: 'User', id: string, fullName: string } | null, legalCaseOwners: Array<{ __typename?: 'LegalCaseOwner', id?: string | null, ownershipPercentage: number, user?: { __typename?: 'User', id: string, fullName: string } | null } | null>, connectedLawyers: Array<{ __typename?: 'User', id: string } | null> } | null, client?: { __typename?: 'Client', id: string, fullName?: string | null, amlStatus: ClientAmlStatus, antiMoneyLaunderingDate?: any | null, amlExpectedDate?: any | null, clientOwners: Array<{ __typename?: 'ClientOwner', id?: string | null, user?: { __typename?: 'User', id: string } | null } | null> } | null, currency?: { __typename?: 'Currency', id: string, name: string } | null, paymentTerm?: { __typename?: 'PaymentTerm', id: string, days: number } | null, invoiceIssuer?: { __typename?: 'Entity', id: string, name: string } | null, billingContact?: { __typename?: 'Contact', id: string, fullName: string, opponent: boolean } | null, vatPercentage?: { __typename?: 'VatPercentage', id: string, percentage: number, location: VatPercentageLocation } | null, inheritedInvoiceIssuer?: { __typename?: 'Entity', id: string, name: string } | null, inheritedCurrency?: { __typename?: 'Currency', id: string, name: string } | null, inheritedStandardPriceList?: { __typename?: 'PriceList', id: string, name: string } | null, standardPriceList?: { __typename?: 'PriceList', id: string, name: string } | null, creditedInvoice?: { __typename?: 'Invoice', id: string, number?: string | null } | null, creditNote?: { __typename?: 'Invoice', id: string, number?: string | null, state: InvoiceState } | null, customizedPriceList?: { __typename?: 'PriceList', id: string, name: string, priceListRates: Array<{ __typename?: 'PriceListRate', id?: string | null, pricedType: string, rate?: number | null, priced?: { __typename?: 'Priced', id: string, name: string, positionName?: string | null, sequence?: number | null } | null, currency?: { __typename?: 'Currency', id: string } | null } | null> } | null, approveeRole?: { __typename?: 'UserRole', id: string } | null, billableTime: Array<{ __typename?: 'InvoiceBillableTime', userFullName: string, positionName: string, minutesSpent: number, rate: number, total: number, positionSequence?: number | null }>, copiedTo?: { __typename?: 'Invoice', id: string, number?: string | null } | null, copyOf?: { __typename?: 'Invoice', id: string, number?: string | null } | null } };

export type ApprovalStateSwitchMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ApprovalStateSwitchMutation = { __typename?: 'Mutation', approvalStateSwitch: { __typename?: 'Invoice', id: string, state: InvoiceState, invoiceType: InvoiceType, number?: string | null, paidAt?: any | null, issuedAt?: any | null, approvedAt?: any | null, alternateCaseName?: string | null, discountPercentage?: number | null, clientReferenceNumber?: string | null, language?: string | null, vat?: number | null, billingEmails: Array<string>, billingInformationFromLegalCase: boolean, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, billingAddress?: string | null, billingCountry?: string | null, billingPostalCode?: string | null, billingPhone?: string | null, minutesSpent?: number | null, timeCardTotal?: number | null, totalValue?: number | null, disbursementTotal?: number | null, caseNameOnInvoice?: string | null, invoiceSubtotal?: number | null, invoiceDiscount?: number | null, nextStateEvent?: InvoiceEvent | null, inheritedDiscountPercentage?: number | null, inheritedClientReferenceNumber?: string | null, periodFromDate?: any | null, periodToDate?: any | null, inheritedPaymentType?: PaymentType | null, inheritedHourlyFeeType?: HourlyFeeType | null, inheritedFixedFee?: number | null, inheritedLawyerRate?: number | null, inheritedNonLawyerRate?: number | null, paymentType?: PaymentType | null, hourlyFeeType?: HourlyFeeType | null, fixedFee?: number | null, flatRate?: number | null, recordsExistBeforePeriod?: boolean | null, includedRecordsPeriodFromDate?: any | null, includedRecordsPeriodToDate?: any | null, approvable: boolean, nextApproverStateRole?: string | null, rejectable: boolean, previousRejectEvent?: InvoiceApprovalEvent | null, approvalState: string, feeTotal?: number | null, creditAmount?: number | null, feeValue?: number | null, creditableAmountType?: CreditableAmountType | null, prepaymentIntendedUse?: InvoicePrepaymentIntendedUse | null, allocatedPrepaymentTotalValue?: number | null, legalCase?: { __typename?: 'LegalCase', id: string, fullName?: string | null, state: LegalCaseState, billingInformationFromClient: boolean, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, billingAddress?: string | null, billingPostalCode?: string | null, billingCountry?: string | null, billingEmails: Array<string>, language?: string | null, client?: { __typename?: 'Client', id: string, fullName?: string | null, identificationNumber?: string | null, vatRegistrationNumber?: string | null, country?: string | null, address?: string | null, postalCode?: string | null, billingAddressType: BillingAddressType, billingAddress?: string | null, billingPostalCode?: string | null, billingCountry?: string | null, billingEmails: Array<string>, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, clientOwners: Array<{ __typename?: 'ClientOwner', id?: string | null, user?: { __typename?: 'User', id: string } | null } | null> } | null, manager?: { __typename?: 'User', id: string, fullName: string } | null, legalCaseOwners: Array<{ __typename?: 'LegalCaseOwner', id?: string | null, ownershipPercentage: number, user?: { __typename?: 'User', id: string, fullName: string } | null } | null>, connectedLawyers: Array<{ __typename?: 'User', id: string } | null> } | null, client?: { __typename?: 'Client', id: string, fullName?: string | null, amlStatus: ClientAmlStatus, antiMoneyLaunderingDate?: any | null, amlExpectedDate?: any | null, clientOwners: Array<{ __typename?: 'ClientOwner', id?: string | null, user?: { __typename?: 'User', id: string } | null } | null> } | null, currency?: { __typename?: 'Currency', id: string, name: string } | null, paymentTerm?: { __typename?: 'PaymentTerm', id: string, days: number } | null, invoiceIssuer?: { __typename?: 'Entity', id: string, name: string } | null, billingContact?: { __typename?: 'Contact', id: string, fullName: string, opponent: boolean } | null, vatPercentage?: { __typename?: 'VatPercentage', id: string, percentage: number, location: VatPercentageLocation } | null, inheritedInvoiceIssuer?: { __typename?: 'Entity', id: string, name: string } | null, inheritedCurrency?: { __typename?: 'Currency', id: string, name: string } | null, inheritedStandardPriceList?: { __typename?: 'PriceList', id: string, name: string } | null, standardPriceList?: { __typename?: 'PriceList', id: string, name: string } | null, creditedInvoice?: { __typename?: 'Invoice', id: string, number?: string | null } | null, creditNote?: { __typename?: 'Invoice', id: string, number?: string | null, state: InvoiceState } | null, customizedPriceList?: { __typename?: 'PriceList', id: string, name: string, priceListRates: Array<{ __typename?: 'PriceListRate', id?: string | null, pricedType: string, rate?: number | null, priced?: { __typename?: 'Priced', id: string, name: string, positionName?: string | null, sequence?: number | null } | null, currency?: { __typename?: 'Currency', id: string } | null } | null> } | null, approveeRole?: { __typename?: 'UserRole', id: string } | null, billableTime: Array<{ __typename?: 'InvoiceBillableTime', userFullName: string, positionName: string, minutesSpent: number, rate: number, total: number, positionSequence?: number | null }>, copiedTo?: { __typename?: 'Invoice', id: string, number?: string | null } | null, copyOf?: { __typename?: 'Invoice', id: string, number?: string | null } | null } };

export type AssignInvoiceNumberMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AssignInvoiceNumberMutation = { __typename?: 'Mutation', assignInvoiceNumber: { __typename?: 'Invoice', number?: string | null } };

export type DeleteInvoiceMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteInvoiceMutation = { __typename?: 'Mutation', deleteInvoice: boolean };

export type InvoicesCountQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<InvoiceFilterInput>;
}>;


export type InvoicesCountQuery = { __typename?: 'Query', invoices: { __typename?: 'InvoiceConnection', totalCount: number } };

export type InvoicesExportQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<InvoiceFilterInput>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type InvoicesExportQuery = { __typename?: 'Query', invoices: { __typename?: 'InvoiceConnection', xlsxExport: { __typename?: 'XlsxExport', filename: string, content: string } } };

export type CreateInvoiceCopyMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CreateInvoiceCopyMutation = { __typename?: 'Mutation', createInvoiceCopy: { __typename?: 'Invoice', id: string } };

export type RefreshInvoiceMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RefreshInvoiceMutation = { __typename?: 'Mutation', refreshInvoice: { __typename?: 'Invoice', id: string } };

export type SwitchPaymentTypeMutationVariables = Exact<{
  id: Scalars['ID'];
  input: SwitchPaymentTypeInput;
}>;


export type SwitchPaymentTypeMutation = { __typename?: 'Mutation', switchPaymentType: { __typename?: 'LegalCase', id: string, paymentType?: PaymentType | null, unsentInvoicesPresent: boolean } };

export type InvoiceAssociatedPrepaymentsQueryVariables = Exact<{
  invoiceId: Scalars['ID'];
}>;


export type InvoiceAssociatedPrepaymentsQuery = { __typename?: 'Query', invoice: { __typename?: 'Invoice', id: string, invoicesAllocatedFrom?: Array<{ __typename?: 'Invoice', id: string, number?: string | null } | null> | null, invoicesAllocatedTo?: Array<{ __typename?: 'Invoice', id: string, number?: string | null } | null> | null } };

export type PreviewInvoiceQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PreviewInvoiceQuery = { __typename?: 'Query', invoice: { __typename?: 'Invoice', id: string, number?: string | null, invoiceType: InvoiceType, state: InvoiceState, creditableAmountType?: CreditableAmountType | null, issuedAt?: any | null, invoiceSubtotal?: number | null, creditAmount?: number | null, caseNameOnInvoice?: string | null, inheritedClientReferenceNumber?: string | null, vat?: number | null, totalValue?: number | null, inheritedDiscountPercentage?: number | null, feeTotal?: number | null, invoiceDiscount?: number | null, allocatedPrepaymentTotalValue?: number | null, prepaymentIntendedUse?: InvoicePrepaymentIntendedUse | null, billingInformationFromLegalCase: boolean, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, billingCountry?: string | null, billingAddress?: string | null, billingPostalCode?: string | null, billingEmails: Array<string>, inheritedVatPercentage?: { __typename?: 'VatPercentage', id: string, percentage: number, location: VatPercentageLocation } | null, invoiceItems: Array<{ __typename?: 'InvoiceItem', type?: InvoiceItemType | null, quantity: number, total: number, quantityType: string }>, inheritedPaymentTerm?: { __typename?: 'PaymentTerm', id: string, days: number } | null, inheritedCurrency?: { __typename?: 'Currency', id: string, name: string } | null, inheritedInvoiceIssuer?: { __typename?: 'Entity', id: string, name: string, registrationNumber?: string | null, vatRegistrationNumber?: string | null, address?: string | null, postalCode?: string | null, country?: string | null, faxNumber?: string | null, phone?: string | null, websiteUrl?: string | null, bankDetails?: string | null, email?: string | null } | null, legalCase?: { __typename?: 'LegalCase', id: string, billingToName?: string | null, billingInformationFromClient: boolean, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, billingCountry?: string | null, billingAddress?: string | null, billingPostalCode?: string | null, billingEmails: Array<string>, client?: { __typename?: 'Client', id: string, fullName?: string | null, billingToName?: string | null, billingAddressType: BillingAddressType, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, billingCountry?: string | null, country?: string | null, identificationNumber?: string | null, vatRegistrationNumber?: string | null, billingEmails: Array<string>, address?: string | null, postalCode?: string | null, billingAddress?: string | null, billingPostalCode?: string | null } | null } | null } };

export type RejectInvoiceMutationVariables = Exact<{
  id: Scalars['ID'];
  eventName: InvoiceApprovalEvent;
}>;


export type RejectInvoiceMutation = { __typename?: 'Mutation', rejectInvoice: { __typename?: 'Invoice', id: string, state: InvoiceState, invoiceType: InvoiceType, number?: string | null, paidAt?: any | null, issuedAt?: any | null, approvedAt?: any | null, alternateCaseName?: string | null, discountPercentage?: number | null, clientReferenceNumber?: string | null, language?: string | null, vat?: number | null, billingEmails: Array<string>, billingInformationFromLegalCase: boolean, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, billingAddress?: string | null, billingCountry?: string | null, billingPostalCode?: string | null, billingPhone?: string | null, minutesSpent?: number | null, timeCardTotal?: number | null, totalValue?: number | null, disbursementTotal?: number | null, caseNameOnInvoice?: string | null, invoiceSubtotal?: number | null, invoiceDiscount?: number | null, nextStateEvent?: InvoiceEvent | null, inheritedDiscountPercentage?: number | null, inheritedClientReferenceNumber?: string | null, periodFromDate?: any | null, periodToDate?: any | null, inheritedPaymentType?: PaymentType | null, inheritedHourlyFeeType?: HourlyFeeType | null, inheritedFixedFee?: number | null, inheritedLawyerRate?: number | null, inheritedNonLawyerRate?: number | null, paymentType?: PaymentType | null, hourlyFeeType?: HourlyFeeType | null, fixedFee?: number | null, flatRate?: number | null, recordsExistBeforePeriod?: boolean | null, includedRecordsPeriodFromDate?: any | null, includedRecordsPeriodToDate?: any | null, approvable: boolean, nextApproverStateRole?: string | null, rejectable: boolean, previousRejectEvent?: InvoiceApprovalEvent | null, approvalState: string, feeTotal?: number | null, creditAmount?: number | null, feeValue?: number | null, creditableAmountType?: CreditableAmountType | null, prepaymentIntendedUse?: InvoicePrepaymentIntendedUse | null, allocatedPrepaymentTotalValue?: number | null, legalCase?: { __typename?: 'LegalCase', id: string, fullName?: string | null, state: LegalCaseState, billingInformationFromClient: boolean, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, billingAddress?: string | null, billingPostalCode?: string | null, billingCountry?: string | null, billingEmails: Array<string>, language?: string | null, client?: { __typename?: 'Client', id: string, fullName?: string | null, identificationNumber?: string | null, vatRegistrationNumber?: string | null, country?: string | null, address?: string | null, postalCode?: string | null, billingAddressType: BillingAddressType, billingAddress?: string | null, billingPostalCode?: string | null, billingCountry?: string | null, billingEmails: Array<string>, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, clientOwners: Array<{ __typename?: 'ClientOwner', id?: string | null, user?: { __typename?: 'User', id: string } | null } | null> } | null, manager?: { __typename?: 'User', id: string, fullName: string } | null, legalCaseOwners: Array<{ __typename?: 'LegalCaseOwner', id?: string | null, ownershipPercentage: number, user?: { __typename?: 'User', id: string, fullName: string } | null } | null>, connectedLawyers: Array<{ __typename?: 'User', id: string } | null> } | null, client?: { __typename?: 'Client', id: string, fullName?: string | null, amlStatus: ClientAmlStatus, antiMoneyLaunderingDate?: any | null, amlExpectedDate?: any | null, clientOwners: Array<{ __typename?: 'ClientOwner', id?: string | null, user?: { __typename?: 'User', id: string } | null } | null> } | null, currency?: { __typename?: 'Currency', id: string, name: string } | null, paymentTerm?: { __typename?: 'PaymentTerm', id: string, days: number } | null, invoiceIssuer?: { __typename?: 'Entity', id: string, name: string } | null, billingContact?: { __typename?: 'Contact', id: string, fullName: string, opponent: boolean } | null, vatPercentage?: { __typename?: 'VatPercentage', id: string, percentage: number, location: VatPercentageLocation } | null, inheritedInvoiceIssuer?: { __typename?: 'Entity', id: string, name: string } | null, inheritedCurrency?: { __typename?: 'Currency', id: string, name: string } | null, inheritedStandardPriceList?: { __typename?: 'PriceList', id: string, name: string } | null, standardPriceList?: { __typename?: 'PriceList', id: string, name: string } | null, creditedInvoice?: { __typename?: 'Invoice', id: string, number?: string | null } | null, creditNote?: { __typename?: 'Invoice', id: string, number?: string | null, state: InvoiceState } | null, customizedPriceList?: { __typename?: 'PriceList', id: string, name: string, priceListRates: Array<{ __typename?: 'PriceListRate', id?: string | null, pricedType: string, rate?: number | null, priced?: { __typename?: 'Priced', id: string, name: string, positionName?: string | null, sequence?: number | null } | null, currency?: { __typename?: 'Currency', id: string } | null } | null> } | null, approveeRole?: { __typename?: 'UserRole', id: string } | null, billableTime: Array<{ __typename?: 'InvoiceBillableTime', userFullName: string, positionName: string, minutesSpent: number, rate: number, total: number, positionSequence?: number | null }>, copiedTo?: { __typename?: 'Invoice', id: string, number?: string | null } | null, copyOf?: { __typename?: 'Invoice', id: string, number?: string | null } | null } };

export type RevertInvoiceStateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RevertInvoiceStateMutation = { __typename?: 'Mutation', revertInvoiceState: { __typename?: 'Invoice', id: string, state: InvoiceState, invoiceType: InvoiceType, number?: string | null, paidAt?: any | null, issuedAt?: any | null, approvedAt?: any | null, alternateCaseName?: string | null, discountPercentage?: number | null, clientReferenceNumber?: string | null, language?: string | null, vat?: number | null, billingEmails: Array<string>, billingInformationFromLegalCase: boolean, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, billingAddress?: string | null, billingCountry?: string | null, billingPostalCode?: string | null, billingPhone?: string | null, minutesSpent?: number | null, timeCardTotal?: number | null, totalValue?: number | null, disbursementTotal?: number | null, caseNameOnInvoice?: string | null, invoiceSubtotal?: number | null, invoiceDiscount?: number | null, nextStateEvent?: InvoiceEvent | null, inheritedDiscountPercentage?: number | null, inheritedClientReferenceNumber?: string | null, periodFromDate?: any | null, periodToDate?: any | null, inheritedPaymentType?: PaymentType | null, inheritedHourlyFeeType?: HourlyFeeType | null, inheritedFixedFee?: number | null, inheritedLawyerRate?: number | null, inheritedNonLawyerRate?: number | null, paymentType?: PaymentType | null, hourlyFeeType?: HourlyFeeType | null, fixedFee?: number | null, flatRate?: number | null, recordsExistBeforePeriod?: boolean | null, includedRecordsPeriodFromDate?: any | null, includedRecordsPeriodToDate?: any | null, approvable: boolean, nextApproverStateRole?: string | null, rejectable: boolean, previousRejectEvent?: InvoiceApprovalEvent | null, approvalState: string, feeTotal?: number | null, creditAmount?: number | null, feeValue?: number | null, creditableAmountType?: CreditableAmountType | null, prepaymentIntendedUse?: InvoicePrepaymentIntendedUse | null, allocatedPrepaymentTotalValue?: number | null, legalCase?: { __typename?: 'LegalCase', id: string, fullName?: string | null, state: LegalCaseState, billingInformationFromClient: boolean, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, billingAddress?: string | null, billingPostalCode?: string | null, billingCountry?: string | null, billingEmails: Array<string>, language?: string | null, client?: { __typename?: 'Client', id: string, fullName?: string | null, identificationNumber?: string | null, vatRegistrationNumber?: string | null, country?: string | null, address?: string | null, postalCode?: string | null, billingAddressType: BillingAddressType, billingAddress?: string | null, billingPostalCode?: string | null, billingCountry?: string | null, billingEmails: Array<string>, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, clientOwners: Array<{ __typename?: 'ClientOwner', id?: string | null, user?: { __typename?: 'User', id: string } | null } | null> } | null, manager?: { __typename?: 'User', id: string, fullName: string } | null, legalCaseOwners: Array<{ __typename?: 'LegalCaseOwner', id?: string | null, ownershipPercentage: number, user?: { __typename?: 'User', id: string, fullName: string } | null } | null>, connectedLawyers: Array<{ __typename?: 'User', id: string } | null> } | null, client?: { __typename?: 'Client', id: string, fullName?: string | null, amlStatus: ClientAmlStatus, antiMoneyLaunderingDate?: any | null, amlExpectedDate?: any | null, clientOwners: Array<{ __typename?: 'ClientOwner', id?: string | null, user?: { __typename?: 'User', id: string } | null } | null> } | null, currency?: { __typename?: 'Currency', id: string, name: string } | null, paymentTerm?: { __typename?: 'PaymentTerm', id: string, days: number } | null, invoiceIssuer?: { __typename?: 'Entity', id: string, name: string } | null, billingContact?: { __typename?: 'Contact', id: string, fullName: string, opponent: boolean } | null, vatPercentage?: { __typename?: 'VatPercentage', id: string, percentage: number, location: VatPercentageLocation } | null, inheritedInvoiceIssuer?: { __typename?: 'Entity', id: string, name: string } | null, inheritedCurrency?: { __typename?: 'Currency', id: string, name: string } | null, inheritedStandardPriceList?: { __typename?: 'PriceList', id: string, name: string } | null, standardPriceList?: { __typename?: 'PriceList', id: string, name: string } | null, creditedInvoice?: { __typename?: 'Invoice', id: string, number?: string | null } | null, creditNote?: { __typename?: 'Invoice', id: string, number?: string | null, state: InvoiceState } | null, customizedPriceList?: { __typename?: 'PriceList', id: string, name: string, priceListRates: Array<{ __typename?: 'PriceListRate', id?: string | null, pricedType: string, rate?: number | null, priced?: { __typename?: 'Priced', id: string, name: string, positionName?: string | null, sequence?: number | null } | null, currency?: { __typename?: 'Currency', id: string } | null } | null> } | null, approveeRole?: { __typename?: 'UserRole', id: string } | null, billableTime: Array<{ __typename?: 'InvoiceBillableTime', userFullName: string, positionName: string, minutesSpent: number, rate: number, total: number, positionSequence?: number | null }>, copiedTo?: { __typename?: 'Invoice', id: string, number?: string | null } | null, copyOf?: { __typename?: 'Invoice', id: string, number?: string | null } | null } };

export type TimeCardsCountQueryVariables = Exact<{
  filter?: InputMaybe<TimeCardFilterInput>;
}>;


export type TimeCardsCountQuery = { __typename?: 'Query', timeCards: { __typename?: 'TimeCardConnection', totalCount: number } };

export type UnlinkTimeCardMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UnlinkTimeCardMutation = { __typename?: 'Mutation', unlinkTimeCard: boolean };

export type RestoreLegalCaseMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RestoreLegalCaseMutation = { __typename?: 'Mutation', restoreLegalCase: boolean };

export type CloseLegalCaseMutationVariables = Exact<{
  id: Scalars['ID'];
  input: LegalCaseClosingInput;
}>;


export type CloseLegalCaseMutation = { __typename?: 'Mutation', closeLegalCase: boolean };

export type LegalCaseClosingInfoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LegalCaseClosingInfoQuery = { __typename?: 'Query', legalCase: { __typename?: 'LegalCase', id: string, lastExpenseRecordDate?: any | null, unsentInvoicesPresent: boolean } };

export type CurrentAccountCurrencyQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentAccountCurrencyQuery = { __typename?: 'Query', currentAccount: { __typename?: 'Account', id: string, currency?: { __typename?: 'Currency', id: string, name: string } | null } };

export type CreateLegalCaseMutationVariables = Exact<{
  input: LegalCaseInput;
}>;


export type CreateLegalCaseMutation = { __typename?: 'Mutation', createLegalCase: { __typename?: 'LegalCase', id: string } };

export type FullLegalCaseFieldsFragment = { __typename?: 'LegalCase', id: string, clientReferenceNumber?: string | null, name?: string | null, fullName?: string | null, nameOnInvoice?: string | null, estimatedCaseValue?: number | null, openedOn?: any | null, deadline?: any | null, language?: string | null, state: LegalCaseState, hasInvoicing: boolean, billingEmails: Array<string>, paymentType?: PaymentType | null, hourlyFeeType?: HourlyFeeType | null, discountPercentage?: number | null, fixedFee?: number | null, successFee: boolean, successFeeNotes?: string | null, proBono: boolean, proBonoNotes?: string | null, billingInformationFromClient: boolean, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, billingAddress?: string | null, billingCountry?: string | null, billingPostalCode?: string | null, billingPhone?: string | null, flatRate?: number | null, lawyerRate?: number | null, nonLawyerRate?: number | null, closedOn?: any | null, outcome?: CaseOutcome | null, outcomeComment?: string | null, formattedInvoicedMinutes: string, formattedUninvoicedMinutes: string, formattedNonBillableMinutes: string, formattedTotalMinutes: string, frequency?: LegalCaseFrequency | null, recurringDate?: any | null, client?: { __typename?: 'Client', id: string, fullName?: string | null, invoicingCurrency?: { __typename?: 'Currency', id: string, name: string } | null, clientOwners: Array<{ __typename?: 'ClientOwner', id?: string | null, user?: { __typename?: 'User', id: string } | null } | null>, manager?: { __typename?: 'User', id: string } | null } | null, currency?: { __typename?: 'Currency', id: string, name: string } | null, manager?: { __typename?: 'User', id: string, fullName: string } | null, opponents: Array<{ __typename?: 'Contact', id: string, fullName: string } | null>, connectedLawyers: Array<{ __typename?: 'User', id: string, fullName: string } | null>, paymentTerm?: { __typename?: 'PaymentTerm', id: string, days: number } | null, billingContact?: { __typename?: 'Contact', id: string, fullName: string, opponent: boolean } | null, vatPercentage?: { __typename?: 'VatPercentage', id: string, percentage: number, location: VatPercentageLocation } | null, invoiceIssuer?: { __typename?: 'Entity', id: string, name: string } | null, standardPriceList?: { __typename?: 'PriceList', id: string, name: string } | null, draftInvoice?: { __typename?: 'Invoice', id: string } | null, customizedPriceList?: { __typename?: 'PriceList', id: string, name: string, priceListRates: Array<{ __typename?: 'PriceListRate', id?: string | null, pricedType: string, rate?: number | null, priced?: { __typename?: 'Priced', id: string, name: string, positionName?: string | null, sequence?: number | null } | null, currency?: { __typename?: 'Currency', id: string } | null } | null> } | null, legalCaseOwners: Array<{ __typename?: 'LegalCaseOwner', id?: string | null, ownershipPercentage: number, user?: { __typename?: 'User', id: string, fullName: string } | null } | null>, primaryPracticeArea?: { __typename?: 'PracticeArea', id: string, name: string } | null, secondaryPracticeArea?: { __typename?: 'PracticeArea', id: string, name: string } | null, invoicingCurrency?: { __typename?: 'Currency', id: string, name: string } | null, feedbacks: Array<{ __typename?: 'Feedback', id: string, userId: string, comment?: string | null, rating?: number | null, createdAt: any, user?: { __typename?: 'User', id: string, fullName: string } | null } | null> };

export type LegalCaseBillingFieldsFragment = { __typename?: 'LegalCase', id: string, name?: string | null, fullName?: string | null, nameOnInvoice?: string | null, billingInformationFromClient: boolean, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, billingAddress?: string | null, billingCountry?: string | null, billingPostalCode?: string | null, billingPhone?: string | null, language?: string | null, paymentType?: PaymentType | null, hourlyFeeType?: HourlyFeeType | null, fixedFee?: number | null, flatRate?: number | null, discountPercentage?: number | null, clientReferenceNumber?: string | null, billingEmails: Array<string>, lawyerRate?: number | null, nonLawyerRate?: number | null, billingContact?: { __typename?: 'Contact', id: string, fullName: string, opponent: boolean } | null, vatPercentage?: { __typename?: 'VatPercentage', id: string, percentage: number, location: VatPercentageLocation } | null, paymentTerm?: { __typename?: 'PaymentTerm', id: string, days: number } | null, standardPriceList?: { __typename?: 'PriceList', id: string, name: string } | null, invoiceIssuer?: { __typename?: 'Entity', id: string, name: string } | null, customizedPriceList?: { __typename?: 'PriceList', id: string, name: string, priceListRates: Array<{ __typename?: 'PriceListRate', id?: string | null, pricedType: string, rate?: number | null, priced?: { __typename?: 'Priced', id: string, name: string, positionName?: string | null, sequence?: number | null } | null, currency?: { __typename?: 'Currency', id: string } | null } | null> } | null, invoicingCurrency?: { __typename?: 'Currency', id: string, name: string } | null };

export type CreateLegalCaseDraftInvoiceMutationVariables = Exact<{
  legalCaseId: Scalars['ID'];
}>;


export type CreateLegalCaseDraftInvoiceMutation = { __typename?: 'Mutation', createLegalCaseDraftInvoice: { __typename?: 'Invoice', id: string } };

export type CreatePrepaymentInvoiceMutationVariables = Exact<{
  input: InvoiceInput;
}>;


export type CreatePrepaymentInvoiceMutation = { __typename?: 'Mutation', createPrepaymentInvoice: { __typename?: 'Invoice', id: string } };

export type PrepaymentInvoiceLegalCaseQueryVariables = Exact<{
  legalCaseId: Scalars['ID'];
}>;


export type PrepaymentInvoiceLegalCaseQuery = { __typename?: 'Query', legalCase: { __typename?: 'LegalCase', id: string, nameOnInvoice?: string | null, billingEmails: Array<string>, language?: string | null, billingInformationFromClient: boolean, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, billingAddress?: string | null, billingPostalCode?: string | null, billingCountry?: string | null, billingPhone?: string | null, billingContact?: { __typename?: 'Contact', id: string, fullName: string, opponent: boolean } | null, client?: { __typename?: 'Client', id: string, billingEmails: Array<string>, language?: string | null, billingAddressType: BillingAddressType, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, fullName?: string | null, identificationNumber?: string | null, vatRegistrationNumber?: string | null, address?: string | null, postalCode?: string | null, country?: string | null, billingAddress?: string | null, billingPostalCode?: string | null, billingCountry?: string | null, billingPhone?: string | null, billingContact?: { __typename?: 'Contact', id: string, fullName: string, opponent: boolean } | null, invoicingCurrency?: { __typename?: 'Currency', id: string, name: string } | null, paymentTerm?: { __typename?: 'PaymentTerm', id: string, days: number } | null, invoiceIssuer?: { __typename?: 'Entity', id: string, name: string } | null, vatPercentage?: { __typename?: 'VatPercentage', id: string, percentage: number, location: VatPercentageLocation } | null } | null, invoiceIssuer?: { __typename?: 'Entity', id: string, name: string } | null, vatPercentage?: { __typename?: 'VatPercentage', id: string, percentage: number, location: VatPercentageLocation } | null } };

export type LegalCaseQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LegalCaseQuery = { __typename?: 'Query', legalCase: { __typename?: 'LegalCase', id: string, clientReferenceNumber?: string | null, name?: string | null, fullName?: string | null, nameOnInvoice?: string | null, estimatedCaseValue?: number | null, openedOn?: any | null, deadline?: any | null, language?: string | null, state: LegalCaseState, hasInvoicing: boolean, billingEmails: Array<string>, paymentType?: PaymentType | null, hourlyFeeType?: HourlyFeeType | null, discountPercentage?: number | null, fixedFee?: number | null, successFee: boolean, successFeeNotes?: string | null, proBono: boolean, proBonoNotes?: string | null, billingInformationFromClient: boolean, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, billingAddress?: string | null, billingCountry?: string | null, billingPostalCode?: string | null, billingPhone?: string | null, flatRate?: number | null, lawyerRate?: number | null, nonLawyerRate?: number | null, closedOn?: any | null, outcome?: CaseOutcome | null, outcomeComment?: string | null, formattedInvoicedMinutes: string, formattedUninvoicedMinutes: string, formattedNonBillableMinutes: string, formattedTotalMinutes: string, frequency?: LegalCaseFrequency | null, recurringDate?: any | null, client?: { __typename?: 'Client', id: string, fullName?: string | null, invoicingCurrency?: { __typename?: 'Currency', id: string, name: string } | null, clientOwners: Array<{ __typename?: 'ClientOwner', id?: string | null, user?: { __typename?: 'User', id: string } | null } | null>, manager?: { __typename?: 'User', id: string } | null } | null, currency?: { __typename?: 'Currency', id: string, name: string } | null, manager?: { __typename?: 'User', id: string, fullName: string } | null, opponents: Array<{ __typename?: 'Contact', id: string, fullName: string } | null>, connectedLawyers: Array<{ __typename?: 'User', id: string, fullName: string } | null>, paymentTerm?: { __typename?: 'PaymentTerm', id: string, days: number } | null, billingContact?: { __typename?: 'Contact', id: string, fullName: string, opponent: boolean } | null, vatPercentage?: { __typename?: 'VatPercentage', id: string, percentage: number, location: VatPercentageLocation } | null, invoiceIssuer?: { __typename?: 'Entity', id: string, name: string } | null, standardPriceList?: { __typename?: 'PriceList', id: string, name: string } | null, draftInvoice?: { __typename?: 'Invoice', id: string } | null, customizedPriceList?: { __typename?: 'PriceList', id: string, name: string, priceListRates: Array<{ __typename?: 'PriceListRate', id?: string | null, pricedType: string, rate?: number | null, priced?: { __typename?: 'Priced', id: string, name: string, positionName?: string | null, sequence?: number | null } | null, currency?: { __typename?: 'Currency', id: string } | null } | null> } | null, legalCaseOwners: Array<{ __typename?: 'LegalCaseOwner', id?: string | null, ownershipPercentage: number, user?: { __typename?: 'User', id: string, fullName: string } | null } | null>, primaryPracticeArea?: { __typename?: 'PracticeArea', id: string, name: string } | null, secondaryPracticeArea?: { __typename?: 'PracticeArea', id: string, name: string } | null, invoicingCurrency?: { __typename?: 'Currency', id: string, name: string } | null, feedbacks: Array<{ __typename?: 'Feedback', id: string, userId: string, comment?: string | null, rating?: number | null, createdAt: any, user?: { __typename?: 'User', id: string, fullName: string } | null } | null> } };

export type UpdateLegalCaseMutationVariables = Exact<{
  id: Scalars['ID'];
  input: LegalCaseInput;
}>;


export type UpdateLegalCaseMutation = { __typename?: 'Mutation', updateLegalCase: { __typename?: 'LegalCase', id: string, clientReferenceNumber?: string | null, name?: string | null, fullName?: string | null, nameOnInvoice?: string | null, estimatedCaseValue?: number | null, openedOn?: any | null, deadline?: any | null, language?: string | null, state: LegalCaseState, hasInvoicing: boolean, billingEmails: Array<string>, paymentType?: PaymentType | null, hourlyFeeType?: HourlyFeeType | null, discountPercentage?: number | null, fixedFee?: number | null, successFee: boolean, successFeeNotes?: string | null, proBono: boolean, proBonoNotes?: string | null, billingInformationFromClient: boolean, billingToName?: string | null, billingToRegistrationNumber?: string | null, billingToVatRegistrationNumber?: string | null, billingAddress?: string | null, billingCountry?: string | null, billingPostalCode?: string | null, billingPhone?: string | null, flatRate?: number | null, lawyerRate?: number | null, nonLawyerRate?: number | null, closedOn?: any | null, outcome?: CaseOutcome | null, outcomeComment?: string | null, formattedInvoicedMinutes: string, formattedUninvoicedMinutes: string, formattedNonBillableMinutes: string, formattedTotalMinutes: string, frequency?: LegalCaseFrequency | null, recurringDate?: any | null, client?: { __typename?: 'Client', id: string, fullName?: string | null, invoicingCurrency?: { __typename?: 'Currency', id: string, name: string } | null, clientOwners: Array<{ __typename?: 'ClientOwner', id?: string | null, user?: { __typename?: 'User', id: string } | null } | null>, manager?: { __typename?: 'User', id: string } | null } | null, currency?: { __typename?: 'Currency', id: string, name: string } | null, manager?: { __typename?: 'User', id: string, fullName: string } | null, opponents: Array<{ __typename?: 'Contact', id: string, fullName: string } | null>, connectedLawyers: Array<{ __typename?: 'User', id: string, fullName: string } | null>, paymentTerm?: { __typename?: 'PaymentTerm', id: string, days: number } | null, billingContact?: { __typename?: 'Contact', id: string, fullName: string, opponent: boolean } | null, vatPercentage?: { __typename?: 'VatPercentage', id: string, percentage: number, location: VatPercentageLocation } | null, invoiceIssuer?: { __typename?: 'Entity', id: string, name: string } | null, standardPriceList?: { __typename?: 'PriceList', id: string, name: string } | null, draftInvoice?: { __typename?: 'Invoice', id: string } | null, customizedPriceList?: { __typename?: 'PriceList', id: string, name: string, priceListRates: Array<{ __typename?: 'PriceListRate', id?: string | null, pricedType: string, rate?: number | null, priced?: { __typename?: 'Priced', id: string, name: string, positionName?: string | null, sequence?: number | null } | null, currency?: { __typename?: 'Currency', id: string } | null } | null> } | null, legalCaseOwners: Array<{ __typename?: 'LegalCaseOwner', id?: string | null, ownershipPercentage: number, user?: { __typename?: 'User', id: string, fullName: string } | null } | null>, primaryPracticeArea?: { __typename?: 'PracticeArea', id: string, name: string } | null, secondaryPracticeArea?: { __typename?: 'PracticeArea', id: string, name: string } | null, invoicingCurrency?: { __typename?: 'Currency', id: string, name: string } | null, feedbacks: Array<{ __typename?: 'Feedback', id: string, userId: string, comment?: string | null, rating?: number | null, createdAt: any, user?: { __typename?: 'User', id: string, fullName: string } | null } | null> } };

export type LegalCaseOwnershipQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LegalCaseOwnershipQuery = { __typename?: 'Query', legalCase: { __typename?: 'LegalCase', id: string, legalCaseOwners: Array<{ __typename?: 'LegalCaseOwner', id?: string | null, ownershipPercentage: number, user?: { __typename?: 'User', id: string, fullName: string } | null } | null> } };

export type LegalCasesQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<LegalCaseFilterInput>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type LegalCasesQuery = { __typename?: 'Query', legalCases: { __typename?: 'LegalCaseConnection', totalCount: number, nodes: Array<{ __typename?: 'LegalCase', id: string, fullName?: string | null, state: LegalCaseState, estimatedCaseValue?: number | null, language?: string | null, lastTcDate?: any | null, formattedInvoicedMinutes: string, formattedUninvoicedMinutes: string, formattedNonBillableMinutes: string, formattedTotalMinutes: string, fixedFee?: number | null, paymentType?: PaymentType | null, hourlyFeeType?: HourlyFeeType | null, closedOn?: any | null, client?: { __typename?: 'Client', id: string, fullName?: string | null, amlStatus: ClientAmlStatus, antiMoneyLaunderingDate?: any | null, amlExpectedDate?: any | null, hourlyFeeType?: HourlyFeeType | null, invoicingCurrency?: { __typename?: 'Currency', id: string, name: string } | null, clientOwners: Array<{ __typename?: 'ClientOwner', id?: string | null, user?: { __typename?: 'User', id: string } | null } | null> } | null, legalCaseOwners: Array<{ __typename?: 'LegalCaseOwner', id?: string | null, ownershipPercentage: number, user?: { __typename?: 'User', id: string, fullName: string } | null } | null>, currency?: { __typename?: 'Currency', id: string, name: string } | null, manager?: { __typename?: 'User', id: string, fullName: string } | null, connectedLawyers: Array<{ __typename?: 'User', id: string } | null>, primaryPracticeArea?: { __typename?: 'PracticeArea', id: string, name: string } | null, secondaryPracticeArea?: { __typename?: 'PracticeArea', id: string, name: string } | null }> } };

export type AutocompleteLegalCasesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<LegalCaseFilterInput>;
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
}>;


export type AutocompleteLegalCasesQuery = { __typename?: 'Query', legalCases: { __typename?: 'LegalCaseConnection', nodes: Array<{ __typename?: 'LegalCase', id: string, fullName?: string | null }> } };

export type AutocompleteLegalCasesExpandedQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<LegalCaseFilterInput>;
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
}>;


export type AutocompleteLegalCasesExpandedQuery = { __typename?: 'Query', legalCases: { __typename?: 'LegalCaseConnection', nodes: Array<{ __typename?: 'LegalCase', id: string, fullName?: string | null, language?: string | null, client?: { __typename?: 'Client', id: string, fullName?: string | null, invoicingCurrency?: { __typename?: 'Currency', id: string, name: string } | null } | null, invoicingCurrency?: { __typename?: 'Currency', id: string, name: string } | null }> } };

export type DeleteLegalCaseMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteLegalCaseMutation = { __typename?: 'Mutation', deleteLegalCase: boolean };

export type LegalCasesExportQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LegalCaseFilterInput>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type LegalCasesExportQuery = { __typename?: 'Query', legalCases: { __typename?: 'LegalCaseConnection', xlsxExport: { __typename?: 'XlsxExport', filename: string, content: string } } };

export type TimeCardCaseChangeMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
  input: InvoiceableCaseChangeInput;
}>;


export type TimeCardCaseChangeMutation = { __typename?: 'Mutation', massCaseChangeTimeCard: boolean };

export type DisbursementCaseChangeMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
  input: InvoiceableCaseChangeInput;
}>;


export type DisbursementCaseChangeMutation = { __typename?: 'Mutation', massCaseChangeDisbursement: boolean };

export type LegalCaseProfitabilityQueryVariables = Exact<{
  legalCaseId: Scalars['ID'];
  dateFrom: Scalars['ISO8601Date'];
  dateTo: Scalars['ISO8601Date'];
  invoiceFilter?: InputMaybe<Scalars['String']>;
}>;


export type LegalCaseProfitabilityQuery = { __typename?: 'Query', legalCaseProfitability: { __typename?: 'ProfitabilityResult', revenue: number, totalDirectCost: number, totalIndirectCost: number, profitability: number, currency?: { __typename?: 'Currency', id: string, name: string } | null, invoices: Array<{ __typename?: 'ProfitabilityInvoice', totalValue: number, invoice: { __typename?: 'Invoice', id: string, number?: string | null, state: InvoiceState, includedRecordsPeriodFromDate?: any | null, includedRecordsPeriodToDate?: any | null } }>, rows: Array<{ __typename?: 'ProfitabilityRow', invoicedMinutes: number, revenue: number, directCost: number, indirectCost: number, profitability: number, missingCostData: boolean, totalRow: boolean, user?: { __typename?: 'User', id: string, fullName: string } | null }> } };

export type NotificationsQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<NotificationFilterInput>;
}>;


export type NotificationsQuery = { __typename?: 'Query', notifications: { __typename?: 'NotificationConnection', totalCount: number, nodes: Array<{ __typename?: 'Notification', id: string, kind: NotificationKind, seenAt?: any | null, translationData?: any | null, translationKey?: string | null, relatedId?: string | null, relatedType?: NotificationRelatedType | null, createdAt: any }> } };

export type DownloadGlobalProfitabilityReportMutationVariables = Exact<{
  dateFrom: Scalars['ISO8601Date'];
  dateTo: Scalars['ISO8601Date'];
}>;


export type DownloadGlobalProfitabilityReportMutation = { __typename?: 'Mutation', reportGlobalProfitability: { __typename?: 'ReportExport', id: string, state: string } };

export type GlobalProfitabilityReportExportQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GlobalProfitabilityReportExportQuery = { __typename?: 'Query', reportExport: { __typename?: 'ReportExport', id: string, state: string, errorMessage?: string | null, filename?: string | null, content?: string | null } };

export type DownloadMatterStatusReportMutationVariables = Exact<{
  clientId: Scalars['ID'];
}>;


export type DownloadMatterStatusReportMutation = { __typename?: 'Mutation', reportMatterStatus: { __typename?: 'XlsxExport', content: string, filename: string } };

export type DownloadPersonalPracticeReportMutationVariables = Exact<{
  dateFrom: Scalars['ISO8601Date'];
  dateTo: Scalars['ISO8601Date'];
  userId?: InputMaybe<Scalars['ID']>;
  excludeExternals: Scalars['Boolean'];
}>;


export type DownloadPersonalPracticeReportMutation = { __typename?: 'Mutation', reportPersonalPractice: { __typename?: 'XlsxExport', content: string, filename: string } };

export type DownloadPracticeAreasReportMutationVariables = Exact<{
  dateFrom: Scalars['ISO8601Date'];
  dateTo: Scalars['ISO8601Date'];
  excludeExternals: Scalars['Boolean'];
}>;


export type DownloadPracticeAreasReportMutation = { __typename?: 'Mutation', reportPracticeAreas: { __typename?: 'XlsxExport', content: string, filename: string } };

export type DownloadReceivablesReportMutationVariables = Exact<{ [key: string]: never; }>;


export type DownloadReceivablesReportMutation = { __typename?: 'Mutation', reportReceivables: { __typename?: 'XlsxExport', content: string, filename: string } };

export type DownloadTimeCardsByLegalCaseReportMutationVariables = Exact<{
  dateFrom: Scalars['ISO8601Date'];
  dateTo: Scalars['ISO8601Date'];
  userIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  excludeExternals: Scalars['Boolean'];
}>;


export type DownloadTimeCardsByLegalCaseReportMutation = { __typename?: 'Mutation', reportTimeCardsByLegalCase: { __typename?: 'XlsxExport', content: string, filename: string } };

export type DownloadTotalTimeReportMutationVariables = Exact<{
  dateFrom: Scalars['ISO8601Date'];
  dateTo: Scalars['ISO8601Date'];
  excludeExternals: Scalars['Boolean'];
}>;


export type DownloadTotalTimeReportMutation = { __typename?: 'Mutation', reportTotalTime: { __typename?: 'XlsxExport', content: string, filename: string } };

export type DownloadUninvoicedTimeCardsReportMutationVariables = Exact<{
  invoiceStates: Array<InvoiceState> | InvoiceState;
}>;


export type DownloadUninvoicedTimeCardsReportMutation = { __typename?: 'Mutation', reportUninvoicedTimeCards: { __typename?: 'XlsxExport', content: string, filename: string } };

export type StartTaskMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type StartTaskMutation = { __typename?: 'Mutation', startTask: { __typename?: 'Task', id: string, state: TaskState, assignee: { __typename?: 'User', id: string } } };

export type PostponeTaskMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PostponeTaskMutation = { __typename?: 'Mutation', postponeTask: { __typename?: 'Task', id: string, state: TaskState, assignee: { __typename?: 'User', id: string } } };

export type FinishTaskMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FinishTaskMutation = { __typename?: 'Mutation', finishTask: { __typename?: 'Task', id: string, state: TaskState, assignee: { __typename?: 'User', id: string } } };

export type ToReviewTaskMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ToReviewTaskMutation = { __typename?: 'Mutation', toReviewTask: { __typename?: 'Task', id: string, state: TaskState, assignee: { __typename?: 'User', id: string } } };

export type RejectTaskMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RejectTaskMutation = { __typename?: 'Mutation', rejectTask: { __typename?: 'Task', id: string, state: TaskState, assignee: { __typename?: 'User', id: string } } };

export type ApproveTaskMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ApproveTaskMutation = { __typename?: 'Mutation', approveTask: { __typename?: 'Task', id: string, state: TaskState, assignee: { __typename?: 'User', id: string } } };

export type CancelTaskMutationVariables = Exact<{
  id: Scalars['ID'];
  reason: Scalars['String'];
}>;


export type CancelTaskMutation = { __typename?: 'Mutation', cancelTask: { __typename?: 'Task', id: string } };

export type DeleteTaskMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteTaskMutation = { __typename?: 'Mutation', deleteTask: boolean };

export type AutocompleteUsersWithTeamsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<UserFilterInput>;
}>;


export type AutocompleteUsersWithTeamsQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', totalCount: number, nodes: Array<{ __typename?: 'User', id: string, fullName: string, positionName?: string | null, teams?: Array<{ __typename?: 'Team', id: string, name: string } | null> | null }> } };

export type CreateTaskMutationVariables = Exact<{
  input: TaskInput;
}>;


export type CreateTaskMutation = { __typename?: 'Mutation', createTask: { __typename?: 'Task', id: string } };

export type TaskQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TaskQuery = { __typename?: 'Query', task: { __typename?: 'Task', id: string, title: string, description: string, personal: boolean, dueDate: any, priority: TaskPriority, needsApproval: boolean, state: TaskState, legalCase?: { __typename?: 'LegalCase', id: string, fullName?: string | null, client?: { __typename?: 'Client', id: string, fullName?: string | null } | null } | null, author: { __typename?: 'User', id: string, fullName: string, profilePictureUrl?: string | null }, assignee: { __typename?: 'User', id: string, fullName: string, profilePictureUrl?: string | null, positionName?: string | null, teams?: Array<{ __typename?: 'Team', id: string, name: string } | null> | null }, team?: { __typename?: 'Team', id: string, name: string } | null } };

export type UpdateTaskMutationVariables = Exact<{
  id: Scalars['ID'];
  input: TaskInput;
}>;


export type UpdateTaskMutation = { __typename?: 'Mutation', updateTask: { __typename?: 'Task', id: string, title: string, description: string, personal: boolean, dueDate: any, priority: TaskPriority, needsApproval: boolean, legalCase?: { __typename?: 'LegalCase', id: string, fullName?: string | null, client?: { __typename?: 'Client', id: string, fullName?: string | null } | null } | null, author: { __typename?: 'User', id: string, fullName: string }, assignee: { __typename?: 'User', id: string, fullName: string, teams?: Array<{ __typename?: 'Team', id: string, name: string } | null> | null }, team?: { __typename?: 'Team', id: string, name: string } | null } };

export type TasksQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<TaskFilterInput>;
}>;


export type TasksQuery = { __typename?: 'Query', tasks: { __typename?: 'TaskConnection', totalCount: number, nodes: Array<{ __typename?: 'Task', id: string, title: string, personal: boolean, dueDate: any, priority: TaskPriority, state: TaskState, needsApproval: boolean, author: { __typename?: 'User', id: string, fullName: string, profilePictureUrl?: string | null }, assignee: { __typename?: 'User', id: string, fullName: string, profilePictureUrl?: string | null }, legalCase?: { __typename?: 'LegalCase', id: string, fullName?: string | null, client?: { __typename?: 'Client', id: string, fullName?: string | null } | null } | null }> } };

export type MyTeamsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyTeamsQuery = { __typename?: 'Query', teams: { __typename?: 'TeamConnection', totalCount: number, nodes: Array<{ __typename?: 'Team', id: string, name: string }> } };

export type MyTeamMembershipsQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<TeamMembershipFilterInput>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type MyTeamMembershipsQuery = { __typename?: 'Query', teamMemberships: { __typename?: 'TeamMembershipConnection', totalCount: number, nodes: Array<{ __typename?: 'TeamMembership', id: string, teamId?: string | null, user?: { __typename?: 'User', id: string, fullName: string, positionName?: string | null, startDate?: any | null, email?: string | null, phone?: string | null, profilePictureUrl?: string | null } | null, supervisor?: { __typename?: 'User', id: string, fullName: string } | null }> } };

export type MyTeamMembershipsExportQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<TeamMembershipFilterInput>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type MyTeamMembershipsExportQuery = { __typename?: 'Query', teamMemberships: { __typename?: 'TeamMembershipConnection', xlsxExport: { __typename?: 'XlsxExport', filename: string, content: string } } };

export type AllTeamMembershipsQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<UserFilterInput>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type AllTeamMembershipsQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', totalCount: number, nodes: Array<{ __typename?: 'User', id: string, fullName: string, positionName?: string | null, startDate?: any | null, email?: string | null, phone?: string | null, profilePictureUrl?: string | null }> } };

export type AllUsersTeamExportQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<UserFilterInput>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type AllUsersTeamExportQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', allUsersTeamXlsxExport: { __typename?: 'XlsxExport', filename: string, content: string } } };

export type TeamMemberQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TeamMemberQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, fullName: string, positionName?: string | null, dateOfBirth?: any | null, startDate?: any | null, email?: string | null, phone?: string | null, linkedinProfileUrl?: string | null, profilePictureUrl?: string | null, employmentType: EmploymentType, statistic?: { __typename?: 'UserStatistic', id: string, casesManaged: any, casesRelated: any, minutesSpent: any, invoicedMinutesSpent: any, uninvoicedMinutesSpent: any, nonBillableMinutesSpent: any, minutesSpentByPracticeArea: any } | null, teams?: Array<{ __typename?: 'Team', id: string, name: string } | null> | null } };

export type CreateTimeCardMutationVariables = Exact<{
  input: TimeCardInput;
}>;


export type CreateTimeCardMutation = { __typename?: 'Mutation', createTimeCard: { __typename?: 'TimeCard', id: string, owner?: { __typename?: 'User', id: string, minutesSpentToday?: number | null, minutesSpentThisMonth?: number | null } | null } };

export type TimeCardQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TimeCardQuery = { __typename?: 'Query', timeCard: { __typename?: 'TimeCard', id: string, description: string, minutesSpent?: number | null, onDate?: any | null, state?: TimeCardState | null, client?: { __typename?: 'Client', id: string, fullName?: string | null } | null, legalCase?: { __typename?: 'LegalCase', id: string, fullName?: string | null, language?: string | null, legalCaseOwners: Array<{ __typename?: 'LegalCaseOwner', user?: { __typename?: 'User', id: string } | null } | null>, manager?: { __typename?: 'User', id: string } | null, client?: { __typename?: 'Client', clientOwners: Array<{ __typename?: 'ClientOwner', id?: string | null, user?: { __typename?: 'User', id: string } | null } | null> } | null } | null, owner?: { __typename?: 'User', id: string, fullName: string } | null } };

export type UpdateTimeCardMutationVariables = Exact<{
  id: Scalars['ID'];
  input: TimeCardInput;
}>;


export type UpdateTimeCardMutation = { __typename?: 'Mutation', updateTimeCard: { __typename?: 'TimeCard', id: string, owner?: { __typename?: 'User', id: string, minutesSpentToday?: number | null, minutesSpentThisMonth?: number | null } | null } };

export type TimeCardsQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<TimeCardFilterInput>;
  search?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
}>;


export type TimeCardsQuery = { __typename?: 'Query', timeCards: { __typename?: 'TimeCardConnection', totalCount: number, nodes: Array<{ __typename?: 'TimeCard', id: string, description: string, minutesSpent?: number | null, formattedMinutesSpent: string, onDate?: any | null, state?: TimeCardState | null, client?: { __typename?: 'Client', id: string, fullName?: string | null, amlStatus: ClientAmlStatus, antiMoneyLaunderingDate?: any | null, amlExpectedDate?: any | null } | null, legalCase?: { __typename?: 'LegalCase', id: string, fullName?: string | null } | null, owner?: { __typename?: 'User', id: string, fullName: string } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type TimeCardsExportQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']>;
  descending?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TimeCardFilterInput>;
  search?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
}>;


export type TimeCardsExportQuery = { __typename?: 'Query', timeCards: { __typename?: 'TimeCardConnection', xlsxExport: { __typename?: 'XlsxExport', filename: string, content: string } } };

export type DeleteTimeCardMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteTimeCardMutation = { __typename?: 'Mutation', deleteTimeCard: { __typename?: 'User', id: string, minutesSpentToday?: number | null, minutesSpentThisMonth?: number | null } };

export type Unnamed_1_MutationVariables = Exact<{ [key: string]: never; }>;


export type Unnamed_1_Mutation = { __typename: 'Mutation' };

export type AcknowledgeNotificationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AcknowledgeNotificationMutation = { __typename?: 'Mutation', acknowledgeNotification: { __typename?: 'Notification', id: string, seenAt?: any | null } };

export type UnseenNotifcationsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type UnseenNotifcationsCountQuery = { __typename?: 'Query', currentUserUnseenNotificationsCount: number };

export type ClearNotificationMutationVariables = Exact<{ [key: string]: never; }>;


export type ClearNotificationMutation = { __typename?: 'Mutation', clearNotification: boolean };

export const EntityFieldsFragmentDoc = gql`
    fragment EntityFields on Entity {
  id
  name
  registrationNumber
  vatRegistrationNumber
  address
  postalCode
  country
  phone
  faxNumber
  websiteUrl
  email
  logoUrl
  altNameTranslations
  altAddressTranslations
  discardedAt
  bankDetails
  altBankDetailsTranslations
}
    `;
export const AccountSettingsFieldsFragmentDoc = gql`
    fragment AccountSettingsFields on Account {
  id
  invoiceNumberMask
  invoiceNumberLength
  creditNoteMark
  creditNoteMarkPosition
  invoiceNumberResetFrequency
  badDebtStatusAfter
  currency {
    id
    name
  }
  paymentTerm {
    id
    days
  }
  invoiceApprovers {
    id
    name
    group
  }
  locale
  otherLocales
  timeZoneName
  firstApprover
  timeFormat
  defaultCaseDescriptions
  footnotes
  clientInactiveAfter
  legalCaseNumberLength
  unpaidInvoiceNotificationIntervalDays
  smtpHost
  smtpPort
  smtpUser
  smtpPasswordPresent
  notificationEmailFromAddressInternal
  notificationEmailFromAddressExternal
  caseNumberingByClient
  caseNumberingShown
  monthlyUserCountEstimate
  showFinishSetupFrom
  logoUrl
  allowedTcCreationTime
  dateFormat
  availableDateFormats
  mailchimpApiKeyPresent
  mailchimpApiListId
  mailchimpServerId
  autoSyncContactsWithMailchimp
  featureFlags
  familyNameFirst
  reportSchedules {
    reportType
    frequency
    dayOfWeek
    dayOfMonth
    excludeExternals
  }
  amlRecurrency
}
    `;
export const PriceListsFieldsFragmentDoc = gql`
    fragment PriceListsFields on PriceList {
  id
  name
  default
}
    `;
export const PriceListFieldsFragmentDoc = gql`
    fragment PriceListFields on PriceList {
  id
  name
  default
  priceListRates {
    id
    currency {
      id
      name
    }
    priced {
      id
      name
      positionName
      sequence
    }
    pricedType
    rate
  }
}
    `;
export const SubscriptionInfoFieldsFragmentDoc = gql`
    fragment SubscriptionInfoFields on SubscriptionInfo {
  id
  terminationDate
  currentIntervalTillDate
  upcomingInvoice {
    id
    dailyCount
    dailyIntervalText
    monthlyCount
    monthlyIntervalText
    userDayPrice
    userMonthPrice
    dailyNetAmount
    monthlyNetAmount
    correctionAmount
    netAmount
    vatPercentage
    vatAmount
    grossAmount
    willTryPayAt
    currency
    applicableCommitments {
      id
      priceExVat
    }
  }
  card {
    id
    cardNumber
    expiration
    ownerName
  }
}
    `;
export const SubscriptionSettingsFieldsFragmentDoc = gql`
    fragment SubscriptionSettingsFields on AccountSubscriptionSettings {
  id
  subscriptionDefaultPlan
  subscriptionInvoiceEmail
  subscriptionLawFirmName
  subscriptionLawFirmAddress
  subscriptionLawFirmPostalCode
  subscriptionLawFirmCountry
  subscriptionLawFirmVatRegistrationNumber
  subscriptionLawFirmRegistrationNumber
}
    `;
export const SubscriptionInvoiceFieldsFragmentDoc = gql`
    fragment SubscriptionInvoiceFields on SubscriptionInvoice {
  id
  number
  date
  description
  grossAmount
  state
  dueDate
  paidAt
  printoutPdfUrl
  paymentError
  currency
}
    `;
export const FullUserFieldsFragmentDoc = gql`
    fragment FullUserFields on User {
  id
  firstName
  altFirstNameTranslations
  lastName
  altLastNameTranslations
  linkedinProfileUrl
  phone
  fullName
  dateOfBirth
  userCredential {
    id
    email
    lastSignInAt
  }
  position {
    id
    name
  }
  userRole {
    id
    name
  }
  admin
  subscriptionPlan
  employmentType
  subscriptionPlanAtIntervalStart
  clockTimeZones {
    id
  }
  startDate
  lastWorkingDay
  current
  profilePictureUrl
  accessLocked
  iconPack
}
    `;
export const NotificationFieldsFragmentDoc = gql`
    fragment NotificationFields on User {
  notifyBadDebtInvoiceVia
  notifyClientOwnerVia
  notifyLegalCaseDeadlineVia
  notifyInvoiceReviewRequestVia
  notifyLegalCaseCostCapVia
  notifyUnpaidInvoiceInternalVia
  notifyLegalCaseManagerVia
  notifyLegalCaseConnectedLawyerVia
  notifyLegalCaseOwnerVia
  notifyLegalCaseOwnershipChangeVia
  notifyClientOwnershipChangeVia
  notifyUninvoicedClientVia
}
    `;
export const ClientBillingFieldsFragmentDoc = gql`
    fragment ClientBillingFields on Client {
  id
  fullName
  identificationNumber
  vatRegistrationNumber
  address
  country
  postalCode
  billingAddressType
  billingAddress
  billingCountry
  billingPostalCode
  billingContact {
    id
    fullName
    opponent
  }
  billingPhone
  paymentType
  hourlyFeeType
  discountPercentage
  language
  paymentTerm {
    id
    days
  }
  invoicingCurrency {
    id
    name
  }
  billingEmails
  invoiceIssuer {
    id
    name
  }
  vatPercentage {
    id
    percentage
    location
  }
  flatRate
  paymentType
  hourlyFeeType
  standardPriceList {
    id
    name
  }
  lawyerRate
  nonLawyerRate
  billingToName
  billingToRegistrationNumber
  billingToVatRegistrationNumber
  customizedPriceList {
    id
    name
    priceListRates {
      id
      priced {
        id
        name
        positionName
        sequence
      }
      pricedType
      rate
      currency {
        id
      }
    }
  }
}
    `;
export const FullClientFieldsFragmentDoc = gql`
    fragment FullClientFields on Client {
  id
  name
  entityType
  lastName
  address
  country
  identificationNumber
  language
  linkedinProfileUrl
  postalCode
  serviceLevel
  vatRegistrationNumber
  websiteUrl
  fullName
  ownershipStory
  antiMoneyLaundering
  antiMoneyLaunderingDate
  engagementLetterExecuted
  engagementLetterDate
  lastYearSales
  matterStatusReports
  manager {
    id
    fullName
  }
  industry {
    id
    name
  }
  clientOwners {
    id
    ownershipPercentage
    user {
      id
      fullName
    }
  }
  shareholders {
    id
    fullName
  }
  marketingEffortTypes {
    id
    name
  }
  hasInvoicing
  billingAddress
  billingCountry
  billingPostalCode
  billingContact {
    id
    fullName
    opponent
  }
  billingPhone
  billingEmails
  invoicingCurrency {
    id
    name
  }
  creditRating {
    id
    name
  }
  paymentTerm {
    id
    days
  }
  paymentType
  hourlyFeeType
  discountPercentage
  supplierIdentifier
  invoiceIssuer {
    id
    name
  }
  invoiceByPost
  latePaymentReminder
  billingAddressType
  currency {
    id
    name
  }
  standardPriceList {
    id
    name
  }
  flatRate
  vatPercentage {
    id
    percentage
    location
  }
  lawyerRate
  nonLawyerRate
  billingToName
  billingToRegistrationNumber
  billingToVatRegistrationNumber
  formattedInvoicedMinutes
  formattedUninvoicedMinutes
  formattedNonBillableMinutes
  formattedTotalMinutes
  customizedPriceList {
    id
    name
    priceListRates {
      id
      priced {
        id
        name
        positionName
        sequence
      }
      pricedType
      rate
      currency {
        id
      }
    }
  }
  syncContact {
    id
    fullName
    opponent
    syncSourceType
  }
  openedOn
  number
}
    `;
export const FullContactFieldsFragmentDoc = gql`
    fragment FullContactFields on Contact {
  id
  entityType
  name
  middleName
  lastName
  title
  country
  phone
  email
  fullName
  address
  postalCode
  websiteUrl
  linkedinProfileUrl
  vatRegistrationNumber
  registrationNumber
  contactCategories {
    id
    name
  }
  owners {
    id
    fullName
    syncSourceType
  }
  shareholders {
    id
    fullName
    syncSourceType
  }
  company {
    id
    fullName
    syncSourceType
  }
  employees {
    id
    fullName
    syncSourceType
  }
  marketingEffortTypes {
    id
    name
  }
  owner {
    id
    fullName
  }
  birthdayDate
  language
  jobTitle
  identificationNumber
  opponent
  syncSourceId
  syncSourceType
  mailchimpSync
}
    `;
export const DisbursementFieldsFragmentDoc = gql`
    fragment DisbursementFields on Disbursement {
  id
  client {
    id
    fullName
  }
  legalCase {
    id
    language
    fullName
    legalCaseOwners {
      user {
        id
      }
    }
    manager {
      id
    }
    client {
      id
      clientOwners {
        id
        user {
          id
        }
      }
    }
  }
  disbursementType {
    id
    name
  }
  description
  expenseAmount
  onDate
  state
  taxable
  currency {
    id
    name
  }
  owner {
    id
    fullName
  }
  invoice {
    id
    anyDisbursementsWithoutPrice
  }
}
    `;
export const FullInvoiceFieldsFragmentDoc = gql`
    fragment FullInvoiceFields on Invoice {
  id
  legalCase {
    id
    fullName
    state
    client {
      id
      fullName
      identificationNumber
      vatRegistrationNumber
      country
      address
      postalCode
      billingAddressType
      billingAddress
      billingPostalCode
      billingCountry
      billingEmails
      billingToName
      billingToRegistrationNumber
      billingToVatRegistrationNumber
      clientOwners {
        id
        user {
          id
        }
      }
    }
    manager {
      id
      fullName
    }
    legalCaseOwners {
      id
      ownershipPercentage
      user {
        id
        fullName
      }
    }
    billingInformationFromClient
    billingToName
    billingToRegistrationNumber
    billingToVatRegistrationNumber
    billingAddress
    billingPostalCode
    billingCountry
    billingEmails
    language
    connectedLawyers {
      id
    }
  }
  client {
    id
    fullName
    amlStatus
    antiMoneyLaunderingDate
    amlExpectedDate
    clientOwners {
      id
      user {
        id
      }
    }
  }
  currency {
    id
    name
  }
  paymentTerm {
    id
    days
  }
  state
  invoiceType
  number
  paidAt
  issuedAt
  approvedAt
  alternateCaseName
  discountPercentage
  clientReferenceNumber
  language
  vat
  invoiceIssuer {
    id
    name
  }
  billingEmails
  billingInformationFromLegalCase
  billingToName
  billingToRegistrationNumber
  billingToVatRegistrationNumber
  billingAddress
  billingCountry
  billingPostalCode
  billingContact {
    id
    fullName
    opponent
  }
  billingPhone
  vatPercentage {
    id
    percentage
    location
  }
  minutesSpent
  timeCardTotal
  totalValue
  disbursementTotal
  caseNameOnInvoice
  invoiceSubtotal
  invoiceDiscount
  nextStateEvent
  inheritedInvoiceIssuer {
    id
    name
  }
  inheritedDiscountPercentage
  inheritedClientReferenceNumber
  inheritedCurrency {
    id
    name
  }
  periodFromDate
  periodToDate
  inheritedPaymentType
  inheritedHourlyFeeType
  inheritedStandardPriceList {
    id
    name
  }
  inheritedFixedFee
  inheritedLawyerRate
  inheritedNonLawyerRate
  paymentType
  hourlyFeeType
  standardPriceList {
    id
    name
  }
  fixedFee
  flatRate
  recordsExistBeforePeriod
  includedRecordsPeriodFromDate
  includedRecordsPeriodToDate
  approvable
  nextApproverStateRole
  rejectable
  previousRejectEvent
  approvalState
  feeTotal
  creditedInvoice {
    id
    number
  }
  creditNote {
    id
    number
    state
  }
  creditAmount
  feeValue
  customizedPriceList {
    id
    name
    priceListRates {
      id
      priced {
        id
        name
        positionName
        sequence
      }
      pricedType
      rate
      currency {
        id
      }
    }
  }
  creditableAmountType
  approveeRole {
    id
  }
  billableTime {
    userFullName
    positionName
    minutesSpent
    rate
    total
    positionSequence
  }
  prepaymentIntendedUse
  billingContact {
    id
    fullName
    opponent
  }
  copiedTo {
    id
    number
  }
  copyOf {
    id
    number
  }
  allocatedPrepaymentTotalValue
}
    `;
export const FullLegalCaseFieldsFragmentDoc = gql`
    fragment FullLegalCaseFields on LegalCase {
  id
  client {
    id
    fullName
    invoicingCurrency {
      id
      name
    }
    clientOwners {
      id
      user {
        id
      }
    }
    manager {
      id
    }
  }
  currency {
    id
    name
  }
  manager {
    id
    fullName
  }
  opponents {
    id
    fullName
  }
  clientReferenceNumber
  name
  fullName
  nameOnInvoice
  estimatedCaseValue
  openedOn
  deadline
  language
  state
  connectedLawyers {
    id
    fullName
  }
  hasInvoicing
  billingEmails
  paymentTerm {
    id
    days
  }
  paymentType
  hourlyFeeType
  discountPercentage
  fixedFee
  successFee
  successFeeNotes
  proBono
  proBonoNotes
  billingInformationFromClient
  billingToName
  billingToRegistrationNumber
  billingToVatRegistrationNumber
  billingAddress
  billingCountry
  billingPostalCode
  billingContact {
    id
    fullName
    opponent
  }
  billingPhone
  vatPercentage {
    id
    percentage
    location
  }
  invoiceIssuer {
    id
    name
  }
  standardPriceList {
    id
    name
  }
  flatRate
  draftInvoice {
    id
  }
  customizedPriceList {
    id
    name
    priceListRates {
      id
      priced {
        id
        name
        positionName
        sequence
      }
      pricedType
      rate
      currency {
        id
      }
    }
  }
  lawyerRate
  nonLawyerRate
  legalCaseOwners {
    id
    ownershipPercentage
    user {
      id
      fullName
    }
  }
  primaryPracticeArea {
    id
    name
  }
  secondaryPracticeArea {
    id
    name
  }
  closedOn
  invoicingCurrency {
    id
    name
  }
  feedbacks {
    id
    user {
      id
      fullName
    }
    userId
    comment
    rating
    createdAt
  }
  outcome
  outcomeComment
  formattedInvoicedMinutes
  formattedUninvoicedMinutes
  formattedNonBillableMinutes
  formattedTotalMinutes
  frequency
  recurringDate
}
    `;
export const LegalCaseBillingFieldsFragmentDoc = gql`
    fragment LegalCaseBillingFields on LegalCase {
  id
  name
  fullName
  nameOnInvoice
  billingInformationFromClient
  billingToName
  billingToRegistrationNumber
  billingToVatRegistrationNumber
  billingAddress
  billingCountry
  billingPostalCode
  billingContact {
    id
    fullName
    opponent
  }
  billingPhone
  language
  vatPercentage {
    id
    percentage
    location
  }
  paymentType
  hourlyFeeType
  fixedFee
  flatRate
  discountPercentage
  clientReferenceNumber
  paymentTerm {
    id
    days
  }
  standardPriceList {
    id
    name
  }
  billingEmails
  invoiceIssuer {
    id
    name
  }
  customizedPriceList {
    id
    name
    priceListRates {
      id
      priced {
        id
        name
        positionName
        sequence
      }
      pricedType
      rate
      currency {
        id
      }
    }
  }
  lawyerRate
  nonLawyerRate
  invoicingCurrency {
    id
    name
  }
}
    `;
export const AuditHistoryDocument = gql`
    query AuditHistory($auditableId: ID!, $auditableType: AuditableType!, $order: String, $descending: Boolean, $after: String, $first: Int, $filter: AuditEventFilterInput) {
  auditEvents(
    auditableId: $auditableId
    auditableType: $auditableType
    order: $order
    descending: $descending
    after: $after
    first: $first
    filter: $filter
  ) {
    nodes {
      id
      action
      auditableType
      changes
      createdAt
      user {
        id
        fullName
      }
    }
    totalCount
  }
}
    `;

/**
 * __useAuditHistoryQuery__
 *
 * To run a query within a React component, call `useAuditHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditHistoryQuery({
 *   variables: {
 *      auditableId: // value for 'auditableId'
 *      auditableType: // value for 'auditableType'
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAuditHistoryQuery(baseOptions: Apollo.QueryHookOptions<AuditHistoryQuery, AuditHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditHistoryQuery, AuditHistoryQueryVariables>(AuditHistoryDocument, options);
      }
export function useAuditHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditHistoryQuery, AuditHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditHistoryQuery, AuditHistoryQueryVariables>(AuditHistoryDocument, options);
        }
export type AuditHistoryQueryHookResult = ReturnType<typeof useAuditHistoryQuery>;
export type AuditHistoryLazyQueryHookResult = ReturnType<typeof useAuditHistoryLazyQuery>;
export type AuditHistoryQueryResult = Apollo.QueryResult<AuditHistoryQuery, AuditHistoryQueryVariables>;
export const AuditClientDocument = gql`
    query AuditClient($id: ID!) {
  client(id: $id) {
    id
    fullName
  }
}
    `;

/**
 * __useAuditClientQuery__
 *
 * To run a query within a React component, call `useAuditClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditClientQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAuditClientQuery(baseOptions: Apollo.QueryHookOptions<AuditClientQuery, AuditClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditClientQuery, AuditClientQueryVariables>(AuditClientDocument, options);
      }
export function useAuditClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditClientQuery, AuditClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditClientQuery, AuditClientQueryVariables>(AuditClientDocument, options);
        }
export type AuditClientQueryHookResult = ReturnType<typeof useAuditClientQuery>;
export type AuditClientLazyQueryHookResult = ReturnType<typeof useAuditClientLazyQuery>;
export type AuditClientQueryResult = Apollo.QueryResult<AuditClientQuery, AuditClientQueryVariables>;
export const AuditUserDocument = gql`
    query AuditUser($id: ID!) {
  user(id: $id) {
    id
    fullName
  }
}
    `;

/**
 * __useAuditUserQuery__
 *
 * To run a query within a React component, call `useAuditUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAuditUserQuery(baseOptions: Apollo.QueryHookOptions<AuditUserQuery, AuditUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditUserQuery, AuditUserQueryVariables>(AuditUserDocument, options);
      }
export function useAuditUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditUserQuery, AuditUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditUserQuery, AuditUserQueryVariables>(AuditUserDocument, options);
        }
export type AuditUserQueryHookResult = ReturnType<typeof useAuditUserQuery>;
export type AuditUserLazyQueryHookResult = ReturnType<typeof useAuditUserLazyQuery>;
export type AuditUserQueryResult = Apollo.QueryResult<AuditUserQuery, AuditUserQueryVariables>;
export const AuditContactDocument = gql`
    query AuditContact($id: ID!) {
  contact(id: $id) {
    id
    fullName
  }
}
    `;

/**
 * __useAuditContactQuery__
 *
 * To run a query within a React component, call `useAuditContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditContactQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAuditContactQuery(baseOptions: Apollo.QueryHookOptions<AuditContactQuery, AuditContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditContactQuery, AuditContactQueryVariables>(AuditContactDocument, options);
      }
export function useAuditContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditContactQuery, AuditContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditContactQuery, AuditContactQueryVariables>(AuditContactDocument, options);
        }
export type AuditContactQueryHookResult = ReturnType<typeof useAuditContactQuery>;
export type AuditContactLazyQueryHookResult = ReturnType<typeof useAuditContactLazyQuery>;
export type AuditContactQueryResult = Apollo.QueryResult<AuditContactQuery, AuditContactQueryVariables>;
export const AuditPriceListDocument = gql`
    query AuditPriceList($id: ID!) {
  priceList(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useAuditPriceListQuery__
 *
 * To run a query within a React component, call `useAuditPriceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditPriceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditPriceListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAuditPriceListQuery(baseOptions: Apollo.QueryHookOptions<AuditPriceListQuery, AuditPriceListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditPriceListQuery, AuditPriceListQueryVariables>(AuditPriceListDocument, options);
      }
export function useAuditPriceListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditPriceListQuery, AuditPriceListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditPriceListQuery, AuditPriceListQueryVariables>(AuditPriceListDocument, options);
        }
export type AuditPriceListQueryHookResult = ReturnType<typeof useAuditPriceListQuery>;
export type AuditPriceListLazyQueryHookResult = ReturnType<typeof useAuditPriceListLazyQuery>;
export type AuditPriceListQueryResult = Apollo.QueryResult<AuditPriceListQuery, AuditPriceListQueryVariables>;
export const AuditVatPercentageDocument = gql`
    query AuditVatPercentage($id: ID!) {
  vatPercentage(id: $id) {
    id
    percentage
  }
}
    `;

/**
 * __useAuditVatPercentageQuery__
 *
 * To run a query within a React component, call `useAuditVatPercentageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditVatPercentageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditVatPercentageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAuditVatPercentageQuery(baseOptions: Apollo.QueryHookOptions<AuditVatPercentageQuery, AuditVatPercentageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditVatPercentageQuery, AuditVatPercentageQueryVariables>(AuditVatPercentageDocument, options);
      }
export function useAuditVatPercentageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditVatPercentageQuery, AuditVatPercentageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditVatPercentageQuery, AuditVatPercentageQueryVariables>(AuditVatPercentageDocument, options);
        }
export type AuditVatPercentageQueryHookResult = ReturnType<typeof useAuditVatPercentageQuery>;
export type AuditVatPercentageLazyQueryHookResult = ReturnType<typeof useAuditVatPercentageLazyQuery>;
export type AuditVatPercentageQueryResult = Apollo.QueryResult<AuditVatPercentageQuery, AuditVatPercentageQueryVariables>;
export const AuditEntityDocument = gql`
    query AuditEntity($id: ID!) {
  entity(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useAuditEntityQuery__
 *
 * To run a query within a React component, call `useAuditEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditEntityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAuditEntityQuery(baseOptions: Apollo.QueryHookOptions<AuditEntityQuery, AuditEntityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditEntityQuery, AuditEntityQueryVariables>(AuditEntityDocument, options);
      }
export function useAuditEntityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditEntityQuery, AuditEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditEntityQuery, AuditEntityQueryVariables>(AuditEntityDocument, options);
        }
export type AuditEntityQueryHookResult = ReturnType<typeof useAuditEntityQuery>;
export type AuditEntityLazyQueryHookResult = ReturnType<typeof useAuditEntityLazyQuery>;
export type AuditEntityQueryResult = Apollo.QueryResult<AuditEntityQuery, AuditEntityQueryVariables>;
export const AuditLegalCaseDocument = gql`
    query AuditLegalCase($id: ID!) {
  legalCase(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useAuditLegalCaseQuery__
 *
 * To run a query within a React component, call `useAuditLegalCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditLegalCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditLegalCaseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAuditLegalCaseQuery(baseOptions: Apollo.QueryHookOptions<AuditLegalCaseQuery, AuditLegalCaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditLegalCaseQuery, AuditLegalCaseQueryVariables>(AuditLegalCaseDocument, options);
      }
export function useAuditLegalCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditLegalCaseQuery, AuditLegalCaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditLegalCaseQuery, AuditLegalCaseQueryVariables>(AuditLegalCaseDocument, options);
        }
export type AuditLegalCaseQueryHookResult = ReturnType<typeof useAuditLegalCaseQuery>;
export type AuditLegalCaseLazyQueryHookResult = ReturnType<typeof useAuditLegalCaseLazyQuery>;
export type AuditLegalCaseQueryResult = Apollo.QueryResult<AuditLegalCaseQuery, AuditLegalCaseQueryVariables>;
export const AuditInvoiceDocument = gql`
    query AuditInvoice($id: ID!) {
  invoice(id: $id) {
    id
    number
    state
    invoiceType
  }
}
    `;

/**
 * __useAuditInvoiceQuery__
 *
 * To run a query within a React component, call `useAuditInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAuditInvoiceQuery(baseOptions: Apollo.QueryHookOptions<AuditInvoiceQuery, AuditInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditInvoiceQuery, AuditInvoiceQueryVariables>(AuditInvoiceDocument, options);
      }
export function useAuditInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditInvoiceQuery, AuditInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditInvoiceQuery, AuditInvoiceQueryVariables>(AuditInvoiceDocument, options);
        }
export type AuditInvoiceQueryHookResult = ReturnType<typeof useAuditInvoiceQuery>;
export type AuditInvoiceLazyQueryHookResult = ReturnType<typeof useAuditInvoiceLazyQuery>;
export type AuditInvoiceQueryResult = Apollo.QueryResult<AuditInvoiceQuery, AuditInvoiceQueryVariables>;
export const AuditPositionDocument = gql`
    query AuditPosition($id: ID!) {
  position(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useAuditPositionQuery__
 *
 * To run a query within a React component, call `useAuditPositionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditPositionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditPositionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAuditPositionQuery(baseOptions: Apollo.QueryHookOptions<AuditPositionQuery, AuditPositionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditPositionQuery, AuditPositionQueryVariables>(AuditPositionDocument, options);
      }
export function useAuditPositionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditPositionQuery, AuditPositionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditPositionQuery, AuditPositionQueryVariables>(AuditPositionDocument, options);
        }
export type AuditPositionQueryHookResult = ReturnType<typeof useAuditPositionQuery>;
export type AuditPositionLazyQueryHookResult = ReturnType<typeof useAuditPositionLazyQuery>;
export type AuditPositionQueryResult = Apollo.QueryResult<AuditPositionQuery, AuditPositionQueryVariables>;
export const CurrentUserHeaderDataDocument = gql`
    query CurrentUserHeaderData {
  currentUser {
    id
    minutesSpentToday
    minutesSpentThisMonth
    currentPerformanceTargetTimeCardMinutesPerDay
    clockTimeZones {
      id
      canonicalName
    }
  }
}
    `;

/**
 * __useCurrentUserHeaderDataQuery__
 *
 * To run a query within a React component, call `useCurrentUserHeaderDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserHeaderDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserHeaderDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserHeaderDataQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserHeaderDataQuery, CurrentUserHeaderDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserHeaderDataQuery, CurrentUserHeaderDataQueryVariables>(CurrentUserHeaderDataDocument, options);
      }
export function useCurrentUserHeaderDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserHeaderDataQuery, CurrentUserHeaderDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserHeaderDataQuery, CurrentUserHeaderDataQueryVariables>(CurrentUserHeaderDataDocument, options);
        }
export type CurrentUserHeaderDataQueryHookResult = ReturnType<typeof useCurrentUserHeaderDataQuery>;
export type CurrentUserHeaderDataLazyQueryHookResult = ReturnType<typeof useCurrentUserHeaderDataLazyQuery>;
export type CurrentUserHeaderDataQueryResult = Apollo.QueryResult<CurrentUserHeaderDataQuery, CurrentUserHeaderDataQueryVariables>;
export const CreateImportAttemptDocument = gql`
    mutation CreateImportAttempt($input: ImportAttemptInput!) {
  createImportAttempt(input: $input) {
    id
  }
}
    `;
export type CreateImportAttemptMutationFn = Apollo.MutationFunction<CreateImportAttemptMutation, CreateImportAttemptMutationVariables>;

/**
 * __useCreateImportAttemptMutation__
 *
 * To run a mutation, you first call `useCreateImportAttemptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateImportAttemptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createImportAttemptMutation, { data, loading, error }] = useCreateImportAttemptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateImportAttemptMutation(baseOptions?: Apollo.MutationHookOptions<CreateImportAttemptMutation, CreateImportAttemptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateImportAttemptMutation, CreateImportAttemptMutationVariables>(CreateImportAttemptDocument, options);
      }
export type CreateImportAttemptMutationHookResult = ReturnType<typeof useCreateImportAttemptMutation>;
export type CreateImportAttemptMutationResult = Apollo.MutationResult<CreateImportAttemptMutation>;
export type CreateImportAttemptMutationOptions = Apollo.BaseMutationOptions<CreateImportAttemptMutation, CreateImportAttemptMutationVariables>;
export const ImportAttemptSampleDocument = gql`
    query ImportAttemptSample($destination: ImportAttemptDestination!) {
  importAttemptSample(destination: $destination)
}
    `;

/**
 * __useImportAttemptSampleQuery__
 *
 * To run a query within a React component, call `useImportAttemptSampleQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportAttemptSampleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportAttemptSampleQuery({
 *   variables: {
 *      destination: // value for 'destination'
 *   },
 * });
 */
export function useImportAttemptSampleQuery(baseOptions: Apollo.QueryHookOptions<ImportAttemptSampleQuery, ImportAttemptSampleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportAttemptSampleQuery, ImportAttemptSampleQueryVariables>(ImportAttemptSampleDocument, options);
      }
export function useImportAttemptSampleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportAttemptSampleQuery, ImportAttemptSampleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportAttemptSampleQuery, ImportAttemptSampleQueryVariables>(ImportAttemptSampleDocument, options);
        }
export type ImportAttemptSampleQueryHookResult = ReturnType<typeof useImportAttemptSampleQuery>;
export type ImportAttemptSampleLazyQueryHookResult = ReturnType<typeof useImportAttemptSampleLazyQuery>;
export type ImportAttemptSampleQueryResult = Apollo.QueryResult<ImportAttemptSampleQuery, ImportAttemptSampleQueryVariables>;
export const ImportAttemptDocument = gql`
    query ImportAttempt($id: ID!) {
  importAttempt(id: $id) {
    id
    createdAt
    state
    processingErrors
    parsedCount
    invalidCount
    insertedCount
    updatedCount
  }
}
    `;

/**
 * __useImportAttemptQuery__
 *
 * To run a query within a React component, call `useImportAttemptQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportAttemptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportAttemptQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useImportAttemptQuery(baseOptions: Apollo.QueryHookOptions<ImportAttemptQuery, ImportAttemptQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportAttemptQuery, ImportAttemptQueryVariables>(ImportAttemptDocument, options);
      }
export function useImportAttemptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportAttemptQuery, ImportAttemptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportAttemptQuery, ImportAttemptQueryVariables>(ImportAttemptDocument, options);
        }
export type ImportAttemptQueryHookResult = ReturnType<typeof useImportAttemptQuery>;
export type ImportAttemptLazyQueryHookResult = ReturnType<typeof useImportAttemptLazyQuery>;
export type ImportAttemptQueryResult = Apollo.QueryResult<ImportAttemptQuery, ImportAttemptQueryVariables>;
export const ScheduleImportAttemptDocument = gql`
    mutation ScheduleImportAttempt($id: ID!) {
  scheduleImportAttempt(id: $id) {
    id
    state
  }
}
    `;
export type ScheduleImportAttemptMutationFn = Apollo.MutationFunction<ScheduleImportAttemptMutation, ScheduleImportAttemptMutationVariables>;

/**
 * __useScheduleImportAttemptMutation__
 *
 * To run a mutation, you first call `useScheduleImportAttemptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleImportAttemptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleImportAttemptMutation, { data, loading, error }] = useScheduleImportAttemptMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useScheduleImportAttemptMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleImportAttemptMutation, ScheduleImportAttemptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleImportAttemptMutation, ScheduleImportAttemptMutationVariables>(ScheduleImportAttemptDocument, options);
      }
export type ScheduleImportAttemptMutationHookResult = ReturnType<typeof useScheduleImportAttemptMutation>;
export type ScheduleImportAttemptMutationResult = Apollo.MutationResult<ScheduleImportAttemptMutation>;
export type ScheduleImportAttemptMutationOptions = Apollo.BaseMutationOptions<ScheduleImportAttemptMutation, ScheduleImportAttemptMutationVariables>;
export const ImportAttemptsDocument = gql`
    query ImportAttempts($order: String, $descending: Boolean, $after: String, $first: Int, $filter: ImportAttemptFilterInput) {
  importAttempts(
    order: $order
    descending: $descending
    after: $after
    first: $first
    filter: $filter
  ) {
    nodes {
      id
      state
      createdAt
    }
    totalCount
  }
}
    `;

/**
 * __useImportAttemptsQuery__
 *
 * To run a query within a React component, call `useImportAttemptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportAttemptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportAttemptsQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useImportAttemptsQuery(baseOptions?: Apollo.QueryHookOptions<ImportAttemptsQuery, ImportAttemptsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportAttemptsQuery, ImportAttemptsQueryVariables>(ImportAttemptsDocument, options);
      }
export function useImportAttemptsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportAttemptsQuery, ImportAttemptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportAttemptsQuery, ImportAttemptsQueryVariables>(ImportAttemptsDocument, options);
        }
export type ImportAttemptsQueryHookResult = ReturnType<typeof useImportAttemptsQuery>;
export type ImportAttemptsLazyQueryHookResult = ReturnType<typeof useImportAttemptsLazyQuery>;
export type ImportAttemptsQueryResult = Apollo.QueryResult<ImportAttemptsQuery, ImportAttemptsQueryVariables>;
export const AskAiDocument = gql`
    query AskAi($question: String!) {
  askAi(question: $question) {
    text
    charts
    error
  }
}
    `;

/**
 * __useAskAiQuery__
 *
 * To run a query within a React component, call `useAskAiQuery` and pass it any options that fit your needs.
 * When your component renders, `useAskAiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAskAiQuery({
 *   variables: {
 *      question: // value for 'question'
 *   },
 * });
 */
export function useAskAiQuery(baseOptions: Apollo.QueryHookOptions<AskAiQuery, AskAiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AskAiQuery, AskAiQueryVariables>(AskAiDocument, options);
      }
export function useAskAiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AskAiQuery, AskAiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AskAiQuery, AskAiQueryVariables>(AskAiDocument, options);
        }
export type AskAiQueryHookResult = ReturnType<typeof useAskAiQuery>;
export type AskAiLazyQueryHookResult = ReturnType<typeof useAskAiLazyQuery>;
export type AskAiQueryResult = Apollo.QueryResult<AskAiQuery, AskAiQueryVariables>;
export const ResetCurrentAccountDbDocument = gql`
    mutation ResetCurrentAccountDb($input: DbResetInput!) {
  resetCurrentAccountDb(input: $input)
}
    `;
export type ResetCurrentAccountDbMutationFn = Apollo.MutationFunction<ResetCurrentAccountDbMutation, ResetCurrentAccountDbMutationVariables>;

/**
 * __useResetCurrentAccountDbMutation__
 *
 * To run a mutation, you first call `useResetCurrentAccountDbMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetCurrentAccountDbMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetCurrentAccountDbMutation, { data, loading, error }] = useResetCurrentAccountDbMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetCurrentAccountDbMutation(baseOptions?: Apollo.MutationHookOptions<ResetCurrentAccountDbMutation, ResetCurrentAccountDbMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetCurrentAccountDbMutation, ResetCurrentAccountDbMutationVariables>(ResetCurrentAccountDbDocument, options);
      }
export type ResetCurrentAccountDbMutationHookResult = ReturnType<typeof useResetCurrentAccountDbMutation>;
export type ResetCurrentAccountDbMutationResult = Apollo.MutationResult<ResetCurrentAccountDbMutation>;
export type ResetCurrentAccountDbMutationOptions = Apollo.BaseMutationOptions<ResetCurrentAccountDbMutation, ResetCurrentAccountDbMutationVariables>;
export const ProhibitCurrentAccountDbResetDocument = gql`
    mutation ProhibitCurrentAccountDbReset {
  prohibitCurrentAccountDbReset {
    id
    dbResetAllowed
  }
}
    `;
export type ProhibitCurrentAccountDbResetMutationFn = Apollo.MutationFunction<ProhibitCurrentAccountDbResetMutation, ProhibitCurrentAccountDbResetMutationVariables>;

/**
 * __useProhibitCurrentAccountDbResetMutation__
 *
 * To run a mutation, you first call `useProhibitCurrentAccountDbResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProhibitCurrentAccountDbResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [prohibitCurrentAccountDbResetMutation, { data, loading, error }] = useProhibitCurrentAccountDbResetMutation({
 *   variables: {
 *   },
 * });
 */
export function useProhibitCurrentAccountDbResetMutation(baseOptions?: Apollo.MutationHookOptions<ProhibitCurrentAccountDbResetMutation, ProhibitCurrentAccountDbResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProhibitCurrentAccountDbResetMutation, ProhibitCurrentAccountDbResetMutationVariables>(ProhibitCurrentAccountDbResetDocument, options);
      }
export type ProhibitCurrentAccountDbResetMutationHookResult = ReturnType<typeof useProhibitCurrentAccountDbResetMutation>;
export type ProhibitCurrentAccountDbResetMutationResult = Apollo.MutationResult<ProhibitCurrentAccountDbResetMutation>;
export type ProhibitCurrentAccountDbResetMutationOptions = Apollo.BaseMutationOptions<ProhibitCurrentAccountDbResetMutation, ProhibitCurrentAccountDbResetMutationVariables>;
export const CurrentAccountResetStatusDocument = gql`
    query CurrentAccountResetStatus {
  currentAccount {
    id
    dbResetAllowed
  }
}
    `;

/**
 * __useCurrentAccountResetStatusQuery__
 *
 * To run a query within a React component, call `useCurrentAccountResetStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentAccountResetStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentAccountResetStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentAccountResetStatusQuery(baseOptions?: Apollo.QueryHookOptions<CurrentAccountResetStatusQuery, CurrentAccountResetStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentAccountResetStatusQuery, CurrentAccountResetStatusQueryVariables>(CurrentAccountResetStatusDocument, options);
      }
export function useCurrentAccountResetStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentAccountResetStatusQuery, CurrentAccountResetStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentAccountResetStatusQuery, CurrentAccountResetStatusQueryVariables>(CurrentAccountResetStatusDocument, options);
        }
export type CurrentAccountResetStatusQueryHookResult = ReturnType<typeof useCurrentAccountResetStatusQuery>;
export type CurrentAccountResetStatusLazyQueryHookResult = ReturnType<typeof useCurrentAccountResetStatusLazyQuery>;
export type CurrentAccountResetStatusQueryResult = Apollo.QueryResult<CurrentAccountResetStatusQuery, CurrentAccountResetStatusQueryVariables>;
export const GlobalSearchQueryDocument = gql`
    query GlobalSearchQuery($q: String!, $recordTypes: [GlobalSearchRecord!]) {
  globalSearch(q: $q, recordTypes: $recordTypes) {
    id
    description
    recordId
    recordType
  }
}
    `;

/**
 * __useGlobalSearchQueryQuery__
 *
 * To run a query within a React component, call `useGlobalSearchQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalSearchQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalSearchQueryQuery({
 *   variables: {
 *      q: // value for 'q'
 *      recordTypes: // value for 'recordTypes'
 *   },
 * });
 */
export function useGlobalSearchQueryQuery(baseOptions: Apollo.QueryHookOptions<GlobalSearchQueryQuery, GlobalSearchQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalSearchQueryQuery, GlobalSearchQueryQueryVariables>(GlobalSearchQueryDocument, options);
      }
export function useGlobalSearchQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalSearchQueryQuery, GlobalSearchQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalSearchQueryQuery, GlobalSearchQueryQueryVariables>(GlobalSearchQueryDocument, options);
        }
export type GlobalSearchQueryQueryHookResult = ReturnType<typeof useGlobalSearchQueryQuery>;
export type GlobalSearchQueryLazyQueryHookResult = ReturnType<typeof useGlobalSearchQueryLazyQuery>;
export type GlobalSearchQueryQueryResult = Apollo.QueryResult<GlobalSearchQueryQuery, GlobalSearchQueryQueryVariables>;
export const CurrentAccountLogoDocument = gql`
    query CurrentAccountLogo {
  currentAccount {
    id
    logoUrl
  }
}
    `;

/**
 * __useCurrentAccountLogoQuery__
 *
 * To run a query within a React component, call `useCurrentAccountLogoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentAccountLogoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentAccountLogoQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentAccountLogoQuery(baseOptions?: Apollo.QueryHookOptions<CurrentAccountLogoQuery, CurrentAccountLogoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentAccountLogoQuery, CurrentAccountLogoQueryVariables>(CurrentAccountLogoDocument, options);
      }
export function useCurrentAccountLogoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentAccountLogoQuery, CurrentAccountLogoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentAccountLogoQuery, CurrentAccountLogoQueryVariables>(CurrentAccountLogoDocument, options);
        }
export type CurrentAccountLogoQueryHookResult = ReturnType<typeof useCurrentAccountLogoQuery>;
export type CurrentAccountLogoLazyQueryHookResult = ReturnType<typeof useCurrentAccountLogoLazyQuery>;
export type CurrentAccountLogoQueryResult = Apollo.QueryResult<CurrentAccountLogoQuery, CurrentAccountLogoQueryVariables>;
export const LatestNotificationsDocument = gql`
    query LatestNotifications {
  notifications(
    first: 10
    descending: true
    filter: {deliveryMethod: system, clearedAt: null}
  ) {
    nodes {
      id
      kind
      seenAt
      translationData
      translationKey
      relatedId
      relatedType
      createdAt
    }
  }
}
    `;

/**
 * __useLatestNotificationsQuery__
 *
 * To run a query within a React component, call `useLatestNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLatestNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<LatestNotificationsQuery, LatestNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LatestNotificationsQuery, LatestNotificationsQueryVariables>(LatestNotificationsDocument, options);
      }
export function useLatestNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LatestNotificationsQuery, LatestNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LatestNotificationsQuery, LatestNotificationsQueryVariables>(LatestNotificationsDocument, options);
        }
export type LatestNotificationsQueryHookResult = ReturnType<typeof useLatestNotificationsQuery>;
export type LatestNotificationsLazyQueryHookResult = ReturnType<typeof useLatestNotificationsLazyQuery>;
export type LatestNotificationsQueryResult = Apollo.QueryResult<LatestNotificationsQuery, LatestNotificationsQueryVariables>;
export const UserTwoFactorDocument = gql`
    query UserTwoFactor($id: ID!) {
  user(id: $id) {
    id
    twoFactorEnabled
  }
}
    `;

/**
 * __useUserTwoFactorQuery__
 *
 * To run a query within a React component, call `useUserTwoFactorQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTwoFactorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTwoFactorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserTwoFactorQuery(baseOptions: Apollo.QueryHookOptions<UserTwoFactorQuery, UserTwoFactorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserTwoFactorQuery, UserTwoFactorQueryVariables>(UserTwoFactorDocument, options);
      }
export function useUserTwoFactorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserTwoFactorQuery, UserTwoFactorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserTwoFactorQuery, UserTwoFactorQueryVariables>(UserTwoFactorDocument, options);
        }
export type UserTwoFactorQueryHookResult = ReturnType<typeof useUserTwoFactorQuery>;
export type UserTwoFactorLazyQueryHookResult = ReturnType<typeof useUserTwoFactorLazyQuery>;
export type UserTwoFactorQueryResult = Apollo.QueryResult<UserTwoFactorQuery, UserTwoFactorQueryVariables>;
export const InitializeUserTwoFactorDocument = gql`
    mutation InitializeUserTwoFactor($id: ID!) {
  initializeTwoFactor(id: $id)
}
    `;
export type InitializeUserTwoFactorMutationFn = Apollo.MutationFunction<InitializeUserTwoFactorMutation, InitializeUserTwoFactorMutationVariables>;

/**
 * __useInitializeUserTwoFactorMutation__
 *
 * To run a mutation, you first call `useInitializeUserTwoFactorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitializeUserTwoFactorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initializeUserTwoFactorMutation, { data, loading, error }] = useInitializeUserTwoFactorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInitializeUserTwoFactorMutation(baseOptions?: Apollo.MutationHookOptions<InitializeUserTwoFactorMutation, InitializeUserTwoFactorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitializeUserTwoFactorMutation, InitializeUserTwoFactorMutationVariables>(InitializeUserTwoFactorDocument, options);
      }
export type InitializeUserTwoFactorMutationHookResult = ReturnType<typeof useInitializeUserTwoFactorMutation>;
export type InitializeUserTwoFactorMutationResult = Apollo.MutationResult<InitializeUserTwoFactorMutation>;
export type InitializeUserTwoFactorMutationOptions = Apollo.BaseMutationOptions<InitializeUserTwoFactorMutation, InitializeUserTwoFactorMutationVariables>;
export const ValidateUserTwoFactorDocument = gql`
    mutation ValidateUserTwoFactor($id: ID!, $otp: String!) {
  validateTwoFactor(id: $id, input: {otp: $otp})
}
    `;
export type ValidateUserTwoFactorMutationFn = Apollo.MutationFunction<ValidateUserTwoFactorMutation, ValidateUserTwoFactorMutationVariables>;

/**
 * __useValidateUserTwoFactorMutation__
 *
 * To run a mutation, you first call `useValidateUserTwoFactorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateUserTwoFactorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateUserTwoFactorMutation, { data, loading, error }] = useValidateUserTwoFactorMutation({
 *   variables: {
 *      id: // value for 'id'
 *      otp: // value for 'otp'
 *   },
 * });
 */
export function useValidateUserTwoFactorMutation(baseOptions?: Apollo.MutationHookOptions<ValidateUserTwoFactorMutation, ValidateUserTwoFactorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateUserTwoFactorMutation, ValidateUserTwoFactorMutationVariables>(ValidateUserTwoFactorDocument, options);
      }
export type ValidateUserTwoFactorMutationHookResult = ReturnType<typeof useValidateUserTwoFactorMutation>;
export type ValidateUserTwoFactorMutationResult = Apollo.MutationResult<ValidateUserTwoFactorMutation>;
export type ValidateUserTwoFactorMutationOptions = Apollo.BaseMutationOptions<ValidateUserTwoFactorMutation, ValidateUserTwoFactorMutationVariables>;
export const DisableTwoFactorDocument = gql`
    mutation DisableTwoFactor($id: ID!, $otp: String!) {
  disableTwoFactor(id: $id, input: {otp: $otp})
}
    `;
export type DisableTwoFactorMutationFn = Apollo.MutationFunction<DisableTwoFactorMutation, DisableTwoFactorMutationVariables>;

/**
 * __useDisableTwoFactorMutation__
 *
 * To run a mutation, you first call `useDisableTwoFactorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableTwoFactorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableTwoFactorMutation, { data, loading, error }] = useDisableTwoFactorMutation({
 *   variables: {
 *      id: // value for 'id'
 *      otp: // value for 'otp'
 *   },
 * });
 */
export function useDisableTwoFactorMutation(baseOptions?: Apollo.MutationHookOptions<DisableTwoFactorMutation, DisableTwoFactorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableTwoFactorMutation, DisableTwoFactorMutationVariables>(DisableTwoFactorDocument, options);
      }
export type DisableTwoFactorMutationHookResult = ReturnType<typeof useDisableTwoFactorMutation>;
export type DisableTwoFactorMutationResult = Apollo.MutationResult<DisableTwoFactorMutation>;
export type DisableTwoFactorMutationOptions = Apollo.BaseMutationOptions<DisableTwoFactorMutation, DisableTwoFactorMutationVariables>;
export const UserNotesCountDocument = gql`
    query UserNotesCount($filter: UserNoteFilterInput) {
  userNotes(filter: $filter) {
    totalCount
  }
}
    `;

/**
 * __useUserNotesCountQuery__
 *
 * To run a query within a React component, call `useUserNotesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserNotesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNotesCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUserNotesCountQuery(baseOptions?: Apollo.QueryHookOptions<UserNotesCountQuery, UserNotesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserNotesCountQuery, UserNotesCountQueryVariables>(UserNotesCountDocument, options);
      }
export function useUserNotesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserNotesCountQuery, UserNotesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserNotesCountQuery, UserNotesCountQueryVariables>(UserNotesCountDocument, options);
        }
export type UserNotesCountQueryHookResult = ReturnType<typeof useUserNotesCountQuery>;
export type UserNotesCountLazyQueryHookResult = ReturnType<typeof useUserNotesCountLazyQuery>;
export type UserNotesCountQueryResult = Apollo.QueryResult<UserNotesCountQuery, UserNotesCountQueryVariables>;
export const UserNoteDocument = gql`
    query UserNote($id: ID!) {
  userNote(id: $id) {
    id
    text
    notableType
    userNoteCategory {
      id
      name
    }
  }
}
    `;

/**
 * __useUserNoteQuery__
 *
 * To run a query within a React component, call `useUserNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNoteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserNoteQuery(baseOptions: Apollo.QueryHookOptions<UserNoteQuery, UserNoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserNoteQuery, UserNoteQueryVariables>(UserNoteDocument, options);
      }
export function useUserNoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserNoteQuery, UserNoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserNoteQuery, UserNoteQueryVariables>(UserNoteDocument, options);
        }
export type UserNoteQueryHookResult = ReturnType<typeof useUserNoteQuery>;
export type UserNoteLazyQueryHookResult = ReturnType<typeof useUserNoteLazyQuery>;
export type UserNoteQueryResult = Apollo.QueryResult<UserNoteQuery, UserNoteQueryVariables>;
export const UpdateUserNoteDocument = gql`
    mutation UpdateUserNote($id: ID!, $input: UserNoteInput!) {
  updateUserNote(id: $id, input: $input) {
    id
    text
    notableType
    userNoteCategory {
      id
      name
    }
  }
}
    `;
export type UpdateUserNoteMutationFn = Apollo.MutationFunction<UpdateUserNoteMutation, UpdateUserNoteMutationVariables>;

/**
 * __useUpdateUserNoteMutation__
 *
 * To run a mutation, you first call `useUpdateUserNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserNoteMutation, { data, loading, error }] = useUpdateUserNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserNoteMutation, UpdateUserNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserNoteMutation, UpdateUserNoteMutationVariables>(UpdateUserNoteDocument, options);
      }
export type UpdateUserNoteMutationHookResult = ReturnType<typeof useUpdateUserNoteMutation>;
export type UpdateUserNoteMutationResult = Apollo.MutationResult<UpdateUserNoteMutation>;
export type UpdateUserNoteMutationOptions = Apollo.BaseMutationOptions<UpdateUserNoteMutation, UpdateUserNoteMutationVariables>;
export const UserNotesDocument = gql`
    query UserNotes($order: String, $descending: Boolean, $after: String, $first: Int, $search: String, $filter: UserNoteFilterInput) {
  userNotes(
    order: $order
    descending: $descending
    after: $after
    first: $first
    search: $search
    filter: $filter
  ) {
    nodes {
      id
      text
      createdAt
      createdBy {
        id
        firstName
        lastName
        fullName
        profilePictureUrl
      }
      userNoteCategory {
        id
        name
      }
      notableType
      notableId
    }
    totalCount
  }
}
    `;

/**
 * __useUserNotesQuery__
 *
 * To run a query within a React component, call `useUserNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNotesQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUserNotesQuery(baseOptions?: Apollo.QueryHookOptions<UserNotesQuery, UserNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserNotesQuery, UserNotesQueryVariables>(UserNotesDocument, options);
      }
export function useUserNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserNotesQuery, UserNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserNotesQuery, UserNotesQueryVariables>(UserNotesDocument, options);
        }
export type UserNotesQueryHookResult = ReturnType<typeof useUserNotesQuery>;
export type UserNotesLazyQueryHookResult = ReturnType<typeof useUserNotesLazyQuery>;
export type UserNotesQueryResult = Apollo.QueryResult<UserNotesQuery, UserNotesQueryVariables>;
export const DeleteUserNoteDocument = gql`
    mutation DeleteUserNote($id: ID!) {
  deleteUserNote(id: $id)
}
    `;
export type DeleteUserNoteMutationFn = Apollo.MutationFunction<DeleteUserNoteMutation, DeleteUserNoteMutationVariables>;

/**
 * __useDeleteUserNoteMutation__
 *
 * To run a mutation, you first call `useDeleteUserNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserNoteMutation, { data, loading, error }] = useDeleteUserNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserNoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserNoteMutation, DeleteUserNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserNoteMutation, DeleteUserNoteMutationVariables>(DeleteUserNoteDocument, options);
      }
export type DeleteUserNoteMutationHookResult = ReturnType<typeof useDeleteUserNoteMutation>;
export type DeleteUserNoteMutationResult = Apollo.MutationResult<DeleteUserNoteMutation>;
export type DeleteUserNoteMutationOptions = Apollo.BaseMutationOptions<DeleteUserNoteMutation, DeleteUserNoteMutationVariables>;
export const CurrentContextDocument = gql`
    query CurrentContext {
  abilities {
    action
    subject
    fields
    conditions
    inverted
  }
  currentUser {
    id
    fullName
    firstName
    profilePictureUrl
    userCredential {
      id
      email
    }
    backgroundPictureVariant
    backgroundPictureUrl
    iconPack
    positionName
    teams {
      id
      name
    }
  }
  currentAccount {
    id
    locale
    otherLocales
    timeFormat
    dateFormat
    allowedTcCreationTime
    firstApprover
    featureFlags
  }
}
    `;

/**
 * __useCurrentContextQuery__
 *
 * To run a query within a React component, call `useCurrentContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentContextQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentContextQuery(baseOptions?: Apollo.QueryHookOptions<CurrentContextQuery, CurrentContextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentContextQuery, CurrentContextQueryVariables>(CurrentContextDocument, options);
      }
export function useCurrentContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentContextQuery, CurrentContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentContextQuery, CurrentContextQueryVariables>(CurrentContextDocument, options);
        }
export type CurrentContextQueryHookResult = ReturnType<typeof useCurrentContextQuery>;
export type CurrentContextLazyQueryHookResult = ReturnType<typeof useCurrentContextLazyQuery>;
export type CurrentContextQueryResult = Apollo.QueryResult<CurrentContextQuery, CurrentContextQueryVariables>;
export const CurrentReleaseDocument = gql`
    query CurrentRelease {
  currentRelease
}
    `;

/**
 * __useCurrentReleaseQuery__
 *
 * To run a query within a React component, call `useCurrentReleaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentReleaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentReleaseQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentReleaseQuery(baseOptions?: Apollo.QueryHookOptions<CurrentReleaseQuery, CurrentReleaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentReleaseQuery, CurrentReleaseQueryVariables>(CurrentReleaseDocument, options);
      }
export function useCurrentReleaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentReleaseQuery, CurrentReleaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentReleaseQuery, CurrentReleaseQueryVariables>(CurrentReleaseDocument, options);
        }
export type CurrentReleaseQueryHookResult = ReturnType<typeof useCurrentReleaseQuery>;
export type CurrentReleaseLazyQueryHookResult = ReturnType<typeof useCurrentReleaseLazyQuery>;
export type CurrentReleaseQueryResult = Apollo.QueryResult<CurrentReleaseQuery, CurrentReleaseQueryVariables>;
export const CreateContactCategoryDocument = gql`
    mutation CreateContactCategory($input: ContactCategoryInput!) {
  createContactCategory(input: $input) {
    id
  }
}
    `;
export type CreateContactCategoryMutationFn = Apollo.MutationFunction<CreateContactCategoryMutation, CreateContactCategoryMutationVariables>;

/**
 * __useCreateContactCategoryMutation__
 *
 * To run a mutation, you first call `useCreateContactCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactCategoryMutation, { data, loading, error }] = useCreateContactCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContactCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactCategoryMutation, CreateContactCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactCategoryMutation, CreateContactCategoryMutationVariables>(CreateContactCategoryDocument, options);
      }
export type CreateContactCategoryMutationHookResult = ReturnType<typeof useCreateContactCategoryMutation>;
export type CreateContactCategoryMutationResult = Apollo.MutationResult<CreateContactCategoryMutation>;
export type CreateContactCategoryMutationOptions = Apollo.BaseMutationOptions<CreateContactCategoryMutation, CreateContactCategoryMutationVariables>;
export const ContactCategoryDocument = gql`
    query ContactCategory($id: ID!) {
  contactCategory(id: $id) {
    id
    name: nameWithoutFallback
    altNameTranslations
  }
}
    `;

/**
 * __useContactCategoryQuery__
 *
 * To run a query within a React component, call `useContactCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContactCategoryQuery(baseOptions: Apollo.QueryHookOptions<ContactCategoryQuery, ContactCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactCategoryQuery, ContactCategoryQueryVariables>(ContactCategoryDocument, options);
      }
export function useContactCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactCategoryQuery, ContactCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactCategoryQuery, ContactCategoryQueryVariables>(ContactCategoryDocument, options);
        }
export type ContactCategoryQueryHookResult = ReturnType<typeof useContactCategoryQuery>;
export type ContactCategoryLazyQueryHookResult = ReturnType<typeof useContactCategoryLazyQuery>;
export type ContactCategoryQueryResult = Apollo.QueryResult<ContactCategoryQuery, ContactCategoryQueryVariables>;
export const UpdateContactCategoryDocument = gql`
    mutation UpdateContactCategory($id: ID!, $input: ContactCategoryInput!) {
  updateContactCategory(id: $id, input: $input) {
    id
    name: nameWithoutFallback
    altNameTranslations
  }
}
    `;
export type UpdateContactCategoryMutationFn = Apollo.MutationFunction<UpdateContactCategoryMutation, UpdateContactCategoryMutationVariables>;

/**
 * __useUpdateContactCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateContactCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactCategoryMutation, { data, loading, error }] = useUpdateContactCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContactCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactCategoryMutation, UpdateContactCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactCategoryMutation, UpdateContactCategoryMutationVariables>(UpdateContactCategoryDocument, options);
      }
export type UpdateContactCategoryMutationHookResult = ReturnType<typeof useUpdateContactCategoryMutation>;
export type UpdateContactCategoryMutationResult = Apollo.MutationResult<UpdateContactCategoryMutation>;
export type UpdateContactCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateContactCategoryMutation, UpdateContactCategoryMutationVariables>;
export const ContactCategoriesDocument = gql`
    query ContactCategories($order: String, $descending: Boolean, $after: String, $first: Int, $search: String, $active: Boolean) {
  contactCategories(
    order: $order
    descending: $descending
    after: $after
    first: $first
    search: $search
    active: $active
  ) {
    nodes {
      id
      name
      createdAt
      updatedAt
      discardedAt
    }
    totalCount
  }
}
    `;

/**
 * __useContactCategoriesQuery__
 *
 * To run a query within a React component, call `useContactCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactCategoriesQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      search: // value for 'search'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useContactCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<ContactCategoriesQuery, ContactCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactCategoriesQuery, ContactCategoriesQueryVariables>(ContactCategoriesDocument, options);
      }
export function useContactCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactCategoriesQuery, ContactCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactCategoriesQuery, ContactCategoriesQueryVariables>(ContactCategoriesDocument, options);
        }
export type ContactCategoriesQueryHookResult = ReturnType<typeof useContactCategoriesQuery>;
export type ContactCategoriesLazyQueryHookResult = ReturnType<typeof useContactCategoriesLazyQuery>;
export type ContactCategoriesQueryResult = Apollo.QueryResult<ContactCategoriesQuery, ContactCategoriesQueryVariables>;
export const AutocompleteContactCategoriesDocument = gql`
    query AutocompleteContactCategories($search: String) {
  contactCategories(search: $search) {
    nodes {
      id
      name
    }
  }
}
    `;

/**
 * __useAutocompleteContactCategoriesQuery__
 *
 * To run a query within a React component, call `useAutocompleteContactCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteContactCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteContactCategoriesQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAutocompleteContactCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<AutocompleteContactCategoriesQuery, AutocompleteContactCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompleteContactCategoriesQuery, AutocompleteContactCategoriesQueryVariables>(AutocompleteContactCategoriesDocument, options);
      }
export function useAutocompleteContactCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompleteContactCategoriesQuery, AutocompleteContactCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompleteContactCategoriesQuery, AutocompleteContactCategoriesQueryVariables>(AutocompleteContactCategoriesDocument, options);
        }
export type AutocompleteContactCategoriesQueryHookResult = ReturnType<typeof useAutocompleteContactCategoriesQuery>;
export type AutocompleteContactCategoriesLazyQueryHookResult = ReturnType<typeof useAutocompleteContactCategoriesLazyQuery>;
export type AutocompleteContactCategoriesQueryResult = Apollo.QueryResult<AutocompleteContactCategoriesQuery, AutocompleteContactCategoriesQueryVariables>;
export const DeleteContactCategoryDocument = gql`
    mutation DeleteContactCategory($id: ID!) {
  deleteContactCategory(id: $id)
}
    `;
export type DeleteContactCategoryMutationFn = Apollo.MutationFunction<DeleteContactCategoryMutation, DeleteContactCategoryMutationVariables>;

/**
 * __useDeleteContactCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteContactCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactCategoryMutation, { data, loading, error }] = useDeleteContactCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteContactCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContactCategoryMutation, DeleteContactCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContactCategoryMutation, DeleteContactCategoryMutationVariables>(DeleteContactCategoryDocument, options);
      }
export type DeleteContactCategoryMutationHookResult = ReturnType<typeof useDeleteContactCategoryMutation>;
export type DeleteContactCategoryMutationResult = Apollo.MutationResult<DeleteContactCategoryMutation>;
export type DeleteContactCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteContactCategoryMutation, DeleteContactCategoryMutationVariables>;
export const RestoreContactCategoryDocument = gql`
    mutation RestoreContactCategory($id: ID!) {
  restoreContactCategory(id: $id) {
    id
    discardedAt
  }
}
    `;
export type RestoreContactCategoryMutationFn = Apollo.MutationFunction<RestoreContactCategoryMutation, RestoreContactCategoryMutationVariables>;

/**
 * __useRestoreContactCategoryMutation__
 *
 * To run a mutation, you first call `useRestoreContactCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreContactCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreContactCategoryMutation, { data, loading, error }] = useRestoreContactCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreContactCategoryMutation(baseOptions?: Apollo.MutationHookOptions<RestoreContactCategoryMutation, RestoreContactCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreContactCategoryMutation, RestoreContactCategoryMutationVariables>(RestoreContactCategoryDocument, options);
      }
export type RestoreContactCategoryMutationHookResult = ReturnType<typeof useRestoreContactCategoryMutation>;
export type RestoreContactCategoryMutationResult = Apollo.MutationResult<RestoreContactCategoryMutation>;
export type RestoreContactCategoryMutationOptions = Apollo.BaseMutationOptions<RestoreContactCategoryMutation, RestoreContactCategoryMutationVariables>;
export const CreateCreditRatingDocument = gql`
    mutation CreateCreditRating($input: CreditRatingInput!) {
  createCreditRating(input: $input) {
    id
  }
}
    `;
export type CreateCreditRatingMutationFn = Apollo.MutationFunction<CreateCreditRatingMutation, CreateCreditRatingMutationVariables>;

/**
 * __useCreateCreditRatingMutation__
 *
 * To run a mutation, you first call `useCreateCreditRatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCreditRatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCreditRatingMutation, { data, loading, error }] = useCreateCreditRatingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCreditRatingMutation(baseOptions?: Apollo.MutationHookOptions<CreateCreditRatingMutation, CreateCreditRatingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCreditRatingMutation, CreateCreditRatingMutationVariables>(CreateCreditRatingDocument, options);
      }
export type CreateCreditRatingMutationHookResult = ReturnType<typeof useCreateCreditRatingMutation>;
export type CreateCreditRatingMutationResult = Apollo.MutationResult<CreateCreditRatingMutation>;
export type CreateCreditRatingMutationOptions = Apollo.BaseMutationOptions<CreateCreditRatingMutation, CreateCreditRatingMutationVariables>;
export const CreditRatingDocument = gql`
    query CreditRating($id: ID!) {
  creditRating(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useCreditRatingQuery__
 *
 * To run a query within a React component, call `useCreditRatingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditRatingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditRatingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreditRatingQuery(baseOptions: Apollo.QueryHookOptions<CreditRatingQuery, CreditRatingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreditRatingQuery, CreditRatingQueryVariables>(CreditRatingDocument, options);
      }
export function useCreditRatingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreditRatingQuery, CreditRatingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreditRatingQuery, CreditRatingQueryVariables>(CreditRatingDocument, options);
        }
export type CreditRatingQueryHookResult = ReturnType<typeof useCreditRatingQuery>;
export type CreditRatingLazyQueryHookResult = ReturnType<typeof useCreditRatingLazyQuery>;
export type CreditRatingQueryResult = Apollo.QueryResult<CreditRatingQuery, CreditRatingQueryVariables>;
export const UpdateCreditRatingDocument = gql`
    mutation UpdateCreditRating($id: ID!, $input: CreditRatingInput!) {
  updateCreditRating(id: $id, input: $input) {
    id
    name
  }
}
    `;
export type UpdateCreditRatingMutationFn = Apollo.MutationFunction<UpdateCreditRatingMutation, UpdateCreditRatingMutationVariables>;

/**
 * __useUpdateCreditRatingMutation__
 *
 * To run a mutation, you first call `useUpdateCreditRatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreditRatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreditRatingMutation, { data, loading, error }] = useUpdateCreditRatingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCreditRatingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreditRatingMutation, UpdateCreditRatingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCreditRatingMutation, UpdateCreditRatingMutationVariables>(UpdateCreditRatingDocument, options);
      }
export type UpdateCreditRatingMutationHookResult = ReturnType<typeof useUpdateCreditRatingMutation>;
export type UpdateCreditRatingMutationResult = Apollo.MutationResult<UpdateCreditRatingMutation>;
export type UpdateCreditRatingMutationOptions = Apollo.BaseMutationOptions<UpdateCreditRatingMutation, UpdateCreditRatingMutationVariables>;
export const CreditRatingsDocument = gql`
    query CreditRatings($order: String, $descending: Boolean, $after: String, $first: Int, $search: String, $active: Boolean) {
  creditRatings(
    order: $order
    descending: $descending
    after: $after
    first: $first
    search: $search
    active: $active
  ) {
    nodes {
      id
      name
      createdAt
      updatedAt
      discardedAt
    }
    totalCount
  }
}
    `;

/**
 * __useCreditRatingsQuery__
 *
 * To run a query within a React component, call `useCreditRatingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditRatingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditRatingsQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      search: // value for 'search'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useCreditRatingsQuery(baseOptions?: Apollo.QueryHookOptions<CreditRatingsQuery, CreditRatingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreditRatingsQuery, CreditRatingsQueryVariables>(CreditRatingsDocument, options);
      }
export function useCreditRatingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreditRatingsQuery, CreditRatingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreditRatingsQuery, CreditRatingsQueryVariables>(CreditRatingsDocument, options);
        }
export type CreditRatingsQueryHookResult = ReturnType<typeof useCreditRatingsQuery>;
export type CreditRatingsLazyQueryHookResult = ReturnType<typeof useCreditRatingsLazyQuery>;
export type CreditRatingsQueryResult = Apollo.QueryResult<CreditRatingsQuery, CreditRatingsQueryVariables>;
export const AutocompleteCreditRatingsDocument = gql`
    query AutocompleteCreditRatings($search: String) {
  creditRatings(search: $search) {
    nodes {
      id
      name
    }
  }
}
    `;

/**
 * __useAutocompleteCreditRatingsQuery__
 *
 * To run a query within a React component, call `useAutocompleteCreditRatingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteCreditRatingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteCreditRatingsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAutocompleteCreditRatingsQuery(baseOptions?: Apollo.QueryHookOptions<AutocompleteCreditRatingsQuery, AutocompleteCreditRatingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompleteCreditRatingsQuery, AutocompleteCreditRatingsQueryVariables>(AutocompleteCreditRatingsDocument, options);
      }
export function useAutocompleteCreditRatingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompleteCreditRatingsQuery, AutocompleteCreditRatingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompleteCreditRatingsQuery, AutocompleteCreditRatingsQueryVariables>(AutocompleteCreditRatingsDocument, options);
        }
export type AutocompleteCreditRatingsQueryHookResult = ReturnType<typeof useAutocompleteCreditRatingsQuery>;
export type AutocompleteCreditRatingsLazyQueryHookResult = ReturnType<typeof useAutocompleteCreditRatingsLazyQuery>;
export type AutocompleteCreditRatingsQueryResult = Apollo.QueryResult<AutocompleteCreditRatingsQuery, AutocompleteCreditRatingsQueryVariables>;
export const DeleteCreditRatingDocument = gql`
    mutation DeleteCreditRating($id: ID!) {
  deleteCreditRating(id: $id)
}
    `;
export type DeleteCreditRatingMutationFn = Apollo.MutationFunction<DeleteCreditRatingMutation, DeleteCreditRatingMutationVariables>;

/**
 * __useDeleteCreditRatingMutation__
 *
 * To run a mutation, you first call `useDeleteCreditRatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCreditRatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCreditRatingMutation, { data, loading, error }] = useDeleteCreditRatingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCreditRatingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCreditRatingMutation, DeleteCreditRatingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCreditRatingMutation, DeleteCreditRatingMutationVariables>(DeleteCreditRatingDocument, options);
      }
export type DeleteCreditRatingMutationHookResult = ReturnType<typeof useDeleteCreditRatingMutation>;
export type DeleteCreditRatingMutationResult = Apollo.MutationResult<DeleteCreditRatingMutation>;
export type DeleteCreditRatingMutationOptions = Apollo.BaseMutationOptions<DeleteCreditRatingMutation, DeleteCreditRatingMutationVariables>;
export const RestoreCreditRatingDocument = gql`
    mutation RestoreCreditRating($id: ID!) {
  restoreCreditRating(id: $id) {
    id
    discardedAt
  }
}
    `;
export type RestoreCreditRatingMutationFn = Apollo.MutationFunction<RestoreCreditRatingMutation, RestoreCreditRatingMutationVariables>;

/**
 * __useRestoreCreditRatingMutation__
 *
 * To run a mutation, you first call `useRestoreCreditRatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreCreditRatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreCreditRatingMutation, { data, loading, error }] = useRestoreCreditRatingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreCreditRatingMutation(baseOptions?: Apollo.MutationHookOptions<RestoreCreditRatingMutation, RestoreCreditRatingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreCreditRatingMutation, RestoreCreditRatingMutationVariables>(RestoreCreditRatingDocument, options);
      }
export type RestoreCreditRatingMutationHookResult = ReturnType<typeof useRestoreCreditRatingMutation>;
export type RestoreCreditRatingMutationResult = Apollo.MutationResult<RestoreCreditRatingMutation>;
export type RestoreCreditRatingMutationOptions = Apollo.BaseMutationOptions<RestoreCreditRatingMutation, RestoreCreditRatingMutationVariables>;
export const CreateCurrencyDocument = gql`
    mutation CreateCurrency($input: CurrencyInput!) {
  createCurrency(input: $input) {
    id
  }
}
    `;
export type CreateCurrencyMutationFn = Apollo.MutationFunction<CreateCurrencyMutation, CreateCurrencyMutationVariables>;

/**
 * __useCreateCurrencyMutation__
 *
 * To run a mutation, you first call `useCreateCurrencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCurrencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCurrencyMutation, { data, loading, error }] = useCreateCurrencyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCurrencyMutation(baseOptions?: Apollo.MutationHookOptions<CreateCurrencyMutation, CreateCurrencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCurrencyMutation, CreateCurrencyMutationVariables>(CreateCurrencyDocument, options);
      }
export type CreateCurrencyMutationHookResult = ReturnType<typeof useCreateCurrencyMutation>;
export type CreateCurrencyMutationResult = Apollo.MutationResult<CreateCurrencyMutation>;
export type CreateCurrencyMutationOptions = Apollo.BaseMutationOptions<CreateCurrencyMutation, CreateCurrencyMutationVariables>;
export const CurrencyDocument = gql`
    query Currency($id: ID!) {
  currency(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useCurrencyQuery__
 *
 * To run a query within a React component, call `useCurrencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrencyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCurrencyQuery(baseOptions: Apollo.QueryHookOptions<CurrencyQuery, CurrencyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrencyQuery, CurrencyQueryVariables>(CurrencyDocument, options);
      }
export function useCurrencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrencyQuery, CurrencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrencyQuery, CurrencyQueryVariables>(CurrencyDocument, options);
        }
export type CurrencyQueryHookResult = ReturnType<typeof useCurrencyQuery>;
export type CurrencyLazyQueryHookResult = ReturnType<typeof useCurrencyLazyQuery>;
export type CurrencyQueryResult = Apollo.QueryResult<CurrencyQuery, CurrencyQueryVariables>;
export const UpdateCurrencyDocument = gql`
    mutation UpdateCurrency($id: ID!, $input: CurrencyInput!) {
  updateCurrency(id: $id, input: $input) {
    id
    name
  }
}
    `;
export type UpdateCurrencyMutationFn = Apollo.MutationFunction<UpdateCurrencyMutation, UpdateCurrencyMutationVariables>;

/**
 * __useUpdateCurrencyMutation__
 *
 * To run a mutation, you first call `useUpdateCurrencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrencyMutation, { data, loading, error }] = useUpdateCurrencyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCurrencyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCurrencyMutation, UpdateCurrencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCurrencyMutation, UpdateCurrencyMutationVariables>(UpdateCurrencyDocument, options);
      }
export type UpdateCurrencyMutationHookResult = ReturnType<typeof useUpdateCurrencyMutation>;
export type UpdateCurrencyMutationResult = Apollo.MutationResult<UpdateCurrencyMutation>;
export type UpdateCurrencyMutationOptions = Apollo.BaseMutationOptions<UpdateCurrencyMutation, UpdateCurrencyMutationVariables>;
export const CurrenciesDocument = gql`
    query Currencies($order: String, $descending: Boolean, $after: String, $first: Int, $search: String, $active: Boolean) {
  currencies(
    order: $order
    descending: $descending
    after: $after
    first: $first
    search: $search
    active: $active
  ) {
    nodes {
      id
      name
      createdAt
      updatedAt
      discardedAt
    }
    totalCount
  }
}
    `;

/**
 * __useCurrenciesQuery__
 *
 * To run a query within a React component, call `useCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrenciesQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      search: // value for 'search'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useCurrenciesQuery(baseOptions?: Apollo.QueryHookOptions<CurrenciesQuery, CurrenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrenciesQuery, CurrenciesQueryVariables>(CurrenciesDocument, options);
      }
export function useCurrenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrenciesQuery, CurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrenciesQuery, CurrenciesQueryVariables>(CurrenciesDocument, options);
        }
export type CurrenciesQueryHookResult = ReturnType<typeof useCurrenciesQuery>;
export type CurrenciesLazyQueryHookResult = ReturnType<typeof useCurrenciesLazyQuery>;
export type CurrenciesQueryResult = Apollo.QueryResult<CurrenciesQuery, CurrenciesQueryVariables>;
export const AutocompleteCurrenciesDocument = gql`
    query AutocompleteCurrencies($search: String) {
  currencies(search: $search) {
    nodes {
      id
      name
    }
  }
}
    `;

/**
 * __useAutocompleteCurrenciesQuery__
 *
 * To run a query within a React component, call `useAutocompleteCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteCurrenciesQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAutocompleteCurrenciesQuery(baseOptions?: Apollo.QueryHookOptions<AutocompleteCurrenciesQuery, AutocompleteCurrenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompleteCurrenciesQuery, AutocompleteCurrenciesQueryVariables>(AutocompleteCurrenciesDocument, options);
      }
export function useAutocompleteCurrenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompleteCurrenciesQuery, AutocompleteCurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompleteCurrenciesQuery, AutocompleteCurrenciesQueryVariables>(AutocompleteCurrenciesDocument, options);
        }
export type AutocompleteCurrenciesQueryHookResult = ReturnType<typeof useAutocompleteCurrenciesQuery>;
export type AutocompleteCurrenciesLazyQueryHookResult = ReturnType<typeof useAutocompleteCurrenciesLazyQuery>;
export type AutocompleteCurrenciesQueryResult = Apollo.QueryResult<AutocompleteCurrenciesQuery, AutocompleteCurrenciesQueryVariables>;
export const DeleteCurrencyDocument = gql`
    mutation DeleteCurrency($id: ID!) {
  deleteCurrency(id: $id)
}
    `;
export type DeleteCurrencyMutationFn = Apollo.MutationFunction<DeleteCurrencyMutation, DeleteCurrencyMutationVariables>;

/**
 * __useDeleteCurrencyMutation__
 *
 * To run a mutation, you first call `useDeleteCurrencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCurrencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCurrencyMutation, { data, loading, error }] = useDeleteCurrencyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCurrencyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCurrencyMutation, DeleteCurrencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCurrencyMutation, DeleteCurrencyMutationVariables>(DeleteCurrencyDocument, options);
      }
export type DeleteCurrencyMutationHookResult = ReturnType<typeof useDeleteCurrencyMutation>;
export type DeleteCurrencyMutationResult = Apollo.MutationResult<DeleteCurrencyMutation>;
export type DeleteCurrencyMutationOptions = Apollo.BaseMutationOptions<DeleteCurrencyMutation, DeleteCurrencyMutationVariables>;
export const RestoreCurrencyDocument = gql`
    mutation RestoreCurrency($id: ID!) {
  restoreCurrency(id: $id) {
    id
    discardedAt
  }
}
    `;
export type RestoreCurrencyMutationFn = Apollo.MutationFunction<RestoreCurrencyMutation, RestoreCurrencyMutationVariables>;

/**
 * __useRestoreCurrencyMutation__
 *
 * To run a mutation, you first call `useRestoreCurrencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreCurrencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreCurrencyMutation, { data, loading, error }] = useRestoreCurrencyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreCurrencyMutation(baseOptions?: Apollo.MutationHookOptions<RestoreCurrencyMutation, RestoreCurrencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreCurrencyMutation, RestoreCurrencyMutationVariables>(RestoreCurrencyDocument, options);
      }
export type RestoreCurrencyMutationHookResult = ReturnType<typeof useRestoreCurrencyMutation>;
export type RestoreCurrencyMutationResult = Apollo.MutationResult<RestoreCurrencyMutation>;
export type RestoreCurrencyMutationOptions = Apollo.BaseMutationOptions<RestoreCurrencyMutation, RestoreCurrencyMutationVariables>;
export const CreateDisbursementTypeDocument = gql`
    mutation CreateDisbursementType($input: DisbursementTypeInput!) {
  createDisbursementType(input: $input) {
    id
  }
}
    `;
export type CreateDisbursementTypeMutationFn = Apollo.MutationFunction<CreateDisbursementTypeMutation, CreateDisbursementTypeMutationVariables>;

/**
 * __useCreateDisbursementTypeMutation__
 *
 * To run a mutation, you first call `useCreateDisbursementTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDisbursementTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDisbursementTypeMutation, { data, loading, error }] = useCreateDisbursementTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDisbursementTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateDisbursementTypeMutation, CreateDisbursementTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDisbursementTypeMutation, CreateDisbursementTypeMutationVariables>(CreateDisbursementTypeDocument, options);
      }
export type CreateDisbursementTypeMutationHookResult = ReturnType<typeof useCreateDisbursementTypeMutation>;
export type CreateDisbursementTypeMutationResult = Apollo.MutationResult<CreateDisbursementTypeMutation>;
export type CreateDisbursementTypeMutationOptions = Apollo.BaseMutationOptions<CreateDisbursementTypeMutation, CreateDisbursementTypeMutationVariables>;
export const DisbursementTypeDocument = gql`
    query DisbursementType($id: ID!) {
  disbursementType(id: $id) {
    id
    name: nameWithoutFallback
    altNameTranslations
  }
}
    `;

/**
 * __useDisbursementTypeQuery__
 *
 * To run a query within a React component, call `useDisbursementTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDisbursementTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDisbursementTypeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDisbursementTypeQuery(baseOptions: Apollo.QueryHookOptions<DisbursementTypeQuery, DisbursementTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DisbursementTypeQuery, DisbursementTypeQueryVariables>(DisbursementTypeDocument, options);
      }
export function useDisbursementTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DisbursementTypeQuery, DisbursementTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DisbursementTypeQuery, DisbursementTypeQueryVariables>(DisbursementTypeDocument, options);
        }
export type DisbursementTypeQueryHookResult = ReturnType<typeof useDisbursementTypeQuery>;
export type DisbursementTypeLazyQueryHookResult = ReturnType<typeof useDisbursementTypeLazyQuery>;
export type DisbursementTypeQueryResult = Apollo.QueryResult<DisbursementTypeQuery, DisbursementTypeQueryVariables>;
export const UpdateDisbursementTypeDocument = gql`
    mutation UpdateDisbursementType($id: ID!, $input: DisbursementTypeInput!) {
  updateDisbursementType(id: $id, input: $input) {
    id
    name: nameWithoutFallback
    altNameTranslations
  }
}
    `;
export type UpdateDisbursementTypeMutationFn = Apollo.MutationFunction<UpdateDisbursementTypeMutation, UpdateDisbursementTypeMutationVariables>;

/**
 * __useUpdateDisbursementTypeMutation__
 *
 * To run a mutation, you first call `useUpdateDisbursementTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDisbursementTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDisbursementTypeMutation, { data, loading, error }] = useUpdateDisbursementTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDisbursementTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDisbursementTypeMutation, UpdateDisbursementTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDisbursementTypeMutation, UpdateDisbursementTypeMutationVariables>(UpdateDisbursementTypeDocument, options);
      }
export type UpdateDisbursementTypeMutationHookResult = ReturnType<typeof useUpdateDisbursementTypeMutation>;
export type UpdateDisbursementTypeMutationResult = Apollo.MutationResult<UpdateDisbursementTypeMutation>;
export type UpdateDisbursementTypeMutationOptions = Apollo.BaseMutationOptions<UpdateDisbursementTypeMutation, UpdateDisbursementTypeMutationVariables>;
export const DisbursementTypesDocument = gql`
    query DisbursementTypes($order: String, $descending: Boolean, $after: String, $first: Int, $search: String, $active: Boolean) {
  disbursementTypes(
    order: $order
    descending: $descending
    after: $after
    first: $first
    search: $search
    active: $active
  ) {
    nodes {
      id
      name
      createdAt
      updatedAt
      discardedAt
    }
    totalCount
  }
}
    `;

/**
 * __useDisbursementTypesQuery__
 *
 * To run a query within a React component, call `useDisbursementTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDisbursementTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDisbursementTypesQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      search: // value for 'search'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useDisbursementTypesQuery(baseOptions?: Apollo.QueryHookOptions<DisbursementTypesQuery, DisbursementTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DisbursementTypesQuery, DisbursementTypesQueryVariables>(DisbursementTypesDocument, options);
      }
export function useDisbursementTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DisbursementTypesQuery, DisbursementTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DisbursementTypesQuery, DisbursementTypesQueryVariables>(DisbursementTypesDocument, options);
        }
export type DisbursementTypesQueryHookResult = ReturnType<typeof useDisbursementTypesQuery>;
export type DisbursementTypesLazyQueryHookResult = ReturnType<typeof useDisbursementTypesLazyQuery>;
export type DisbursementTypesQueryResult = Apollo.QueryResult<DisbursementTypesQuery, DisbursementTypesQueryVariables>;
export const AutocompleteDisbursementTypesDocument = gql`
    query AutocompleteDisbursementTypes($search: String) {
  disbursementTypes(search: $search) {
    nodes {
      id
      name
    }
  }
}
    `;

/**
 * __useAutocompleteDisbursementTypesQuery__
 *
 * To run a query within a React component, call `useAutocompleteDisbursementTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteDisbursementTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteDisbursementTypesQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAutocompleteDisbursementTypesQuery(baseOptions?: Apollo.QueryHookOptions<AutocompleteDisbursementTypesQuery, AutocompleteDisbursementTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompleteDisbursementTypesQuery, AutocompleteDisbursementTypesQueryVariables>(AutocompleteDisbursementTypesDocument, options);
      }
export function useAutocompleteDisbursementTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompleteDisbursementTypesQuery, AutocompleteDisbursementTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompleteDisbursementTypesQuery, AutocompleteDisbursementTypesQueryVariables>(AutocompleteDisbursementTypesDocument, options);
        }
export type AutocompleteDisbursementTypesQueryHookResult = ReturnType<typeof useAutocompleteDisbursementTypesQuery>;
export type AutocompleteDisbursementTypesLazyQueryHookResult = ReturnType<typeof useAutocompleteDisbursementTypesLazyQuery>;
export type AutocompleteDisbursementTypesQueryResult = Apollo.QueryResult<AutocompleteDisbursementTypesQuery, AutocompleteDisbursementTypesQueryVariables>;
export const DeleteDisbursementTypeDocument = gql`
    mutation DeleteDisbursementType($id: ID!) {
  deleteDisbursementType(id: $id)
}
    `;
export type DeleteDisbursementTypeMutationFn = Apollo.MutationFunction<DeleteDisbursementTypeMutation, DeleteDisbursementTypeMutationVariables>;

/**
 * __useDeleteDisbursementTypeMutation__
 *
 * To run a mutation, you first call `useDeleteDisbursementTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDisbursementTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDisbursementTypeMutation, { data, loading, error }] = useDeleteDisbursementTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDisbursementTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDisbursementTypeMutation, DeleteDisbursementTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDisbursementTypeMutation, DeleteDisbursementTypeMutationVariables>(DeleteDisbursementTypeDocument, options);
      }
export type DeleteDisbursementTypeMutationHookResult = ReturnType<typeof useDeleteDisbursementTypeMutation>;
export type DeleteDisbursementTypeMutationResult = Apollo.MutationResult<DeleteDisbursementTypeMutation>;
export type DeleteDisbursementTypeMutationOptions = Apollo.BaseMutationOptions<DeleteDisbursementTypeMutation, DeleteDisbursementTypeMutationVariables>;
export const RestoreDisbursementTypeDocument = gql`
    mutation RestoreDisbursementType($id: ID!) {
  restoreDisbursementType(id: $id) {
    id
    discardedAt
  }
}
    `;
export type RestoreDisbursementTypeMutationFn = Apollo.MutationFunction<RestoreDisbursementTypeMutation, RestoreDisbursementTypeMutationVariables>;

/**
 * __useRestoreDisbursementTypeMutation__
 *
 * To run a mutation, you first call `useRestoreDisbursementTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreDisbursementTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreDisbursementTypeMutation, { data, loading, error }] = useRestoreDisbursementTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreDisbursementTypeMutation(baseOptions?: Apollo.MutationHookOptions<RestoreDisbursementTypeMutation, RestoreDisbursementTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreDisbursementTypeMutation, RestoreDisbursementTypeMutationVariables>(RestoreDisbursementTypeDocument, options);
      }
export type RestoreDisbursementTypeMutationHookResult = ReturnType<typeof useRestoreDisbursementTypeMutation>;
export type RestoreDisbursementTypeMutationResult = Apollo.MutationResult<RestoreDisbursementTypeMutation>;
export type RestoreDisbursementTypeMutationOptions = Apollo.BaseMutationOptions<RestoreDisbursementTypeMutation, RestoreDisbursementTypeMutationVariables>;
export const CreateIndustryDocument = gql`
    mutation CreateIndustry($input: IndustryInput!) {
  createIndustry(input: $input) {
    id
  }
}
    `;
export type CreateIndustryMutationFn = Apollo.MutationFunction<CreateIndustryMutation, CreateIndustryMutationVariables>;

/**
 * __useCreateIndustryMutation__
 *
 * To run a mutation, you first call `useCreateIndustryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIndustryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIndustryMutation, { data, loading, error }] = useCreateIndustryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIndustryMutation(baseOptions?: Apollo.MutationHookOptions<CreateIndustryMutation, CreateIndustryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIndustryMutation, CreateIndustryMutationVariables>(CreateIndustryDocument, options);
      }
export type CreateIndustryMutationHookResult = ReturnType<typeof useCreateIndustryMutation>;
export type CreateIndustryMutationResult = Apollo.MutationResult<CreateIndustryMutation>;
export type CreateIndustryMutationOptions = Apollo.BaseMutationOptions<CreateIndustryMutation, CreateIndustryMutationVariables>;
export const IndustryDocument = gql`
    query Industry($id: ID!) {
  industry(id: $id) {
    id
    name
    altNameTranslations
  }
}
    `;

/**
 * __useIndustryQuery__
 *
 * To run a query within a React component, call `useIndustryQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndustryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndustryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIndustryQuery(baseOptions: Apollo.QueryHookOptions<IndustryQuery, IndustryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IndustryQuery, IndustryQueryVariables>(IndustryDocument, options);
      }
export function useIndustryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IndustryQuery, IndustryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IndustryQuery, IndustryQueryVariables>(IndustryDocument, options);
        }
export type IndustryQueryHookResult = ReturnType<typeof useIndustryQuery>;
export type IndustryLazyQueryHookResult = ReturnType<typeof useIndustryLazyQuery>;
export type IndustryQueryResult = Apollo.QueryResult<IndustryQuery, IndustryQueryVariables>;
export const UpdateIndustryDocument = gql`
    mutation UpdateIndustry($id: ID!, $input: IndustryInput!) {
  updateIndustry(id: $id, input: $input) {
    id
    name
    altNameTranslations
  }
}
    `;
export type UpdateIndustryMutationFn = Apollo.MutationFunction<UpdateIndustryMutation, UpdateIndustryMutationVariables>;

/**
 * __useUpdateIndustryMutation__
 *
 * To run a mutation, you first call `useUpdateIndustryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIndustryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIndustryMutation, { data, loading, error }] = useUpdateIndustryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIndustryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIndustryMutation, UpdateIndustryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIndustryMutation, UpdateIndustryMutationVariables>(UpdateIndustryDocument, options);
      }
export type UpdateIndustryMutationHookResult = ReturnType<typeof useUpdateIndustryMutation>;
export type UpdateIndustryMutationResult = Apollo.MutationResult<UpdateIndustryMutation>;
export type UpdateIndustryMutationOptions = Apollo.BaseMutationOptions<UpdateIndustryMutation, UpdateIndustryMutationVariables>;
export const IndustriesDocument = gql`
    query Industries($order: String, $descending: Boolean, $after: String, $first: Int, $search: String, $active: Boolean) {
  industries(
    order: $order
    descending: $descending
    after: $after
    first: $first
    search: $search
    active: $active
  ) {
    nodes {
      id
      name
      createdAt
      updatedAt
      discardedAt
    }
    totalCount
  }
}
    `;

/**
 * __useIndustriesQuery__
 *
 * To run a query within a React component, call `useIndustriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndustriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndustriesQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      search: // value for 'search'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useIndustriesQuery(baseOptions?: Apollo.QueryHookOptions<IndustriesQuery, IndustriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IndustriesQuery, IndustriesQueryVariables>(IndustriesDocument, options);
      }
export function useIndustriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IndustriesQuery, IndustriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IndustriesQuery, IndustriesQueryVariables>(IndustriesDocument, options);
        }
export type IndustriesQueryHookResult = ReturnType<typeof useIndustriesQuery>;
export type IndustriesLazyQueryHookResult = ReturnType<typeof useIndustriesLazyQuery>;
export type IndustriesQueryResult = Apollo.QueryResult<IndustriesQuery, IndustriesQueryVariables>;
export const AutocompleteIndustriesDocument = gql`
    query AutocompleteIndustries($search: String) {
  industries(search: $search) {
    nodes {
      id
      name
    }
  }
}
    `;

/**
 * __useAutocompleteIndustriesQuery__
 *
 * To run a query within a React component, call `useAutocompleteIndustriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteIndustriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteIndustriesQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAutocompleteIndustriesQuery(baseOptions?: Apollo.QueryHookOptions<AutocompleteIndustriesQuery, AutocompleteIndustriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompleteIndustriesQuery, AutocompleteIndustriesQueryVariables>(AutocompleteIndustriesDocument, options);
      }
export function useAutocompleteIndustriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompleteIndustriesQuery, AutocompleteIndustriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompleteIndustriesQuery, AutocompleteIndustriesQueryVariables>(AutocompleteIndustriesDocument, options);
        }
export type AutocompleteIndustriesQueryHookResult = ReturnType<typeof useAutocompleteIndustriesQuery>;
export type AutocompleteIndustriesLazyQueryHookResult = ReturnType<typeof useAutocompleteIndustriesLazyQuery>;
export type AutocompleteIndustriesQueryResult = Apollo.QueryResult<AutocompleteIndustriesQuery, AutocompleteIndustriesQueryVariables>;
export const DeleteIndustryDocument = gql`
    mutation DeleteIndustry($id: ID!) {
  deleteIndustry(id: $id)
}
    `;
export type DeleteIndustryMutationFn = Apollo.MutationFunction<DeleteIndustryMutation, DeleteIndustryMutationVariables>;

/**
 * __useDeleteIndustryMutation__
 *
 * To run a mutation, you first call `useDeleteIndustryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIndustryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIndustryMutation, { data, loading, error }] = useDeleteIndustryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIndustryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIndustryMutation, DeleteIndustryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIndustryMutation, DeleteIndustryMutationVariables>(DeleteIndustryDocument, options);
      }
export type DeleteIndustryMutationHookResult = ReturnType<typeof useDeleteIndustryMutation>;
export type DeleteIndustryMutationResult = Apollo.MutationResult<DeleteIndustryMutation>;
export type DeleteIndustryMutationOptions = Apollo.BaseMutationOptions<DeleteIndustryMutation, DeleteIndustryMutationVariables>;
export const RestoreIndustryDocument = gql`
    mutation RestoreIndustry($id: ID!) {
  restoreIndustry(id: $id) {
    id
    discardedAt
  }
}
    `;
export type RestoreIndustryMutationFn = Apollo.MutationFunction<RestoreIndustryMutation, RestoreIndustryMutationVariables>;

/**
 * __useRestoreIndustryMutation__
 *
 * To run a mutation, you first call `useRestoreIndustryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreIndustryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreIndustryMutation, { data, loading, error }] = useRestoreIndustryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreIndustryMutation(baseOptions?: Apollo.MutationHookOptions<RestoreIndustryMutation, RestoreIndustryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreIndustryMutation, RestoreIndustryMutationVariables>(RestoreIndustryDocument, options);
      }
export type RestoreIndustryMutationHookResult = ReturnType<typeof useRestoreIndustryMutation>;
export type RestoreIndustryMutationResult = Apollo.MutationResult<RestoreIndustryMutation>;
export type RestoreIndustryMutationOptions = Apollo.BaseMutationOptions<RestoreIndustryMutation, RestoreIndustryMutationVariables>;
export const CreateMarketingEffortNeedTypeDocument = gql`
    mutation CreateMarketingEffortNeedType($input: MarketingEffortNeedTypeInput!) {
  createMarketingEffortNeedType(input: $input) {
    id
  }
}
    `;
export type CreateMarketingEffortNeedTypeMutationFn = Apollo.MutationFunction<CreateMarketingEffortNeedTypeMutation, CreateMarketingEffortNeedTypeMutationVariables>;

/**
 * __useCreateMarketingEffortNeedTypeMutation__
 *
 * To run a mutation, you first call `useCreateMarketingEffortNeedTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMarketingEffortNeedTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMarketingEffortNeedTypeMutation, { data, loading, error }] = useCreateMarketingEffortNeedTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMarketingEffortNeedTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateMarketingEffortNeedTypeMutation, CreateMarketingEffortNeedTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMarketingEffortNeedTypeMutation, CreateMarketingEffortNeedTypeMutationVariables>(CreateMarketingEffortNeedTypeDocument, options);
      }
export type CreateMarketingEffortNeedTypeMutationHookResult = ReturnType<typeof useCreateMarketingEffortNeedTypeMutation>;
export type CreateMarketingEffortNeedTypeMutationResult = Apollo.MutationResult<CreateMarketingEffortNeedTypeMutation>;
export type CreateMarketingEffortNeedTypeMutationOptions = Apollo.BaseMutationOptions<CreateMarketingEffortNeedTypeMutation, CreateMarketingEffortNeedTypeMutationVariables>;
export const MarketingEffortNeedTypeDocument = gql`
    query MarketingEffortNeedType($id: ID!) {
  marketingEffortNeedType(id: $id) {
    id
    name: nameWithoutFallback
    altNameTranslations
  }
}
    `;

/**
 * __useMarketingEffortNeedTypeQuery__
 *
 * To run a query within a React component, call `useMarketingEffortNeedTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingEffortNeedTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingEffortNeedTypeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarketingEffortNeedTypeQuery(baseOptions: Apollo.QueryHookOptions<MarketingEffortNeedTypeQuery, MarketingEffortNeedTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketingEffortNeedTypeQuery, MarketingEffortNeedTypeQueryVariables>(MarketingEffortNeedTypeDocument, options);
      }
export function useMarketingEffortNeedTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingEffortNeedTypeQuery, MarketingEffortNeedTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketingEffortNeedTypeQuery, MarketingEffortNeedTypeQueryVariables>(MarketingEffortNeedTypeDocument, options);
        }
export type MarketingEffortNeedTypeQueryHookResult = ReturnType<typeof useMarketingEffortNeedTypeQuery>;
export type MarketingEffortNeedTypeLazyQueryHookResult = ReturnType<typeof useMarketingEffortNeedTypeLazyQuery>;
export type MarketingEffortNeedTypeQueryResult = Apollo.QueryResult<MarketingEffortNeedTypeQuery, MarketingEffortNeedTypeQueryVariables>;
export const UpdateMarketingEffortNeedTypeDocument = gql`
    mutation UpdateMarketingEffortNeedType($id: ID!, $input: MarketingEffortNeedTypeInput!) {
  updateMarketingEffortNeedType(id: $id, input: $input) {
    id
    name: nameWithoutFallback
    altNameTranslations
  }
}
    `;
export type UpdateMarketingEffortNeedTypeMutationFn = Apollo.MutationFunction<UpdateMarketingEffortNeedTypeMutation, UpdateMarketingEffortNeedTypeMutationVariables>;

/**
 * __useUpdateMarketingEffortNeedTypeMutation__
 *
 * To run a mutation, you first call `useUpdateMarketingEffortNeedTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMarketingEffortNeedTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMarketingEffortNeedTypeMutation, { data, loading, error }] = useUpdateMarketingEffortNeedTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMarketingEffortNeedTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMarketingEffortNeedTypeMutation, UpdateMarketingEffortNeedTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMarketingEffortNeedTypeMutation, UpdateMarketingEffortNeedTypeMutationVariables>(UpdateMarketingEffortNeedTypeDocument, options);
      }
export type UpdateMarketingEffortNeedTypeMutationHookResult = ReturnType<typeof useUpdateMarketingEffortNeedTypeMutation>;
export type UpdateMarketingEffortNeedTypeMutationResult = Apollo.MutationResult<UpdateMarketingEffortNeedTypeMutation>;
export type UpdateMarketingEffortNeedTypeMutationOptions = Apollo.BaseMutationOptions<UpdateMarketingEffortNeedTypeMutation, UpdateMarketingEffortNeedTypeMutationVariables>;
export const MarketingEffortNeedTypesDocument = gql`
    query MarketingEffortNeedTypes($order: String, $descending: Boolean, $after: String, $first: Int, $search: String, $active: Boolean) {
  marketingEffortNeedTypes(
    order: $order
    descending: $descending
    after: $after
    first: $first
    search: $search
    active: $active
  ) {
    nodes {
      id
      name
      createdAt
      updatedAt
      discardedAt
    }
    totalCount
  }
}
    `;

/**
 * __useMarketingEffortNeedTypesQuery__
 *
 * To run a query within a React component, call `useMarketingEffortNeedTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingEffortNeedTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingEffortNeedTypesQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      search: // value for 'search'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useMarketingEffortNeedTypesQuery(baseOptions?: Apollo.QueryHookOptions<MarketingEffortNeedTypesQuery, MarketingEffortNeedTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketingEffortNeedTypesQuery, MarketingEffortNeedTypesQueryVariables>(MarketingEffortNeedTypesDocument, options);
      }
export function useMarketingEffortNeedTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingEffortNeedTypesQuery, MarketingEffortNeedTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketingEffortNeedTypesQuery, MarketingEffortNeedTypesQueryVariables>(MarketingEffortNeedTypesDocument, options);
        }
export type MarketingEffortNeedTypesQueryHookResult = ReturnType<typeof useMarketingEffortNeedTypesQuery>;
export type MarketingEffortNeedTypesLazyQueryHookResult = ReturnType<typeof useMarketingEffortNeedTypesLazyQuery>;
export type MarketingEffortNeedTypesQueryResult = Apollo.QueryResult<MarketingEffortNeedTypesQuery, MarketingEffortNeedTypesQueryVariables>;
export const DeleteMarketingEffortNeedTypeDocument = gql`
    mutation DeleteMarketingEffortNeedType($id: ID!) {
  deleteMarketingEffortNeedType(id: $id)
}
    `;
export type DeleteMarketingEffortNeedTypeMutationFn = Apollo.MutationFunction<DeleteMarketingEffortNeedTypeMutation, DeleteMarketingEffortNeedTypeMutationVariables>;

/**
 * __useDeleteMarketingEffortNeedTypeMutation__
 *
 * To run a mutation, you first call `useDeleteMarketingEffortNeedTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMarketingEffortNeedTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMarketingEffortNeedTypeMutation, { data, loading, error }] = useDeleteMarketingEffortNeedTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMarketingEffortNeedTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMarketingEffortNeedTypeMutation, DeleteMarketingEffortNeedTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMarketingEffortNeedTypeMutation, DeleteMarketingEffortNeedTypeMutationVariables>(DeleteMarketingEffortNeedTypeDocument, options);
      }
export type DeleteMarketingEffortNeedTypeMutationHookResult = ReturnType<typeof useDeleteMarketingEffortNeedTypeMutation>;
export type DeleteMarketingEffortNeedTypeMutationResult = Apollo.MutationResult<DeleteMarketingEffortNeedTypeMutation>;
export type DeleteMarketingEffortNeedTypeMutationOptions = Apollo.BaseMutationOptions<DeleteMarketingEffortNeedTypeMutation, DeleteMarketingEffortNeedTypeMutationVariables>;
export const RestoreMarketingEffortNeedTypeDocument = gql`
    mutation RestoreMarketingEffortNeedType($id: ID!) {
  restoreMarketingEffortNeedType(id: $id) {
    id
    discardedAt
  }
}
    `;
export type RestoreMarketingEffortNeedTypeMutationFn = Apollo.MutationFunction<RestoreMarketingEffortNeedTypeMutation, RestoreMarketingEffortNeedTypeMutationVariables>;

/**
 * __useRestoreMarketingEffortNeedTypeMutation__
 *
 * To run a mutation, you first call `useRestoreMarketingEffortNeedTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreMarketingEffortNeedTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreMarketingEffortNeedTypeMutation, { data, loading, error }] = useRestoreMarketingEffortNeedTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreMarketingEffortNeedTypeMutation(baseOptions?: Apollo.MutationHookOptions<RestoreMarketingEffortNeedTypeMutation, RestoreMarketingEffortNeedTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreMarketingEffortNeedTypeMutation, RestoreMarketingEffortNeedTypeMutationVariables>(RestoreMarketingEffortNeedTypeDocument, options);
      }
export type RestoreMarketingEffortNeedTypeMutationHookResult = ReturnType<typeof useRestoreMarketingEffortNeedTypeMutation>;
export type RestoreMarketingEffortNeedTypeMutationResult = Apollo.MutationResult<RestoreMarketingEffortNeedTypeMutation>;
export type RestoreMarketingEffortNeedTypeMutationOptions = Apollo.BaseMutationOptions<RestoreMarketingEffortNeedTypeMutation, RestoreMarketingEffortNeedTypeMutationVariables>;
export const CreateMarketingEffortResponseTypeDocument = gql`
    mutation CreateMarketingEffortResponseType($input: MarketingEffortResponseTypeInput!) {
  createMarketingEffortResponseType(input: $input) {
    id
  }
}
    `;
export type CreateMarketingEffortResponseTypeMutationFn = Apollo.MutationFunction<CreateMarketingEffortResponseTypeMutation, CreateMarketingEffortResponseTypeMutationVariables>;

/**
 * __useCreateMarketingEffortResponseTypeMutation__
 *
 * To run a mutation, you first call `useCreateMarketingEffortResponseTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMarketingEffortResponseTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMarketingEffortResponseTypeMutation, { data, loading, error }] = useCreateMarketingEffortResponseTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMarketingEffortResponseTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateMarketingEffortResponseTypeMutation, CreateMarketingEffortResponseTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMarketingEffortResponseTypeMutation, CreateMarketingEffortResponseTypeMutationVariables>(CreateMarketingEffortResponseTypeDocument, options);
      }
export type CreateMarketingEffortResponseTypeMutationHookResult = ReturnType<typeof useCreateMarketingEffortResponseTypeMutation>;
export type CreateMarketingEffortResponseTypeMutationResult = Apollo.MutationResult<CreateMarketingEffortResponseTypeMutation>;
export type CreateMarketingEffortResponseTypeMutationOptions = Apollo.BaseMutationOptions<CreateMarketingEffortResponseTypeMutation, CreateMarketingEffortResponseTypeMutationVariables>;
export const MarketingEffortResponseTypeDocument = gql`
    query MarketingEffortResponseType($id: ID!) {
  marketingEffortResponseType(id: $id) {
    id
    name: nameWithoutFallback
    altNameTranslations
  }
}
    `;

/**
 * __useMarketingEffortResponseTypeQuery__
 *
 * To run a query within a React component, call `useMarketingEffortResponseTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingEffortResponseTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingEffortResponseTypeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarketingEffortResponseTypeQuery(baseOptions: Apollo.QueryHookOptions<MarketingEffortResponseTypeQuery, MarketingEffortResponseTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketingEffortResponseTypeQuery, MarketingEffortResponseTypeQueryVariables>(MarketingEffortResponseTypeDocument, options);
      }
export function useMarketingEffortResponseTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingEffortResponseTypeQuery, MarketingEffortResponseTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketingEffortResponseTypeQuery, MarketingEffortResponseTypeQueryVariables>(MarketingEffortResponseTypeDocument, options);
        }
export type MarketingEffortResponseTypeQueryHookResult = ReturnType<typeof useMarketingEffortResponseTypeQuery>;
export type MarketingEffortResponseTypeLazyQueryHookResult = ReturnType<typeof useMarketingEffortResponseTypeLazyQuery>;
export type MarketingEffortResponseTypeQueryResult = Apollo.QueryResult<MarketingEffortResponseTypeQuery, MarketingEffortResponseTypeQueryVariables>;
export const UpdateMarketingEffortResponseTypeDocument = gql`
    mutation UpdateMarketingEffortResponseType($id: ID!, $input: MarketingEffortResponseTypeInput!) {
  updateMarketingEffortResponseType(id: $id, input: $input) {
    id
    name: nameWithoutFallback
    altNameTranslations
  }
}
    `;
export type UpdateMarketingEffortResponseTypeMutationFn = Apollo.MutationFunction<UpdateMarketingEffortResponseTypeMutation, UpdateMarketingEffortResponseTypeMutationVariables>;

/**
 * __useUpdateMarketingEffortResponseTypeMutation__
 *
 * To run a mutation, you first call `useUpdateMarketingEffortResponseTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMarketingEffortResponseTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMarketingEffortResponseTypeMutation, { data, loading, error }] = useUpdateMarketingEffortResponseTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMarketingEffortResponseTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMarketingEffortResponseTypeMutation, UpdateMarketingEffortResponseTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMarketingEffortResponseTypeMutation, UpdateMarketingEffortResponseTypeMutationVariables>(UpdateMarketingEffortResponseTypeDocument, options);
      }
export type UpdateMarketingEffortResponseTypeMutationHookResult = ReturnType<typeof useUpdateMarketingEffortResponseTypeMutation>;
export type UpdateMarketingEffortResponseTypeMutationResult = Apollo.MutationResult<UpdateMarketingEffortResponseTypeMutation>;
export type UpdateMarketingEffortResponseTypeMutationOptions = Apollo.BaseMutationOptions<UpdateMarketingEffortResponseTypeMutation, UpdateMarketingEffortResponseTypeMutationVariables>;
export const MarketingEffortResponseTypesDocument = gql`
    query MarketingEffortResponseTypes($order: String, $descending: Boolean, $after: String, $first: Int, $search: String, $active: Boolean) {
  marketingEffortResponseTypes(
    order: $order
    descending: $descending
    after: $after
    first: $first
    search: $search
    active: $active
  ) {
    nodes {
      id
      name
      createdAt
      updatedAt
      discardedAt
    }
    totalCount
  }
}
    `;

/**
 * __useMarketingEffortResponseTypesQuery__
 *
 * To run a query within a React component, call `useMarketingEffortResponseTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingEffortResponseTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingEffortResponseTypesQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      search: // value for 'search'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useMarketingEffortResponseTypesQuery(baseOptions?: Apollo.QueryHookOptions<MarketingEffortResponseTypesQuery, MarketingEffortResponseTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketingEffortResponseTypesQuery, MarketingEffortResponseTypesQueryVariables>(MarketingEffortResponseTypesDocument, options);
      }
export function useMarketingEffortResponseTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingEffortResponseTypesQuery, MarketingEffortResponseTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketingEffortResponseTypesQuery, MarketingEffortResponseTypesQueryVariables>(MarketingEffortResponseTypesDocument, options);
        }
export type MarketingEffortResponseTypesQueryHookResult = ReturnType<typeof useMarketingEffortResponseTypesQuery>;
export type MarketingEffortResponseTypesLazyQueryHookResult = ReturnType<typeof useMarketingEffortResponseTypesLazyQuery>;
export type MarketingEffortResponseTypesQueryResult = Apollo.QueryResult<MarketingEffortResponseTypesQuery, MarketingEffortResponseTypesQueryVariables>;
export const DeleteMarketingEffortResponseTypeDocument = gql`
    mutation DeleteMarketingEffortResponseType($id: ID!) {
  deleteMarketingEffortResponseType(id: $id)
}
    `;
export type DeleteMarketingEffortResponseTypeMutationFn = Apollo.MutationFunction<DeleteMarketingEffortResponseTypeMutation, DeleteMarketingEffortResponseTypeMutationVariables>;

/**
 * __useDeleteMarketingEffortResponseTypeMutation__
 *
 * To run a mutation, you first call `useDeleteMarketingEffortResponseTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMarketingEffortResponseTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMarketingEffortResponseTypeMutation, { data, loading, error }] = useDeleteMarketingEffortResponseTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMarketingEffortResponseTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMarketingEffortResponseTypeMutation, DeleteMarketingEffortResponseTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMarketingEffortResponseTypeMutation, DeleteMarketingEffortResponseTypeMutationVariables>(DeleteMarketingEffortResponseTypeDocument, options);
      }
export type DeleteMarketingEffortResponseTypeMutationHookResult = ReturnType<typeof useDeleteMarketingEffortResponseTypeMutation>;
export type DeleteMarketingEffortResponseTypeMutationResult = Apollo.MutationResult<DeleteMarketingEffortResponseTypeMutation>;
export type DeleteMarketingEffortResponseTypeMutationOptions = Apollo.BaseMutationOptions<DeleteMarketingEffortResponseTypeMutation, DeleteMarketingEffortResponseTypeMutationVariables>;
export const RestoreMarketingEffortResponseTypeDocument = gql`
    mutation RestoreMarketingEffortResponseType($id: ID!) {
  restoreMarketingEffortResponseType(id: $id) {
    id
    discardedAt
  }
}
    `;
export type RestoreMarketingEffortResponseTypeMutationFn = Apollo.MutationFunction<RestoreMarketingEffortResponseTypeMutation, RestoreMarketingEffortResponseTypeMutationVariables>;

/**
 * __useRestoreMarketingEffortResponseTypeMutation__
 *
 * To run a mutation, you first call `useRestoreMarketingEffortResponseTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreMarketingEffortResponseTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreMarketingEffortResponseTypeMutation, { data, loading, error }] = useRestoreMarketingEffortResponseTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreMarketingEffortResponseTypeMutation(baseOptions?: Apollo.MutationHookOptions<RestoreMarketingEffortResponseTypeMutation, RestoreMarketingEffortResponseTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreMarketingEffortResponseTypeMutation, RestoreMarketingEffortResponseTypeMutationVariables>(RestoreMarketingEffortResponseTypeDocument, options);
      }
export type RestoreMarketingEffortResponseTypeMutationHookResult = ReturnType<typeof useRestoreMarketingEffortResponseTypeMutation>;
export type RestoreMarketingEffortResponseTypeMutationResult = Apollo.MutationResult<RestoreMarketingEffortResponseTypeMutation>;
export type RestoreMarketingEffortResponseTypeMutationOptions = Apollo.BaseMutationOptions<RestoreMarketingEffortResponseTypeMutation, RestoreMarketingEffortResponseTypeMutationVariables>;
export const CreateMarketingEffortTypeDocument = gql`
    mutation CreateMarketingEffortType($input: MarketingEffortTypeInput!) {
  createMarketingEffortType(input: $input) {
    id
  }
}
    `;
export type CreateMarketingEffortTypeMutationFn = Apollo.MutationFunction<CreateMarketingEffortTypeMutation, CreateMarketingEffortTypeMutationVariables>;

/**
 * __useCreateMarketingEffortTypeMutation__
 *
 * To run a mutation, you first call `useCreateMarketingEffortTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMarketingEffortTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMarketingEffortTypeMutation, { data, loading, error }] = useCreateMarketingEffortTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMarketingEffortTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateMarketingEffortTypeMutation, CreateMarketingEffortTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMarketingEffortTypeMutation, CreateMarketingEffortTypeMutationVariables>(CreateMarketingEffortTypeDocument, options);
      }
export type CreateMarketingEffortTypeMutationHookResult = ReturnType<typeof useCreateMarketingEffortTypeMutation>;
export type CreateMarketingEffortTypeMutationResult = Apollo.MutationResult<CreateMarketingEffortTypeMutation>;
export type CreateMarketingEffortTypeMutationOptions = Apollo.BaseMutationOptions<CreateMarketingEffortTypeMutation, CreateMarketingEffortTypeMutationVariables>;
export const MarketingEffortTypeDocument = gql`
    query MarketingEffortType($id: ID!) {
  marketingEffortType(id: $id) {
    id
    name: nameWithoutFallback
    altNameTranslations
  }
}
    `;

/**
 * __useMarketingEffortTypeQuery__
 *
 * To run a query within a React component, call `useMarketingEffortTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingEffortTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingEffortTypeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarketingEffortTypeQuery(baseOptions: Apollo.QueryHookOptions<MarketingEffortTypeQuery, MarketingEffortTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketingEffortTypeQuery, MarketingEffortTypeQueryVariables>(MarketingEffortTypeDocument, options);
      }
export function useMarketingEffortTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingEffortTypeQuery, MarketingEffortTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketingEffortTypeQuery, MarketingEffortTypeQueryVariables>(MarketingEffortTypeDocument, options);
        }
export type MarketingEffortTypeQueryHookResult = ReturnType<typeof useMarketingEffortTypeQuery>;
export type MarketingEffortTypeLazyQueryHookResult = ReturnType<typeof useMarketingEffortTypeLazyQuery>;
export type MarketingEffortTypeQueryResult = Apollo.QueryResult<MarketingEffortTypeQuery, MarketingEffortTypeQueryVariables>;
export const UpdateMarketingEffortTypeDocument = gql`
    mutation UpdateMarketingEffortType($id: ID!, $input: MarketingEffortTypeInput!) {
  updateMarketingEffortType(id: $id, input: $input) {
    id
    name: nameWithoutFallback
    altNameTranslations
  }
}
    `;
export type UpdateMarketingEffortTypeMutationFn = Apollo.MutationFunction<UpdateMarketingEffortTypeMutation, UpdateMarketingEffortTypeMutationVariables>;

/**
 * __useUpdateMarketingEffortTypeMutation__
 *
 * To run a mutation, you first call `useUpdateMarketingEffortTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMarketingEffortTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMarketingEffortTypeMutation, { data, loading, error }] = useUpdateMarketingEffortTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMarketingEffortTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMarketingEffortTypeMutation, UpdateMarketingEffortTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMarketingEffortTypeMutation, UpdateMarketingEffortTypeMutationVariables>(UpdateMarketingEffortTypeDocument, options);
      }
export type UpdateMarketingEffortTypeMutationHookResult = ReturnType<typeof useUpdateMarketingEffortTypeMutation>;
export type UpdateMarketingEffortTypeMutationResult = Apollo.MutationResult<UpdateMarketingEffortTypeMutation>;
export type UpdateMarketingEffortTypeMutationOptions = Apollo.BaseMutationOptions<UpdateMarketingEffortTypeMutation, UpdateMarketingEffortTypeMutationVariables>;
export const MarketingEffortTypesDocument = gql`
    query MarketingEffortTypes($order: String, $descending: Boolean, $after: String, $first: Int, $search: String, $active: Boolean) {
  marketingEffortTypes(
    order: $order
    descending: $descending
    after: $after
    first: $first
    search: $search
    active: $active
  ) {
    nodes {
      id
      name
      createdAt
      updatedAt
      discardedAt
    }
    totalCount
  }
}
    `;

/**
 * __useMarketingEffortTypesQuery__
 *
 * To run a query within a React component, call `useMarketingEffortTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingEffortTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingEffortTypesQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      search: // value for 'search'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useMarketingEffortTypesQuery(baseOptions?: Apollo.QueryHookOptions<MarketingEffortTypesQuery, MarketingEffortTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketingEffortTypesQuery, MarketingEffortTypesQueryVariables>(MarketingEffortTypesDocument, options);
      }
export function useMarketingEffortTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingEffortTypesQuery, MarketingEffortTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketingEffortTypesQuery, MarketingEffortTypesQueryVariables>(MarketingEffortTypesDocument, options);
        }
export type MarketingEffortTypesQueryHookResult = ReturnType<typeof useMarketingEffortTypesQuery>;
export type MarketingEffortTypesLazyQueryHookResult = ReturnType<typeof useMarketingEffortTypesLazyQuery>;
export type MarketingEffortTypesQueryResult = Apollo.QueryResult<MarketingEffortTypesQuery, MarketingEffortTypesQueryVariables>;
export const DeleteMarketingEffortTypeDocument = gql`
    mutation DeleteMarketingEffortType($id: ID!) {
  deleteMarketingEffortType(id: $id)
}
    `;
export type DeleteMarketingEffortTypeMutationFn = Apollo.MutationFunction<DeleteMarketingEffortTypeMutation, DeleteMarketingEffortTypeMutationVariables>;

/**
 * __useDeleteMarketingEffortTypeMutation__
 *
 * To run a mutation, you first call `useDeleteMarketingEffortTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMarketingEffortTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMarketingEffortTypeMutation, { data, loading, error }] = useDeleteMarketingEffortTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMarketingEffortTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMarketingEffortTypeMutation, DeleteMarketingEffortTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMarketingEffortTypeMutation, DeleteMarketingEffortTypeMutationVariables>(DeleteMarketingEffortTypeDocument, options);
      }
export type DeleteMarketingEffortTypeMutationHookResult = ReturnType<typeof useDeleteMarketingEffortTypeMutation>;
export type DeleteMarketingEffortTypeMutationResult = Apollo.MutationResult<DeleteMarketingEffortTypeMutation>;
export type DeleteMarketingEffortTypeMutationOptions = Apollo.BaseMutationOptions<DeleteMarketingEffortTypeMutation, DeleteMarketingEffortTypeMutationVariables>;
export const RestoreMarketingEffortTypeDocument = gql`
    mutation RestoreMarketingEffortType($id: ID!) {
  restoreMarketingEffortType(id: $id) {
    id
    discardedAt
  }
}
    `;
export type RestoreMarketingEffortTypeMutationFn = Apollo.MutationFunction<RestoreMarketingEffortTypeMutation, RestoreMarketingEffortTypeMutationVariables>;

/**
 * __useRestoreMarketingEffortTypeMutation__
 *
 * To run a mutation, you first call `useRestoreMarketingEffortTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreMarketingEffortTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreMarketingEffortTypeMutation, { data, loading, error }] = useRestoreMarketingEffortTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreMarketingEffortTypeMutation(baseOptions?: Apollo.MutationHookOptions<RestoreMarketingEffortTypeMutation, RestoreMarketingEffortTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreMarketingEffortTypeMutation, RestoreMarketingEffortTypeMutationVariables>(RestoreMarketingEffortTypeDocument, options);
      }
export type RestoreMarketingEffortTypeMutationHookResult = ReturnType<typeof useRestoreMarketingEffortTypeMutation>;
export type RestoreMarketingEffortTypeMutationResult = Apollo.MutationResult<RestoreMarketingEffortTypeMutation>;
export type RestoreMarketingEffortTypeMutationOptions = Apollo.BaseMutationOptions<RestoreMarketingEffortTypeMutation, RestoreMarketingEffortTypeMutationVariables>;
export const CreatePaymentTermDocument = gql`
    mutation CreatePaymentTerm($input: PaymentTermInput!) {
  createPaymentTerm(input: $input) {
    id
  }
}
    `;
export type CreatePaymentTermMutationFn = Apollo.MutationFunction<CreatePaymentTermMutation, CreatePaymentTermMutationVariables>;

/**
 * __useCreatePaymentTermMutation__
 *
 * To run a mutation, you first call `useCreatePaymentTermMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentTermMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentTermMutation, { data, loading, error }] = useCreatePaymentTermMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePaymentTermMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentTermMutation, CreatePaymentTermMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentTermMutation, CreatePaymentTermMutationVariables>(CreatePaymentTermDocument, options);
      }
export type CreatePaymentTermMutationHookResult = ReturnType<typeof useCreatePaymentTermMutation>;
export type CreatePaymentTermMutationResult = Apollo.MutationResult<CreatePaymentTermMutation>;
export type CreatePaymentTermMutationOptions = Apollo.BaseMutationOptions<CreatePaymentTermMutation, CreatePaymentTermMutationVariables>;
export const PaymentTermDocument = gql`
    query PaymentTerm($id: ID!) {
  paymentTerm(id: $id) {
    id
    days
  }
}
    `;

/**
 * __usePaymentTermQuery__
 *
 * To run a query within a React component, call `usePaymentTermQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentTermQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentTermQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePaymentTermQuery(baseOptions: Apollo.QueryHookOptions<PaymentTermQuery, PaymentTermQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentTermQuery, PaymentTermQueryVariables>(PaymentTermDocument, options);
      }
export function usePaymentTermLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentTermQuery, PaymentTermQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentTermQuery, PaymentTermQueryVariables>(PaymentTermDocument, options);
        }
export type PaymentTermQueryHookResult = ReturnType<typeof usePaymentTermQuery>;
export type PaymentTermLazyQueryHookResult = ReturnType<typeof usePaymentTermLazyQuery>;
export type PaymentTermQueryResult = Apollo.QueryResult<PaymentTermQuery, PaymentTermQueryVariables>;
export const UpdatePaymentTermDocument = gql`
    mutation UpdatePaymentTerm($id: ID!, $input: PaymentTermInput!) {
  updatePaymentTerm(id: $id, input: $input) {
    id
    days
  }
}
    `;
export type UpdatePaymentTermMutationFn = Apollo.MutationFunction<UpdatePaymentTermMutation, UpdatePaymentTermMutationVariables>;

/**
 * __useUpdatePaymentTermMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentTermMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentTermMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentTermMutation, { data, loading, error }] = useUpdatePaymentTermMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePaymentTermMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentTermMutation, UpdatePaymentTermMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentTermMutation, UpdatePaymentTermMutationVariables>(UpdatePaymentTermDocument, options);
      }
export type UpdatePaymentTermMutationHookResult = ReturnType<typeof useUpdatePaymentTermMutation>;
export type UpdatePaymentTermMutationResult = Apollo.MutationResult<UpdatePaymentTermMutation>;
export type UpdatePaymentTermMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentTermMutation, UpdatePaymentTermMutationVariables>;
export const PaymentTermsDocument = gql`
    query PaymentTerms($order: String, $descending: Boolean, $after: String, $first: Int, $search: String, $active: Boolean) {
  paymentTerms(
    order: $order
    descending: $descending
    after: $after
    first: $first
    search: $search
    active: $active
  ) {
    nodes {
      id
      days
      createdAt
      updatedAt
      discardedAt
    }
    totalCount
  }
}
    `;

/**
 * __usePaymentTermsQuery__
 *
 * To run a query within a React component, call `usePaymentTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentTermsQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      search: // value for 'search'
 *      active: // value for 'active'
 *   },
 * });
 */
export function usePaymentTermsQuery(baseOptions?: Apollo.QueryHookOptions<PaymentTermsQuery, PaymentTermsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentTermsQuery, PaymentTermsQueryVariables>(PaymentTermsDocument, options);
      }
export function usePaymentTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentTermsQuery, PaymentTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentTermsQuery, PaymentTermsQueryVariables>(PaymentTermsDocument, options);
        }
export type PaymentTermsQueryHookResult = ReturnType<typeof usePaymentTermsQuery>;
export type PaymentTermsLazyQueryHookResult = ReturnType<typeof usePaymentTermsLazyQuery>;
export type PaymentTermsQueryResult = Apollo.QueryResult<PaymentTermsQuery, PaymentTermsQueryVariables>;
export const AutocompletePaymentTermsDocument = gql`
    query AutocompletePaymentTerms($search: String) {
  paymentTerms(search: $search) {
    nodes {
      id
      days
    }
  }
}
    `;

/**
 * __useAutocompletePaymentTermsQuery__
 *
 * To run a query within a React component, call `useAutocompletePaymentTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompletePaymentTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompletePaymentTermsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAutocompletePaymentTermsQuery(baseOptions?: Apollo.QueryHookOptions<AutocompletePaymentTermsQuery, AutocompletePaymentTermsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompletePaymentTermsQuery, AutocompletePaymentTermsQueryVariables>(AutocompletePaymentTermsDocument, options);
      }
export function useAutocompletePaymentTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompletePaymentTermsQuery, AutocompletePaymentTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompletePaymentTermsQuery, AutocompletePaymentTermsQueryVariables>(AutocompletePaymentTermsDocument, options);
        }
export type AutocompletePaymentTermsQueryHookResult = ReturnType<typeof useAutocompletePaymentTermsQuery>;
export type AutocompletePaymentTermsLazyQueryHookResult = ReturnType<typeof useAutocompletePaymentTermsLazyQuery>;
export type AutocompletePaymentTermsQueryResult = Apollo.QueryResult<AutocompletePaymentTermsQuery, AutocompletePaymentTermsQueryVariables>;
export const DeletePaymentTermDocument = gql`
    mutation DeletePaymentTerm($id: ID!) {
  deletePaymentTerm(id: $id)
}
    `;
export type DeletePaymentTermMutationFn = Apollo.MutationFunction<DeletePaymentTermMutation, DeletePaymentTermMutationVariables>;

/**
 * __useDeletePaymentTermMutation__
 *
 * To run a mutation, you first call `useDeletePaymentTermMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentTermMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentTermMutation, { data, loading, error }] = useDeletePaymentTermMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePaymentTermMutation(baseOptions?: Apollo.MutationHookOptions<DeletePaymentTermMutation, DeletePaymentTermMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePaymentTermMutation, DeletePaymentTermMutationVariables>(DeletePaymentTermDocument, options);
      }
export type DeletePaymentTermMutationHookResult = ReturnType<typeof useDeletePaymentTermMutation>;
export type DeletePaymentTermMutationResult = Apollo.MutationResult<DeletePaymentTermMutation>;
export type DeletePaymentTermMutationOptions = Apollo.BaseMutationOptions<DeletePaymentTermMutation, DeletePaymentTermMutationVariables>;
export const RestorePaymentTermDocument = gql`
    mutation RestorePaymentTerm($id: ID!) {
  restorePaymentTerm(id: $id) {
    id
    discardedAt
  }
}
    `;
export type RestorePaymentTermMutationFn = Apollo.MutationFunction<RestorePaymentTermMutation, RestorePaymentTermMutationVariables>;

/**
 * __useRestorePaymentTermMutation__
 *
 * To run a mutation, you first call `useRestorePaymentTermMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestorePaymentTermMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restorePaymentTermMutation, { data, loading, error }] = useRestorePaymentTermMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestorePaymentTermMutation(baseOptions?: Apollo.MutationHookOptions<RestorePaymentTermMutation, RestorePaymentTermMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestorePaymentTermMutation, RestorePaymentTermMutationVariables>(RestorePaymentTermDocument, options);
      }
export type RestorePaymentTermMutationHookResult = ReturnType<typeof useRestorePaymentTermMutation>;
export type RestorePaymentTermMutationResult = Apollo.MutationResult<RestorePaymentTermMutation>;
export type RestorePaymentTermMutationOptions = Apollo.BaseMutationOptions<RestorePaymentTermMutation, RestorePaymentTermMutationVariables>;
export const CreatePositionDocument = gql`
    mutation CreatePosition($input: PositionInput!) {
  createPosition(input: $input) {
    id
  }
}
    `;
export type CreatePositionMutationFn = Apollo.MutationFunction<CreatePositionMutation, CreatePositionMutationVariables>;

/**
 * __useCreatePositionMutation__
 *
 * To run a mutation, you first call `useCreatePositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPositionMutation, { data, loading, error }] = useCreatePositionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePositionMutation(baseOptions?: Apollo.MutationHookOptions<CreatePositionMutation, CreatePositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePositionMutation, CreatePositionMutationVariables>(CreatePositionDocument, options);
      }
export type CreatePositionMutationHookResult = ReturnType<typeof useCreatePositionMutation>;
export type CreatePositionMutationResult = Apollo.MutationResult<CreatePositionMutation>;
export type CreatePositionMutationOptions = Apollo.BaseMutationOptions<CreatePositionMutation, CreatePositionMutationVariables>;
export const MaximumPositionSequenceDocument = gql`
    query MaximumPositionSequence {
  positions {
    maximumPositionSequence
  }
}
    `;

/**
 * __useMaximumPositionSequenceQuery__
 *
 * To run a query within a React component, call `useMaximumPositionSequenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaximumPositionSequenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaximumPositionSequenceQuery({
 *   variables: {
 *   },
 * });
 */
export function useMaximumPositionSequenceQuery(baseOptions?: Apollo.QueryHookOptions<MaximumPositionSequenceQuery, MaximumPositionSequenceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaximumPositionSequenceQuery, MaximumPositionSequenceQueryVariables>(MaximumPositionSequenceDocument, options);
      }
export function useMaximumPositionSequenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaximumPositionSequenceQuery, MaximumPositionSequenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaximumPositionSequenceQuery, MaximumPositionSequenceQueryVariables>(MaximumPositionSequenceDocument, options);
        }
export type MaximumPositionSequenceQueryHookResult = ReturnType<typeof useMaximumPositionSequenceQuery>;
export type MaximumPositionSequenceLazyQueryHookResult = ReturnType<typeof useMaximumPositionSequenceLazyQuery>;
export type MaximumPositionSequenceQueryResult = Apollo.QueryResult<MaximumPositionSequenceQuery, MaximumPositionSequenceQueryVariables>;
export const PositionDocument = gql`
    query Position($id: ID!) {
  position(id: $id) {
    id
    name: nameWithoutFallback
    altNameTranslations
    isLawyer
    sequence
  }
}
    `;

/**
 * __usePositionQuery__
 *
 * To run a query within a React component, call `usePositionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePositionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePositionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePositionQuery(baseOptions: Apollo.QueryHookOptions<PositionQuery, PositionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PositionQuery, PositionQueryVariables>(PositionDocument, options);
      }
export function usePositionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PositionQuery, PositionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PositionQuery, PositionQueryVariables>(PositionDocument, options);
        }
export type PositionQueryHookResult = ReturnType<typeof usePositionQuery>;
export type PositionLazyQueryHookResult = ReturnType<typeof usePositionLazyQuery>;
export type PositionQueryResult = Apollo.QueryResult<PositionQuery, PositionQueryVariables>;
export const UpdatePositionDocument = gql`
    mutation UpdatePosition($id: ID!, $input: PositionInput!) {
  updatePosition(id: $id, input: $input) {
    id
    name: nameWithoutFallback
    altNameTranslations
    isLawyer
    sequence
  }
}
    `;
export type UpdatePositionMutationFn = Apollo.MutationFunction<UpdatePositionMutation, UpdatePositionMutationVariables>;

/**
 * __useUpdatePositionMutation__
 *
 * To run a mutation, you first call `useUpdatePositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePositionMutation, { data, loading, error }] = useUpdatePositionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePositionMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePositionMutation, UpdatePositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePositionMutation, UpdatePositionMutationVariables>(UpdatePositionDocument, options);
      }
export type UpdatePositionMutationHookResult = ReturnType<typeof useUpdatePositionMutation>;
export type UpdatePositionMutationResult = Apollo.MutationResult<UpdatePositionMutation>;
export type UpdatePositionMutationOptions = Apollo.BaseMutationOptions<UpdatePositionMutation, UpdatePositionMutationVariables>;
export const PositionsDocument = gql`
    query Positions($order: String, $descending: Boolean, $after: String, $first: Int, $search: String, $filter: PositionFilterInput, $active: Boolean) {
  positions(
    order: $order
    descending: $descending
    after: $after
    first: $first
    search: $search
    filter: $filter
    active: $active
  ) {
    nodes {
      id
      name
      isLawyer
      createdAt
      updatedAt
      discardedAt
      sequence
    }
    totalCount
  }
}
    `;

/**
 * __usePositionsQuery__
 *
 * To run a query within a React component, call `usePositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePositionsQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      active: // value for 'active'
 *   },
 * });
 */
export function usePositionsQuery(baseOptions?: Apollo.QueryHookOptions<PositionsQuery, PositionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PositionsQuery, PositionsQueryVariables>(PositionsDocument, options);
      }
export function usePositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PositionsQuery, PositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PositionsQuery, PositionsQueryVariables>(PositionsDocument, options);
        }
export type PositionsQueryHookResult = ReturnType<typeof usePositionsQuery>;
export type PositionsLazyQueryHookResult = ReturnType<typeof usePositionsLazyQuery>;
export type PositionsQueryResult = Apollo.QueryResult<PositionsQuery, PositionsQueryVariables>;
export const AutocompletePositionsDocument = gql`
    query AutocompletePositions($search: String, $filter: PositionFilterInput) {
  positions(search: $search, filter: $filter) {
    nodes {
      id
      name
    }
  }
}
    `;

/**
 * __useAutocompletePositionsQuery__
 *
 * To run a query within a React component, call `useAutocompletePositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompletePositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompletePositionsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAutocompletePositionsQuery(baseOptions?: Apollo.QueryHookOptions<AutocompletePositionsQuery, AutocompletePositionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompletePositionsQuery, AutocompletePositionsQueryVariables>(AutocompletePositionsDocument, options);
      }
export function useAutocompletePositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompletePositionsQuery, AutocompletePositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompletePositionsQuery, AutocompletePositionsQueryVariables>(AutocompletePositionsDocument, options);
        }
export type AutocompletePositionsQueryHookResult = ReturnType<typeof useAutocompletePositionsQuery>;
export type AutocompletePositionsLazyQueryHookResult = ReturnType<typeof useAutocompletePositionsLazyQuery>;
export type AutocompletePositionsQueryResult = Apollo.QueryResult<AutocompletePositionsQuery, AutocompletePositionsQueryVariables>;
export const DeletePositionDocument = gql`
    mutation DeletePosition($id: ID!) {
  deletePosition(id: $id)
}
    `;
export type DeletePositionMutationFn = Apollo.MutationFunction<DeletePositionMutation, DeletePositionMutationVariables>;

/**
 * __useDeletePositionMutation__
 *
 * To run a mutation, you first call `useDeletePositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePositionMutation, { data, loading, error }] = useDeletePositionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePositionMutation(baseOptions?: Apollo.MutationHookOptions<DeletePositionMutation, DeletePositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePositionMutation, DeletePositionMutationVariables>(DeletePositionDocument, options);
      }
export type DeletePositionMutationHookResult = ReturnType<typeof useDeletePositionMutation>;
export type DeletePositionMutationResult = Apollo.MutationResult<DeletePositionMutation>;
export type DeletePositionMutationOptions = Apollo.BaseMutationOptions<DeletePositionMutation, DeletePositionMutationVariables>;
export const RestorePositionDocument = gql`
    mutation RestorePosition($id: ID!) {
  restorePosition(id: $id) {
    id
    discardedAt
  }
}
    `;
export type RestorePositionMutationFn = Apollo.MutationFunction<RestorePositionMutation, RestorePositionMutationVariables>;

/**
 * __useRestorePositionMutation__
 *
 * To run a mutation, you first call `useRestorePositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestorePositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restorePositionMutation, { data, loading, error }] = useRestorePositionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestorePositionMutation(baseOptions?: Apollo.MutationHookOptions<RestorePositionMutation, RestorePositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestorePositionMutation, RestorePositionMutationVariables>(RestorePositionDocument, options);
      }
export type RestorePositionMutationHookResult = ReturnType<typeof useRestorePositionMutation>;
export type RestorePositionMutationResult = Apollo.MutationResult<RestorePositionMutation>;
export type RestorePositionMutationOptions = Apollo.BaseMutationOptions<RestorePositionMutation, RestorePositionMutationVariables>;
export const CreatePracticeAreaDocument = gql`
    mutation CreatePracticeArea($input: PracticeAreaInput!) {
  createPracticeArea(input: $input) {
    id
  }
}
    `;
export type CreatePracticeAreaMutationFn = Apollo.MutationFunction<CreatePracticeAreaMutation, CreatePracticeAreaMutationVariables>;

/**
 * __useCreatePracticeAreaMutation__
 *
 * To run a mutation, you first call `useCreatePracticeAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePracticeAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPracticeAreaMutation, { data, loading, error }] = useCreatePracticeAreaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePracticeAreaMutation(baseOptions?: Apollo.MutationHookOptions<CreatePracticeAreaMutation, CreatePracticeAreaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePracticeAreaMutation, CreatePracticeAreaMutationVariables>(CreatePracticeAreaDocument, options);
      }
export type CreatePracticeAreaMutationHookResult = ReturnType<typeof useCreatePracticeAreaMutation>;
export type CreatePracticeAreaMutationResult = Apollo.MutationResult<CreatePracticeAreaMutation>;
export type CreatePracticeAreaMutationOptions = Apollo.BaseMutationOptions<CreatePracticeAreaMutation, CreatePracticeAreaMutationVariables>;
export const PracticeAreaDocument = gql`
    query PracticeArea($id: ID!) {
  practiceArea(id: $id) {
    id
    name: nameWithoutFallback
    altNameTranslations
  }
}
    `;

/**
 * __usePracticeAreaQuery__
 *
 * To run a query within a React component, call `usePracticeAreaQuery` and pass it any options that fit your needs.
 * When your component renders, `usePracticeAreaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePracticeAreaQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePracticeAreaQuery(baseOptions: Apollo.QueryHookOptions<PracticeAreaQuery, PracticeAreaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PracticeAreaQuery, PracticeAreaQueryVariables>(PracticeAreaDocument, options);
      }
export function usePracticeAreaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PracticeAreaQuery, PracticeAreaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PracticeAreaQuery, PracticeAreaQueryVariables>(PracticeAreaDocument, options);
        }
export type PracticeAreaQueryHookResult = ReturnType<typeof usePracticeAreaQuery>;
export type PracticeAreaLazyQueryHookResult = ReturnType<typeof usePracticeAreaLazyQuery>;
export type PracticeAreaQueryResult = Apollo.QueryResult<PracticeAreaQuery, PracticeAreaQueryVariables>;
export const UpdatePracticeAreaDocument = gql`
    mutation UpdatePracticeArea($id: ID!, $input: PracticeAreaInput!) {
  updatePracticeArea(id: $id, input: $input) {
    id
    name: nameWithoutFallback
    altNameTranslations
  }
}
    `;
export type UpdatePracticeAreaMutationFn = Apollo.MutationFunction<UpdatePracticeAreaMutation, UpdatePracticeAreaMutationVariables>;

/**
 * __useUpdatePracticeAreaMutation__
 *
 * To run a mutation, you first call `useUpdatePracticeAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePracticeAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePracticeAreaMutation, { data, loading, error }] = useUpdatePracticeAreaMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePracticeAreaMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePracticeAreaMutation, UpdatePracticeAreaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePracticeAreaMutation, UpdatePracticeAreaMutationVariables>(UpdatePracticeAreaDocument, options);
      }
export type UpdatePracticeAreaMutationHookResult = ReturnType<typeof useUpdatePracticeAreaMutation>;
export type UpdatePracticeAreaMutationResult = Apollo.MutationResult<UpdatePracticeAreaMutation>;
export type UpdatePracticeAreaMutationOptions = Apollo.BaseMutationOptions<UpdatePracticeAreaMutation, UpdatePracticeAreaMutationVariables>;
export const PracticeAreasDocument = gql`
    query PracticeAreas($order: String, $descending: Boolean, $after: String, $first: Int, $search: String, $active: Boolean) {
  practiceAreas(
    order: $order
    descending: $descending
    after: $after
    first: $first
    search: $search
    active: $active
  ) {
    nodes {
      id
      name
      createdAt
      updatedAt
      discardedAt
    }
    totalCount
  }
}
    `;

/**
 * __usePracticeAreasQuery__
 *
 * To run a query within a React component, call `usePracticeAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `usePracticeAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePracticeAreasQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      search: // value for 'search'
 *      active: // value for 'active'
 *   },
 * });
 */
export function usePracticeAreasQuery(baseOptions?: Apollo.QueryHookOptions<PracticeAreasQuery, PracticeAreasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PracticeAreasQuery, PracticeAreasQueryVariables>(PracticeAreasDocument, options);
      }
export function usePracticeAreasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PracticeAreasQuery, PracticeAreasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PracticeAreasQuery, PracticeAreasQueryVariables>(PracticeAreasDocument, options);
        }
export type PracticeAreasQueryHookResult = ReturnType<typeof usePracticeAreasQuery>;
export type PracticeAreasLazyQueryHookResult = ReturnType<typeof usePracticeAreasLazyQuery>;
export type PracticeAreasQueryResult = Apollo.QueryResult<PracticeAreasQuery, PracticeAreasQueryVariables>;
export const AutocompletePracticeAreasDocument = gql`
    query AutocompletePracticeAreas($search: String) {
  practiceAreas(search: $search) {
    nodes {
      id
      name
    }
  }
}
    `;

/**
 * __useAutocompletePracticeAreasQuery__
 *
 * To run a query within a React component, call `useAutocompletePracticeAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompletePracticeAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompletePracticeAreasQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAutocompletePracticeAreasQuery(baseOptions?: Apollo.QueryHookOptions<AutocompletePracticeAreasQuery, AutocompletePracticeAreasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompletePracticeAreasQuery, AutocompletePracticeAreasQueryVariables>(AutocompletePracticeAreasDocument, options);
      }
export function useAutocompletePracticeAreasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompletePracticeAreasQuery, AutocompletePracticeAreasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompletePracticeAreasQuery, AutocompletePracticeAreasQueryVariables>(AutocompletePracticeAreasDocument, options);
        }
export type AutocompletePracticeAreasQueryHookResult = ReturnType<typeof useAutocompletePracticeAreasQuery>;
export type AutocompletePracticeAreasLazyQueryHookResult = ReturnType<typeof useAutocompletePracticeAreasLazyQuery>;
export type AutocompletePracticeAreasQueryResult = Apollo.QueryResult<AutocompletePracticeAreasQuery, AutocompletePracticeAreasQueryVariables>;
export const DeletePracticeAreaDocument = gql`
    mutation DeletePracticeArea($id: ID!) {
  deletePracticeArea(id: $id)
}
    `;
export type DeletePracticeAreaMutationFn = Apollo.MutationFunction<DeletePracticeAreaMutation, DeletePracticeAreaMutationVariables>;

/**
 * __useDeletePracticeAreaMutation__
 *
 * To run a mutation, you first call `useDeletePracticeAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePracticeAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePracticeAreaMutation, { data, loading, error }] = useDeletePracticeAreaMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePracticeAreaMutation(baseOptions?: Apollo.MutationHookOptions<DeletePracticeAreaMutation, DeletePracticeAreaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePracticeAreaMutation, DeletePracticeAreaMutationVariables>(DeletePracticeAreaDocument, options);
      }
export type DeletePracticeAreaMutationHookResult = ReturnType<typeof useDeletePracticeAreaMutation>;
export type DeletePracticeAreaMutationResult = Apollo.MutationResult<DeletePracticeAreaMutation>;
export type DeletePracticeAreaMutationOptions = Apollo.BaseMutationOptions<DeletePracticeAreaMutation, DeletePracticeAreaMutationVariables>;
export const RestorePracticeAreaDocument = gql`
    mutation RestorePracticeArea($id: ID!) {
  restorePracticeArea(id: $id) {
    id
    discardedAt
  }
}
    `;
export type RestorePracticeAreaMutationFn = Apollo.MutationFunction<RestorePracticeAreaMutation, RestorePracticeAreaMutationVariables>;

/**
 * __useRestorePracticeAreaMutation__
 *
 * To run a mutation, you first call `useRestorePracticeAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestorePracticeAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restorePracticeAreaMutation, { data, loading, error }] = useRestorePracticeAreaMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestorePracticeAreaMutation(baseOptions?: Apollo.MutationHookOptions<RestorePracticeAreaMutation, RestorePracticeAreaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestorePracticeAreaMutation, RestorePracticeAreaMutationVariables>(RestorePracticeAreaDocument, options);
      }
export type RestorePracticeAreaMutationHookResult = ReturnType<typeof useRestorePracticeAreaMutation>;
export type RestorePracticeAreaMutationResult = Apollo.MutationResult<RestorePracticeAreaMutation>;
export type RestorePracticeAreaMutationOptions = Apollo.BaseMutationOptions<RestorePracticeAreaMutation, RestorePracticeAreaMutationVariables>;
export const CreateUserCostTypeDocument = gql`
    mutation CreateUserCostType($input: UserCostTypeInput!) {
  createUserCostType(input: $input) {
    id
  }
}
    `;
export type CreateUserCostTypeMutationFn = Apollo.MutationFunction<CreateUserCostTypeMutation, CreateUserCostTypeMutationVariables>;

/**
 * __useCreateUserCostTypeMutation__
 *
 * To run a mutation, you first call `useCreateUserCostTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserCostTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserCostTypeMutation, { data, loading, error }] = useCreateUserCostTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserCostTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserCostTypeMutation, CreateUserCostTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserCostTypeMutation, CreateUserCostTypeMutationVariables>(CreateUserCostTypeDocument, options);
      }
export type CreateUserCostTypeMutationHookResult = ReturnType<typeof useCreateUserCostTypeMutation>;
export type CreateUserCostTypeMutationResult = Apollo.MutationResult<CreateUserCostTypeMutation>;
export type CreateUserCostTypeMutationOptions = Apollo.BaseMutationOptions<CreateUserCostTypeMutation, CreateUserCostTypeMutationVariables>;
export const UserCostTypeDocument = gql`
    query UserCostType($id: ID!) {
  userCostType(id: $id) {
    id
    name: nameWithoutFallback
    altNameTranslations
  }
}
    `;

/**
 * __useUserCostTypeQuery__
 *
 * To run a query within a React component, call `useUserCostTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCostTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCostTypeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserCostTypeQuery(baseOptions: Apollo.QueryHookOptions<UserCostTypeQuery, UserCostTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserCostTypeQuery, UserCostTypeQueryVariables>(UserCostTypeDocument, options);
      }
export function useUserCostTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserCostTypeQuery, UserCostTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserCostTypeQuery, UserCostTypeQueryVariables>(UserCostTypeDocument, options);
        }
export type UserCostTypeQueryHookResult = ReturnType<typeof useUserCostTypeQuery>;
export type UserCostTypeLazyQueryHookResult = ReturnType<typeof useUserCostTypeLazyQuery>;
export type UserCostTypeQueryResult = Apollo.QueryResult<UserCostTypeQuery, UserCostTypeQueryVariables>;
export const UpdateUserCostTypeDocument = gql`
    mutation UpdateUserCostType($id: ID!, $input: UserCostTypeInput!) {
  updateUserCostType(id: $id, input: $input) {
    id
    name: nameWithoutFallback
    altNameTranslations
  }
}
    `;
export type UpdateUserCostTypeMutationFn = Apollo.MutationFunction<UpdateUserCostTypeMutation, UpdateUserCostTypeMutationVariables>;

/**
 * __useUpdateUserCostTypeMutation__
 *
 * To run a mutation, you first call `useUpdateUserCostTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserCostTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserCostTypeMutation, { data, loading, error }] = useUpdateUserCostTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserCostTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserCostTypeMutation, UpdateUserCostTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserCostTypeMutation, UpdateUserCostTypeMutationVariables>(UpdateUserCostTypeDocument, options);
      }
export type UpdateUserCostTypeMutationHookResult = ReturnType<typeof useUpdateUserCostTypeMutation>;
export type UpdateUserCostTypeMutationResult = Apollo.MutationResult<UpdateUserCostTypeMutation>;
export type UpdateUserCostTypeMutationOptions = Apollo.BaseMutationOptions<UpdateUserCostTypeMutation, UpdateUserCostTypeMutationVariables>;
export const UserCostTypesDocument = gql`
    query UserCostTypes($order: String, $descending: Boolean, $after: String, $first: Int, $search: String, $active: Boolean) {
  userCostTypes(
    order: $order
    descending: $descending
    after: $after
    first: $first
    search: $search
    active: $active
  ) {
    nodes {
      id
      name
      createdAt
      updatedAt
      discardedAt
    }
    totalCount
  }
}
    `;

/**
 * __useUserCostTypesQuery__
 *
 * To run a query within a React component, call `useUserCostTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCostTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCostTypesQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      search: // value for 'search'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useUserCostTypesQuery(baseOptions?: Apollo.QueryHookOptions<UserCostTypesQuery, UserCostTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserCostTypesQuery, UserCostTypesQueryVariables>(UserCostTypesDocument, options);
      }
export function useUserCostTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserCostTypesQuery, UserCostTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserCostTypesQuery, UserCostTypesQueryVariables>(UserCostTypesDocument, options);
        }
export type UserCostTypesQueryHookResult = ReturnType<typeof useUserCostTypesQuery>;
export type UserCostTypesLazyQueryHookResult = ReturnType<typeof useUserCostTypesLazyQuery>;
export type UserCostTypesQueryResult = Apollo.QueryResult<UserCostTypesQuery, UserCostTypesQueryVariables>;
export const AutocompleteUserCostTypesDocument = gql`
    query AutocompleteUserCostTypes($search: String) {
  userCostTypes(search: $search) {
    nodes {
      id
      name
    }
  }
}
    `;

/**
 * __useAutocompleteUserCostTypesQuery__
 *
 * To run a query within a React component, call `useAutocompleteUserCostTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteUserCostTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteUserCostTypesQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAutocompleteUserCostTypesQuery(baseOptions?: Apollo.QueryHookOptions<AutocompleteUserCostTypesQuery, AutocompleteUserCostTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompleteUserCostTypesQuery, AutocompleteUserCostTypesQueryVariables>(AutocompleteUserCostTypesDocument, options);
      }
export function useAutocompleteUserCostTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompleteUserCostTypesQuery, AutocompleteUserCostTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompleteUserCostTypesQuery, AutocompleteUserCostTypesQueryVariables>(AutocompleteUserCostTypesDocument, options);
        }
export type AutocompleteUserCostTypesQueryHookResult = ReturnType<typeof useAutocompleteUserCostTypesQuery>;
export type AutocompleteUserCostTypesLazyQueryHookResult = ReturnType<typeof useAutocompleteUserCostTypesLazyQuery>;
export type AutocompleteUserCostTypesQueryResult = Apollo.QueryResult<AutocompleteUserCostTypesQuery, AutocompleteUserCostTypesQueryVariables>;
export const DeleteUserCostTypeDocument = gql`
    mutation DeleteUserCostType($id: ID!) {
  deleteUserCostType(id: $id)
}
    `;
export type DeleteUserCostTypeMutationFn = Apollo.MutationFunction<DeleteUserCostTypeMutation, DeleteUserCostTypeMutationVariables>;

/**
 * __useDeleteUserCostTypeMutation__
 *
 * To run a mutation, you first call `useDeleteUserCostTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserCostTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserCostTypeMutation, { data, loading, error }] = useDeleteUserCostTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserCostTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserCostTypeMutation, DeleteUserCostTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserCostTypeMutation, DeleteUserCostTypeMutationVariables>(DeleteUserCostTypeDocument, options);
      }
export type DeleteUserCostTypeMutationHookResult = ReturnType<typeof useDeleteUserCostTypeMutation>;
export type DeleteUserCostTypeMutationResult = Apollo.MutationResult<DeleteUserCostTypeMutation>;
export type DeleteUserCostTypeMutationOptions = Apollo.BaseMutationOptions<DeleteUserCostTypeMutation, DeleteUserCostTypeMutationVariables>;
export const RestoreUserCostTypeDocument = gql`
    mutation RestoreUserCostType($id: ID!) {
  restoreUserCostType(id: $id) {
    id
    discardedAt
  }
}
    `;
export type RestoreUserCostTypeMutationFn = Apollo.MutationFunction<RestoreUserCostTypeMutation, RestoreUserCostTypeMutationVariables>;

/**
 * __useRestoreUserCostTypeMutation__
 *
 * To run a mutation, you first call `useRestoreUserCostTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreUserCostTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreUserCostTypeMutation, { data, loading, error }] = useRestoreUserCostTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreUserCostTypeMutation(baseOptions?: Apollo.MutationHookOptions<RestoreUserCostTypeMutation, RestoreUserCostTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreUserCostTypeMutation, RestoreUserCostTypeMutationVariables>(RestoreUserCostTypeDocument, options);
      }
export type RestoreUserCostTypeMutationHookResult = ReturnType<typeof useRestoreUserCostTypeMutation>;
export type RestoreUserCostTypeMutationResult = Apollo.MutationResult<RestoreUserCostTypeMutation>;
export type RestoreUserCostTypeMutationOptions = Apollo.BaseMutationOptions<RestoreUserCostTypeMutation, RestoreUserCostTypeMutationVariables>;
export const CreateUserNoteCategoryDocument = gql`
    mutation CreateUserNoteCategory($input: UserNoteCategoryInput!) {
  createUserNoteCategory(input: $input) {
    id
  }
}
    `;
export type CreateUserNoteCategoryMutationFn = Apollo.MutationFunction<CreateUserNoteCategoryMutation, CreateUserNoteCategoryMutationVariables>;

/**
 * __useCreateUserNoteCategoryMutation__
 *
 * To run a mutation, you first call `useCreateUserNoteCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserNoteCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserNoteCategoryMutation, { data, loading, error }] = useCreateUserNoteCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserNoteCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserNoteCategoryMutation, CreateUserNoteCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserNoteCategoryMutation, CreateUserNoteCategoryMutationVariables>(CreateUserNoteCategoryDocument, options);
      }
export type CreateUserNoteCategoryMutationHookResult = ReturnType<typeof useCreateUserNoteCategoryMutation>;
export type CreateUserNoteCategoryMutationResult = Apollo.MutationResult<CreateUserNoteCategoryMutation>;
export type CreateUserNoteCategoryMutationOptions = Apollo.BaseMutationOptions<CreateUserNoteCategoryMutation, CreateUserNoteCategoryMutationVariables>;
export const UserNoteCategoryDocument = gql`
    query UserNoteCategory($id: ID!) {
  userNoteCategory(id: $id) {
    id
    name: nameWithoutFallback
    altNameTranslations
    invoiceApprovalSpecific
    isMatterStatus
  }
}
    `;

/**
 * __useUserNoteCategoryQuery__
 *
 * To run a query within a React component, call `useUserNoteCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserNoteCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNoteCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserNoteCategoryQuery(baseOptions: Apollo.QueryHookOptions<UserNoteCategoryQuery, UserNoteCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserNoteCategoryQuery, UserNoteCategoryQueryVariables>(UserNoteCategoryDocument, options);
      }
export function useUserNoteCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserNoteCategoryQuery, UserNoteCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserNoteCategoryQuery, UserNoteCategoryQueryVariables>(UserNoteCategoryDocument, options);
        }
export type UserNoteCategoryQueryHookResult = ReturnType<typeof useUserNoteCategoryQuery>;
export type UserNoteCategoryLazyQueryHookResult = ReturnType<typeof useUserNoteCategoryLazyQuery>;
export type UserNoteCategoryQueryResult = Apollo.QueryResult<UserNoteCategoryQuery, UserNoteCategoryQueryVariables>;
export const UpdateUserNoteCategoryDocument = gql`
    mutation UpdateUserNoteCategory($id: ID!, $input: UserNoteCategoryInput!) {
  updateUserNoteCategory(id: $id, input: $input) {
    id
    name: nameWithoutFallback
    altNameTranslations
    invoiceApprovalSpecific
    isMatterStatus
  }
}
    `;
export type UpdateUserNoteCategoryMutationFn = Apollo.MutationFunction<UpdateUserNoteCategoryMutation, UpdateUserNoteCategoryMutationVariables>;

/**
 * __useUpdateUserNoteCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateUserNoteCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserNoteCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserNoteCategoryMutation, { data, loading, error }] = useUpdateUserNoteCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserNoteCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserNoteCategoryMutation, UpdateUserNoteCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserNoteCategoryMutation, UpdateUserNoteCategoryMutationVariables>(UpdateUserNoteCategoryDocument, options);
      }
export type UpdateUserNoteCategoryMutationHookResult = ReturnType<typeof useUpdateUserNoteCategoryMutation>;
export type UpdateUserNoteCategoryMutationResult = Apollo.MutationResult<UpdateUserNoteCategoryMutation>;
export type UpdateUserNoteCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateUserNoteCategoryMutation, UpdateUserNoteCategoryMutationVariables>;
export const UserNoteCategoriesDocument = gql`
    query UserNoteCategories($order: String, $descending: Boolean, $after: String, $first: Int, $search: String, $active: Boolean, $filter: UserNoteCategoryFilterInput) {
  userNoteCategories(
    order: $order
    descending: $descending
    after: $after
    first: $first
    search: $search
    active: $active
    filter: $filter
  ) {
    nodes {
      id
      name
      createdAt
      updatedAt
      discardedAt
      invoiceApprovalSpecific
      isMatterStatus
    }
    totalCount
  }
}
    `;

/**
 * __useUserNoteCategoriesQuery__
 *
 * To run a query within a React component, call `useUserNoteCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserNoteCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNoteCategoriesQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      search: // value for 'search'
 *      active: // value for 'active'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUserNoteCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<UserNoteCategoriesQuery, UserNoteCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserNoteCategoriesQuery, UserNoteCategoriesQueryVariables>(UserNoteCategoriesDocument, options);
      }
export function useUserNoteCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserNoteCategoriesQuery, UserNoteCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserNoteCategoriesQuery, UserNoteCategoriesQueryVariables>(UserNoteCategoriesDocument, options);
        }
export type UserNoteCategoriesQueryHookResult = ReturnType<typeof useUserNoteCategoriesQuery>;
export type UserNoteCategoriesLazyQueryHookResult = ReturnType<typeof useUserNoteCategoriesLazyQuery>;
export type UserNoteCategoriesQueryResult = Apollo.QueryResult<UserNoteCategoriesQuery, UserNoteCategoriesQueryVariables>;
export const AutocompleteUserNoteCategoriesDocument = gql`
    query AutocompleteUserNoteCategories($search: String, $filter: UserNoteCategoryFilterInput) {
  userNoteCategories(search: $search, filter: $filter) {
    nodes {
      id
      name
    }
  }
}
    `;

/**
 * __useAutocompleteUserNoteCategoriesQuery__
 *
 * To run a query within a React component, call `useAutocompleteUserNoteCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteUserNoteCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteUserNoteCategoriesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAutocompleteUserNoteCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<AutocompleteUserNoteCategoriesQuery, AutocompleteUserNoteCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompleteUserNoteCategoriesQuery, AutocompleteUserNoteCategoriesQueryVariables>(AutocompleteUserNoteCategoriesDocument, options);
      }
export function useAutocompleteUserNoteCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompleteUserNoteCategoriesQuery, AutocompleteUserNoteCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompleteUserNoteCategoriesQuery, AutocompleteUserNoteCategoriesQueryVariables>(AutocompleteUserNoteCategoriesDocument, options);
        }
export type AutocompleteUserNoteCategoriesQueryHookResult = ReturnType<typeof useAutocompleteUserNoteCategoriesQuery>;
export type AutocompleteUserNoteCategoriesLazyQueryHookResult = ReturnType<typeof useAutocompleteUserNoteCategoriesLazyQuery>;
export type AutocompleteUserNoteCategoriesQueryResult = Apollo.QueryResult<AutocompleteUserNoteCategoriesQuery, AutocompleteUserNoteCategoriesQueryVariables>;
export const DeleteUserNoteCategoryDocument = gql`
    mutation DeleteUserNoteCategory($id: ID!) {
  deleteUserNoteCategory(id: $id)
}
    `;
export type DeleteUserNoteCategoryMutationFn = Apollo.MutationFunction<DeleteUserNoteCategoryMutation, DeleteUserNoteCategoryMutationVariables>;

/**
 * __useDeleteUserNoteCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteUserNoteCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserNoteCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserNoteCategoryMutation, { data, loading, error }] = useDeleteUserNoteCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserNoteCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserNoteCategoryMutation, DeleteUserNoteCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserNoteCategoryMutation, DeleteUserNoteCategoryMutationVariables>(DeleteUserNoteCategoryDocument, options);
      }
export type DeleteUserNoteCategoryMutationHookResult = ReturnType<typeof useDeleteUserNoteCategoryMutation>;
export type DeleteUserNoteCategoryMutationResult = Apollo.MutationResult<DeleteUserNoteCategoryMutation>;
export type DeleteUserNoteCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteUserNoteCategoryMutation, DeleteUserNoteCategoryMutationVariables>;
export const RestoreUserNoteCategoryDocument = gql`
    mutation RestoreUserNoteCategory($id: ID!) {
  restoreUserNoteCategory(id: $id) {
    id
    discardedAt
  }
}
    `;
export type RestoreUserNoteCategoryMutationFn = Apollo.MutationFunction<RestoreUserNoteCategoryMutation, RestoreUserNoteCategoryMutationVariables>;

/**
 * __useRestoreUserNoteCategoryMutation__
 *
 * To run a mutation, you first call `useRestoreUserNoteCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreUserNoteCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreUserNoteCategoryMutation, { data, loading, error }] = useRestoreUserNoteCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreUserNoteCategoryMutation(baseOptions?: Apollo.MutationHookOptions<RestoreUserNoteCategoryMutation, RestoreUserNoteCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreUserNoteCategoryMutation, RestoreUserNoteCategoryMutationVariables>(RestoreUserNoteCategoryDocument, options);
      }
export type RestoreUserNoteCategoryMutationHookResult = ReturnType<typeof useRestoreUserNoteCategoryMutation>;
export type RestoreUserNoteCategoryMutationResult = Apollo.MutationResult<RestoreUserNoteCategoryMutation>;
export type RestoreUserNoteCategoryMutationOptions = Apollo.BaseMutationOptions<RestoreUserNoteCategoryMutation, RestoreUserNoteCategoryMutationVariables>;
export const CreateVatPercentageDocument = gql`
    mutation CreateVatPercentage($input: VatPercentageInput!) {
  createVatPercentage(input: $input) {
    id
  }
}
    `;
export type CreateVatPercentageMutationFn = Apollo.MutationFunction<CreateVatPercentageMutation, CreateVatPercentageMutationVariables>;

/**
 * __useCreateVatPercentageMutation__
 *
 * To run a mutation, you first call `useCreateVatPercentageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVatPercentageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVatPercentageMutation, { data, loading, error }] = useCreateVatPercentageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVatPercentageMutation(baseOptions?: Apollo.MutationHookOptions<CreateVatPercentageMutation, CreateVatPercentageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVatPercentageMutation, CreateVatPercentageMutationVariables>(CreateVatPercentageDocument, options);
      }
export type CreateVatPercentageMutationHookResult = ReturnType<typeof useCreateVatPercentageMutation>;
export type CreateVatPercentageMutationResult = Apollo.MutationResult<CreateVatPercentageMutation>;
export type CreateVatPercentageMutationOptions = Apollo.BaseMutationOptions<CreateVatPercentageMutation, CreateVatPercentageMutationVariables>;
export const VatPercentageDocument = gql`
    query VatPercentage($id: ID!) {
  vatPercentage(id: $id) {
    id
    percentage
    location
    noticeTranslations
  }
}
    `;

/**
 * __useVatPercentageQuery__
 *
 * To run a query within a React component, call `useVatPercentageQuery` and pass it any options that fit your needs.
 * When your component renders, `useVatPercentageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVatPercentageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVatPercentageQuery(baseOptions: Apollo.QueryHookOptions<VatPercentageQuery, VatPercentageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VatPercentageQuery, VatPercentageQueryVariables>(VatPercentageDocument, options);
      }
export function useVatPercentageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VatPercentageQuery, VatPercentageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VatPercentageQuery, VatPercentageQueryVariables>(VatPercentageDocument, options);
        }
export type VatPercentageQueryHookResult = ReturnType<typeof useVatPercentageQuery>;
export type VatPercentageLazyQueryHookResult = ReturnType<typeof useVatPercentageLazyQuery>;
export type VatPercentageQueryResult = Apollo.QueryResult<VatPercentageQuery, VatPercentageQueryVariables>;
export const UpdateVatPercentageDocument = gql`
    mutation UpdateVatPercentage($id: ID!, $input: VatPercentageInput!) {
  updateVatPercentage(id: $id, input: $input) {
    id
    percentage
    location
    noticeTranslations
  }
}
    `;
export type UpdateVatPercentageMutationFn = Apollo.MutationFunction<UpdateVatPercentageMutation, UpdateVatPercentageMutationVariables>;

/**
 * __useUpdateVatPercentageMutation__
 *
 * To run a mutation, you first call `useUpdateVatPercentageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVatPercentageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVatPercentageMutation, { data, loading, error }] = useUpdateVatPercentageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVatPercentageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVatPercentageMutation, UpdateVatPercentageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVatPercentageMutation, UpdateVatPercentageMutationVariables>(UpdateVatPercentageDocument, options);
      }
export type UpdateVatPercentageMutationHookResult = ReturnType<typeof useUpdateVatPercentageMutation>;
export type UpdateVatPercentageMutationResult = Apollo.MutationResult<UpdateVatPercentageMutation>;
export type UpdateVatPercentageMutationOptions = Apollo.BaseMutationOptions<UpdateVatPercentageMutation, UpdateVatPercentageMutationVariables>;
export const VatPercentagesDocument = gql`
    query VatPercentages($order: String, $descending: Boolean, $after: String, $first: Int, $search: String, $active: Boolean) {
  vatPercentages(
    order: $order
    descending: $descending
    after: $after
    first: $first
    search: $search
    active: $active
  ) {
    nodes {
      id
      percentage
      location
      createdAt
      updatedAt
      discardedAt
    }
    totalCount
  }
}
    `;

/**
 * __useVatPercentagesQuery__
 *
 * To run a query within a React component, call `useVatPercentagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVatPercentagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVatPercentagesQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      search: // value for 'search'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useVatPercentagesQuery(baseOptions?: Apollo.QueryHookOptions<VatPercentagesQuery, VatPercentagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VatPercentagesQuery, VatPercentagesQueryVariables>(VatPercentagesDocument, options);
      }
export function useVatPercentagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VatPercentagesQuery, VatPercentagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VatPercentagesQuery, VatPercentagesQueryVariables>(VatPercentagesDocument, options);
        }
export type VatPercentagesQueryHookResult = ReturnType<typeof useVatPercentagesQuery>;
export type VatPercentagesLazyQueryHookResult = ReturnType<typeof useVatPercentagesLazyQuery>;
export type VatPercentagesQueryResult = Apollo.QueryResult<VatPercentagesQuery, VatPercentagesQueryVariables>;
export const AutocompleteVatPercentagesDocument = gql`
    query AutocompleteVatPercentages($search: String) {
  vatPercentages(search: $search) {
    nodes {
      id
      percentage
      location
    }
  }
}
    `;

/**
 * __useAutocompleteVatPercentagesQuery__
 *
 * To run a query within a React component, call `useAutocompleteVatPercentagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteVatPercentagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteVatPercentagesQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAutocompleteVatPercentagesQuery(baseOptions?: Apollo.QueryHookOptions<AutocompleteVatPercentagesQuery, AutocompleteVatPercentagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompleteVatPercentagesQuery, AutocompleteVatPercentagesQueryVariables>(AutocompleteVatPercentagesDocument, options);
      }
export function useAutocompleteVatPercentagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompleteVatPercentagesQuery, AutocompleteVatPercentagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompleteVatPercentagesQuery, AutocompleteVatPercentagesQueryVariables>(AutocompleteVatPercentagesDocument, options);
        }
export type AutocompleteVatPercentagesQueryHookResult = ReturnType<typeof useAutocompleteVatPercentagesQuery>;
export type AutocompleteVatPercentagesLazyQueryHookResult = ReturnType<typeof useAutocompleteVatPercentagesLazyQuery>;
export type AutocompleteVatPercentagesQueryResult = Apollo.QueryResult<AutocompleteVatPercentagesQuery, AutocompleteVatPercentagesQueryVariables>;
export const DeleteVatPercentageDocument = gql`
    mutation DeleteVatPercentage($id: ID!) {
  deleteVatPercentage(id: $id)
}
    `;
export type DeleteVatPercentageMutationFn = Apollo.MutationFunction<DeleteVatPercentageMutation, DeleteVatPercentageMutationVariables>;

/**
 * __useDeleteVatPercentageMutation__
 *
 * To run a mutation, you first call `useDeleteVatPercentageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVatPercentageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVatPercentageMutation, { data, loading, error }] = useDeleteVatPercentageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVatPercentageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVatPercentageMutation, DeleteVatPercentageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVatPercentageMutation, DeleteVatPercentageMutationVariables>(DeleteVatPercentageDocument, options);
      }
export type DeleteVatPercentageMutationHookResult = ReturnType<typeof useDeleteVatPercentageMutation>;
export type DeleteVatPercentageMutationResult = Apollo.MutationResult<DeleteVatPercentageMutation>;
export type DeleteVatPercentageMutationOptions = Apollo.BaseMutationOptions<DeleteVatPercentageMutation, DeleteVatPercentageMutationVariables>;
export const RestoreVatPercentageDocument = gql`
    mutation RestoreVatPercentage($id: ID!) {
  restoreVatPercentage(id: $id) {
    id
    discardedAt
  }
}
    `;
export type RestoreVatPercentageMutationFn = Apollo.MutationFunction<RestoreVatPercentageMutation, RestoreVatPercentageMutationVariables>;

/**
 * __useRestoreVatPercentageMutation__
 *
 * To run a mutation, you first call `useRestoreVatPercentageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreVatPercentageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreVatPercentageMutation, { data, loading, error }] = useRestoreVatPercentageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreVatPercentageMutation(baseOptions?: Apollo.MutationHookOptions<RestoreVatPercentageMutation, RestoreVatPercentageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreVatPercentageMutation, RestoreVatPercentageMutationVariables>(RestoreVatPercentageDocument, options);
      }
export type RestoreVatPercentageMutationHookResult = ReturnType<typeof useRestoreVatPercentageMutation>;
export type RestoreVatPercentageMutationResult = Apollo.MutationResult<RestoreVatPercentageMutation>;
export type RestoreVatPercentageMutationOptions = Apollo.BaseMutationOptions<RestoreVatPercentageMutation, RestoreVatPercentageMutationVariables>;
export const CreateEntityDocument = gql`
    mutation CreateEntity($input: EntityInput!) {
  createEntity(input: $input) {
    id
  }
}
    `;
export type CreateEntityMutationFn = Apollo.MutationFunction<CreateEntityMutation, CreateEntityMutationVariables>;

/**
 * __useCreateEntityMutation__
 *
 * To run a mutation, you first call `useCreateEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEntityMutation, { data, loading, error }] = useCreateEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEntityMutation(baseOptions?: Apollo.MutationHookOptions<CreateEntityMutation, CreateEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEntityMutation, CreateEntityMutationVariables>(CreateEntityDocument, options);
      }
export type CreateEntityMutationHookResult = ReturnType<typeof useCreateEntityMutation>;
export type CreateEntityMutationResult = Apollo.MutationResult<CreateEntityMutation>;
export type CreateEntityMutationOptions = Apollo.BaseMutationOptions<CreateEntityMutation, CreateEntityMutationVariables>;
export const EntityDocument = gql`
    query Entity($id: ID!) {
  entity(id: $id) {
    id
    name: nameWithoutFallback
    registrationNumber
    vatRegistrationNumber
    address
    postalCode
    country
    phone
    faxNumber
    websiteUrl
    email
    logoUrl
    altNameTranslations
    altAddressTranslations
    discardedAt
    invoiceCode
    invoiceInitialNumberSequence
    bankDetails
    altBankDetailsTranslations
  }
}
    `;

/**
 * __useEntityQuery__
 *
 * To run a query within a React component, call `useEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEntityQuery(baseOptions: Apollo.QueryHookOptions<EntityQuery, EntityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityQuery, EntityQueryVariables>(EntityDocument, options);
      }
export function useEntityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityQuery, EntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityQuery, EntityQueryVariables>(EntityDocument, options);
        }
export type EntityQueryHookResult = ReturnType<typeof useEntityQuery>;
export type EntityLazyQueryHookResult = ReturnType<typeof useEntityLazyQuery>;
export type EntityQueryResult = Apollo.QueryResult<EntityQuery, EntityQueryVariables>;
export const UpdateEntityDocument = gql`
    mutation UpdateEntity($id: ID!, $input: EntityInput!) {
  updateEntity(id: $id, input: $input) {
    id
    name: nameWithoutFallback
    registrationNumber
    vatRegistrationNumber
    address
    postalCode
    country
    phone
    faxNumber
    websiteUrl
    email
    logoUrl
    altNameTranslations
    altAddressTranslations
    invoiceCode
    invoiceInitialNumberSequence
    bankDetails
    altBankDetailsTranslations
  }
}
    `;
export type UpdateEntityMutationFn = Apollo.MutationFunction<UpdateEntityMutation, UpdateEntityMutationVariables>;

/**
 * __useUpdateEntityMutation__
 *
 * To run a mutation, you first call `useUpdateEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityMutation, { data, loading, error }] = useUpdateEntityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEntityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEntityMutation, UpdateEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEntityMutation, UpdateEntityMutationVariables>(UpdateEntityDocument, options);
      }
export type UpdateEntityMutationHookResult = ReturnType<typeof useUpdateEntityMutation>;
export type UpdateEntityMutationResult = Apollo.MutationResult<UpdateEntityMutation>;
export type UpdateEntityMutationOptions = Apollo.BaseMutationOptions<UpdateEntityMutation, UpdateEntityMutationVariables>;
export const EntitiesDocument = gql`
    query Entities($order: String, $descending: Boolean, $after: String, $first: Int, $search: String, $active: Boolean) {
  entities(
    order: $order
    descending: $descending
    after: $after
    first: $first
    search: $search
    active: $active
  ) {
    nodes {
      ...EntityFields
    }
    totalCount
  }
}
    ${EntityFieldsFragmentDoc}`;

/**
 * __useEntitiesQuery__
 *
 * To run a query within a React component, call `useEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntitiesQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      search: // value for 'search'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useEntitiesQuery(baseOptions?: Apollo.QueryHookOptions<EntitiesQuery, EntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntitiesQuery, EntitiesQueryVariables>(EntitiesDocument, options);
      }
export function useEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntitiesQuery, EntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntitiesQuery, EntitiesQueryVariables>(EntitiesDocument, options);
        }
export type EntitiesQueryHookResult = ReturnType<typeof useEntitiesQuery>;
export type EntitiesLazyQueryHookResult = ReturnType<typeof useEntitiesLazyQuery>;
export type EntitiesQueryResult = Apollo.QueryResult<EntitiesQuery, EntitiesQueryVariables>;
export const DeleteEntityDocument = gql`
    mutation DeleteEntity($id: ID!) {
  deleteEntity(id: $id)
}
    `;
export type DeleteEntityMutationFn = Apollo.MutationFunction<DeleteEntityMutation, DeleteEntityMutationVariables>;

/**
 * __useDeleteEntityMutation__
 *
 * To run a mutation, you first call `useDeleteEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEntityMutation, { data, loading, error }] = useDeleteEntityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEntityMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEntityMutation, DeleteEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEntityMutation, DeleteEntityMutationVariables>(DeleteEntityDocument, options);
      }
export type DeleteEntityMutationHookResult = ReturnType<typeof useDeleteEntityMutation>;
export type DeleteEntityMutationResult = Apollo.MutationResult<DeleteEntityMutation>;
export type DeleteEntityMutationOptions = Apollo.BaseMutationOptions<DeleteEntityMutation, DeleteEntityMutationVariables>;
export const AutocompleteEntitiesDocument = gql`
    query AutocompleteEntities($search: String) {
  entities(search: $search) {
    nodes {
      id
      name
    }
  }
}
    `;

/**
 * __useAutocompleteEntitiesQuery__
 *
 * To run a query within a React component, call `useAutocompleteEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteEntitiesQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAutocompleteEntitiesQuery(baseOptions?: Apollo.QueryHookOptions<AutocompleteEntitiesQuery, AutocompleteEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompleteEntitiesQuery, AutocompleteEntitiesQueryVariables>(AutocompleteEntitiesDocument, options);
      }
export function useAutocompleteEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompleteEntitiesQuery, AutocompleteEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompleteEntitiesQuery, AutocompleteEntitiesQueryVariables>(AutocompleteEntitiesDocument, options);
        }
export type AutocompleteEntitiesQueryHookResult = ReturnType<typeof useAutocompleteEntitiesQuery>;
export type AutocompleteEntitiesLazyQueryHookResult = ReturnType<typeof useAutocompleteEntitiesLazyQuery>;
export type AutocompleteEntitiesQueryResult = Apollo.QueryResult<AutocompleteEntitiesQuery, AutocompleteEntitiesQueryVariables>;
export const RestoreEntityDocument = gql`
    mutation RestoreEntity($id: ID!) {
  restoreEntity(id: $id) {
    id
    discardedAt
  }
}
    `;
export type RestoreEntityMutationFn = Apollo.MutationFunction<RestoreEntityMutation, RestoreEntityMutationVariables>;

/**
 * __useRestoreEntityMutation__
 *
 * To run a mutation, you first call `useRestoreEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreEntityMutation, { data, loading, error }] = useRestoreEntityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreEntityMutation(baseOptions?: Apollo.MutationHookOptions<RestoreEntityMutation, RestoreEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreEntityMutation, RestoreEntityMutationVariables>(RestoreEntityDocument, options);
      }
export type RestoreEntityMutationHookResult = ReturnType<typeof useRestoreEntityMutation>;
export type RestoreEntityMutationResult = Apollo.MutationResult<RestoreEntityMutation>;
export type RestoreEntityMutationOptions = Apollo.BaseMutationOptions<RestoreEntityMutation, RestoreEntityMutationVariables>;
export const CreateIndirectCostDocument = gql`
    mutation CreateIndirectCost($input: UserCostInput!) {
  createUserCost(input: $input) {
    id
    amount
    frequency
    fromDate
    toDate
    notes
    userCostType {
      id
      name
    }
  }
}
    `;
export type CreateIndirectCostMutationFn = Apollo.MutationFunction<CreateIndirectCostMutation, CreateIndirectCostMutationVariables>;

/**
 * __useCreateIndirectCostMutation__
 *
 * To run a mutation, you first call `useCreateIndirectCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIndirectCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIndirectCostMutation, { data, loading, error }] = useCreateIndirectCostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIndirectCostMutation(baseOptions?: Apollo.MutationHookOptions<CreateIndirectCostMutation, CreateIndirectCostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIndirectCostMutation, CreateIndirectCostMutationVariables>(CreateIndirectCostDocument, options);
      }
export type CreateIndirectCostMutationHookResult = ReturnType<typeof useCreateIndirectCostMutation>;
export type CreateIndirectCostMutationResult = Apollo.MutationResult<CreateIndirectCostMutation>;
export type CreateIndirectCostMutationOptions = Apollo.BaseMutationOptions<CreateIndirectCostMutation, CreateIndirectCostMutationVariables>;
export const UpdateIndirectCostDocument = gql`
    mutation UpdateIndirectCost($id: ID!, $input: UserCostInput!) {
  updateUserCost(id: $id, input: $input) {
    id
    amount
    frequency
    fromDate
    toDate
    notes
    userCostType {
      id
      name
    }
  }
}
    `;
export type UpdateIndirectCostMutationFn = Apollo.MutationFunction<UpdateIndirectCostMutation, UpdateIndirectCostMutationVariables>;

/**
 * __useUpdateIndirectCostMutation__
 *
 * To run a mutation, you first call `useUpdateIndirectCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIndirectCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIndirectCostMutation, { data, loading, error }] = useUpdateIndirectCostMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIndirectCostMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIndirectCostMutation, UpdateIndirectCostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIndirectCostMutation, UpdateIndirectCostMutationVariables>(UpdateIndirectCostDocument, options);
      }
export type UpdateIndirectCostMutationHookResult = ReturnType<typeof useUpdateIndirectCostMutation>;
export type UpdateIndirectCostMutationResult = Apollo.MutationResult<UpdateIndirectCostMutation>;
export type UpdateIndirectCostMutationOptions = Apollo.BaseMutationOptions<UpdateIndirectCostMutation, UpdateIndirectCostMutationVariables>;
export const IndirectCostsDocument = gql`
    query IndirectCosts($order: String, $descending: Boolean, $after: String, $first: Int, $filter: UserCostFilterInput) {
  userCosts(
    order: $order
    descending: $descending
    after: $after
    first: $first
    filter: $filter
  ) {
    nodes {
      id
      amount
      frequency
      fromDate
      toDate
      notes
      userCostType {
        id
        name
      }
    }
    totalCount
  }
}
    `;

/**
 * __useIndirectCostsQuery__
 *
 * To run a query within a React component, call `useIndirectCostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndirectCostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndirectCostsQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useIndirectCostsQuery(baseOptions?: Apollo.QueryHookOptions<IndirectCostsQuery, IndirectCostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IndirectCostsQuery, IndirectCostsQueryVariables>(IndirectCostsDocument, options);
      }
export function useIndirectCostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IndirectCostsQuery, IndirectCostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IndirectCostsQuery, IndirectCostsQueryVariables>(IndirectCostsDocument, options);
        }
export type IndirectCostsQueryHookResult = ReturnType<typeof useIndirectCostsQuery>;
export type IndirectCostsLazyQueryHookResult = ReturnType<typeof useIndirectCostsLazyQuery>;
export type IndirectCostsQueryResult = Apollo.QueryResult<IndirectCostsQuery, IndirectCostsQueryVariables>;
export const DeleteIndirectCostDocument = gql`
    mutation DeleteIndirectCost($id: ID!) {
  deleteUserCost(id: $id)
}
    `;
export type DeleteIndirectCostMutationFn = Apollo.MutationFunction<DeleteIndirectCostMutation, DeleteIndirectCostMutationVariables>;

/**
 * __useDeleteIndirectCostMutation__
 *
 * To run a mutation, you first call `useDeleteIndirectCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIndirectCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIndirectCostMutation, { data, loading, error }] = useDeleteIndirectCostMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIndirectCostMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIndirectCostMutation, DeleteIndirectCostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIndirectCostMutation, DeleteIndirectCostMutationVariables>(DeleteIndirectCostDocument, options);
      }
export type DeleteIndirectCostMutationHookResult = ReturnType<typeof useDeleteIndirectCostMutation>;
export type DeleteIndirectCostMutationResult = Apollo.MutationResult<DeleteIndirectCostMutation>;
export type DeleteIndirectCostMutationOptions = Apollo.BaseMutationOptions<DeleteIndirectCostMutation, DeleteIndirectCostMutationVariables>;
export const SyncContactsWithMailchimpDocument = gql`
    mutation SyncContactsWithMailchimp {
  syncContactsWithMailchimp
}
    `;
export type SyncContactsWithMailchimpMutationFn = Apollo.MutationFunction<SyncContactsWithMailchimpMutation, SyncContactsWithMailchimpMutationVariables>;

/**
 * __useSyncContactsWithMailchimpMutation__
 *
 * To run a mutation, you first call `useSyncContactsWithMailchimpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncContactsWithMailchimpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncContactsWithMailchimpMutation, { data, loading, error }] = useSyncContactsWithMailchimpMutation({
 *   variables: {
 *   },
 * });
 */
export function useSyncContactsWithMailchimpMutation(baseOptions?: Apollo.MutationHookOptions<SyncContactsWithMailchimpMutation, SyncContactsWithMailchimpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncContactsWithMailchimpMutation, SyncContactsWithMailchimpMutationVariables>(SyncContactsWithMailchimpDocument, options);
      }
export type SyncContactsWithMailchimpMutationHookResult = ReturnType<typeof useSyncContactsWithMailchimpMutation>;
export type SyncContactsWithMailchimpMutationResult = Apollo.MutationResult<SyncContactsWithMailchimpMutation>;
export type SyncContactsWithMailchimpMutationOptions = Apollo.BaseMutationOptions<SyncContactsWithMailchimpMutation, SyncContactsWithMailchimpMutationVariables>;
export const CreateInvoiceTemplateDocument = gql`
    mutation CreateInvoiceTemplate($input: InvoiceTemplateInput!) {
  createInvoiceTemplate(input: $input) {
    id
  }
}
    `;
export type CreateInvoiceTemplateMutationFn = Apollo.MutationFunction<CreateInvoiceTemplateMutation, CreateInvoiceTemplateMutationVariables>;

/**
 * __useCreateInvoiceTemplateMutation__
 *
 * To run a mutation, you first call `useCreateInvoiceTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoiceTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoiceTemplateMutation, { data, loading, error }] = useCreateInvoiceTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInvoiceTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateInvoiceTemplateMutation, CreateInvoiceTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInvoiceTemplateMutation, CreateInvoiceTemplateMutationVariables>(CreateInvoiceTemplateDocument, options);
      }
export type CreateInvoiceTemplateMutationHookResult = ReturnType<typeof useCreateInvoiceTemplateMutation>;
export type CreateInvoiceTemplateMutationResult = Apollo.MutationResult<CreateInvoiceTemplateMutation>;
export type CreateInvoiceTemplateMutationOptions = Apollo.BaseMutationOptions<CreateInvoiceTemplateMutation, CreateInvoiceTemplateMutationVariables>;
export const InvoiceTemplateDocument = gql`
    query InvoiceTemplate($id: ID!) {
  invoiceTemplate(id: $id) {
    id
    name
    entity {
      id
      name
    }
    language
    detailLevel
    layout
  }
}
    `;

/**
 * __useInvoiceTemplateQuery__
 *
 * To run a query within a React component, call `useInvoiceTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvoiceTemplateQuery(baseOptions: Apollo.QueryHookOptions<InvoiceTemplateQuery, InvoiceTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceTemplateQuery, InvoiceTemplateQueryVariables>(InvoiceTemplateDocument, options);
      }
export function useInvoiceTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceTemplateQuery, InvoiceTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceTemplateQuery, InvoiceTemplateQueryVariables>(InvoiceTemplateDocument, options);
        }
export type InvoiceTemplateQueryHookResult = ReturnType<typeof useInvoiceTemplateQuery>;
export type InvoiceTemplateLazyQueryHookResult = ReturnType<typeof useInvoiceTemplateLazyQuery>;
export type InvoiceTemplateQueryResult = Apollo.QueryResult<InvoiceTemplateQuery, InvoiceTemplateQueryVariables>;
export const UpdateInvoiceTemplateDocument = gql`
    mutation UpdateInvoiceTemplate($id: ID!, $input: InvoiceTemplateInput!) {
  updateInvoiceTemplate(id: $id, input: $input) {
    id
    name
    entity {
      id
      name
    }
    language
    detailLevel
    layout
  }
}
    `;
export type UpdateInvoiceTemplateMutationFn = Apollo.MutationFunction<UpdateInvoiceTemplateMutation, UpdateInvoiceTemplateMutationVariables>;

/**
 * __useUpdateInvoiceTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateInvoiceTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvoiceTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvoiceTemplateMutation, { data, loading, error }] = useUpdateInvoiceTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInvoiceTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInvoiceTemplateMutation, UpdateInvoiceTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInvoiceTemplateMutation, UpdateInvoiceTemplateMutationVariables>(UpdateInvoiceTemplateDocument, options);
      }
export type UpdateInvoiceTemplateMutationHookResult = ReturnType<typeof useUpdateInvoiceTemplateMutation>;
export type UpdateInvoiceTemplateMutationResult = Apollo.MutationResult<UpdateInvoiceTemplateMutation>;
export type UpdateInvoiceTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateInvoiceTemplateMutation, UpdateInvoiceTemplateMutationVariables>;
export const InvoiceTemplatesDocument = gql`
    query InvoiceTemplates($order: String, $descending: Boolean, $after: String, $first: Int, $search: String) {
  invoiceTemplates(
    order: $order
    descending: $descending
    after: $after
    first: $first
    search: $search
  ) {
    nodes {
      id
      name
      entity {
        id
        name
      }
      language
      detailLevel
    }
    totalCount
  }
}
    `;

/**
 * __useInvoiceTemplatesQuery__
 *
 * To run a query within a React component, call `useInvoiceTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceTemplatesQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useInvoiceTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<InvoiceTemplatesQuery, InvoiceTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceTemplatesQuery, InvoiceTemplatesQueryVariables>(InvoiceTemplatesDocument, options);
      }
export function useInvoiceTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceTemplatesQuery, InvoiceTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceTemplatesQuery, InvoiceTemplatesQueryVariables>(InvoiceTemplatesDocument, options);
        }
export type InvoiceTemplatesQueryHookResult = ReturnType<typeof useInvoiceTemplatesQuery>;
export type InvoiceTemplatesLazyQueryHookResult = ReturnType<typeof useInvoiceTemplatesLazyQuery>;
export type InvoiceTemplatesQueryResult = Apollo.QueryResult<InvoiceTemplatesQuery, InvoiceTemplatesQueryVariables>;
export const DeleteInvoiceTemplateDocument = gql`
    mutation DeleteInvoiceTemplate($id: ID!) {
  deleteInvoiceTemplate(id: $id)
}
    `;
export type DeleteInvoiceTemplateMutationFn = Apollo.MutationFunction<DeleteInvoiceTemplateMutation, DeleteInvoiceTemplateMutationVariables>;

/**
 * __useDeleteInvoiceTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteInvoiceTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvoiceTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvoiceTemplateMutation, { data, loading, error }] = useDeleteInvoiceTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInvoiceTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInvoiceTemplateMutation, DeleteInvoiceTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInvoiceTemplateMutation, DeleteInvoiceTemplateMutationVariables>(DeleteInvoiceTemplateDocument, options);
      }
export type DeleteInvoiceTemplateMutationHookResult = ReturnType<typeof useDeleteInvoiceTemplateMutation>;
export type DeleteInvoiceTemplateMutationResult = Apollo.MutationResult<DeleteInvoiceTemplateMutation>;
export type DeleteInvoiceTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteInvoiceTemplateMutation, DeleteInvoiceTemplateMutationVariables>;
export const AutocompleteInvoiceTemplatesDocument = gql`
    query AutocompleteInvoiceTemplates($search: String, $filter: InvoiceTemplateFilterInput) {
  invoiceTemplates(search: $search, filter: $filter) {
    nodes {
      id
      name
      detailLevel
    }
  }
}
    `;

/**
 * __useAutocompleteInvoiceTemplatesQuery__
 *
 * To run a query within a React component, call `useAutocompleteInvoiceTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteInvoiceTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteInvoiceTemplatesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAutocompleteInvoiceTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<AutocompleteInvoiceTemplatesQuery, AutocompleteInvoiceTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompleteInvoiceTemplatesQuery, AutocompleteInvoiceTemplatesQueryVariables>(AutocompleteInvoiceTemplatesDocument, options);
      }
export function useAutocompleteInvoiceTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompleteInvoiceTemplatesQuery, AutocompleteInvoiceTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompleteInvoiceTemplatesQuery, AutocompleteInvoiceTemplatesQueryVariables>(AutocompleteInvoiceTemplatesDocument, options);
        }
export type AutocompleteInvoiceTemplatesQueryHookResult = ReturnType<typeof useAutocompleteInvoiceTemplatesQuery>;
export type AutocompleteInvoiceTemplatesLazyQueryHookResult = ReturnType<typeof useAutocompleteInvoiceTemplatesLazyQuery>;
export type AutocompleteInvoiceTemplatesQueryResult = Apollo.QueryResult<AutocompleteInvoiceTemplatesQuery, AutocompleteInvoiceTemplatesQueryVariables>;
export const AccountSettingsDocument = gql`
    query AccountSettings {
  currentAccount {
    ...AccountSettingsFields
  }
}
    ${AccountSettingsFieldsFragmentDoc}`;

/**
 * __useAccountSettingsQuery__
 *
 * To run a query within a React component, call `useAccountSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountSettingsQuery(baseOptions?: Apollo.QueryHookOptions<AccountSettingsQuery, AccountSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountSettingsQuery, AccountSettingsQueryVariables>(AccountSettingsDocument, options);
      }
export function useAccountSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountSettingsQuery, AccountSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountSettingsQuery, AccountSettingsQueryVariables>(AccountSettingsDocument, options);
        }
export type AccountSettingsQueryHookResult = ReturnType<typeof useAccountSettingsQuery>;
export type AccountSettingsLazyQueryHookResult = ReturnType<typeof useAccountSettingsLazyQuery>;
export type AccountSettingsQueryResult = Apollo.QueryResult<AccountSettingsQuery, AccountSettingsQueryVariables>;
export const UpdateAccountSettingsDocument = gql`
    mutation UpdateAccountSettings($input: AccountSettingsInput!) {
  updateCurrentAccountSettings(input: $input) {
    ...AccountSettingsFields
  }
}
    ${AccountSettingsFieldsFragmentDoc}`;
export type UpdateAccountSettingsMutationFn = Apollo.MutationFunction<UpdateAccountSettingsMutation, UpdateAccountSettingsMutationVariables>;

/**
 * __useUpdateAccountSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateAccountSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountSettingsMutation, { data, loading, error }] = useUpdateAccountSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountSettingsMutation, UpdateAccountSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountSettingsMutation, UpdateAccountSettingsMutationVariables>(UpdateAccountSettingsDocument, options);
      }
export type UpdateAccountSettingsMutationHookResult = ReturnType<typeof useUpdateAccountSettingsMutation>;
export type UpdateAccountSettingsMutationResult = Apollo.MutationResult<UpdateAccountSettingsMutation>;
export type UpdateAccountSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateAccountSettingsMutation, UpdateAccountSettingsMutationVariables>;
export const NotificationTextConfigurationDocument = gql`
    query NotificationTextConfiguration($kind: NotificationKind!) {
  notificationConfiguration(kind: $kind) {
    id
    kind
    emailSubjectTranslations
    emailBodyTranslations
  }
}
    `;

/**
 * __useNotificationTextConfigurationQuery__
 *
 * To run a query within a React component, call `useNotificationTextConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationTextConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationTextConfigurationQuery({
 *   variables: {
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useNotificationTextConfigurationQuery(baseOptions: Apollo.QueryHookOptions<NotificationTextConfigurationQuery, NotificationTextConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationTextConfigurationQuery, NotificationTextConfigurationQueryVariables>(NotificationTextConfigurationDocument, options);
      }
export function useNotificationTextConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationTextConfigurationQuery, NotificationTextConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationTextConfigurationQuery, NotificationTextConfigurationQueryVariables>(NotificationTextConfigurationDocument, options);
        }
export type NotificationTextConfigurationQueryHookResult = ReturnType<typeof useNotificationTextConfigurationQuery>;
export type NotificationTextConfigurationLazyQueryHookResult = ReturnType<typeof useNotificationTextConfigurationLazyQuery>;
export type NotificationTextConfigurationQueryResult = Apollo.QueryResult<NotificationTextConfigurationQuery, NotificationTextConfigurationQueryVariables>;
export const UpdateNotificationConfigurationDocument = gql`
    mutation UpdateNotificationConfiguration($kind: NotificationKind!, $input: NotificationConfigurationInput!) {
  updateNotificationConfiguration(kind: $kind, input: $input) {
    id
    emailSubjectTranslations
    emailBodyTranslations
  }
}
    `;
export type UpdateNotificationConfigurationMutationFn = Apollo.MutationFunction<UpdateNotificationConfigurationMutation, UpdateNotificationConfigurationMutationVariables>;

/**
 * __useUpdateNotificationConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationConfigurationMutation, { data, loading, error }] = useUpdateNotificationConfigurationMutation({
 *   variables: {
 *      kind: // value for 'kind'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotificationConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationConfigurationMutation, UpdateNotificationConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationConfigurationMutation, UpdateNotificationConfigurationMutationVariables>(UpdateNotificationConfigurationDocument, options);
      }
export type UpdateNotificationConfigurationMutationHookResult = ReturnType<typeof useUpdateNotificationConfigurationMutation>;
export type UpdateNotificationConfigurationMutationResult = Apollo.MutationResult<UpdateNotificationConfigurationMutation>;
export type UpdateNotificationConfigurationMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationConfigurationMutation, UpdateNotificationConfigurationMutationVariables>;
export const CreatePriceListDocument = gql`
    mutation CreatePriceList($input: PriceListInput!) {
  createPriceList(input: $input) {
    id
  }
}
    `;
export type CreatePriceListMutationFn = Apollo.MutationFunction<CreatePriceListMutation, CreatePriceListMutationVariables>;

/**
 * __useCreatePriceListMutation__
 *
 * To run a mutation, you first call `useCreatePriceListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePriceListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPriceListMutation, { data, loading, error }] = useCreatePriceListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePriceListMutation(baseOptions?: Apollo.MutationHookOptions<CreatePriceListMutation, CreatePriceListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePriceListMutation, CreatePriceListMutationVariables>(CreatePriceListDocument, options);
      }
export type CreatePriceListMutationHookResult = ReturnType<typeof useCreatePriceListMutation>;
export type CreatePriceListMutationResult = Apollo.MutationResult<CreatePriceListMutation>;
export type CreatePriceListMutationOptions = Apollo.BaseMutationOptions<CreatePriceListMutation, CreatePriceListMutationVariables>;
export const UpdatePriceListDocument = gql`
    mutation UpdatePriceList($id: ID!, $input: PriceListInput!) {
  updatePriceList(id: $id, input: $input) {
    ...PriceListFields
  }
}
    ${PriceListFieldsFragmentDoc}`;
export type UpdatePriceListMutationFn = Apollo.MutationFunction<UpdatePriceListMutation, UpdatePriceListMutationVariables>;

/**
 * __useUpdatePriceListMutation__
 *
 * To run a mutation, you first call `useUpdatePriceListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePriceListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePriceListMutation, { data, loading, error }] = useUpdatePriceListMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePriceListMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePriceListMutation, UpdatePriceListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePriceListMutation, UpdatePriceListMutationVariables>(UpdatePriceListDocument, options);
      }
export type UpdatePriceListMutationHookResult = ReturnType<typeof useUpdatePriceListMutation>;
export type UpdatePriceListMutationResult = Apollo.MutationResult<UpdatePriceListMutation>;
export type UpdatePriceListMutationOptions = Apollo.BaseMutationOptions<UpdatePriceListMutation, UpdatePriceListMutationVariables>;
export const PriceListDocument = gql`
    query PriceList($id: ID!) {
  priceList(id: $id) {
    ...PriceListFields
  }
}
    ${PriceListFieldsFragmentDoc}`;

/**
 * __usePriceListQuery__
 *
 * To run a query within a React component, call `usePriceListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePriceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePriceListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePriceListQuery(baseOptions: Apollo.QueryHookOptions<PriceListQuery, PriceListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PriceListQuery, PriceListQueryVariables>(PriceListDocument, options);
      }
export function usePriceListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PriceListQuery, PriceListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PriceListQuery, PriceListQueryVariables>(PriceListDocument, options);
        }
export type PriceListQueryHookResult = ReturnType<typeof usePriceListQuery>;
export type PriceListLazyQueryHookResult = ReturnType<typeof usePriceListLazyQuery>;
export type PriceListQueryResult = Apollo.QueryResult<PriceListQuery, PriceListQueryVariables>;
export const PriceListMinimalDocument = gql`
    query PriceListMinimal($id: ID!) {
  priceList(id: $id) {
    id
    name
  }
}
    `;

/**
 * __usePriceListMinimalQuery__
 *
 * To run a query within a React component, call `usePriceListMinimalQuery` and pass it any options that fit your needs.
 * When your component renders, `usePriceListMinimalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePriceListMinimalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePriceListMinimalQuery(baseOptions: Apollo.QueryHookOptions<PriceListMinimalQuery, PriceListMinimalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PriceListMinimalQuery, PriceListMinimalQueryVariables>(PriceListMinimalDocument, options);
      }
export function usePriceListMinimalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PriceListMinimalQuery, PriceListMinimalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PriceListMinimalQuery, PriceListMinimalQueryVariables>(PriceListMinimalDocument, options);
        }
export type PriceListMinimalQueryHookResult = ReturnType<typeof usePriceListMinimalQuery>;
export type PriceListMinimalLazyQueryHookResult = ReturnType<typeof usePriceListMinimalLazyQuery>;
export type PriceListMinimalQueryResult = Apollo.QueryResult<PriceListMinimalQuery, PriceListMinimalQueryVariables>;
export const DeletePriceListDocument = gql`
    mutation DeletePriceList($id: ID!) {
  deletePriceList(id: $id)
}
    `;
export type DeletePriceListMutationFn = Apollo.MutationFunction<DeletePriceListMutation, DeletePriceListMutationVariables>;

/**
 * __useDeletePriceListMutation__
 *
 * To run a mutation, you first call `useDeletePriceListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePriceListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePriceListMutation, { data, loading, error }] = useDeletePriceListMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePriceListMutation(baseOptions?: Apollo.MutationHookOptions<DeletePriceListMutation, DeletePriceListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePriceListMutation, DeletePriceListMutationVariables>(DeletePriceListDocument, options);
      }
export type DeletePriceListMutationHookResult = ReturnType<typeof useDeletePriceListMutation>;
export type DeletePriceListMutationResult = Apollo.MutationResult<DeletePriceListMutation>;
export type DeletePriceListMutationOptions = Apollo.BaseMutationOptions<DeletePriceListMutation, DeletePriceListMutationVariables>;
export const PriceListsDocument = gql`
    query PriceLists($order: String, $descending: Boolean, $after: String, $first: Int, $search: String, $filter: PriceListFilterInput) {
  priceLists(
    order: $order
    descending: $descending
    after: $after
    first: $first
    search: $search
    filter: $filter
  ) {
    nodes {
      ...PriceListsFields
    }
    totalCount
  }
}
    ${PriceListsFieldsFragmentDoc}`;

/**
 * __usePriceListsQuery__
 *
 * To run a query within a React component, call `usePriceListsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePriceListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePriceListsQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePriceListsQuery(baseOptions?: Apollo.QueryHookOptions<PriceListsQuery, PriceListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PriceListsQuery, PriceListsQueryVariables>(PriceListsDocument, options);
      }
export function usePriceListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PriceListsQuery, PriceListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PriceListsQuery, PriceListsQueryVariables>(PriceListsDocument, options);
        }
export type PriceListsQueryHookResult = ReturnType<typeof usePriceListsQuery>;
export type PriceListsLazyQueryHookResult = ReturnType<typeof usePriceListsLazyQuery>;
export type PriceListsQueryResult = Apollo.QueryResult<PriceListsQuery, PriceListsQueryVariables>;
export const PriceListRatesDocument = gql`
    query PriceListRates($order: String, $descending: Boolean, $after: String, $first: Int, $filter: PriceListRateFilterInput) {
  priceListRates(
    order: $order
    descending: $descending
    after: $after
    first: $first
    filter: $filter
  ) {
    nodes {
      id
      rate
      priced {
        id
        name
        positionName
        sequence
      }
      pricedType
      currency {
        id
      }
    }
    totalCount
  }
}
    `;

/**
 * __usePriceListRatesQuery__
 *
 * To run a query within a React component, call `usePriceListRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePriceListRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePriceListRatesQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePriceListRatesQuery(baseOptions?: Apollo.QueryHookOptions<PriceListRatesQuery, PriceListRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PriceListRatesQuery, PriceListRatesQueryVariables>(PriceListRatesDocument, options);
      }
export function usePriceListRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PriceListRatesQuery, PriceListRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PriceListRatesQuery, PriceListRatesQueryVariables>(PriceListRatesDocument, options);
        }
export type PriceListRatesQueryHookResult = ReturnType<typeof usePriceListRatesQuery>;
export type PriceListRatesLazyQueryHookResult = ReturnType<typeof usePriceListRatesLazyQuery>;
export type PriceListRatesQueryResult = Apollo.QueryResult<PriceListRatesQuery, PriceListRatesQueryVariables>;
export const SwitchDefaultPriceListDocument = gql`
    mutation SwitchDefaultPriceList($id: ID!, $default: Boolean!) {
  switchDefaultPriceList(id: $id, default: $default) {
    ...PriceListsFields
  }
}
    ${PriceListsFieldsFragmentDoc}`;
export type SwitchDefaultPriceListMutationFn = Apollo.MutationFunction<SwitchDefaultPriceListMutation, SwitchDefaultPriceListMutationVariables>;

/**
 * __useSwitchDefaultPriceListMutation__
 *
 * To run a mutation, you first call `useSwitchDefaultPriceListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchDefaultPriceListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchDefaultPriceListMutation, { data, loading, error }] = useSwitchDefaultPriceListMutation({
 *   variables: {
 *      id: // value for 'id'
 *      default: // value for 'default'
 *   },
 * });
 */
export function useSwitchDefaultPriceListMutation(baseOptions?: Apollo.MutationHookOptions<SwitchDefaultPriceListMutation, SwitchDefaultPriceListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwitchDefaultPriceListMutation, SwitchDefaultPriceListMutationVariables>(SwitchDefaultPriceListDocument, options);
      }
export type SwitchDefaultPriceListMutationHookResult = ReturnType<typeof useSwitchDefaultPriceListMutation>;
export type SwitchDefaultPriceListMutationResult = Apollo.MutationResult<SwitchDefaultPriceListMutation>;
export type SwitchDefaultPriceListMutationOptions = Apollo.BaseMutationOptions<SwitchDefaultPriceListMutation, SwitchDefaultPriceListMutationVariables>;
export const AutocompletePriceListsDocument = gql`
    query AutocompletePriceLists($search: String, $filter: PriceListFilterInput = {customRecordId: "NULL"}) {
  priceLists(search: $search, filter: $filter) {
    nodes {
      id
      name
    }
  }
}
    `;

/**
 * __useAutocompletePriceListsQuery__
 *
 * To run a query within a React component, call `useAutocompletePriceListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompletePriceListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompletePriceListsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAutocompletePriceListsQuery(baseOptions?: Apollo.QueryHookOptions<AutocompletePriceListsQuery, AutocompletePriceListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompletePriceListsQuery, AutocompletePriceListsQueryVariables>(AutocompletePriceListsDocument, options);
      }
export function useAutocompletePriceListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompletePriceListsQuery, AutocompletePriceListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompletePriceListsQuery, AutocompletePriceListsQueryVariables>(AutocompletePriceListsDocument, options);
        }
export type AutocompletePriceListsQueryHookResult = ReturnType<typeof useAutocompletePriceListsQuery>;
export type AutocompletePriceListsLazyQueryHookResult = ReturnType<typeof useAutocompletePriceListsLazyQuery>;
export type AutocompletePriceListsQueryResult = Apollo.QueryResult<AutocompletePriceListsQuery, AutocompletePriceListsQueryVariables>;
export const CreateUserRoleDocument = gql`
    mutation CreateUserRole($input: UserRoleInput!) {
  createUserRole(input: $input) {
    id
  }
}
    `;
export type CreateUserRoleMutationFn = Apollo.MutationFunction<CreateUserRoleMutation, CreateUserRoleMutationVariables>;

/**
 * __useCreateUserRoleMutation__
 *
 * To run a mutation, you first call `useCreateUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserRoleMutation, { data, loading, error }] = useCreateUserRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserRoleMutation, CreateUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserRoleMutation, CreateUserRoleMutationVariables>(CreateUserRoleDocument, options);
      }
export type CreateUserRoleMutationHookResult = ReturnType<typeof useCreateUserRoleMutation>;
export type CreateUserRoleMutationResult = Apollo.MutationResult<CreateUserRoleMutation>;
export type CreateUserRoleMutationOptions = Apollo.BaseMutationOptions<CreateUserRoleMutation, CreateUserRoleMutationVariables>;
export const UpdateUserRoleDocument = gql`
    mutation UpdateUserRole($id: ID!, $input: UserRoleInput!) {
  updateUserRole(id: $id, input: $input) {
    id
    name
    description
  }
}
    `;
export type UpdateUserRoleMutationFn = Apollo.MutationFunction<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>;

/**
 * __useUpdateUserRoleMutation__
 *
 * To run a mutation, you first call `useUpdateUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRoleMutation, { data, loading, error }] = useUpdateUserRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>(UpdateUserRoleDocument, options);
      }
export type UpdateUserRoleMutationHookResult = ReturnType<typeof useUpdateUserRoleMutation>;
export type UpdateUserRoleMutationResult = Apollo.MutationResult<UpdateUserRoleMutation>;
export type UpdateUserRoleMutationOptions = Apollo.BaseMutationOptions<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>;
export const UserRoleDocument = gql`
    query UserRole($id: ID!) {
  userRole(id: $id) {
    id
    name
    description
  }
}
    `;

/**
 * __useUserRoleQuery__
 *
 * To run a query within a React component, call `useUserRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserRoleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserRoleQuery(baseOptions: Apollo.QueryHookOptions<UserRoleQuery, UserRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserRoleQuery, UserRoleQueryVariables>(UserRoleDocument, options);
      }
export function useUserRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserRoleQuery, UserRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserRoleQuery, UserRoleQueryVariables>(UserRoleDocument, options);
        }
export type UserRoleQueryHookResult = ReturnType<typeof useUserRoleQuery>;
export type UserRoleLazyQueryHookResult = ReturnType<typeof useUserRoleLazyQuery>;
export type UserRoleQueryResult = Apollo.QueryResult<UserRoleQuery, UserRoleQueryVariables>;
export const UserRolesDocument = gql`
    query UserRoles($order: String, $descending: Boolean, $after: String, $first: Int, $search: String) {
  userRoles(
    order: $order
    descending: $descending
    after: $after
    first: $first
    search: $search
  ) {
    nodes {
      id
      name
      description
      usersCount
      updatedAt
    }
    totalCount
  }
}
    `;

/**
 * __useUserRolesQuery__
 *
 * To run a query within a React component, call `useUserRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserRolesQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useUserRolesQuery(baseOptions?: Apollo.QueryHookOptions<UserRolesQuery, UserRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserRolesQuery, UserRolesQueryVariables>(UserRolesDocument, options);
      }
export function useUserRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserRolesQuery, UserRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserRolesQuery, UserRolesQueryVariables>(UserRolesDocument, options);
        }
export type UserRolesQueryHookResult = ReturnType<typeof useUserRolesQuery>;
export type UserRolesLazyQueryHookResult = ReturnType<typeof useUserRolesLazyQuery>;
export type UserRolesQueryResult = Apollo.QueryResult<UserRolesQuery, UserRolesQueryVariables>;
export const AutocompleteUserRolesDocument = gql`
    query AutocompleteUserRoles($search: String) {
  userRoles(search: $search) {
    nodes {
      id
      name
    }
  }
}
    `;

/**
 * __useAutocompleteUserRolesQuery__
 *
 * To run a query within a React component, call `useAutocompleteUserRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteUserRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteUserRolesQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAutocompleteUserRolesQuery(baseOptions?: Apollo.QueryHookOptions<AutocompleteUserRolesQuery, AutocompleteUserRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompleteUserRolesQuery, AutocompleteUserRolesQueryVariables>(AutocompleteUserRolesDocument, options);
      }
export function useAutocompleteUserRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompleteUserRolesQuery, AutocompleteUserRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompleteUserRolesQuery, AutocompleteUserRolesQueryVariables>(AutocompleteUserRolesDocument, options);
        }
export type AutocompleteUserRolesQueryHookResult = ReturnType<typeof useAutocompleteUserRolesQuery>;
export type AutocompleteUserRolesLazyQueryHookResult = ReturnType<typeof useAutocompleteUserRolesLazyQuery>;
export type AutocompleteUserRolesQueryResult = Apollo.QueryResult<AutocompleteUserRolesQuery, AutocompleteUserRolesQueryVariables>;
export const DeleteUserRoleDocument = gql`
    mutation DeleteUserRole($id: ID!) {
  deleteUserRole(id: $id)
}
    `;
export type DeleteUserRoleMutationFn = Apollo.MutationFunction<DeleteUserRoleMutation, DeleteUserRoleMutationVariables>;

/**
 * __useDeleteUserRoleMutation__
 *
 * To run a mutation, you first call `useDeleteUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserRoleMutation, { data, loading, error }] = useDeleteUserRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserRoleMutation, DeleteUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserRoleMutation, DeleteUserRoleMutationVariables>(DeleteUserRoleDocument, options);
      }
export type DeleteUserRoleMutationHookResult = ReturnType<typeof useDeleteUserRoleMutation>;
export type DeleteUserRoleMutationResult = Apollo.MutationResult<DeleteUserRoleMutation>;
export type DeleteUserRoleMutationOptions = Apollo.BaseMutationOptions<DeleteUserRoleMutation, DeleteUserRoleMutationVariables>;
export const StartStripeCardRegistrationDocument = gql`
    mutation StartStripeCardRegistration {
  startStripeCardRegistration {
    intentSecret
    callbackPath
  }
}
    `;
export type StartStripeCardRegistrationMutationFn = Apollo.MutationFunction<StartStripeCardRegistrationMutation, StartStripeCardRegistrationMutationVariables>;

/**
 * __useStartStripeCardRegistrationMutation__
 *
 * To run a mutation, you first call `useStartStripeCardRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartStripeCardRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startStripeCardRegistrationMutation, { data, loading, error }] = useStartStripeCardRegistrationMutation({
 *   variables: {
 *   },
 * });
 */
export function useStartStripeCardRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<StartStripeCardRegistrationMutation, StartStripeCardRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartStripeCardRegistrationMutation, StartStripeCardRegistrationMutationVariables>(StartStripeCardRegistrationDocument, options);
      }
export type StartStripeCardRegistrationMutationHookResult = ReturnType<typeof useStartStripeCardRegistrationMutation>;
export type StartStripeCardRegistrationMutationResult = Apollo.MutationResult<StartStripeCardRegistrationMutation>;
export type StartStripeCardRegistrationMutationOptions = Apollo.BaseMutationOptions<StartStripeCardRegistrationMutation, StartStripeCardRegistrationMutationVariables>;
export const SubscriptionDataDocument = gql`
    query SubscriptionData {
  subscriptionInfo {
    ...SubscriptionInfoFields
  }
}
    ${SubscriptionInfoFieldsFragmentDoc}`;

/**
 * __useSubscriptionDataQuery__
 *
 * To run a query within a React component, call `useSubscriptionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionDataQuery(baseOptions?: Apollo.QueryHookOptions<SubscriptionDataQuery, SubscriptionDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionDataQuery, SubscriptionDataQueryVariables>(SubscriptionDataDocument, options);
      }
export function useSubscriptionDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionDataQuery, SubscriptionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionDataQuery, SubscriptionDataQueryVariables>(SubscriptionDataDocument, options);
        }
export type SubscriptionDataQueryHookResult = ReturnType<typeof useSubscriptionDataQuery>;
export type SubscriptionDataLazyQueryHookResult = ReturnType<typeof useSubscriptionDataLazyQuery>;
export type SubscriptionDataQueryResult = Apollo.QueryResult<SubscriptionDataQuery, SubscriptionDataQueryVariables>;
export const TerminateSubscriptionDocument = gql`
    mutation TerminateSubscription {
  terminateSubscription {
    ...SubscriptionInfoFields
  }
}
    ${SubscriptionInfoFieldsFragmentDoc}`;
export type TerminateSubscriptionMutationFn = Apollo.MutationFunction<TerminateSubscriptionMutation, TerminateSubscriptionMutationVariables>;

/**
 * __useTerminateSubscriptionMutation__
 *
 * To run a mutation, you first call `useTerminateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTerminateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [terminateSubscriptionMutation, { data, loading, error }] = useTerminateSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useTerminateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<TerminateSubscriptionMutation, TerminateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TerminateSubscriptionMutation, TerminateSubscriptionMutationVariables>(TerminateSubscriptionDocument, options);
      }
export type TerminateSubscriptionMutationHookResult = ReturnType<typeof useTerminateSubscriptionMutation>;
export type TerminateSubscriptionMutationResult = Apollo.MutationResult<TerminateSubscriptionMutation>;
export type TerminateSubscriptionMutationOptions = Apollo.BaseMutationOptions<TerminateSubscriptionMutation, TerminateSubscriptionMutationVariables>;
export const ResumeSubscriptionDocument = gql`
    mutation ResumeSubscription {
  resumeSubscription {
    ...SubscriptionInfoFields
  }
}
    ${SubscriptionInfoFieldsFragmentDoc}`;
export type ResumeSubscriptionMutationFn = Apollo.MutationFunction<ResumeSubscriptionMutation, ResumeSubscriptionMutationVariables>;

/**
 * __useResumeSubscriptionMutation__
 *
 * To run a mutation, you first call `useResumeSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeSubscriptionMutation, { data, loading, error }] = useResumeSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useResumeSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<ResumeSubscriptionMutation, ResumeSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResumeSubscriptionMutation, ResumeSubscriptionMutationVariables>(ResumeSubscriptionDocument, options);
      }
export type ResumeSubscriptionMutationHookResult = ReturnType<typeof useResumeSubscriptionMutation>;
export type ResumeSubscriptionMutationResult = Apollo.MutationResult<ResumeSubscriptionMutation>;
export type ResumeSubscriptionMutationOptions = Apollo.BaseMutationOptions<ResumeSubscriptionMutation, ResumeSubscriptionMutationVariables>;
export const AccountSubscriptionSettingsDocument = gql`
    query AccountSubscriptionSettings {
  accountSubscriptionSettings {
    ...SubscriptionSettingsFields
  }
}
    ${SubscriptionSettingsFieldsFragmentDoc}`;

/**
 * __useAccountSubscriptionSettingsQuery__
 *
 * To run a query within a React component, call `useAccountSubscriptionSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountSubscriptionSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountSubscriptionSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountSubscriptionSettingsQuery(baseOptions?: Apollo.QueryHookOptions<AccountSubscriptionSettingsQuery, AccountSubscriptionSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountSubscriptionSettingsQuery, AccountSubscriptionSettingsQueryVariables>(AccountSubscriptionSettingsDocument, options);
      }
export function useAccountSubscriptionSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountSubscriptionSettingsQuery, AccountSubscriptionSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountSubscriptionSettingsQuery, AccountSubscriptionSettingsQueryVariables>(AccountSubscriptionSettingsDocument, options);
        }
export type AccountSubscriptionSettingsQueryHookResult = ReturnType<typeof useAccountSubscriptionSettingsQuery>;
export type AccountSubscriptionSettingsLazyQueryHookResult = ReturnType<typeof useAccountSubscriptionSettingsLazyQuery>;
export type AccountSubscriptionSettingsQueryResult = Apollo.QueryResult<AccountSubscriptionSettingsQuery, AccountSubscriptionSettingsQueryVariables>;
export const UpdateAccountSubscriptionSettingsDocument = gql`
    mutation UpdateAccountSubscriptionSettings($input: AccountSubscriptionSettingsInput!) {
  updateAccountSubscriptionSettings(input: $input) {
    ...SubscriptionSettingsFields
  }
}
    ${SubscriptionSettingsFieldsFragmentDoc}`;
export type UpdateAccountSubscriptionSettingsMutationFn = Apollo.MutationFunction<UpdateAccountSubscriptionSettingsMutation, UpdateAccountSubscriptionSettingsMutationVariables>;

/**
 * __useUpdateAccountSubscriptionSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateAccountSubscriptionSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountSubscriptionSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountSubscriptionSettingsMutation, { data, loading, error }] = useUpdateAccountSubscriptionSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountSubscriptionSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountSubscriptionSettingsMutation, UpdateAccountSubscriptionSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountSubscriptionSettingsMutation, UpdateAccountSubscriptionSettingsMutationVariables>(UpdateAccountSubscriptionSettingsDocument, options);
      }
export type UpdateAccountSubscriptionSettingsMutationHookResult = ReturnType<typeof useUpdateAccountSubscriptionSettingsMutation>;
export type UpdateAccountSubscriptionSettingsMutationResult = Apollo.MutationResult<UpdateAccountSubscriptionSettingsMutation>;
export type UpdateAccountSubscriptionSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateAccountSubscriptionSettingsMutation, UpdateAccountSubscriptionSettingsMutationVariables>;
export const SubscriptionCommitmentsDocument = gql`
    query SubscriptionCommitments {
  subscriptionCommitments {
    nodes {
      id
      priceExVat
      currency
      fromDate
      tillDate
    }
  }
}
    `;

/**
 * __useSubscriptionCommitmentsQuery__
 *
 * To run a query within a React component, call `useSubscriptionCommitmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionCommitmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionCommitmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionCommitmentsQuery(baseOptions?: Apollo.QueryHookOptions<SubscriptionCommitmentsQuery, SubscriptionCommitmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionCommitmentsQuery, SubscriptionCommitmentsQueryVariables>(SubscriptionCommitmentsDocument, options);
      }
export function useSubscriptionCommitmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionCommitmentsQuery, SubscriptionCommitmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionCommitmentsQuery, SubscriptionCommitmentsQueryVariables>(SubscriptionCommitmentsDocument, options);
        }
export type SubscriptionCommitmentsQueryHookResult = ReturnType<typeof useSubscriptionCommitmentsQuery>;
export type SubscriptionCommitmentsLazyQueryHookResult = ReturnType<typeof useSubscriptionCommitmentsLazyQuery>;
export type SubscriptionCommitmentsQueryResult = Apollo.QueryResult<SubscriptionCommitmentsQuery, SubscriptionCommitmentsQueryVariables>;
export const SubscriptionCommitmentChangeDataDocument = gql`
    query SubscriptionCommitmentChangeData {
  users(filter: {subscriptionPlan: monthly}) {
    totalCount
  }
  accountSubscriptionSettings {
    id
    subscriptionRequestedLongTermCommitments
  }
  subscriptionInfo {
    id
    currentCurrency
    currentUserMonthPrice
    currentUserMonthPriceLongTermCommitment
    currentIntervalTillDate
  }
}
    `;

/**
 * __useSubscriptionCommitmentChangeDataQuery__
 *
 * To run a query within a React component, call `useSubscriptionCommitmentChangeDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionCommitmentChangeDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionCommitmentChangeDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionCommitmentChangeDataQuery(baseOptions?: Apollo.QueryHookOptions<SubscriptionCommitmentChangeDataQuery, SubscriptionCommitmentChangeDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionCommitmentChangeDataQuery, SubscriptionCommitmentChangeDataQueryVariables>(SubscriptionCommitmentChangeDataDocument, options);
      }
export function useSubscriptionCommitmentChangeDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionCommitmentChangeDataQuery, SubscriptionCommitmentChangeDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionCommitmentChangeDataQuery, SubscriptionCommitmentChangeDataQueryVariables>(SubscriptionCommitmentChangeDataDocument, options);
        }
export type SubscriptionCommitmentChangeDataQueryHookResult = ReturnType<typeof useSubscriptionCommitmentChangeDataQuery>;
export type SubscriptionCommitmentChangeDataLazyQueryHookResult = ReturnType<typeof useSubscriptionCommitmentChangeDataLazyQuery>;
export type SubscriptionCommitmentChangeDataQueryResult = Apollo.QueryResult<SubscriptionCommitmentChangeDataQuery, SubscriptionCommitmentChangeDataQueryVariables>;
export const UpdateAccountSubscriptionCommitmentsDocument = gql`
    mutation UpdateAccountSubscriptionCommitments($input: AccountSubscriptionSettingsInput!) {
  updateAccountSubscriptionSettings(input: $input) {
    id
    subscriptionRequestedLongTermCommitments
  }
}
    `;
export type UpdateAccountSubscriptionCommitmentsMutationFn = Apollo.MutationFunction<UpdateAccountSubscriptionCommitmentsMutation, UpdateAccountSubscriptionCommitmentsMutationVariables>;

/**
 * __useUpdateAccountSubscriptionCommitmentsMutation__
 *
 * To run a mutation, you first call `useUpdateAccountSubscriptionCommitmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountSubscriptionCommitmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountSubscriptionCommitmentsMutation, { data, loading, error }] = useUpdateAccountSubscriptionCommitmentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountSubscriptionCommitmentsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountSubscriptionCommitmentsMutation, UpdateAccountSubscriptionCommitmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountSubscriptionCommitmentsMutation, UpdateAccountSubscriptionCommitmentsMutationVariables>(UpdateAccountSubscriptionCommitmentsDocument, options);
      }
export type UpdateAccountSubscriptionCommitmentsMutationHookResult = ReturnType<typeof useUpdateAccountSubscriptionCommitmentsMutation>;
export type UpdateAccountSubscriptionCommitmentsMutationResult = Apollo.MutationResult<UpdateAccountSubscriptionCommitmentsMutation>;
export type UpdateAccountSubscriptionCommitmentsMutationOptions = Apollo.BaseMutationOptions<UpdateAccountSubscriptionCommitmentsMutation, UpdateAccountSubscriptionCommitmentsMutationVariables>;
export const SubscriptionInvoicesDocument = gql`
    query SubscriptionInvoices {
  subscriptionInvoices {
    nodes {
      ...SubscriptionInvoiceFields
    }
  }
}
    ${SubscriptionInvoiceFieldsFragmentDoc}`;

/**
 * __useSubscriptionInvoicesQuery__
 *
 * To run a query within a React component, call `useSubscriptionInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionInvoicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<SubscriptionInvoicesQuery, SubscriptionInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionInvoicesQuery, SubscriptionInvoicesQueryVariables>(SubscriptionInvoicesDocument, options);
      }
export function useSubscriptionInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionInvoicesQuery, SubscriptionInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionInvoicesQuery, SubscriptionInvoicesQueryVariables>(SubscriptionInvoicesDocument, options);
        }
export type SubscriptionInvoicesQueryHookResult = ReturnType<typeof useSubscriptionInvoicesQuery>;
export type SubscriptionInvoicesLazyQueryHookResult = ReturnType<typeof useSubscriptionInvoicesLazyQuery>;
export type SubscriptionInvoicesQueryResult = Apollo.QueryResult<SubscriptionInvoicesQuery, SubscriptionInvoicesQueryVariables>;
export const RefreshSubscriptionInvoicePdfDocument = gql`
    mutation RefreshSubscriptionInvoicePdf($id: ID!) {
  refreshSubscriptionInvoicePdf(id: $id) {
    ...SubscriptionInvoiceFields
  }
}
    ${SubscriptionInvoiceFieldsFragmentDoc}`;
export type RefreshSubscriptionInvoicePdfMutationFn = Apollo.MutationFunction<RefreshSubscriptionInvoicePdfMutation, RefreshSubscriptionInvoicePdfMutationVariables>;

/**
 * __useRefreshSubscriptionInvoicePdfMutation__
 *
 * To run a mutation, you first call `useRefreshSubscriptionInvoicePdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshSubscriptionInvoicePdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshSubscriptionInvoicePdfMutation, { data, loading, error }] = useRefreshSubscriptionInvoicePdfMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefreshSubscriptionInvoicePdfMutation(baseOptions?: Apollo.MutationHookOptions<RefreshSubscriptionInvoicePdfMutation, RefreshSubscriptionInvoicePdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshSubscriptionInvoicePdfMutation, RefreshSubscriptionInvoicePdfMutationVariables>(RefreshSubscriptionInvoicePdfDocument, options);
      }
export type RefreshSubscriptionInvoicePdfMutationHookResult = ReturnType<typeof useRefreshSubscriptionInvoicePdfMutation>;
export type RefreshSubscriptionInvoicePdfMutationResult = Apollo.MutationResult<RefreshSubscriptionInvoicePdfMutation>;
export type RefreshSubscriptionInvoicePdfMutationOptions = Apollo.BaseMutationOptions<RefreshSubscriptionInvoicePdfMutation, RefreshSubscriptionInvoicePdfMutationVariables>;
export const PaySubscriptionInvoiceDocument = gql`
    mutation PaySubscriptionInvoice($id: ID!) {
  paySubscriptionInvoice(id: $id) {
    paymentResult {
      status
      paymentSecret
      subscriptionPaymentId
    }
    invoice {
      ...SubscriptionInvoiceFields
    }
  }
}
    ${SubscriptionInvoiceFieldsFragmentDoc}`;
export type PaySubscriptionInvoiceMutationFn = Apollo.MutationFunction<PaySubscriptionInvoiceMutation, PaySubscriptionInvoiceMutationVariables>;

/**
 * __usePaySubscriptionInvoiceMutation__
 *
 * To run a mutation, you first call `usePaySubscriptionInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaySubscriptionInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paySubscriptionInvoiceMutation, { data, loading, error }] = usePaySubscriptionInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePaySubscriptionInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<PaySubscriptionInvoiceMutation, PaySubscriptionInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaySubscriptionInvoiceMutation, PaySubscriptionInvoiceMutationVariables>(PaySubscriptionInvoiceDocument, options);
      }
export type PaySubscriptionInvoiceMutationHookResult = ReturnType<typeof usePaySubscriptionInvoiceMutation>;
export type PaySubscriptionInvoiceMutationResult = Apollo.MutationResult<PaySubscriptionInvoiceMutation>;
export type PaySubscriptionInvoiceMutationOptions = Apollo.BaseMutationOptions<PaySubscriptionInvoiceMutation, PaySubscriptionInvoiceMutationVariables>;
export const ConfirmSubscriptionInvoicePaymentDocument = gql`
    mutation ConfirmSubscriptionInvoicePayment($subscriptionPaymentId: ID!) {
  confirmSubscriptionInvoicePayment(subscriptionPaymentId: $subscriptionPaymentId) {
    ...SubscriptionInvoiceFields
  }
}
    ${SubscriptionInvoiceFieldsFragmentDoc}`;
export type ConfirmSubscriptionInvoicePaymentMutationFn = Apollo.MutationFunction<ConfirmSubscriptionInvoicePaymentMutation, ConfirmSubscriptionInvoicePaymentMutationVariables>;

/**
 * __useConfirmSubscriptionInvoicePaymentMutation__
 *
 * To run a mutation, you first call `useConfirmSubscriptionInvoicePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmSubscriptionInvoicePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmSubscriptionInvoicePaymentMutation, { data, loading, error }] = useConfirmSubscriptionInvoicePaymentMutation({
 *   variables: {
 *      subscriptionPaymentId: // value for 'subscriptionPaymentId'
 *   },
 * });
 */
export function useConfirmSubscriptionInvoicePaymentMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmSubscriptionInvoicePaymentMutation, ConfirmSubscriptionInvoicePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmSubscriptionInvoicePaymentMutation, ConfirmSubscriptionInvoicePaymentMutationVariables>(ConfirmSubscriptionInvoicePaymentDocument, options);
      }
export type ConfirmSubscriptionInvoicePaymentMutationHookResult = ReturnType<typeof useConfirmSubscriptionInvoicePaymentMutation>;
export type ConfirmSubscriptionInvoicePaymentMutationResult = Apollo.MutationResult<ConfirmSubscriptionInvoicePaymentMutation>;
export type ConfirmSubscriptionInvoicePaymentMutationOptions = Apollo.BaseMutationOptions<ConfirmSubscriptionInvoicePaymentMutation, ConfirmSubscriptionInvoicePaymentMutationVariables>;
export const CancelSubscriptionInvoicePaymentDocument = gql`
    mutation CancelSubscriptionInvoicePayment($subscriptionPaymentId: ID!, $errorMessage: String!) {
  cancelSubscriptionInvoicePayment(
    subscriptionPaymentId: $subscriptionPaymentId
    errorMessage: $errorMessage
  ) {
    ...SubscriptionInvoiceFields
  }
}
    ${SubscriptionInvoiceFieldsFragmentDoc}`;
export type CancelSubscriptionInvoicePaymentMutationFn = Apollo.MutationFunction<CancelSubscriptionInvoicePaymentMutation, CancelSubscriptionInvoicePaymentMutationVariables>;

/**
 * __useCancelSubscriptionInvoicePaymentMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionInvoicePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionInvoicePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionInvoicePaymentMutation, { data, loading, error }] = useCancelSubscriptionInvoicePaymentMutation({
 *   variables: {
 *      subscriptionPaymentId: // value for 'subscriptionPaymentId'
 *      errorMessage: // value for 'errorMessage'
 *   },
 * });
 */
export function useCancelSubscriptionInvoicePaymentMutation(baseOptions?: Apollo.MutationHookOptions<CancelSubscriptionInvoicePaymentMutation, CancelSubscriptionInvoicePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSubscriptionInvoicePaymentMutation, CancelSubscriptionInvoicePaymentMutationVariables>(CancelSubscriptionInvoicePaymentDocument, options);
      }
export type CancelSubscriptionInvoicePaymentMutationHookResult = ReturnType<typeof useCancelSubscriptionInvoicePaymentMutation>;
export type CancelSubscriptionInvoicePaymentMutationResult = Apollo.MutationResult<CancelSubscriptionInvoicePaymentMutation>;
export type CancelSubscriptionInvoicePaymentMutationOptions = Apollo.BaseMutationOptions<CancelSubscriptionInvoicePaymentMutation, CancelSubscriptionInvoicePaymentMutationVariables>;
export const TestCurrentAccountEmailSettingsDocument = gql`
    mutation TestCurrentAccountEmailSettings {
  testCurrentAccountEmailSettings
}
    `;
export type TestCurrentAccountEmailSettingsMutationFn = Apollo.MutationFunction<TestCurrentAccountEmailSettingsMutation, TestCurrentAccountEmailSettingsMutationVariables>;

/**
 * __useTestCurrentAccountEmailSettingsMutation__
 *
 * To run a mutation, you first call `useTestCurrentAccountEmailSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestCurrentAccountEmailSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testCurrentAccountEmailSettingsMutation, { data, loading, error }] = useTestCurrentAccountEmailSettingsMutation({
 *   variables: {
 *   },
 * });
 */
export function useTestCurrentAccountEmailSettingsMutation(baseOptions?: Apollo.MutationHookOptions<TestCurrentAccountEmailSettingsMutation, TestCurrentAccountEmailSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TestCurrentAccountEmailSettingsMutation, TestCurrentAccountEmailSettingsMutationVariables>(TestCurrentAccountEmailSettingsDocument, options);
      }
export type TestCurrentAccountEmailSettingsMutationHookResult = ReturnType<typeof useTestCurrentAccountEmailSettingsMutation>;
export type TestCurrentAccountEmailSettingsMutationResult = Apollo.MutationResult<TestCurrentAccountEmailSettingsMutation>;
export type TestCurrentAccountEmailSettingsMutationOptions = Apollo.BaseMutationOptions<TestCurrentAccountEmailSettingsMutation, TestCurrentAccountEmailSettingsMutationVariables>;
export const CreateTeamDocument = gql`
    mutation CreateTeam($input: TeamInput!) {
  createTeam(input: $input) {
    id
  }
}
    `;
export type CreateTeamMutationFn = Apollo.MutationFunction<CreateTeamMutation, CreateTeamMutationVariables>;

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMutation, { data, loading, error }] = useCreateTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTeamMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeamMutation, CreateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTeamMutation, CreateTeamMutationVariables>(CreateTeamDocument, options);
      }
export type CreateTeamMutationHookResult = ReturnType<typeof useCreateTeamMutation>;
export type CreateTeamMutationResult = Apollo.MutationResult<CreateTeamMutation>;
export type CreateTeamMutationOptions = Apollo.BaseMutationOptions<CreateTeamMutation, CreateTeamMutationVariables>;
export const TeamDocument = gql`
    query Team($id: ID!) {
  team(id: $id) {
    id
    name: nameWithoutFallback
    altNameTranslations
    supervisor {
      id
      fullName
    }
  }
}
    `;

/**
 * __useTeamQuery__
 *
 * To run a query within a React component, call `useTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTeamQuery(baseOptions: Apollo.QueryHookOptions<TeamQuery, TeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamQuery, TeamQueryVariables>(TeamDocument, options);
      }
export function useTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamQuery, TeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamQuery, TeamQueryVariables>(TeamDocument, options);
        }
export type TeamQueryHookResult = ReturnType<typeof useTeamQuery>;
export type TeamLazyQueryHookResult = ReturnType<typeof useTeamLazyQuery>;
export type TeamQueryResult = Apollo.QueryResult<TeamQuery, TeamQueryVariables>;
export const UpdateTeamDocument = gql`
    mutation UpdateTeam($id: ID!, $input: TeamInput!) {
  updateTeam(id: $id, input: $input) {
    id
    name
    altNameTranslations
    supervisor {
      id
      fullName
    }
  }
}
    `;
export type UpdateTeamMutationFn = Apollo.MutationFunction<UpdateTeamMutation, UpdateTeamMutationVariables>;

/**
 * __useUpdateTeamMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamMutation, { data, loading, error }] = useUpdateTeamMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamMutation, UpdateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamMutation, UpdateTeamMutationVariables>(UpdateTeamDocument, options);
      }
export type UpdateTeamMutationHookResult = ReturnType<typeof useUpdateTeamMutation>;
export type UpdateTeamMutationResult = Apollo.MutationResult<UpdateTeamMutation>;
export type UpdateTeamMutationOptions = Apollo.BaseMutationOptions<UpdateTeamMutation, UpdateTeamMutationVariables>;
export const CreateTeamMembershipDocument = gql`
    mutation CreateTeamMembership($input: TeamMembershipInput!) {
  createTeamMembership(input: $input) {
    id
  }
}
    `;
export type CreateTeamMembershipMutationFn = Apollo.MutationFunction<CreateTeamMembershipMutation, CreateTeamMembershipMutationVariables>;

/**
 * __useCreateTeamMembershipMutation__
 *
 * To run a mutation, you first call `useCreateTeamMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMembershipMutation, { data, loading, error }] = useCreateTeamMembershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTeamMembershipMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeamMembershipMutation, CreateTeamMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTeamMembershipMutation, CreateTeamMembershipMutationVariables>(CreateTeamMembershipDocument, options);
      }
export type CreateTeamMembershipMutationHookResult = ReturnType<typeof useCreateTeamMembershipMutation>;
export type CreateTeamMembershipMutationResult = Apollo.MutationResult<CreateTeamMembershipMutation>;
export type CreateTeamMembershipMutationOptions = Apollo.BaseMutationOptions<CreateTeamMembershipMutation, CreateTeamMembershipMutationVariables>;
export const TeamsDocument = gql`
    query Teams($order: String, $descending: Boolean, $after: String, $first: Int, $search: String) {
  teams(
    order: $order
    descending: $descending
    after: $after
    first: $first
    search: $search
  ) {
    nodes {
      id
      name
      teamMembersCount
      supervisor {
        id
        fullName
      }
    }
    totalCount
  }
}
    `;

/**
 * __useTeamsQuery__
 *
 * To run a query within a React component, call `useTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamsQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useTeamsQuery(baseOptions?: Apollo.QueryHookOptions<TeamsQuery, TeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamsQuery, TeamsQueryVariables>(TeamsDocument, options);
      }
export function useTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamsQuery, TeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamsQuery, TeamsQueryVariables>(TeamsDocument, options);
        }
export type TeamsQueryHookResult = ReturnType<typeof useTeamsQuery>;
export type TeamsLazyQueryHookResult = ReturnType<typeof useTeamsLazyQuery>;
export type TeamsQueryResult = Apollo.QueryResult<TeamsQuery, TeamsQueryVariables>;
export const DeleteTeamDocument = gql`
    mutation DeleteTeam($id: ID!) {
  deleteTeam(id: $id)
}
    `;
export type DeleteTeamMutationFn = Apollo.MutationFunction<DeleteTeamMutation, DeleteTeamMutationVariables>;

/**
 * __useDeleteTeamMutation__
 *
 * To run a mutation, you first call `useDeleteTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamMutation, { data, loading, error }] = useDeleteTeamMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTeamMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTeamMutation, DeleteTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTeamMutation, DeleteTeamMutationVariables>(DeleteTeamDocument, options);
      }
export type DeleteTeamMutationHookResult = ReturnType<typeof useDeleteTeamMutation>;
export type DeleteTeamMutationResult = Apollo.MutationResult<DeleteTeamMutation>;
export type DeleteTeamMutationOptions = Apollo.BaseMutationOptions<DeleteTeamMutation, DeleteTeamMutationVariables>;
export const TeamMembershipsDocument = gql`
    query TeamMemberships($order: String, $descending: Boolean, $after: String, $first: Int, $filter: TeamMembershipFilterInput) {
  teamMemberships(
    order: $order
    descending: $descending
    after: $after
    first: $first
    filter: $filter
  ) {
    nodes {
      id
      teamId
      user {
        id
        fullName
      }
      supervisor {
        id
        fullName
      }
    }
    totalCount
  }
}
    `;

/**
 * __useTeamMembershipsQuery__
 *
 * To run a query within a React component, call `useTeamMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamMembershipsQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTeamMembershipsQuery(baseOptions?: Apollo.QueryHookOptions<TeamMembershipsQuery, TeamMembershipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamMembershipsQuery, TeamMembershipsQueryVariables>(TeamMembershipsDocument, options);
      }
export function useTeamMembershipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamMembershipsQuery, TeamMembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamMembershipsQuery, TeamMembershipsQueryVariables>(TeamMembershipsDocument, options);
        }
export type TeamMembershipsQueryHookResult = ReturnType<typeof useTeamMembershipsQuery>;
export type TeamMembershipsLazyQueryHookResult = ReturnType<typeof useTeamMembershipsLazyQuery>;
export type TeamMembershipsQueryResult = Apollo.QueryResult<TeamMembershipsQuery, TeamMembershipsQueryVariables>;
export const DeleteTeamMembershipDocument = gql`
    mutation DeleteTeamMembership($id: ID!) {
  deleteTeamMembership(id: $id)
}
    `;
export type DeleteTeamMembershipMutationFn = Apollo.MutationFunction<DeleteTeamMembershipMutation, DeleteTeamMembershipMutationVariables>;

/**
 * __useDeleteTeamMembershipMutation__
 *
 * To run a mutation, you first call `useDeleteTeamMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamMembershipMutation, { data, loading, error }] = useDeleteTeamMembershipMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTeamMembershipMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTeamMembershipMutation, DeleteTeamMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTeamMembershipMutation, DeleteTeamMembershipMutationVariables>(DeleteTeamMembershipDocument, options);
      }
export type DeleteTeamMembershipMutationHookResult = ReturnType<typeof useDeleteTeamMembershipMutation>;
export type DeleteTeamMembershipMutationResult = Apollo.MutationResult<DeleteTeamMembershipMutation>;
export type DeleteTeamMembershipMutationOptions = Apollo.BaseMutationOptions<DeleteTeamMembershipMutation, DeleteTeamMembershipMutationVariables>;
export const UpdateTeamMembershipDocument = gql`
    mutation UpdateTeamMembership($id: ID!, $input: TeamMembershipInput!) {
  updateTeamMembership(id: $id, input: $input) {
    id
    supervisor {
      id
      fullName
    }
  }
}
    `;
export type UpdateTeamMembershipMutationFn = Apollo.MutationFunction<UpdateTeamMembershipMutation, UpdateTeamMembershipMutationVariables>;

/**
 * __useUpdateTeamMembershipMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamMembershipMutation, { data, loading, error }] = useUpdateTeamMembershipMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamMembershipMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamMembershipMutation, UpdateTeamMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamMembershipMutation, UpdateTeamMembershipMutationVariables>(UpdateTeamMembershipDocument, options);
      }
export type UpdateTeamMembershipMutationHookResult = ReturnType<typeof useUpdateTeamMembershipMutation>;
export type UpdateTeamMembershipMutationResult = Apollo.MutationResult<UpdateTeamMembershipMutation>;
export type UpdateTeamMembershipMutationOptions = Apollo.BaseMutationOptions<UpdateTeamMembershipMutation, UpdateTeamMembershipMutationVariables>;
export const CreateUserApiTokenDocument = gql`
    mutation CreateUserApiToken {
  createUserApiToken {
    id
    name
    token
  }
}
    `;
export type CreateUserApiTokenMutationFn = Apollo.MutationFunction<CreateUserApiTokenMutation, CreateUserApiTokenMutationVariables>;

/**
 * __useCreateUserApiTokenMutation__
 *
 * To run a mutation, you first call `useCreateUserApiTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserApiTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserApiTokenMutation, { data, loading, error }] = useCreateUserApiTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateUserApiTokenMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserApiTokenMutation, CreateUserApiTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserApiTokenMutation, CreateUserApiTokenMutationVariables>(CreateUserApiTokenDocument, options);
      }
export type CreateUserApiTokenMutationHookResult = ReturnType<typeof useCreateUserApiTokenMutation>;
export type CreateUserApiTokenMutationResult = Apollo.MutationResult<CreateUserApiTokenMutation>;
export type CreateUserApiTokenMutationOptions = Apollo.BaseMutationOptions<CreateUserApiTokenMutation, CreateUserApiTokenMutationVariables>;
export const UserApiTokensDocument = gql`
    query UserAPITokens($order: String, $descending: Boolean, $after: String, $first: Int, $filter: UserAPITokenFilterInput) {
  userApiTokens(
    order: $order
    descending: $descending
    after: $after
    first: $first
    filter: $filter
  ) {
    nodes {
      id
      name
      createdAt
      accessedAt
    }
    totalCount
  }
}
    `;

/**
 * __useUserApiTokensQuery__
 *
 * To run a query within a React component, call `useUserApiTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserApiTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserApiTokensQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUserApiTokensQuery(baseOptions?: Apollo.QueryHookOptions<UserApiTokensQuery, UserApiTokensQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserApiTokensQuery, UserApiTokensQueryVariables>(UserApiTokensDocument, options);
      }
export function useUserApiTokensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserApiTokensQuery, UserApiTokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserApiTokensQuery, UserApiTokensQueryVariables>(UserApiTokensDocument, options);
        }
export type UserApiTokensQueryHookResult = ReturnType<typeof useUserApiTokensQuery>;
export type UserApiTokensLazyQueryHookResult = ReturnType<typeof useUserApiTokensLazyQuery>;
export type UserApiTokensQueryResult = Apollo.QueryResult<UserApiTokensQuery, UserApiTokensQueryVariables>;
export const DeleteUserApiTokenDocument = gql`
    mutation DeleteUserAPIToken($id: ID!) {
  deleteUserApiToken(id: $id)
}
    `;
export type DeleteUserApiTokenMutationFn = Apollo.MutationFunction<DeleteUserApiTokenMutation, DeleteUserApiTokenMutationVariables>;

/**
 * __useDeleteUserApiTokenMutation__
 *
 * To run a mutation, you first call `useDeleteUserApiTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserApiTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserApiTokenMutation, { data, loading, error }] = useDeleteUserApiTokenMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserApiTokenMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserApiTokenMutation, DeleteUserApiTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserApiTokenMutation, DeleteUserApiTokenMutationVariables>(DeleteUserApiTokenDocument, options);
      }
export type DeleteUserApiTokenMutationHookResult = ReturnType<typeof useDeleteUserApiTokenMutation>;
export type DeleteUserApiTokenMutationResult = Apollo.MutationResult<DeleteUserApiTokenMutation>;
export type DeleteUserApiTokenMutationOptions = Apollo.BaseMutationOptions<DeleteUserApiTokenMutation, DeleteUserApiTokenMutationVariables>;
export const UserCalendarsDocument = gql`
    query UserCalendars($id: ID!) {
  user(id: $id) {
    id
    configuredCalendarProviders
    calendars {
      id
      provider
      name
      primary
      synchronize
    }
  }
}
    `;

/**
 * __useUserCalendarsQuery__
 *
 * To run a query within a React component, call `useUserCalendarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCalendarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCalendarsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserCalendarsQuery(baseOptions: Apollo.QueryHookOptions<UserCalendarsQuery, UserCalendarsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserCalendarsQuery, UserCalendarsQueryVariables>(UserCalendarsDocument, options);
      }
export function useUserCalendarsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserCalendarsQuery, UserCalendarsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserCalendarsQuery, UserCalendarsQueryVariables>(UserCalendarsDocument, options);
        }
export type UserCalendarsQueryHookResult = ReturnType<typeof useUserCalendarsQuery>;
export type UserCalendarsLazyQueryHookResult = ReturnType<typeof useUserCalendarsLazyQuery>;
export type UserCalendarsQueryResult = Apollo.QueryResult<UserCalendarsQuery, UserCalendarsQueryVariables>;
export const UpdateUserCalendarDocument = gql`
    mutation UpdateUserCalendar($id: ID!, $input: CalendarInput!) {
  updateCalendar(id: $id, input: $input) {
    id
    synchronize
  }
}
    `;
export type UpdateUserCalendarMutationFn = Apollo.MutationFunction<UpdateUserCalendarMutation, UpdateUserCalendarMutationVariables>;

/**
 * __useUpdateUserCalendarMutation__
 *
 * To run a mutation, you first call `useUpdateUserCalendarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserCalendarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserCalendarMutation, { data, loading, error }] = useUpdateUserCalendarMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserCalendarMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserCalendarMutation, UpdateUserCalendarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserCalendarMutation, UpdateUserCalendarMutationVariables>(UpdateUserCalendarDocument, options);
      }
export type UpdateUserCalendarMutationHookResult = ReturnType<typeof useUpdateUserCalendarMutation>;
export type UpdateUserCalendarMutationResult = Apollo.MutationResult<UpdateUserCalendarMutation>;
export type UpdateUserCalendarMutationOptions = Apollo.BaseMutationOptions<UpdateUserCalendarMutation, UpdateUserCalendarMutationVariables>;
export const InviteUserDocument = gql`
    mutation InviteUser($input: UserInput!) {
  inviteUser(input: $input)
}
    `;
export type InviteUserMutationFn = Apollo.MutationFunction<InviteUserMutation, InviteUserMutationVariables>;

/**
 * __useInviteUserMutation__
 *
 * To run a mutation, you first call `useInviteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserMutation, { data, loading, error }] = useInviteUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteUserMutation(baseOptions?: Apollo.MutationHookOptions<InviteUserMutation, InviteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteUserMutation, InviteUserMutationVariables>(InviteUserDocument, options);
      }
export type InviteUserMutationHookResult = ReturnType<typeof useInviteUserMutation>;
export type InviteUserMutationResult = Apollo.MutationResult<InviteUserMutation>;
export type InviteUserMutationOptions = Apollo.BaseMutationOptions<InviteUserMutation, InviteUserMutationVariables>;
export const AccountSubscriptionDefaultPlanDocument = gql`
    query AccountSubscriptionDefaultPlan {
  accountSubscriptionSettings {
    id
    subscriptionDefaultPlan
  }
}
    `;

/**
 * __useAccountSubscriptionDefaultPlanQuery__
 *
 * To run a query within a React component, call `useAccountSubscriptionDefaultPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountSubscriptionDefaultPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountSubscriptionDefaultPlanQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountSubscriptionDefaultPlanQuery(baseOptions?: Apollo.QueryHookOptions<AccountSubscriptionDefaultPlanQuery, AccountSubscriptionDefaultPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountSubscriptionDefaultPlanQuery, AccountSubscriptionDefaultPlanQueryVariables>(AccountSubscriptionDefaultPlanDocument, options);
      }
export function useAccountSubscriptionDefaultPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountSubscriptionDefaultPlanQuery, AccountSubscriptionDefaultPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountSubscriptionDefaultPlanQuery, AccountSubscriptionDefaultPlanQueryVariables>(AccountSubscriptionDefaultPlanDocument, options);
        }
export type AccountSubscriptionDefaultPlanQueryHookResult = ReturnType<typeof useAccountSubscriptionDefaultPlanQuery>;
export type AccountSubscriptionDefaultPlanLazyQueryHookResult = ReturnType<typeof useAccountSubscriptionDefaultPlanLazyQuery>;
export type AccountSubscriptionDefaultPlanQueryResult = Apollo.QueryResult<AccountSubscriptionDefaultPlanQuery, AccountSubscriptionDefaultPlanQueryVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($id: ID!, $userId: ID!, $input: UserCredentialInput!) {
  changePassword(id: $id, userId: $userId, input: $input)
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const TimeZonesDocument = gql`
    query TimeZones {
  timeZones {
    id
  }
}
    `;

/**
 * __useTimeZonesQuery__
 *
 * To run a query within a React component, call `useTimeZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeZonesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTimeZonesQuery(baseOptions?: Apollo.QueryHookOptions<TimeZonesQuery, TimeZonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeZonesQuery, TimeZonesQueryVariables>(TimeZonesDocument, options);
      }
export function useTimeZonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeZonesQuery, TimeZonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeZonesQuery, TimeZonesQueryVariables>(TimeZonesDocument, options);
        }
export type TimeZonesQueryHookResult = ReturnType<typeof useTimeZonesQuery>;
export type TimeZonesLazyQueryHookResult = ReturnType<typeof useTimeZonesLazyQuery>;
export type TimeZonesQueryResult = Apollo.QueryResult<TimeZonesQuery, TimeZonesQueryVariables>;
export const UnlockUserDocument = gql`
    mutation UnlockUser($id: ID!) {
  unlockUser(id: $id) {
    id
    accessLocked
  }
}
    `;
export type UnlockUserMutationFn = Apollo.MutationFunction<UnlockUserMutation, UnlockUserMutationVariables>;

/**
 * __useUnlockUserMutation__
 *
 * To run a mutation, you first call `useUnlockUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockUserMutation, { data, loading, error }] = useUnlockUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnlockUserMutation(baseOptions?: Apollo.MutationHookOptions<UnlockUserMutation, UnlockUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlockUserMutation, UnlockUserMutationVariables>(UnlockUserDocument, options);
      }
export type UnlockUserMutationHookResult = ReturnType<typeof useUnlockUserMutation>;
export type UnlockUserMutationResult = Apollo.MutationResult<UnlockUserMutation>;
export type UnlockUserMutationOptions = Apollo.BaseMutationOptions<UnlockUserMutation, UnlockUserMutationVariables>;
export const UserDocument = gql`
    query User($id: ID!) {
  user(id: $id) {
    ...FullUserFields
  }
}
    ${FullUserFieldsFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserQuery(baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($id: ID!, $input: UserInput!) {
  updateUser(id: $id, input: $input) {
    ...FullUserFields
  }
}
    ${FullUserFieldsFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const ResendUserInvitationDocument = gql`
    mutation ResendUserInvitation($id: ID!) {
  resendUserInvitation(id: $id) {
    id
  }
}
    `;
export type ResendUserInvitationMutationFn = Apollo.MutationFunction<ResendUserInvitationMutation, ResendUserInvitationMutationVariables>;

/**
 * __useResendUserInvitationMutation__
 *
 * To run a mutation, you first call `useResendUserInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendUserInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendUserInvitationMutation, { data, loading, error }] = useResendUserInvitationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResendUserInvitationMutation(baseOptions?: Apollo.MutationHookOptions<ResendUserInvitationMutation, ResendUserInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendUserInvitationMutation, ResendUserInvitationMutationVariables>(ResendUserInvitationDocument, options);
      }
export type ResendUserInvitationMutationHookResult = ReturnType<typeof useResendUserInvitationMutation>;
export type ResendUserInvitationMutationResult = Apollo.MutationResult<ResendUserInvitationMutation>;
export type ResendUserInvitationMutationOptions = Apollo.BaseMutationOptions<ResendUserInvitationMutation, ResendUserInvitationMutationVariables>;
export const UsersDocument = gql`
    query Users($order: String, $descending: Boolean, $after: String, $first: Int, $search: String, $filter: UserFilterInput, $active: Boolean) {
  users(
    order: $order
    descending: $descending
    after: $after
    first: $first
    search: $search
    filter: $filter
    active: $active
  ) {
    nodes {
      id
      firstName
      lastName
      fullName
      userCredential {
        id
        email
        lastSignInAt
      }
      position {
        id
        name
      }
      userRole {
        id
        name
      }
      admin
      email
      subscriptionPlan
      subscriptionPlanAtIntervalStart
      discardedAt
      startDate
    }
    totalCount
  }
}
    `;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export const AutocompleteUsersDocument = gql`
    query AutocompleteUsers($search: String, $filter: UserFilterInput) {
  users(search: $search, filter: $filter) {
    nodes {
      id
      fullName
      positionName
    }
    totalCount
  }
}
    `;

/**
 * __useAutocompleteUsersQuery__
 *
 * To run a query within a React component, call `useAutocompleteUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteUsersQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAutocompleteUsersQuery(baseOptions?: Apollo.QueryHookOptions<AutocompleteUsersQuery, AutocompleteUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompleteUsersQuery, AutocompleteUsersQueryVariables>(AutocompleteUsersDocument, options);
      }
export function useAutocompleteUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompleteUsersQuery, AutocompleteUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompleteUsersQuery, AutocompleteUsersQueryVariables>(AutocompleteUsersDocument, options);
        }
export type AutocompleteUsersQueryHookResult = ReturnType<typeof useAutocompleteUsersQuery>;
export type AutocompleteUsersLazyQueryHookResult = ReturnType<typeof useAutocompleteUsersLazyQuery>;
export type AutocompleteUsersQueryResult = Apollo.QueryResult<AutocompleteUsersQuery, AutocompleteUsersQueryVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($id: ID!) {
  deleteUser(id: $id)
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const RestoreUserDocument = gql`
    mutation RestoreUser($id: ID!) {
  restoreUser(id: $id) {
    id
    discardedAt
  }
}
    `;
export type RestoreUserMutationFn = Apollo.MutationFunction<RestoreUserMutation, RestoreUserMutationVariables>;

/**
 * __useRestoreUserMutation__
 *
 * To run a mutation, you first call `useRestoreUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreUserMutation, { data, loading, error }] = useRestoreUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreUserMutation(baseOptions?: Apollo.MutationHookOptions<RestoreUserMutation, RestoreUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreUserMutation, RestoreUserMutationVariables>(RestoreUserDocument, options);
      }
export type RestoreUserMutationHookResult = ReturnType<typeof useRestoreUserMutation>;
export type RestoreUserMutationResult = Apollo.MutationResult<RestoreUserMutation>;
export type RestoreUserMutationOptions = Apollo.BaseMutationOptions<RestoreUserMutation, RestoreUserMutationVariables>;
export const MonthlyUserEstimateAlertDocument = gql`
    query MonthlyUserEstimateAlert {
  monthlyUserEstimateInfo {
    id
    showAlert
    estimatedCount
    currentCount
  }
}
    `;

/**
 * __useMonthlyUserEstimateAlertQuery__
 *
 * To run a query within a React component, call `useMonthlyUserEstimateAlertQuery` and pass it any options that fit your needs.
 * When your component renders, `useMonthlyUserEstimateAlertQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMonthlyUserEstimateAlertQuery({
 *   variables: {
 *   },
 * });
 */
export function useMonthlyUserEstimateAlertQuery(baseOptions?: Apollo.QueryHookOptions<MonthlyUserEstimateAlertQuery, MonthlyUserEstimateAlertQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MonthlyUserEstimateAlertQuery, MonthlyUserEstimateAlertQueryVariables>(MonthlyUserEstimateAlertDocument, options);
      }
export function useMonthlyUserEstimateAlertLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MonthlyUserEstimateAlertQuery, MonthlyUserEstimateAlertQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MonthlyUserEstimateAlertQuery, MonthlyUserEstimateAlertQueryVariables>(MonthlyUserEstimateAlertDocument, options);
        }
export type MonthlyUserEstimateAlertQueryHookResult = ReturnType<typeof useMonthlyUserEstimateAlertQuery>;
export type MonthlyUserEstimateAlertLazyQueryHookResult = ReturnType<typeof useMonthlyUserEstimateAlertLazyQuery>;
export type MonthlyUserEstimateAlertQueryResult = Apollo.QueryResult<MonthlyUserEstimateAlertQuery, MonthlyUserEstimateAlertQueryVariables>;
export const MassInviteDocument = gql`
    mutation MassInvite($ids: [ID!]!) {
  massInvite(ids: $ids)
}
    `;
export type MassInviteMutationFn = Apollo.MutationFunction<MassInviteMutation, MassInviteMutationVariables>;

/**
 * __useMassInviteMutation__
 *
 * To run a mutation, you first call `useMassInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMassInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [massInviteMutation, { data, loading, error }] = useMassInviteMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useMassInviteMutation(baseOptions?: Apollo.MutationHookOptions<MassInviteMutation, MassInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MassInviteMutation, MassInviteMutationVariables>(MassInviteDocument, options);
      }
export type MassInviteMutationHookResult = ReturnType<typeof useMassInviteMutation>;
export type MassInviteMutationResult = Apollo.MutationResult<MassInviteMutation>;
export type MassInviteMutationOptions = Apollo.BaseMutationOptions<MassInviteMutation, MassInviteMutationVariables>;
export const UserNotificationsDocument = gql`
    query UserNotifications($id: ID!) {
  user(id: $id) {
    id
    ...NotificationFields
  }
}
    ${NotificationFieldsFragmentDoc}`;

/**
 * __useUserNotificationsQuery__
 *
 * To run a query within a React component, call `useUserNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNotificationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserNotificationsQuery(baseOptions: Apollo.QueryHookOptions<UserNotificationsQuery, UserNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserNotificationsQuery, UserNotificationsQueryVariables>(UserNotificationsDocument, options);
      }
export function useUserNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserNotificationsQuery, UserNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserNotificationsQuery, UserNotificationsQueryVariables>(UserNotificationsDocument, options);
        }
export type UserNotificationsQueryHookResult = ReturnType<typeof useUserNotificationsQuery>;
export type UserNotificationsLazyQueryHookResult = ReturnType<typeof useUserNotificationsLazyQuery>;
export type UserNotificationsQueryResult = Apollo.QueryResult<UserNotificationsQuery, UserNotificationsQueryVariables>;
export const UpdateUserNotificationsDocument = gql`
    mutation UpdateUserNotifications($id: ID!, $input: UserInput!) {
  updateUser(id: $id, input: $input) {
    id
    ...NotificationFields
  }
}
    ${NotificationFieldsFragmentDoc}`;
export type UpdateUserNotificationsMutationFn = Apollo.MutationFunction<UpdateUserNotificationsMutation, UpdateUserNotificationsMutationVariables>;

/**
 * __useUpdateUserNotificationsMutation__
 *
 * To run a mutation, you first call `useUpdateUserNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserNotificationsMutation, { data, loading, error }] = useUpdateUserNotificationsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserNotificationsMutation, UpdateUserNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserNotificationsMutation, UpdateUserNotificationsMutationVariables>(UpdateUserNotificationsDocument, options);
      }
export type UpdateUserNotificationsMutationHookResult = ReturnType<typeof useUpdateUserNotificationsMutation>;
export type UpdateUserNotificationsMutationResult = Apollo.MutationResult<UpdateUserNotificationsMutation>;
export type UpdateUserNotificationsMutationOptions = Apollo.BaseMutationOptions<UpdateUserNotificationsMutation, UpdateUserNotificationsMutationVariables>;
export const CreateUserSalaryDocument = gql`
    mutation CreateUserSalary($input: UserSalaryInput!) {
  createUserSalary(input: $input) {
    id
    amount
    fromDate
    toDate
  }
}
    `;
export type CreateUserSalaryMutationFn = Apollo.MutationFunction<CreateUserSalaryMutation, CreateUserSalaryMutationVariables>;

/**
 * __useCreateUserSalaryMutation__
 *
 * To run a mutation, you first call `useCreateUserSalaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserSalaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserSalaryMutation, { data, loading, error }] = useCreateUserSalaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserSalaryMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserSalaryMutation, CreateUserSalaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserSalaryMutation, CreateUserSalaryMutationVariables>(CreateUserSalaryDocument, options);
      }
export type CreateUserSalaryMutationHookResult = ReturnType<typeof useCreateUserSalaryMutation>;
export type CreateUserSalaryMutationResult = Apollo.MutationResult<CreateUserSalaryMutation>;
export type CreateUserSalaryMutationOptions = Apollo.BaseMutationOptions<CreateUserSalaryMutation, CreateUserSalaryMutationVariables>;
export const UserSalaryDocument = gql`
    query UserSalary($id: ID!) {
  userSalary(id: $id) {
    id
    amount
    fromDate
    toDate
  }
}
    `;

/**
 * __useUserSalaryQuery__
 *
 * To run a query within a React component, call `useUserSalaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSalaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSalaryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserSalaryQuery(baseOptions: Apollo.QueryHookOptions<UserSalaryQuery, UserSalaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSalaryQuery, UserSalaryQueryVariables>(UserSalaryDocument, options);
      }
export function useUserSalaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSalaryQuery, UserSalaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSalaryQuery, UserSalaryQueryVariables>(UserSalaryDocument, options);
        }
export type UserSalaryQueryHookResult = ReturnType<typeof useUserSalaryQuery>;
export type UserSalaryLazyQueryHookResult = ReturnType<typeof useUserSalaryLazyQuery>;
export type UserSalaryQueryResult = Apollo.QueryResult<UserSalaryQuery, UserSalaryQueryVariables>;
export const UpdateUserSalaryDocument = gql`
    mutation UpdateUserSalary($id: ID!, $input: UserSalaryInput!) {
  updateUserSalary(id: $id, input: $input) {
    id
    amount
    fromDate
    toDate
  }
}
    `;
export type UpdateUserSalaryMutationFn = Apollo.MutationFunction<UpdateUserSalaryMutation, UpdateUserSalaryMutationVariables>;

/**
 * __useUpdateUserSalaryMutation__
 *
 * To run a mutation, you first call `useUpdateUserSalaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSalaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSalaryMutation, { data, loading, error }] = useUpdateUserSalaryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserSalaryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserSalaryMutation, UpdateUserSalaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserSalaryMutation, UpdateUserSalaryMutationVariables>(UpdateUserSalaryDocument, options);
      }
export type UpdateUserSalaryMutationHookResult = ReturnType<typeof useUpdateUserSalaryMutation>;
export type UpdateUserSalaryMutationResult = Apollo.MutationResult<UpdateUserSalaryMutation>;
export type UpdateUserSalaryMutationOptions = Apollo.BaseMutationOptions<UpdateUserSalaryMutation, UpdateUserSalaryMutationVariables>;
export const CreateUserHourlyRateDocument = gql`
    mutation CreateUserHourlyRate($input: UserHourlyRateInput!) {
  createUserHourlyRate(input: $input) {
    id
    rate
    fromDate
    toDate
  }
}
    `;
export type CreateUserHourlyRateMutationFn = Apollo.MutationFunction<CreateUserHourlyRateMutation, CreateUserHourlyRateMutationVariables>;

/**
 * __useCreateUserHourlyRateMutation__
 *
 * To run a mutation, you first call `useCreateUserHourlyRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserHourlyRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserHourlyRateMutation, { data, loading, error }] = useCreateUserHourlyRateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserHourlyRateMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserHourlyRateMutation, CreateUserHourlyRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserHourlyRateMutation, CreateUserHourlyRateMutationVariables>(CreateUserHourlyRateDocument, options);
      }
export type CreateUserHourlyRateMutationHookResult = ReturnType<typeof useCreateUserHourlyRateMutation>;
export type CreateUserHourlyRateMutationResult = Apollo.MutationResult<CreateUserHourlyRateMutation>;
export type CreateUserHourlyRateMutationOptions = Apollo.BaseMutationOptions<CreateUserHourlyRateMutation, CreateUserHourlyRateMutationVariables>;
export const UserHourlyRateDocument = gql`
    query UserHourlyRate($id: ID!) {
  userHourlyRate(id: $id) {
    id
    rate
    fromDate
    toDate
  }
}
    `;

/**
 * __useUserHourlyRateQuery__
 *
 * To run a query within a React component, call `useUserHourlyRateQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserHourlyRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserHourlyRateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserHourlyRateQuery(baseOptions: Apollo.QueryHookOptions<UserHourlyRateQuery, UserHourlyRateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserHourlyRateQuery, UserHourlyRateQueryVariables>(UserHourlyRateDocument, options);
      }
export function useUserHourlyRateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserHourlyRateQuery, UserHourlyRateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserHourlyRateQuery, UserHourlyRateQueryVariables>(UserHourlyRateDocument, options);
        }
export type UserHourlyRateQueryHookResult = ReturnType<typeof useUserHourlyRateQuery>;
export type UserHourlyRateLazyQueryHookResult = ReturnType<typeof useUserHourlyRateLazyQuery>;
export type UserHourlyRateQueryResult = Apollo.QueryResult<UserHourlyRateQuery, UserHourlyRateQueryVariables>;
export const UpdateUserHourlyRateDocument = gql`
    mutation UpdateUserHourlyRate($id: ID!, $input: UserHourlyRateInput!) {
  updateUserHourlyRate(id: $id, input: $input) {
    id
    rate
    fromDate
    toDate
  }
}
    `;
export type UpdateUserHourlyRateMutationFn = Apollo.MutationFunction<UpdateUserHourlyRateMutation, UpdateUserHourlyRateMutationVariables>;

/**
 * __useUpdateUserHourlyRateMutation__
 *
 * To run a mutation, you first call `useUpdateUserHourlyRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserHourlyRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserHourlyRateMutation, { data, loading, error }] = useUpdateUserHourlyRateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserHourlyRateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserHourlyRateMutation, UpdateUserHourlyRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserHourlyRateMutation, UpdateUserHourlyRateMutationVariables>(UpdateUserHourlyRateDocument, options);
      }
export type UpdateUserHourlyRateMutationHookResult = ReturnType<typeof useUpdateUserHourlyRateMutation>;
export type UpdateUserHourlyRateMutationResult = Apollo.MutationResult<UpdateUserHourlyRateMutation>;
export type UpdateUserHourlyRateMutationOptions = Apollo.BaseMutationOptions<UpdateUserHourlyRateMutation, UpdateUserHourlyRateMutationVariables>;
export const UserHourlyRatesDocument = gql`
    query UserHourlyRates($order: String, $descending: Boolean, $after: String, $first: Int, $filter: UserHourlyRateFilterInput) {
  userHourlyRates(
    order: $order
    descending: $descending
    after: $after
    first: $first
    filter: $filter
  ) {
    nodes {
      id
      rate
      fromDate
      toDate
    }
    totalCount
  }
}
    `;

/**
 * __useUserHourlyRatesQuery__
 *
 * To run a query within a React component, call `useUserHourlyRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserHourlyRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserHourlyRatesQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUserHourlyRatesQuery(baseOptions?: Apollo.QueryHookOptions<UserHourlyRatesQuery, UserHourlyRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserHourlyRatesQuery, UserHourlyRatesQueryVariables>(UserHourlyRatesDocument, options);
      }
export function useUserHourlyRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserHourlyRatesQuery, UserHourlyRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserHourlyRatesQuery, UserHourlyRatesQueryVariables>(UserHourlyRatesDocument, options);
        }
export type UserHourlyRatesQueryHookResult = ReturnType<typeof useUserHourlyRatesQuery>;
export type UserHourlyRatesLazyQueryHookResult = ReturnType<typeof useUserHourlyRatesLazyQuery>;
export type UserHourlyRatesQueryResult = Apollo.QueryResult<UserHourlyRatesQuery, UserHourlyRatesQueryVariables>;
export const DeleteUserHourlyRateDocument = gql`
    mutation DeleteUserHourlyRate($id: ID!) {
  deleteUserHourlyRate(id: $id)
}
    `;
export type DeleteUserHourlyRateMutationFn = Apollo.MutationFunction<DeleteUserHourlyRateMutation, DeleteUserHourlyRateMutationVariables>;

/**
 * __useDeleteUserHourlyRateMutation__
 *
 * To run a mutation, you first call `useDeleteUserHourlyRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserHourlyRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserHourlyRateMutation, { data, loading, error }] = useDeleteUserHourlyRateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserHourlyRateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserHourlyRateMutation, DeleteUserHourlyRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserHourlyRateMutation, DeleteUserHourlyRateMutationVariables>(DeleteUserHourlyRateDocument, options);
      }
export type DeleteUserHourlyRateMutationHookResult = ReturnType<typeof useDeleteUserHourlyRateMutation>;
export type DeleteUserHourlyRateMutationResult = Apollo.MutationResult<DeleteUserHourlyRateMutation>;
export type DeleteUserHourlyRateMutationOptions = Apollo.BaseMutationOptions<DeleteUserHourlyRateMutation, DeleteUserHourlyRateMutationVariables>;
export const CreateUserCostDocument = gql`
    mutation CreateUserCost($input: UserCostInput!) {
  createUserCost(input: $input) {
    id
    amount
    frequency
    fromDate
    toDate
    notes
    userCostType {
      id
      name
    }
  }
}
    `;
export type CreateUserCostMutationFn = Apollo.MutationFunction<CreateUserCostMutation, CreateUserCostMutationVariables>;

/**
 * __useCreateUserCostMutation__
 *
 * To run a mutation, you first call `useCreateUserCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserCostMutation, { data, loading, error }] = useCreateUserCostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserCostMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserCostMutation, CreateUserCostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserCostMutation, CreateUserCostMutationVariables>(CreateUserCostDocument, options);
      }
export type CreateUserCostMutationHookResult = ReturnType<typeof useCreateUserCostMutation>;
export type CreateUserCostMutationResult = Apollo.MutationResult<CreateUserCostMutation>;
export type CreateUserCostMutationOptions = Apollo.BaseMutationOptions<CreateUserCostMutation, CreateUserCostMutationVariables>;
export const UserCostDocument = gql`
    query UserCost($id: ID!) {
  userCost(id: $id) {
    id
    amount
    frequency
    fromDate
    toDate
    notes
    userCostType {
      id
      name
    }
  }
}
    `;

/**
 * __useUserCostQuery__
 *
 * To run a query within a React component, call `useUserCostQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCostQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserCostQuery(baseOptions: Apollo.QueryHookOptions<UserCostQuery, UserCostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserCostQuery, UserCostQueryVariables>(UserCostDocument, options);
      }
export function useUserCostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserCostQuery, UserCostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserCostQuery, UserCostQueryVariables>(UserCostDocument, options);
        }
export type UserCostQueryHookResult = ReturnType<typeof useUserCostQuery>;
export type UserCostLazyQueryHookResult = ReturnType<typeof useUserCostLazyQuery>;
export type UserCostQueryResult = Apollo.QueryResult<UserCostQuery, UserCostQueryVariables>;
export const UpdateUserCostDocument = gql`
    mutation UpdateUserCost($id: ID!, $input: UserCostInput!) {
  updateUserCost(id: $id, input: $input) {
    id
    amount
    frequency
    fromDate
    toDate
    notes
    userCostType {
      id
      name
    }
  }
}
    `;
export type UpdateUserCostMutationFn = Apollo.MutationFunction<UpdateUserCostMutation, UpdateUserCostMutationVariables>;

/**
 * __useUpdateUserCostMutation__
 *
 * To run a mutation, you first call `useUpdateUserCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserCostMutation, { data, loading, error }] = useUpdateUserCostMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserCostMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserCostMutation, UpdateUserCostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserCostMutation, UpdateUserCostMutationVariables>(UpdateUserCostDocument, options);
      }
export type UpdateUserCostMutationHookResult = ReturnType<typeof useUpdateUserCostMutation>;
export type UpdateUserCostMutationResult = Apollo.MutationResult<UpdateUserCostMutation>;
export type UpdateUserCostMutationOptions = Apollo.BaseMutationOptions<UpdateUserCostMutation, UpdateUserCostMutationVariables>;
export const UserCostsDocument = gql`
    query UserCosts($order: String, $descending: Boolean, $after: String, $first: Int, $filter: UserCostFilterInput) {
  userCosts(
    order: $order
    descending: $descending
    after: $after
    first: $first
    filter: $filter
  ) {
    nodes {
      id
      amount
      frequency
      fromDate
      toDate
      notes
      userCostType {
        id
        name
      }
    }
    totalCount
  }
}
    `;

/**
 * __useUserCostsQuery__
 *
 * To run a query within a React component, call `useUserCostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCostsQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUserCostsQuery(baseOptions?: Apollo.QueryHookOptions<UserCostsQuery, UserCostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserCostsQuery, UserCostsQueryVariables>(UserCostsDocument, options);
      }
export function useUserCostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserCostsQuery, UserCostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserCostsQuery, UserCostsQueryVariables>(UserCostsDocument, options);
        }
export type UserCostsQueryHookResult = ReturnType<typeof useUserCostsQuery>;
export type UserCostsLazyQueryHookResult = ReturnType<typeof useUserCostsLazyQuery>;
export type UserCostsQueryResult = Apollo.QueryResult<UserCostsQuery, UserCostsQueryVariables>;
export const DeleteUserCostDocument = gql`
    mutation DeleteUserCost($id: ID!) {
  deleteUserCost(id: $id)
}
    `;
export type DeleteUserCostMutationFn = Apollo.MutationFunction<DeleteUserCostMutation, DeleteUserCostMutationVariables>;

/**
 * __useDeleteUserCostMutation__
 *
 * To run a mutation, you first call `useDeleteUserCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserCostMutation, { data, loading, error }] = useDeleteUserCostMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserCostMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserCostMutation, DeleteUserCostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserCostMutation, DeleteUserCostMutationVariables>(DeleteUserCostDocument, options);
      }
export type DeleteUserCostMutationHookResult = ReturnType<typeof useDeleteUserCostMutation>;
export type DeleteUserCostMutationResult = Apollo.MutationResult<DeleteUserCostMutation>;
export type DeleteUserCostMutationOptions = Apollo.BaseMutationOptions<DeleteUserCostMutation, DeleteUserCostMutationVariables>;
export const UserSalariesDocument = gql`
    query UserSalaries($order: String, $descending: Boolean, $after: String, $first: Int, $filter: UserSalaryFilterInput) {
  userSalaries(
    order: $order
    descending: $descending
    after: $after
    first: $first
    filter: $filter
  ) {
    nodes {
      id
      amount
      fromDate
      toDate
    }
    totalCount
  }
}
    `;

/**
 * __useUserSalariesQuery__
 *
 * To run a query within a React component, call `useUserSalariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSalariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSalariesQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUserSalariesQuery(baseOptions?: Apollo.QueryHookOptions<UserSalariesQuery, UserSalariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSalariesQuery, UserSalariesQueryVariables>(UserSalariesDocument, options);
      }
export function useUserSalariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSalariesQuery, UserSalariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSalariesQuery, UserSalariesQueryVariables>(UserSalariesDocument, options);
        }
export type UserSalariesQueryHookResult = ReturnType<typeof useUserSalariesQuery>;
export type UserSalariesLazyQueryHookResult = ReturnType<typeof useUserSalariesLazyQuery>;
export type UserSalariesQueryResult = Apollo.QueryResult<UserSalariesQuery, UserSalariesQueryVariables>;
export const DeleteUserSalaryDocument = gql`
    mutation DeleteUserSalary($id: ID!) {
  deleteUserSalary(id: $id)
}
    `;
export type DeleteUserSalaryMutationFn = Apollo.MutationFunction<DeleteUserSalaryMutation, DeleteUserSalaryMutationVariables>;

/**
 * __useDeleteUserSalaryMutation__
 *
 * To run a mutation, you first call `useDeleteUserSalaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserSalaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserSalaryMutation, { data, loading, error }] = useDeleteUserSalaryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserSalaryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserSalaryMutation, DeleteUserSalaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserSalaryMutation, DeleteUserSalaryMutationVariables>(DeleteUserSalaryDocument, options);
      }
export type DeleteUserSalaryMutationHookResult = ReturnType<typeof useDeleteUserSalaryMutation>;
export type DeleteUserSalaryMutationResult = Apollo.MutationResult<DeleteUserSalaryMutation>;
export type DeleteUserSalaryMutationOptions = Apollo.BaseMutationOptions<DeleteUserSalaryMutation, DeleteUserSalaryMutationVariables>;
export const CreatePerformanceTargetDocument = gql`
    mutation CreatePerformanceTarget($input: PerformanceTargetInput!) {
  createPerformanceTarget(input: $input) {
    id
    periodFromDate
    periodToDate
    formattedTimeCardMinutes
  }
}
    `;
export type CreatePerformanceTargetMutationFn = Apollo.MutationFunction<CreatePerformanceTargetMutation, CreatePerformanceTargetMutationVariables>;

/**
 * __useCreatePerformanceTargetMutation__
 *
 * To run a mutation, you first call `useCreatePerformanceTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePerformanceTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPerformanceTargetMutation, { data, loading, error }] = useCreatePerformanceTargetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePerformanceTargetMutation(baseOptions?: Apollo.MutationHookOptions<CreatePerformanceTargetMutation, CreatePerformanceTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePerformanceTargetMutation, CreatePerformanceTargetMutationVariables>(CreatePerformanceTargetDocument, options);
      }
export type CreatePerformanceTargetMutationHookResult = ReturnType<typeof useCreatePerformanceTargetMutation>;
export type CreatePerformanceTargetMutationResult = Apollo.MutationResult<CreatePerformanceTargetMutation>;
export type CreatePerformanceTargetMutationOptions = Apollo.BaseMutationOptions<CreatePerformanceTargetMutation, CreatePerformanceTargetMutationVariables>;
export const PerformanceTargetDocument = gql`
    query PerformanceTarget($id: ID!) {
  performanceTarget(id: $id) {
    id
    periodFromDate
    periodToDate
    formattedTimeCardMinutes
  }
}
    `;

/**
 * __usePerformanceTargetQuery__
 *
 * To run a query within a React component, call `usePerformanceTargetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerformanceTargetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerformanceTargetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePerformanceTargetQuery(baseOptions: Apollo.QueryHookOptions<PerformanceTargetQuery, PerformanceTargetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PerformanceTargetQuery, PerformanceTargetQueryVariables>(PerformanceTargetDocument, options);
      }
export function usePerformanceTargetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PerformanceTargetQuery, PerformanceTargetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PerformanceTargetQuery, PerformanceTargetQueryVariables>(PerformanceTargetDocument, options);
        }
export type PerformanceTargetQueryHookResult = ReturnType<typeof usePerformanceTargetQuery>;
export type PerformanceTargetLazyQueryHookResult = ReturnType<typeof usePerformanceTargetLazyQuery>;
export type PerformanceTargetQueryResult = Apollo.QueryResult<PerformanceTargetQuery, PerformanceTargetQueryVariables>;
export const UpdatePerformanceTargetDocument = gql`
    mutation UpdatePerformanceTarget($id: ID!, $input: PerformanceTargetInput!) {
  updatePerformanceTarget(id: $id, input: $input) {
    id
    periodFromDate
    periodToDate
    formattedTimeCardMinutes
  }
}
    `;
export type UpdatePerformanceTargetMutationFn = Apollo.MutationFunction<UpdatePerformanceTargetMutation, UpdatePerformanceTargetMutationVariables>;

/**
 * __useUpdatePerformanceTargetMutation__
 *
 * To run a mutation, you first call `useUpdatePerformanceTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePerformanceTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePerformanceTargetMutation, { data, loading, error }] = useUpdatePerformanceTargetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePerformanceTargetMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePerformanceTargetMutation, UpdatePerformanceTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePerformanceTargetMutation, UpdatePerformanceTargetMutationVariables>(UpdatePerformanceTargetDocument, options);
      }
export type UpdatePerformanceTargetMutationHookResult = ReturnType<typeof useUpdatePerformanceTargetMutation>;
export type UpdatePerformanceTargetMutationResult = Apollo.MutationResult<UpdatePerformanceTargetMutation>;
export type UpdatePerformanceTargetMutationOptions = Apollo.BaseMutationOptions<UpdatePerformanceTargetMutation, UpdatePerformanceTargetMutationVariables>;
export const PerformanceTargetsDocument = gql`
    query PerformanceTargets($order: String, $descending: Boolean, $after: String, $first: Int, $filter: PerformanceTargetFilterInput) {
  performanceTargets(
    order: $order
    descending: $descending
    after: $after
    first: $first
    filter: $filter
  ) {
    nodes {
      id
      periodFromDate
      periodToDate
      formattedTimeCardMinutes
    }
    totalCount
  }
}
    `;

/**
 * __usePerformanceTargetsQuery__
 *
 * To run a query within a React component, call `usePerformanceTargetsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerformanceTargetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerformanceTargetsQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePerformanceTargetsQuery(baseOptions?: Apollo.QueryHookOptions<PerformanceTargetsQuery, PerformanceTargetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PerformanceTargetsQuery, PerformanceTargetsQueryVariables>(PerformanceTargetsDocument, options);
      }
export function usePerformanceTargetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PerformanceTargetsQuery, PerformanceTargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PerformanceTargetsQuery, PerformanceTargetsQueryVariables>(PerformanceTargetsDocument, options);
        }
export type PerformanceTargetsQueryHookResult = ReturnType<typeof usePerformanceTargetsQuery>;
export type PerformanceTargetsLazyQueryHookResult = ReturnType<typeof usePerformanceTargetsLazyQuery>;
export type PerformanceTargetsQueryResult = Apollo.QueryResult<PerformanceTargetsQuery, PerformanceTargetsQueryVariables>;
export const DeletePerformanceTargetDocument = gql`
    mutation DeletePerformanceTarget($id: ID!) {
  deletePerformanceTarget(id: $id)
}
    `;
export type DeletePerformanceTargetMutationFn = Apollo.MutationFunction<DeletePerformanceTargetMutation, DeletePerformanceTargetMutationVariables>;

/**
 * __useDeletePerformanceTargetMutation__
 *
 * To run a mutation, you first call `useDeletePerformanceTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePerformanceTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePerformanceTargetMutation, { data, loading, error }] = useDeletePerformanceTargetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePerformanceTargetMutation(baseOptions?: Apollo.MutationHookOptions<DeletePerformanceTargetMutation, DeletePerformanceTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePerformanceTargetMutation, DeletePerformanceTargetMutationVariables>(DeletePerformanceTargetDocument, options);
      }
export type DeletePerformanceTargetMutationHookResult = ReturnType<typeof useDeletePerformanceTargetMutation>;
export type DeletePerformanceTargetMutationResult = Apollo.MutationResult<DeletePerformanceTargetMutation>;
export type DeletePerformanceTargetMutationOptions = Apollo.BaseMutationOptions<DeletePerformanceTargetMutation, DeletePerformanceTargetMutationVariables>;
export const ClientPresenceDocument = gql`
    query ClientPresence($filter: ClientFilterInput, $search: String) {
  clientPresence(filter: $filter, search: $search)
}
    `;

/**
 * __useClientPresenceQuery__
 *
 * To run a query within a React component, call `useClientPresenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientPresenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientPresenceQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useClientPresenceQuery(baseOptions?: Apollo.QueryHookOptions<ClientPresenceQuery, ClientPresenceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientPresenceQuery, ClientPresenceQueryVariables>(ClientPresenceDocument, options);
      }
export function useClientPresenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientPresenceQuery, ClientPresenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientPresenceQuery, ClientPresenceQueryVariables>(ClientPresenceDocument, options);
        }
export type ClientPresenceQueryHookResult = ReturnType<typeof useClientPresenceQuery>;
export type ClientPresenceLazyQueryHookResult = ReturnType<typeof useClientPresenceLazyQuery>;
export type ClientPresenceQueryResult = Apollo.QueryResult<ClientPresenceQuery, ClientPresenceQueryVariables>;
export const CreateClientDocument = gql`
    mutation CreateClient($input: ClientInput!) {
  createClient(input: $input) {
    id
  }
}
    `;
export type CreateClientMutationFn = Apollo.MutationFunction<CreateClientMutation, CreateClientMutationVariables>;

/**
 * __useCreateClientMutation__
 *
 * To run a mutation, you first call `useCreateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientMutation, { data, loading, error }] = useCreateClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClientMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientMutation, CreateClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientMutation, CreateClientMutationVariables>(CreateClientDocument, options);
      }
export type CreateClientMutationHookResult = ReturnType<typeof useCreateClientMutation>;
export type CreateClientMutationResult = Apollo.MutationResult<CreateClientMutation>;
export type CreateClientMutationOptions = Apollo.BaseMutationOptions<CreateClientMutation, CreateClientMutationVariables>;
export const CreateUserNoteDocument = gql`
    mutation CreateUserNote($input: UserNoteInput!) {
  createUserNote(input: $input) {
    id
  }
}
    `;
export type CreateUserNoteMutationFn = Apollo.MutationFunction<CreateUserNoteMutation, CreateUserNoteMutationVariables>;

/**
 * __useCreateUserNoteMutation__
 *
 * To run a mutation, you first call `useCreateUserNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserNoteMutation, { data, loading, error }] = useCreateUserNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserNoteMutation, CreateUserNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserNoteMutation, CreateUserNoteMutationVariables>(CreateUserNoteDocument, options);
      }
export type CreateUserNoteMutationHookResult = ReturnType<typeof useCreateUserNoteMutation>;
export type CreateUserNoteMutationResult = Apollo.MutationResult<CreateUserNoteMutation>;
export type CreateUserNoteMutationOptions = Apollo.BaseMutationOptions<CreateUserNoteMutation, CreateUserNoteMutationVariables>;
export const CreateClientDetailsDocument = gql`
    query CreateClientDetails {
  priceLists(filter: {default: true}) {
    nodes {
      ...PriceListsFields
    }
  }
  currentAccount {
    id
    locale
    currency {
      id
      name
    }
    paymentTerm {
      id
      days
    }
  }
  entities {
    nodes {
      ...EntityFields
    }
    totalCount
  }
}
    ${PriceListsFieldsFragmentDoc}
${EntityFieldsFragmentDoc}`;

/**
 * __useCreateClientDetailsQuery__
 *
 * To run a query within a React component, call `useCreateClientDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateClientDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateClientDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreateClientDetailsQuery(baseOptions?: Apollo.QueryHookOptions<CreateClientDetailsQuery, CreateClientDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateClientDetailsQuery, CreateClientDetailsQueryVariables>(CreateClientDetailsDocument, options);
      }
export function useCreateClientDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateClientDetailsQuery, CreateClientDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateClientDetailsQuery, CreateClientDetailsQueryVariables>(CreateClientDetailsDocument, options);
        }
export type CreateClientDetailsQueryHookResult = ReturnType<typeof useCreateClientDetailsQuery>;
export type CreateClientDetailsLazyQueryHookResult = ReturnType<typeof useCreateClientDetailsLazyQuery>;
export type CreateClientDetailsQueryResult = Apollo.QueryResult<CreateClientDetailsQuery, CreateClientDetailsQueryVariables>;
export const ClientDocument = gql`
    query Client($id: ID!) {
  client(id: $id) {
    ...FullClientFields
  }
}
    ${FullClientFieldsFragmentDoc}`;

/**
 * __useClientQuery__
 *
 * To run a query within a React component, call `useClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClientQuery(baseOptions: Apollo.QueryHookOptions<ClientQuery, ClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientQuery, ClientQueryVariables>(ClientDocument, options);
      }
export function useClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientQuery, ClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientQuery, ClientQueryVariables>(ClientDocument, options);
        }
export type ClientQueryHookResult = ReturnType<typeof useClientQuery>;
export type ClientLazyQueryHookResult = ReturnType<typeof useClientLazyQuery>;
export type ClientQueryResult = Apollo.QueryResult<ClientQuery, ClientQueryVariables>;
export const UpdateClientDocument = gql`
    mutation UpdateClient($id: ID!, $input: ClientInput!) {
  updateClient(id: $id, input: $input) {
    ...FullClientFields
  }
}
    ${FullClientFieldsFragmentDoc}`;
export type UpdateClientMutationFn = Apollo.MutationFunction<UpdateClientMutation, UpdateClientMutationVariables>;

/**
 * __useUpdateClientMutation__
 *
 * To run a mutation, you first call `useUpdateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientMutation, { data, loading, error }] = useUpdateClientMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientMutation, UpdateClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientMutation, UpdateClientMutationVariables>(UpdateClientDocument, options);
      }
export type UpdateClientMutationHookResult = ReturnType<typeof useUpdateClientMutation>;
export type UpdateClientMutationResult = Apollo.MutationResult<UpdateClientMutation>;
export type UpdateClientMutationOptions = Apollo.BaseMutationOptions<UpdateClientMutation, UpdateClientMutationVariables>;
export const ClientOwnershipDocument = gql`
    query ClientOwnership($id: ID!) {
  client(id: $id) {
    id
    clientOwners {
      id
      ownershipPercentage
      user {
        id
        fullName
      }
    }
  }
}
    `;

/**
 * __useClientOwnershipQuery__
 *
 * To run a query within a React component, call `useClientOwnershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientOwnershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientOwnershipQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClientOwnershipQuery(baseOptions: Apollo.QueryHookOptions<ClientOwnershipQuery, ClientOwnershipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientOwnershipQuery, ClientOwnershipQueryVariables>(ClientOwnershipDocument, options);
      }
export function useClientOwnershipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientOwnershipQuery, ClientOwnershipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientOwnershipQuery, ClientOwnershipQueryVariables>(ClientOwnershipDocument, options);
        }
export type ClientOwnershipQueryHookResult = ReturnType<typeof useClientOwnershipQuery>;
export type ClientOwnershipLazyQueryHookResult = ReturnType<typeof useClientOwnershipLazyQuery>;
export type ClientOwnershipQueryResult = Apollo.QueryResult<ClientOwnershipQuery, ClientOwnershipQueryVariables>;
export const ClientManagersDocument = gql`
    query ClientManagers($id: ID!) {
  client(id: $id) {
    id
    clientManagers {
      id
      fromDate
      toDate
      createdAt
      manager {
        id
        fullName
      }
    }
  }
}
    `;

/**
 * __useClientManagersQuery__
 *
 * To run a query within a React component, call `useClientManagersQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientManagersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientManagersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClientManagersQuery(baseOptions: Apollo.QueryHookOptions<ClientManagersQuery, ClientManagersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientManagersQuery, ClientManagersQueryVariables>(ClientManagersDocument, options);
      }
export function useClientManagersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientManagersQuery, ClientManagersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientManagersQuery, ClientManagersQueryVariables>(ClientManagersDocument, options);
        }
export type ClientManagersQueryHookResult = ReturnType<typeof useClientManagersQuery>;
export type ClientManagersLazyQueryHookResult = ReturnType<typeof useClientManagersLazyQuery>;
export type ClientManagersQueryResult = Apollo.QueryResult<ClientManagersQuery, ClientManagersQueryVariables>;
export const ClientOwnershipPeriodsDocument = gql`
    query ClientOwnershipPeriods($id: ID!) {
  client(id: $id) {
    id
    clientOwnershipPeriods {
      id
      fromDate
      toDate
      createdAt
      owners {
        ownershipPercentage
        user {
          id
          fullName
        }
      }
    }
  }
}
    `;

/**
 * __useClientOwnershipPeriodsQuery__
 *
 * To run a query within a React component, call `useClientOwnershipPeriodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientOwnershipPeriodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientOwnershipPeriodsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClientOwnershipPeriodsQuery(baseOptions: Apollo.QueryHookOptions<ClientOwnershipPeriodsQuery, ClientOwnershipPeriodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientOwnershipPeriodsQuery, ClientOwnershipPeriodsQueryVariables>(ClientOwnershipPeriodsDocument, options);
      }
export function useClientOwnershipPeriodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientOwnershipPeriodsQuery, ClientOwnershipPeriodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientOwnershipPeriodsQuery, ClientOwnershipPeriodsQueryVariables>(ClientOwnershipPeriodsDocument, options);
        }
export type ClientOwnershipPeriodsQueryHookResult = ReturnType<typeof useClientOwnershipPeriodsQuery>;
export type ClientOwnershipPeriodsLazyQueryHookResult = ReturnType<typeof useClientOwnershipPeriodsLazyQuery>;
export type ClientOwnershipPeriodsQueryResult = Apollo.QueryResult<ClientOwnershipPeriodsQuery, ClientOwnershipPeriodsQueryVariables>;
export const ClientBillingDataDocument = gql`
    query ClientBillingData($id: ID!) {
  client(id: $id) {
    ...ClientBillingFields
  }
}
    ${ClientBillingFieldsFragmentDoc}`;

/**
 * __useClientBillingDataQuery__
 *
 * To run a query within a React component, call `useClientBillingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientBillingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientBillingDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClientBillingDataQuery(baseOptions: Apollo.QueryHookOptions<ClientBillingDataQuery, ClientBillingDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientBillingDataQuery, ClientBillingDataQueryVariables>(ClientBillingDataDocument, options);
      }
export function useClientBillingDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientBillingDataQuery, ClientBillingDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientBillingDataQuery, ClientBillingDataQueryVariables>(ClientBillingDataDocument, options);
        }
export type ClientBillingDataQueryHookResult = ReturnType<typeof useClientBillingDataQuery>;
export type ClientBillingDataLazyQueryHookResult = ReturnType<typeof useClientBillingDataLazyQuery>;
export type ClientBillingDataQueryResult = Apollo.QueryResult<ClientBillingDataQuery, ClientBillingDataQueryVariables>;
export const ClientsDocument = gql`
    query Clients($order: String, $descending: Boolean, $after: String, $first: Int, $filter: ClientFilterInput, $search: String, $scope: String) {
  clients(
    order: $order
    descending: $descending
    after: $after
    first: $first
    filter: $filter
    search: $search
    scope: $scope
  ) {
    nodes {
      id
      fullName
      entityType
      country
      amlStatus
      antiMoneyLaunderingDate
      industry {
        id
        name
      }
      clientOwners {
        id
        ownershipPercentage
        user {
          id
          fullName
        }
      }
      legalCasesCount
      formattedTotalMinutes
      formattedInvoicedMinutes
      formattedUninvoicedMinutes
      formattedNonBillableMinutes
      lastTcDate
      inactivatedAt
      clientStatus
    }
    totalCount
  }
}
    `;

/**
 * __useClientsQuery__
 *
 * To run a query within a React component, call `useClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientsQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *      search: // value for 'search'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useClientsQuery(baseOptions?: Apollo.QueryHookOptions<ClientsQuery, ClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientsQuery, ClientsQueryVariables>(ClientsDocument, options);
      }
export function useClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientsQuery, ClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientsQuery, ClientsQueryVariables>(ClientsDocument, options);
        }
export type ClientsQueryHookResult = ReturnType<typeof useClientsQuery>;
export type ClientsLazyQueryHookResult = ReturnType<typeof useClientsLazyQuery>;
export type ClientsQueryResult = Apollo.QueryResult<ClientsQuery, ClientsQueryVariables>;
export const AutocompleteClientsDocument = gql`
    query AutocompleteClients($search: String) {
  clients(search: $search) {
    nodes {
      id
      fullName
    }
  }
}
    `;

/**
 * __useAutocompleteClientsQuery__
 *
 * To run a query within a React component, call `useAutocompleteClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteClientsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAutocompleteClientsQuery(baseOptions?: Apollo.QueryHookOptions<AutocompleteClientsQuery, AutocompleteClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompleteClientsQuery, AutocompleteClientsQueryVariables>(AutocompleteClientsDocument, options);
      }
export function useAutocompleteClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompleteClientsQuery, AutocompleteClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompleteClientsQuery, AutocompleteClientsQueryVariables>(AutocompleteClientsDocument, options);
        }
export type AutocompleteClientsQueryHookResult = ReturnType<typeof useAutocompleteClientsQuery>;
export type AutocompleteClientsLazyQueryHookResult = ReturnType<typeof useAutocompleteClientsLazyQuery>;
export type AutocompleteClientsQueryResult = Apollo.QueryResult<AutocompleteClientsQuery, AutocompleteClientsQueryVariables>;
export const AutocompleteClientsExpandedDocument = gql`
    query AutocompleteClientsExpanded($search: String) {
  clients(search: $search) {
    nodes {
      id
      fullName
      language
      hasInvoicing
      invoicingCurrency {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useAutocompleteClientsExpandedQuery__
 *
 * To run a query within a React component, call `useAutocompleteClientsExpandedQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteClientsExpandedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteClientsExpandedQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAutocompleteClientsExpandedQuery(baseOptions?: Apollo.QueryHookOptions<AutocompleteClientsExpandedQuery, AutocompleteClientsExpandedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompleteClientsExpandedQuery, AutocompleteClientsExpandedQueryVariables>(AutocompleteClientsExpandedDocument, options);
      }
export function useAutocompleteClientsExpandedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompleteClientsExpandedQuery, AutocompleteClientsExpandedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompleteClientsExpandedQuery, AutocompleteClientsExpandedQueryVariables>(AutocompleteClientsExpandedDocument, options);
        }
export type AutocompleteClientsExpandedQueryHookResult = ReturnType<typeof useAutocompleteClientsExpandedQuery>;
export type AutocompleteClientsExpandedLazyQueryHookResult = ReturnType<typeof useAutocompleteClientsExpandedLazyQuery>;
export type AutocompleteClientsExpandedQueryResult = Apollo.QueryResult<AutocompleteClientsExpandedQuery, AutocompleteClientsExpandedQueryVariables>;
export const DeleteClientDocument = gql`
    mutation DeleteClient($id: ID!) {
  deleteClient(id: $id)
}
    `;
export type DeleteClientMutationFn = Apollo.MutationFunction<DeleteClientMutation, DeleteClientMutationVariables>;

/**
 * __useDeleteClientMutation__
 *
 * To run a mutation, you first call `useDeleteClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientMutation, { data, loading, error }] = useDeleteClientMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClientMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientMutation, DeleteClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClientMutation, DeleteClientMutationVariables>(DeleteClientDocument, options);
      }
export type DeleteClientMutationHookResult = ReturnType<typeof useDeleteClientMutation>;
export type DeleteClientMutationResult = Apollo.MutationResult<DeleteClientMutation>;
export type DeleteClientMutationOptions = Apollo.BaseMutationOptions<DeleteClientMutation, DeleteClientMutationVariables>;
export const ClientsExportDocument = gql`
    query ClientsExport($order: String, $descending: Boolean, $filter: ClientFilterInput, $search: String, $scope: String) {
  clients(
    order: $order
    descending: $descending
    filter: $filter
    search: $search
    scope: $scope
  ) {
    xlsxExport {
      filename
      content
    }
  }
}
    `;

/**
 * __useClientsExportQuery__
 *
 * To run a query within a React component, call `useClientsExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientsExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientsExportQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      filter: // value for 'filter'
 *      search: // value for 'search'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useClientsExportQuery(baseOptions?: Apollo.QueryHookOptions<ClientsExportQuery, ClientsExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientsExportQuery, ClientsExportQueryVariables>(ClientsExportDocument, options);
      }
export function useClientsExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientsExportQuery, ClientsExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientsExportQuery, ClientsExportQueryVariables>(ClientsExportDocument, options);
        }
export type ClientsExportQueryHookResult = ReturnType<typeof useClientsExportQuery>;
export type ClientsExportLazyQueryHookResult = ReturnType<typeof useClientsExportLazyQuery>;
export type ClientsExportQueryResult = Apollo.QueryResult<ClientsExportQuery, ClientsExportQueryVariables>;
export const MarketingEffortDocument = gql`
    query MarketingEffort($id: ID!) {
  marketingEffort(id: $id) {
    id
    clientId
    startedAt
    marketingEffortType {
      id
      name
    }
    marketingEffortResponseType {
      id
      name
    }
    marketingEffortNeedTypes {
      id
      name
    }
    nextStepComment
    comment
  }
}
    `;

/**
 * __useMarketingEffortQuery__
 *
 * To run a query within a React component, call `useMarketingEffortQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingEffortQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingEffortQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarketingEffortQuery(baseOptions: Apollo.QueryHookOptions<MarketingEffortQuery, MarketingEffortQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketingEffortQuery, MarketingEffortQueryVariables>(MarketingEffortDocument, options);
      }
export function useMarketingEffortLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingEffortQuery, MarketingEffortQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketingEffortQuery, MarketingEffortQueryVariables>(MarketingEffortDocument, options);
        }
export type MarketingEffortQueryHookResult = ReturnType<typeof useMarketingEffortQuery>;
export type MarketingEffortLazyQueryHookResult = ReturnType<typeof useMarketingEffortLazyQuery>;
export type MarketingEffortQueryResult = Apollo.QueryResult<MarketingEffortQuery, MarketingEffortQueryVariables>;
export const MarketingEffortsDocument = gql`
    query MarketingEfforts($order: String, $descending: Boolean, $after: String, $first: Int, $search: String, $filter: MarketingEffortFilterInput) {
  marketingEfforts(
    order: $order
    descending: $descending
    after: $after
    first: $first
    search: $search
    filter: $filter
  ) {
    nodes {
      id
      startedAt
      marketingEffortType {
        id
        name
      }
      marketingEffortResponseType {
        id
        name
      }
      marketingEffortNeedTypes {
        id
        name
      }
      nextStepComment
      comment
      createdBy {
        id
        fullName
      }
      createdAt
    }
    totalCount
  }
}
    `;

/**
 * __useMarketingEffortsQuery__
 *
 * To run a query within a React component, call `useMarketingEffortsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingEffortsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingEffortsQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMarketingEffortsQuery(baseOptions?: Apollo.QueryHookOptions<MarketingEffortsQuery, MarketingEffortsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketingEffortsQuery, MarketingEffortsQueryVariables>(MarketingEffortsDocument, options);
      }
export function useMarketingEffortsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingEffortsQuery, MarketingEffortsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketingEffortsQuery, MarketingEffortsQueryVariables>(MarketingEffortsDocument, options);
        }
export type MarketingEffortsQueryHookResult = ReturnType<typeof useMarketingEffortsQuery>;
export type MarketingEffortsLazyQueryHookResult = ReturnType<typeof useMarketingEffortsLazyQuery>;
export type MarketingEffortsQueryResult = Apollo.QueryResult<MarketingEffortsQuery, MarketingEffortsQueryVariables>;
export const CreateMarketingEffortDocument = gql`
    mutation CreateMarketingEffort($input: MarketingEffortInput!) {
  createMarketingEffort(input: $input) {
    id
  }
}
    `;
export type CreateMarketingEffortMutationFn = Apollo.MutationFunction<CreateMarketingEffortMutation, CreateMarketingEffortMutationVariables>;

/**
 * __useCreateMarketingEffortMutation__
 *
 * To run a mutation, you first call `useCreateMarketingEffortMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMarketingEffortMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMarketingEffortMutation, { data, loading, error }] = useCreateMarketingEffortMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMarketingEffortMutation(baseOptions?: Apollo.MutationHookOptions<CreateMarketingEffortMutation, CreateMarketingEffortMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMarketingEffortMutation, CreateMarketingEffortMutationVariables>(CreateMarketingEffortDocument, options);
      }
export type CreateMarketingEffortMutationHookResult = ReturnType<typeof useCreateMarketingEffortMutation>;
export type CreateMarketingEffortMutationResult = Apollo.MutationResult<CreateMarketingEffortMutation>;
export type CreateMarketingEffortMutationOptions = Apollo.BaseMutationOptions<CreateMarketingEffortMutation, CreateMarketingEffortMutationVariables>;
export const UpdateMarketingEffortDocument = gql`
    mutation UpdateMarketingEffort($id: ID!, $input: MarketingEffortInput!) {
  updateMarketingEffort(id: $id, input: $input) {
    id
    startedAt
    marketingEffortType {
      id
      name
    }
    marketingEffortResponseType {
      id
      name
    }
    marketingEffortNeedTypes {
      id
      name
    }
    nextStepComment
    comment
  }
}
    `;
export type UpdateMarketingEffortMutationFn = Apollo.MutationFunction<UpdateMarketingEffortMutation, UpdateMarketingEffortMutationVariables>;

/**
 * __useUpdateMarketingEffortMutation__
 *
 * To run a mutation, you first call `useUpdateMarketingEffortMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMarketingEffortMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMarketingEffortMutation, { data, loading, error }] = useUpdateMarketingEffortMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMarketingEffortMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMarketingEffortMutation, UpdateMarketingEffortMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMarketingEffortMutation, UpdateMarketingEffortMutationVariables>(UpdateMarketingEffortDocument, options);
      }
export type UpdateMarketingEffortMutationHookResult = ReturnType<typeof useUpdateMarketingEffortMutation>;
export type UpdateMarketingEffortMutationResult = Apollo.MutationResult<UpdateMarketingEffortMutation>;
export type UpdateMarketingEffortMutationOptions = Apollo.BaseMutationOptions<UpdateMarketingEffortMutation, UpdateMarketingEffortMutationVariables>;
export const DeleteMarketingEffortDocument = gql`
    mutation DeleteMarketingEffort($id: ID!) {
  deleteMarketingEffort(id: $id)
}
    `;
export type DeleteMarketingEffortMutationFn = Apollo.MutationFunction<DeleteMarketingEffortMutation, DeleteMarketingEffortMutationVariables>;

/**
 * __useDeleteMarketingEffortMutation__
 *
 * To run a mutation, you first call `useDeleteMarketingEffortMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMarketingEffortMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMarketingEffortMutation, { data, loading, error }] = useDeleteMarketingEffortMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMarketingEffortMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMarketingEffortMutation, DeleteMarketingEffortMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMarketingEffortMutation, DeleteMarketingEffortMutationVariables>(DeleteMarketingEffortDocument, options);
      }
export type DeleteMarketingEffortMutationHookResult = ReturnType<typeof useDeleteMarketingEffortMutation>;
export type DeleteMarketingEffortMutationResult = Apollo.MutationResult<DeleteMarketingEffortMutation>;
export type DeleteMarketingEffortMutationOptions = Apollo.BaseMutationOptions<DeleteMarketingEffortMutation, DeleteMarketingEffortMutationVariables>;
export const MarketingEffortsExportDocument = gql`
    query MarketingEffortsExport($order: String, $descending: Boolean, $filter: MarketingEffortFilterInput, $search: String) {
  marketingEfforts(
    order: $order
    descending: $descending
    filter: $filter
    search: $search
  ) {
    xlsxExport {
      filename
      content
    }
  }
}
    `;

/**
 * __useMarketingEffortsExportQuery__
 *
 * To run a query within a React component, call `useMarketingEffortsExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingEffortsExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingEffortsExportQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      filter: // value for 'filter'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useMarketingEffortsExportQuery(baseOptions?: Apollo.QueryHookOptions<MarketingEffortsExportQuery, MarketingEffortsExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketingEffortsExportQuery, MarketingEffortsExportQueryVariables>(MarketingEffortsExportDocument, options);
      }
export function useMarketingEffortsExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingEffortsExportQuery, MarketingEffortsExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketingEffortsExportQuery, MarketingEffortsExportQueryVariables>(MarketingEffortsExportDocument, options);
        }
export type MarketingEffortsExportQueryHookResult = ReturnType<typeof useMarketingEffortsExportQuery>;
export type MarketingEffortsExportLazyQueryHookResult = ReturnType<typeof useMarketingEffortsExportLazyQuery>;
export type MarketingEffortsExportQueryResult = Apollo.QueryResult<MarketingEffortsExportQuery, MarketingEffortsExportQueryVariables>;
export const ClientProfitabilityDocument = gql`
    query ClientProfitability($clientId: ID!, $dateFrom: ISO8601Date!, $dateTo: ISO8601Date!, $invoiceFilter: String) {
  clientProfitability(
    clientId: $clientId
    dateFrom: $dateFrom
    dateTo: $dateTo
    invoiceFilter: $invoiceFilter
  ) {
    revenue
    totalDirectCost
    totalIndirectCost
    profitability
    currency {
      id
      name
    }
    invoices {
      totalValue
      invoice {
        id
        number
        state
        includedRecordsPeriodFromDate
        includedRecordsPeriodToDate
      }
    }
    rows {
      user {
        id
        fullName
      }
      invoicedMinutes
      revenue
      directCost
      indirectCost
      profitability
      missingCostData
      totalRow
    }
  }
}
    `;

/**
 * __useClientProfitabilityQuery__
 *
 * To run a query within a React component, call `useClientProfitabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientProfitabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientProfitabilityQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      invoiceFilter: // value for 'invoiceFilter'
 *   },
 * });
 */
export function useClientProfitabilityQuery(baseOptions: Apollo.QueryHookOptions<ClientProfitabilityQuery, ClientProfitabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientProfitabilityQuery, ClientProfitabilityQueryVariables>(ClientProfitabilityDocument, options);
      }
export function useClientProfitabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientProfitabilityQuery, ClientProfitabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientProfitabilityQuery, ClientProfitabilityQueryVariables>(ClientProfitabilityDocument, options);
        }
export type ClientProfitabilityQueryHookResult = ReturnType<typeof useClientProfitabilityQuery>;
export type ClientProfitabilityLazyQueryHookResult = ReturnType<typeof useClientProfitabilityLazyQuery>;
export type ClientProfitabilityQueryResult = Apollo.QueryResult<ClientProfitabilityQuery, ClientProfitabilityQueryVariables>;
export const DownloadProfitabilityReportDocument = gql`
    mutation DownloadProfitabilityReport($scopeType: String!, $scopeId: ID!, $dateFrom: ISO8601Date!, $dateTo: ISO8601Date!) {
  reportProfitability(
    scopeType: $scopeType
    scopeId: $scopeId
    dateFrom: $dateFrom
    dateTo: $dateTo
  ) {
    content
    filename
  }
}
    `;
export type DownloadProfitabilityReportMutationFn = Apollo.MutationFunction<DownloadProfitabilityReportMutation, DownloadProfitabilityReportMutationVariables>;

/**
 * __useDownloadProfitabilityReportMutation__
 *
 * To run a mutation, you first call `useDownloadProfitabilityReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadProfitabilityReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadProfitabilityReportMutation, { data, loading, error }] = useDownloadProfitabilityReportMutation({
 *   variables: {
 *      scopeType: // value for 'scopeType'
 *      scopeId: // value for 'scopeId'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useDownloadProfitabilityReportMutation(baseOptions?: Apollo.MutationHookOptions<DownloadProfitabilityReportMutation, DownloadProfitabilityReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadProfitabilityReportMutation, DownloadProfitabilityReportMutationVariables>(DownloadProfitabilityReportDocument, options);
      }
export type DownloadProfitabilityReportMutationHookResult = ReturnType<typeof useDownloadProfitabilityReportMutation>;
export type DownloadProfitabilityReportMutationResult = Apollo.MutationResult<DownloadProfitabilityReportMutation>;
export type DownloadProfitabilityReportMutationOptions = Apollo.BaseMutationOptions<DownloadProfitabilityReportMutation, DownloadProfitabilityReportMutationVariables>;
export const ContactPresenceDocument = gql`
    query ContactPresence($filter: ContactFilterInput, $search: String) {
  contactPresence(filter: $filter, search: $search)
}
    `;

/**
 * __useContactPresenceQuery__
 *
 * To run a query within a React component, call `useContactPresenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactPresenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactPresenceQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useContactPresenceQuery(baseOptions?: Apollo.QueryHookOptions<ContactPresenceQuery, ContactPresenceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactPresenceQuery, ContactPresenceQueryVariables>(ContactPresenceDocument, options);
      }
export function useContactPresenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactPresenceQuery, ContactPresenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactPresenceQuery, ContactPresenceQueryVariables>(ContactPresenceDocument, options);
        }
export type ContactPresenceQueryHookResult = ReturnType<typeof useContactPresenceQuery>;
export type ContactPresenceLazyQueryHookResult = ReturnType<typeof useContactPresenceLazyQuery>;
export type ContactPresenceQueryResult = Apollo.QueryResult<ContactPresenceQuery, ContactPresenceQueryVariables>;
export const CreateContactDocument = gql`
    mutation CreateContact($input: ContactInput!) {
  createContact(input: $input) {
    id
    fullName
    entityType
  }
}
    `;
export type CreateContactMutationFn = Apollo.MutationFunction<CreateContactMutation, CreateContactMutationVariables>;

/**
 * __useCreateContactMutation__
 *
 * To run a mutation, you first call `useCreateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactMutation, { data, loading, error }] = useCreateContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactMutation, CreateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactMutation, CreateContactMutationVariables>(CreateContactDocument, options);
      }
export type CreateContactMutationHookResult = ReturnType<typeof useCreateContactMutation>;
export type CreateContactMutationResult = Apollo.MutationResult<CreateContactMutation>;
export type CreateContactMutationOptions = Apollo.BaseMutationOptions<CreateContactMutation, CreateContactMutationVariables>;
export const ContactDocument = gql`
    query Contact($id: ID!) {
  contact(id: $id) {
    ...FullContactFields
  }
}
    ${FullContactFieldsFragmentDoc}`;

/**
 * __useContactQuery__
 *
 * To run a query within a React component, call `useContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContactQuery(baseOptions: Apollo.QueryHookOptions<ContactQuery, ContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactQuery, ContactQueryVariables>(ContactDocument, options);
      }
export function useContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactQuery, ContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactQuery, ContactQueryVariables>(ContactDocument, options);
        }
export type ContactQueryHookResult = ReturnType<typeof useContactQuery>;
export type ContactLazyQueryHookResult = ReturnType<typeof useContactLazyQuery>;
export type ContactQueryResult = Apollo.QueryResult<ContactQuery, ContactQueryVariables>;
export const UpdateContactDocument = gql`
    mutation UpdateContact($id: ID!, $input: ContactInput!) {
  updateContact(id: $id, input: $input) {
    ...FullContactFields
  }
}
    ${FullContactFieldsFragmentDoc}`;
export type UpdateContactMutationFn = Apollo.MutationFunction<UpdateContactMutation, UpdateContactMutationVariables>;

/**
 * __useUpdateContactMutation__
 *
 * To run a mutation, you first call `useUpdateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactMutation, { data, loading, error }] = useUpdateContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContactMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactMutation, UpdateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactMutation, UpdateContactMutationVariables>(UpdateContactDocument, options);
      }
export type UpdateContactMutationHookResult = ReturnType<typeof useUpdateContactMutation>;
export type UpdateContactMutationResult = Apollo.MutationResult<UpdateContactMutation>;
export type UpdateContactMutationOptions = Apollo.BaseMutationOptions<UpdateContactMutation, UpdateContactMutationVariables>;
export const ContactLegalCasesDocument = gql`
    query ContactLegalCases($id: ID!) {
  contact(id: $id) {
    id
    relatedLegalCases {
      roles
      legalCase {
        id
        name
        state
        estimatedCaseValue
        lastTcDate
        formattedTotalMinutes
        fullName
        currency {
          id
          name
        }
        client {
          id
          fullName
        }
        legalCaseOwners {
          id
          ownershipPercentage
          user {
            id
            fullName
          }
        }
        manager {
          id
          fullName
        }
      }
    }
  }
}
    `;

/**
 * __useContactLegalCasesQuery__
 *
 * To run a query within a React component, call `useContactLegalCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactLegalCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactLegalCasesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContactLegalCasesQuery(baseOptions: Apollo.QueryHookOptions<ContactLegalCasesQuery, ContactLegalCasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactLegalCasesQuery, ContactLegalCasesQueryVariables>(ContactLegalCasesDocument, options);
      }
export function useContactLegalCasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactLegalCasesQuery, ContactLegalCasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactLegalCasesQuery, ContactLegalCasesQueryVariables>(ContactLegalCasesDocument, options);
        }
export type ContactLegalCasesQueryHookResult = ReturnType<typeof useContactLegalCasesQuery>;
export type ContactLegalCasesLazyQueryHookResult = ReturnType<typeof useContactLegalCasesLazyQuery>;
export type ContactLegalCasesQueryResult = Apollo.QueryResult<ContactLegalCasesQuery, ContactLegalCasesQueryVariables>;
export const ContactsDocument = gql`
    query Contacts($order: String, $descending: Boolean, $after: String, $first: Int, $search: String, $filter: ContactFilterInput) {
  contacts(
    order: $order
    descending: $descending
    after: $after
    first: $first
    search: $search
    filter: $filter
  ) {
    nodes {
      id
      name
      fullName
      lastName
      country
      phone
      email
      vatRegistrationNumber
      registrationNumber
      company {
        id
        country
        name
        syncSourceType
      }
      employees {
        id
        fullName
      }
      contactCategories {
        id
        name
      }
      owner {
        id
        fullName
      }
      opponent
      identificationNumber
      syncSourceId
      syncSourceType
      jobTitle
      entityType
    }
    totalCount
  }
}
    `;

/**
 * __useContactsQuery__
 *
 * To run a query within a React component, call `useContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useContactsQuery(baseOptions?: Apollo.QueryHookOptions<ContactsQuery, ContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactsQuery, ContactsQueryVariables>(ContactsDocument, options);
      }
export function useContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactsQuery, ContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactsQuery, ContactsQueryVariables>(ContactsDocument, options);
        }
export type ContactsQueryHookResult = ReturnType<typeof useContactsQuery>;
export type ContactsLazyQueryHookResult = ReturnType<typeof useContactsLazyQuery>;
export type ContactsQueryResult = Apollo.QueryResult<ContactsQuery, ContactsQueryVariables>;
export const AutocompleteContactsDocument = gql`
    query AutocompleteContacts($search: String, $filter: ContactFilterInput) {
  contacts(search: $search, filter: $filter) {
    nodes {
      id
      fullName
      opponent
      syncSourceType
      entityType
    }
  }
}
    `;

/**
 * __useAutocompleteContactsQuery__
 *
 * To run a query within a React component, call `useAutocompleteContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteContactsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAutocompleteContactsQuery(baseOptions?: Apollo.QueryHookOptions<AutocompleteContactsQuery, AutocompleteContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompleteContactsQuery, AutocompleteContactsQueryVariables>(AutocompleteContactsDocument, options);
      }
export function useAutocompleteContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompleteContactsQuery, AutocompleteContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompleteContactsQuery, AutocompleteContactsQueryVariables>(AutocompleteContactsDocument, options);
        }
export type AutocompleteContactsQueryHookResult = ReturnType<typeof useAutocompleteContactsQuery>;
export type AutocompleteContactsLazyQueryHookResult = ReturnType<typeof useAutocompleteContactsLazyQuery>;
export type AutocompleteContactsQueryResult = Apollo.QueryResult<AutocompleteContactsQuery, AutocompleteContactsQueryVariables>;
export const DeleteContactDocument = gql`
    mutation DeleteContact($id: ID!) {
  deleteContact(id: $id)
}
    `;
export type DeleteContactMutationFn = Apollo.MutationFunction<DeleteContactMutation, DeleteContactMutationVariables>;

/**
 * __useDeleteContactMutation__
 *
 * To run a mutation, you first call `useDeleteContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactMutation, { data, loading, error }] = useDeleteContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteContactMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContactMutation, DeleteContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContactMutation, DeleteContactMutationVariables>(DeleteContactDocument, options);
      }
export type DeleteContactMutationHookResult = ReturnType<typeof useDeleteContactMutation>;
export type DeleteContactMutationResult = Apollo.MutationResult<DeleteContactMutation>;
export type DeleteContactMutationOptions = Apollo.BaseMutationOptions<DeleteContactMutation, DeleteContactMutationVariables>;
export const ContactsExportDocument = gql`
    query ContactsExport($order: String, $descending: Boolean, $filter: ContactFilterInput, $search: String) {
  contacts(
    order: $order
    descending: $descending
    filter: $filter
    search: $search
  ) {
    xlsxExport {
      filename
      content
    }
  }
}
    `;

/**
 * __useContactsExportQuery__
 *
 * To run a query within a React component, call `useContactsExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsExportQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      filter: // value for 'filter'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useContactsExportQuery(baseOptions?: Apollo.QueryHookOptions<ContactsExportQuery, ContactsExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactsExportQuery, ContactsExportQueryVariables>(ContactsExportDocument, options);
      }
export function useContactsExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactsExportQuery, ContactsExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactsExportQuery, ContactsExportQueryVariables>(ContactsExportDocument, options);
        }
export type ContactsExportQueryHookResult = ReturnType<typeof useContactsExportQuery>;
export type ContactsExportLazyQueryHookResult = ReturnType<typeof useContactsExportLazyQuery>;
export type ContactsExportQueryResult = Apollo.QueryResult<ContactsExportQuery, ContactsExportQueryVariables>;
export const RecentUserCasesDocument = gql`
    query RecentUserCases($first: Int) {
  recentUserCases(first: $first) {
    nodes {
      id
      client {
        id
        fullName
        amlStatus
        antiMoneyLaunderingDate
        amlExpectedDate
      }
      fullName
    }
  }
}
    `;

/**
 * __useRecentUserCasesQuery__
 *
 * To run a query within a React component, call `useRecentUserCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentUserCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentUserCasesQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useRecentUserCasesQuery(baseOptions?: Apollo.QueryHookOptions<RecentUserCasesQuery, RecentUserCasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentUserCasesQuery, RecentUserCasesQueryVariables>(RecentUserCasesDocument, options);
      }
export function useRecentUserCasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentUserCasesQuery, RecentUserCasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentUserCasesQuery, RecentUserCasesQueryVariables>(RecentUserCasesDocument, options);
        }
export type RecentUserCasesQueryHookResult = ReturnType<typeof useRecentUserCasesQuery>;
export type RecentUserCasesLazyQueryHookResult = ReturnType<typeof useRecentUserCasesLazyQuery>;
export type RecentUserCasesQueryResult = Apollo.QueryResult<RecentUserCasesQuery, RecentUserCasesQueryVariables>;
export const CurrentUserCalendarEventsDocument = gql`
    query CurrentUserCalendarEvents {
  currentUser {
    id
    calendars {
      id
    }
    calendarEvents {
      id
      name
      startTime
      endTime
      status
    }
  }
}
    `;

/**
 * __useCurrentUserCalendarEventsQuery__
 *
 * To run a query within a React component, call `useCurrentUserCalendarEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserCalendarEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserCalendarEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserCalendarEventsQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserCalendarEventsQuery, CurrentUserCalendarEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserCalendarEventsQuery, CurrentUserCalendarEventsQueryVariables>(CurrentUserCalendarEventsDocument, options);
      }
export function useCurrentUserCalendarEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserCalendarEventsQuery, CurrentUserCalendarEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserCalendarEventsQuery, CurrentUserCalendarEventsQueryVariables>(CurrentUserCalendarEventsDocument, options);
        }
export type CurrentUserCalendarEventsQueryHookResult = ReturnType<typeof useCurrentUserCalendarEventsQuery>;
export type CurrentUserCalendarEventsLazyQueryHookResult = ReturnType<typeof useCurrentUserCalendarEventsLazyQuery>;
export type CurrentUserCalendarEventsQueryResult = Apollo.QueryResult<CurrentUserCalendarEventsQuery, CurrentUserCalendarEventsQueryVariables>;
export const CreateDisbursementDocument = gql`
    mutation CreateDisbursement($input: DisbursementInput!) {
  createDisbursement(input: $input) {
    id
    invoice {
      id
      anyDisbursementsWithoutPrice
    }
  }
}
    `;
export type CreateDisbursementMutationFn = Apollo.MutationFunction<CreateDisbursementMutation, CreateDisbursementMutationVariables>;

/**
 * __useCreateDisbursementMutation__
 *
 * To run a mutation, you first call `useCreateDisbursementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDisbursementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDisbursementMutation, { data, loading, error }] = useCreateDisbursementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDisbursementMutation(baseOptions?: Apollo.MutationHookOptions<CreateDisbursementMutation, CreateDisbursementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDisbursementMutation, CreateDisbursementMutationVariables>(CreateDisbursementDocument, options);
      }
export type CreateDisbursementMutationHookResult = ReturnType<typeof useCreateDisbursementMutation>;
export type CreateDisbursementMutationResult = Apollo.MutationResult<CreateDisbursementMutation>;
export type CreateDisbursementMutationOptions = Apollo.BaseMutationOptions<CreateDisbursementMutation, CreateDisbursementMutationVariables>;
export const DisbursementDocument = gql`
    query Disbursement($id: ID!) {
  disbursement(id: $id) {
    ...DisbursementFields
  }
}
    ${DisbursementFieldsFragmentDoc}`;

/**
 * __useDisbursementQuery__
 *
 * To run a query within a React component, call `useDisbursementQuery` and pass it any options that fit your needs.
 * When your component renders, `useDisbursementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDisbursementQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDisbursementQuery(baseOptions: Apollo.QueryHookOptions<DisbursementQuery, DisbursementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DisbursementQuery, DisbursementQueryVariables>(DisbursementDocument, options);
      }
export function useDisbursementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DisbursementQuery, DisbursementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DisbursementQuery, DisbursementQueryVariables>(DisbursementDocument, options);
        }
export type DisbursementQueryHookResult = ReturnType<typeof useDisbursementQuery>;
export type DisbursementLazyQueryHookResult = ReturnType<typeof useDisbursementLazyQuery>;
export type DisbursementQueryResult = Apollo.QueryResult<DisbursementQuery, DisbursementQueryVariables>;
export const UpdateDisbursementDocument = gql`
    mutation UpdateDisbursement($id: ID!, $input: DisbursementInput!) {
  updateDisbursement(id: $id, input: $input) {
    ...DisbursementFields
  }
}
    ${DisbursementFieldsFragmentDoc}`;
export type UpdateDisbursementMutationFn = Apollo.MutationFunction<UpdateDisbursementMutation, UpdateDisbursementMutationVariables>;

/**
 * __useUpdateDisbursementMutation__
 *
 * To run a mutation, you first call `useUpdateDisbursementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDisbursementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDisbursementMutation, { data, loading, error }] = useUpdateDisbursementMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDisbursementMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDisbursementMutation, UpdateDisbursementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDisbursementMutation, UpdateDisbursementMutationVariables>(UpdateDisbursementDocument, options);
      }
export type UpdateDisbursementMutationHookResult = ReturnType<typeof useUpdateDisbursementMutation>;
export type UpdateDisbursementMutationResult = Apollo.MutationResult<UpdateDisbursementMutation>;
export type UpdateDisbursementMutationOptions = Apollo.BaseMutationOptions<UpdateDisbursementMutation, UpdateDisbursementMutationVariables>;
export const DisbursementsDocument = gql`
    query Disbursements($order: String, $descending: Boolean, $after: String, $first: Int, $filter: DisbursementFilterInput, $search: String, $scope: String) {
  disbursements(
    order: $order
    descending: $descending
    after: $after
    first: $first
    filter: $filter
    search: $search
    scope: $scope
  ) {
    nodes {
      id
      onDate
      description
      expenseAmount
      state
      taxable
      disbursementType {
        id
        name
      }
      currency {
        id
        name
      }
      owner {
        id
        fullName
      }
      legalCase {
        id
        fullName
      }
      client {
        id
        fullName
      }
    }
    totalCount
  }
}
    `;

/**
 * __useDisbursementsQuery__
 *
 * To run a query within a React component, call `useDisbursementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDisbursementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDisbursementsQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *      search: // value for 'search'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useDisbursementsQuery(baseOptions?: Apollo.QueryHookOptions<DisbursementsQuery, DisbursementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DisbursementsQuery, DisbursementsQueryVariables>(DisbursementsDocument, options);
      }
export function useDisbursementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DisbursementsQuery, DisbursementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DisbursementsQuery, DisbursementsQueryVariables>(DisbursementsDocument, options);
        }
export type DisbursementsQueryHookResult = ReturnType<typeof useDisbursementsQuery>;
export type DisbursementsLazyQueryHookResult = ReturnType<typeof useDisbursementsLazyQuery>;
export type DisbursementsQueryResult = Apollo.QueryResult<DisbursementsQuery, DisbursementsQueryVariables>;
export const DeleteDisbursementDocument = gql`
    mutation DeleteDisbursement($id: ID!) {
  deleteDisbursement(id: $id)
}
    `;
export type DeleteDisbursementMutationFn = Apollo.MutationFunction<DeleteDisbursementMutation, DeleteDisbursementMutationVariables>;

/**
 * __useDeleteDisbursementMutation__
 *
 * To run a mutation, you first call `useDeleteDisbursementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDisbursementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDisbursementMutation, { data, loading, error }] = useDeleteDisbursementMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDisbursementMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDisbursementMutation, DeleteDisbursementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDisbursementMutation, DeleteDisbursementMutationVariables>(DeleteDisbursementDocument, options);
      }
export type DeleteDisbursementMutationHookResult = ReturnType<typeof useDeleteDisbursementMutation>;
export type DeleteDisbursementMutationResult = Apollo.MutationResult<DeleteDisbursementMutation>;
export type DeleteDisbursementMutationOptions = Apollo.BaseMutationOptions<DeleteDisbursementMutation, DeleteDisbursementMutationVariables>;
export const LinkDisbursementsDocument = gql`
    mutation LinkDisbursements($ids: [ID!]!, $invoiceId: ID!) {
  linkDisbursements(ids: $ids, invoiceId: $invoiceId)
}
    `;
export type LinkDisbursementsMutationFn = Apollo.MutationFunction<LinkDisbursementsMutation, LinkDisbursementsMutationVariables>;

/**
 * __useLinkDisbursementsMutation__
 *
 * To run a mutation, you first call `useLinkDisbursementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkDisbursementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkDisbursementsMutation, { data, loading, error }] = useLinkDisbursementsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useLinkDisbursementsMutation(baseOptions?: Apollo.MutationHookOptions<LinkDisbursementsMutation, LinkDisbursementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkDisbursementsMutation, LinkDisbursementsMutationVariables>(LinkDisbursementsDocument, options);
      }
export type LinkDisbursementsMutationHookResult = ReturnType<typeof useLinkDisbursementsMutation>;
export type LinkDisbursementsMutationResult = Apollo.MutationResult<LinkDisbursementsMutation>;
export type LinkDisbursementsMutationOptions = Apollo.BaseMutationOptions<LinkDisbursementsMutation, LinkDisbursementsMutationVariables>;
export const LinkTimeCardsDocument = gql`
    mutation LinkTimeCards($ids: [ID!]!, $invoiceId: ID!) {
  linkTimeCards(ids: $ids, invoiceId: $invoiceId)
}
    `;
export type LinkTimeCardsMutationFn = Apollo.MutationFunction<LinkTimeCardsMutation, LinkTimeCardsMutationVariables>;

/**
 * __useLinkTimeCardsMutation__
 *
 * To run a mutation, you first call `useLinkTimeCardsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkTimeCardsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkTimeCardsMutation, { data, loading, error }] = useLinkTimeCardsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useLinkTimeCardsMutation(baseOptions?: Apollo.MutationHookOptions<LinkTimeCardsMutation, LinkTimeCardsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkTimeCardsMutation, LinkTimeCardsMutationVariables>(LinkTimeCardsDocument, options);
      }
export type LinkTimeCardsMutationHookResult = ReturnType<typeof useLinkTimeCardsMutation>;
export type LinkTimeCardsMutationResult = Apollo.MutationResult<LinkTimeCardsMutation>;
export type LinkTimeCardsMutationOptions = Apollo.BaseMutationOptions<LinkTimeCardsMutation, LinkTimeCardsMutationVariables>;
export const BulkStateSwitchDocument = gql`
    mutation BulkStateSwitch($ids: [ID!]!, $input: InvoiceStateChangeInput!) {
  bulkStateSwitch(ids: $ids, input: $input)
}
    `;
export type BulkStateSwitchMutationFn = Apollo.MutationFunction<BulkStateSwitchMutation, BulkStateSwitchMutationVariables>;

/**
 * __useBulkStateSwitchMutation__
 *
 * To run a mutation, you first call `useBulkStateSwitchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkStateSwitchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkStateSwitchMutation, { data, loading, error }] = useBulkStateSwitchMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkStateSwitchMutation(baseOptions?: Apollo.MutationHookOptions<BulkStateSwitchMutation, BulkStateSwitchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkStateSwitchMutation, BulkStateSwitchMutationVariables>(BulkStateSwitchDocument, options);
      }
export type BulkStateSwitchMutationHookResult = ReturnType<typeof useBulkStateSwitchMutation>;
export type BulkStateSwitchMutationResult = Apollo.MutationResult<BulkStateSwitchMutation>;
export type BulkStateSwitchMutationOptions = Apollo.BaseMutationOptions<BulkStateSwitchMutation, BulkStateSwitchMutationVariables>;
export const CreateCreditNoteDocument = gql`
    mutation CreateCreditNote($invoiceId: ID!, $input: CreditNoteInput!) {
  createCreditNote(invoiceId: $invoiceId, input: $input) {
    id
  }
}
    `;
export type CreateCreditNoteMutationFn = Apollo.MutationFunction<CreateCreditNoteMutation, CreateCreditNoteMutationVariables>;

/**
 * __useCreateCreditNoteMutation__
 *
 * To run a mutation, you first call `useCreateCreditNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCreditNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCreditNoteMutation, { data, loading, error }] = useCreateCreditNoteMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCreditNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateCreditNoteMutation, CreateCreditNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCreditNoteMutation, CreateCreditNoteMutationVariables>(CreateCreditNoteDocument, options);
      }
export type CreateCreditNoteMutationHookResult = ReturnType<typeof useCreateCreditNoteMutation>;
export type CreateCreditNoteMutationResult = Apollo.MutationResult<CreateCreditNoteMutation>;
export type CreateCreditNoteMutationOptions = Apollo.BaseMutationOptions<CreateCreditNoteMutation, CreateCreditNoteMutationVariables>;
export const UnlinkDisbursementDocument = gql`
    mutation UnlinkDisbursement($id: ID!) {
  unlinkDisbursement(id: $id)
}
    `;
export type UnlinkDisbursementMutationFn = Apollo.MutationFunction<UnlinkDisbursementMutation, UnlinkDisbursementMutationVariables>;

/**
 * __useUnlinkDisbursementMutation__
 *
 * To run a mutation, you first call `useUnlinkDisbursementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkDisbursementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkDisbursementMutation, { data, loading, error }] = useUnlinkDisbursementMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnlinkDisbursementMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkDisbursementMutation, UnlinkDisbursementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkDisbursementMutation, UnlinkDisbursementMutationVariables>(UnlinkDisbursementDocument, options);
      }
export type UnlinkDisbursementMutationHookResult = ReturnType<typeof useUnlinkDisbursementMutation>;
export type UnlinkDisbursementMutationResult = Apollo.MutationResult<UnlinkDisbursementMutation>;
export type UnlinkDisbursementMutationOptions = Apollo.BaseMutationOptions<UnlinkDisbursementMutation, UnlinkDisbursementMutationVariables>;
export const InvoiceFormDocument = gql`
    query InvoiceForm($id: ID!) {
  invoice(id: $id) {
    id
    number
    state
    alternateCaseName
    issuedAt
    caseNameOnInvoice
    paymentType
    hourlyFeeType
    standardPriceList {
      id
      name
    }
    paymentTerm {
      id
      days
    }
    currency {
      id
      name
    }
    fixedFee
    discountPercentage
    inheritedDiscountPercentage
    clientReferenceNumber
    invoiceIssuer {
      id
      name
    }
    billingEmails
    billingInformationFromLegalCase
    billingToName
    billingToRegistrationNumber
    billingToVatRegistrationNumber
    billingAddress
    billingCountry
    billingPostalCode
    billingContact {
      id
      fullName
      opponent
    }
    billingPhone
    paidAt
    periodFromDate
    periodToDate
    language
    inheritedLanguage
    invoicableRecordsPeriodFromDate
    invoicableRecordsPeriodToDate
    flatRate
    vatPercentage {
      id
      percentage
      location
    }
    vat
    invoiceType
    totalValue
    creditAmount
    creditedInvoice {
      id
    }
    lawyerRate
    nonLawyerRate
    inheritedBillingToName
    invoiceDiscount
    customizedPriceList {
      id
      name
      priceListRates {
        id
        priced {
          id
          name
          positionName
          sequence
        }
        pricedType
        rate
        currency {
          id
        }
      }
    }
    creditableAmountType
    legalCase {
      ...LegalCaseBillingFields
      client {
        ...ClientBillingFields
      }
    }
    prepaymentIntendedUse
  }
}
    ${LegalCaseBillingFieldsFragmentDoc}
${ClientBillingFieldsFragmentDoc}`;

/**
 * __useInvoiceFormQuery__
 *
 * To run a query within a React component, call `useInvoiceFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvoiceFormQuery(baseOptions: Apollo.QueryHookOptions<InvoiceFormQuery, InvoiceFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceFormQuery, InvoiceFormQueryVariables>(InvoiceFormDocument, options);
      }
export function useInvoiceFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceFormQuery, InvoiceFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceFormQuery, InvoiceFormQueryVariables>(InvoiceFormDocument, options);
        }
export type InvoiceFormQueryHookResult = ReturnType<typeof useInvoiceFormQuery>;
export type InvoiceFormLazyQueryHookResult = ReturnType<typeof useInvoiceFormLazyQuery>;
export type InvoiceFormQueryResult = Apollo.QueryResult<InvoiceFormQuery, InvoiceFormQueryVariables>;
export const CreditedInvoiceDocument = gql`
    query CreditedInvoice($id: ID!) {
  invoice(id: $id) {
    totalValue
    vat
    invoiceDiscount
    feeTotal
  }
}
    `;

/**
 * __useCreditedInvoiceQuery__
 *
 * To run a query within a React component, call `useCreditedInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditedInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditedInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreditedInvoiceQuery(baseOptions: Apollo.QueryHookOptions<CreditedInvoiceQuery, CreditedInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreditedInvoiceQuery, CreditedInvoiceQueryVariables>(CreditedInvoiceDocument, options);
      }
export function useCreditedInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreditedInvoiceQuery, CreditedInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreditedInvoiceQuery, CreditedInvoiceQueryVariables>(CreditedInvoiceDocument, options);
        }
export type CreditedInvoiceQueryHookResult = ReturnType<typeof useCreditedInvoiceQuery>;
export type CreditedInvoiceLazyQueryHookResult = ReturnType<typeof useCreditedInvoiceLazyQuery>;
export type CreditedInvoiceQueryResult = Apollo.QueryResult<CreditedInvoiceQuery, CreditedInvoiceQueryVariables>;
export const GenerateInvoicePdfDocument = gql`
    mutation GenerateInvoicePdf($id: ID!, $input: InvoicePdfInput!) {
  generateInvoicePdf(id: $id, input: $input)
}
    `;
export type GenerateInvoicePdfMutationFn = Apollo.MutationFunction<GenerateInvoicePdfMutation, GenerateInvoicePdfMutationVariables>;

/**
 * __useGenerateInvoicePdfMutation__
 *
 * To run a mutation, you first call `useGenerateInvoicePdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateInvoicePdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateInvoicePdfMutation, { data, loading, error }] = useGenerateInvoicePdfMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateInvoicePdfMutation(baseOptions?: Apollo.MutationHookOptions<GenerateInvoicePdfMutation, GenerateInvoicePdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateInvoicePdfMutation, GenerateInvoicePdfMutationVariables>(GenerateInvoicePdfDocument, options);
      }
export type GenerateInvoicePdfMutationHookResult = ReturnType<typeof useGenerateInvoicePdfMutation>;
export type GenerateInvoicePdfMutationResult = Apollo.MutationResult<GenerateInvoicePdfMutation>;
export type GenerateInvoicePdfMutationOptions = Apollo.BaseMutationOptions<GenerateInvoicePdfMutation, GenerateInvoicePdfMutationVariables>;
export const InvoicePdfDataDocument = gql`
    query InvoicePdfData($id: ID!) {
  invoice(id: $id) {
    id
    caseNameOnInvoice
    inheritedInvoiceIssuer {
      id
      name
    }
    defaultInvoiceTemplate {
      id
      name
      detailLevel
    }
    printoutUrl
    inheritedLanguage
    invoiceType
    inheritedLanguage
  }
  currentAccount {
    id
    defaultCaseDescriptions
  }
}
    `;

/**
 * __useInvoicePdfDataQuery__
 *
 * To run a query within a React component, call `useInvoicePdfDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicePdfDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicePdfDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvoicePdfDataQuery(baseOptions: Apollo.QueryHookOptions<InvoicePdfDataQuery, InvoicePdfDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoicePdfDataQuery, InvoicePdfDataQueryVariables>(InvoicePdfDataDocument, options);
      }
export function useInvoicePdfDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicePdfDataQuery, InvoicePdfDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoicePdfDataQuery, InvoicePdfDataQueryVariables>(InvoicePdfDataDocument, options);
        }
export type InvoicePdfDataQueryHookResult = ReturnType<typeof useInvoicePdfDataQuery>;
export type InvoicePdfDataLazyQueryHookResult = ReturnType<typeof useInvoicePdfDataLazyQuery>;
export type InvoicePdfDataQueryResult = Apollo.QueryResult<InvoicePdfDataQuery, InvoicePdfDataQueryVariables>;
export const InvoiceCaseClientDocument = gql`
    query InvoiceCaseClient($id: ID!) {
  invoice(id: $id) {
    id
    client {
      id
      fullName
    }
    legalCase {
      id
      fullName
    }
    copiedTo {
      id
      number
    }
    invoiceType
    anyTimeCardsWithoutRate
    anyDisbursementsWithoutPrice
  }
}
    `;

/**
 * __useInvoiceCaseClientQuery__
 *
 * To run a query within a React component, call `useInvoiceCaseClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceCaseClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceCaseClientQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvoiceCaseClientQuery(baseOptions: Apollo.QueryHookOptions<InvoiceCaseClientQuery, InvoiceCaseClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceCaseClientQuery, InvoiceCaseClientQueryVariables>(InvoiceCaseClientDocument, options);
      }
export function useInvoiceCaseClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceCaseClientQuery, InvoiceCaseClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceCaseClientQuery, InvoiceCaseClientQueryVariables>(InvoiceCaseClientDocument, options);
        }
export type InvoiceCaseClientQueryHookResult = ReturnType<typeof useInvoiceCaseClientQuery>;
export type InvoiceCaseClientLazyQueryHookResult = ReturnType<typeof useInvoiceCaseClientLazyQuery>;
export type InvoiceCaseClientQueryResult = Apollo.QueryResult<InvoiceCaseClientQuery, InvoiceCaseClientQueryVariables>;
export const InvoiceDocument = gql`
    query Invoice($id: ID!) {
  invoice(id: $id) {
    ...FullInvoiceFields
  }
}
    ${FullInvoiceFieldsFragmentDoc}`;

/**
 * __useInvoiceQuery__
 *
 * To run a query within a React component, call `useInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvoiceQuery(baseOptions: Apollo.QueryHookOptions<InvoiceQuery, InvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceQuery, InvoiceQueryVariables>(InvoiceDocument, options);
      }
export function useInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceQuery, InvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceQuery, InvoiceQueryVariables>(InvoiceDocument, options);
        }
export type InvoiceQueryHookResult = ReturnType<typeof useInvoiceQuery>;
export type InvoiceLazyQueryHookResult = ReturnType<typeof useInvoiceLazyQuery>;
export type InvoiceQueryResult = Apollo.QueryResult<InvoiceQuery, InvoiceQueryVariables>;
export const UpdateInvoiceDocument = gql`
    mutation UpdateInvoice($id: ID!, $input: InvoiceInput!) {
  updateInvoice(id: $id, input: $input) {
    ...FullInvoiceFields
  }
}
    ${FullInvoiceFieldsFragmentDoc}`;
export type UpdateInvoiceMutationFn = Apollo.MutationFunction<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>;

/**
 * __useUpdateInvoiceMutation__
 *
 * To run a mutation, you first call `useUpdateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvoiceMutation, { data, loading, error }] = useUpdateInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>(UpdateInvoiceDocument, options);
      }
export type UpdateInvoiceMutationHookResult = ReturnType<typeof useUpdateInvoiceMutation>;
export type UpdateInvoiceMutationResult = Apollo.MutationResult<UpdateInvoiceMutation>;
export type UpdateInvoiceMutationOptions = Apollo.BaseMutationOptions<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>;
export const StateSwitchDocument = gql`
    mutation StateSwitch($id: ID!, $eventName: InvoiceEvent!, $input: InvoiceStateChangeInput!) {
  stateSwitch(id: $id, eventName: $eventName, input: $input) {
    ...FullInvoiceFields
  }
}
    ${FullInvoiceFieldsFragmentDoc}`;
export type StateSwitchMutationFn = Apollo.MutationFunction<StateSwitchMutation, StateSwitchMutationVariables>;

/**
 * __useStateSwitchMutation__
 *
 * To run a mutation, you first call `useStateSwitchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStateSwitchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stateSwitchMutation, { data, loading, error }] = useStateSwitchMutation({
 *   variables: {
 *      id: // value for 'id'
 *      eventName: // value for 'eventName'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStateSwitchMutation(baseOptions?: Apollo.MutationHookOptions<StateSwitchMutation, StateSwitchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StateSwitchMutation, StateSwitchMutationVariables>(StateSwitchDocument, options);
      }
export type StateSwitchMutationHookResult = ReturnType<typeof useStateSwitchMutation>;
export type StateSwitchMutationResult = Apollo.MutationResult<StateSwitchMutation>;
export type StateSwitchMutationOptions = Apollo.BaseMutationOptions<StateSwitchMutation, StateSwitchMutationVariables>;
export const ApprovalStateSwitchDocument = gql`
    mutation ApprovalStateSwitch($id: ID!) {
  approvalStateSwitch(id: $id) {
    ...FullInvoiceFields
  }
}
    ${FullInvoiceFieldsFragmentDoc}`;
export type ApprovalStateSwitchMutationFn = Apollo.MutationFunction<ApprovalStateSwitchMutation, ApprovalStateSwitchMutationVariables>;

/**
 * __useApprovalStateSwitchMutation__
 *
 * To run a mutation, you first call `useApprovalStateSwitchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovalStateSwitchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvalStateSwitchMutation, { data, loading, error }] = useApprovalStateSwitchMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApprovalStateSwitchMutation(baseOptions?: Apollo.MutationHookOptions<ApprovalStateSwitchMutation, ApprovalStateSwitchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApprovalStateSwitchMutation, ApprovalStateSwitchMutationVariables>(ApprovalStateSwitchDocument, options);
      }
export type ApprovalStateSwitchMutationHookResult = ReturnType<typeof useApprovalStateSwitchMutation>;
export type ApprovalStateSwitchMutationResult = Apollo.MutationResult<ApprovalStateSwitchMutation>;
export type ApprovalStateSwitchMutationOptions = Apollo.BaseMutationOptions<ApprovalStateSwitchMutation, ApprovalStateSwitchMutationVariables>;
export const AssignInvoiceNumberDocument = gql`
    mutation AssignInvoiceNumber($id: ID!) {
  assignInvoiceNumber(id: $id) {
    number
  }
}
    `;
export type AssignInvoiceNumberMutationFn = Apollo.MutationFunction<AssignInvoiceNumberMutation, AssignInvoiceNumberMutationVariables>;

/**
 * __useAssignInvoiceNumberMutation__
 *
 * To run a mutation, you first call `useAssignInvoiceNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignInvoiceNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignInvoiceNumberMutation, { data, loading, error }] = useAssignInvoiceNumberMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAssignInvoiceNumberMutation(baseOptions?: Apollo.MutationHookOptions<AssignInvoiceNumberMutation, AssignInvoiceNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignInvoiceNumberMutation, AssignInvoiceNumberMutationVariables>(AssignInvoiceNumberDocument, options);
      }
export type AssignInvoiceNumberMutationHookResult = ReturnType<typeof useAssignInvoiceNumberMutation>;
export type AssignInvoiceNumberMutationResult = Apollo.MutationResult<AssignInvoiceNumberMutation>;
export type AssignInvoiceNumberMutationOptions = Apollo.BaseMutationOptions<AssignInvoiceNumberMutation, AssignInvoiceNumberMutationVariables>;
export const DeleteInvoiceDocument = gql`
    mutation DeleteInvoice($id: ID!) {
  deleteInvoice(id: $id)
}
    `;
export type DeleteInvoiceMutationFn = Apollo.MutationFunction<DeleteInvoiceMutation, DeleteInvoiceMutationVariables>;

/**
 * __useDeleteInvoiceMutation__
 *
 * To run a mutation, you first call `useDeleteInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvoiceMutation, { data, loading, error }] = useDeleteInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInvoiceMutation, DeleteInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInvoiceMutation, DeleteInvoiceMutationVariables>(DeleteInvoiceDocument, options);
      }
export type DeleteInvoiceMutationHookResult = ReturnType<typeof useDeleteInvoiceMutation>;
export type DeleteInvoiceMutationResult = Apollo.MutationResult<DeleteInvoiceMutation>;
export type DeleteInvoiceMutationOptions = Apollo.BaseMutationOptions<DeleteInvoiceMutation, DeleteInvoiceMutationVariables>;
export const InvoicesCountDocument = gql`
    query InvoicesCount($order: String, $descending: Boolean, $after: String, $first: Int, $search: String, $filter: InvoiceFilterInput) {
  invoices(
    order: $order
    descending: $descending
    after: $after
    first: $first
    search: $search
    filter: $filter
  ) {
    totalCount
  }
}
    `;

/**
 * __useInvoicesCountQuery__
 *
 * To run a query within a React component, call `useInvoicesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesCountQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useInvoicesCountQuery(baseOptions?: Apollo.QueryHookOptions<InvoicesCountQuery, InvoicesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoicesCountQuery, InvoicesCountQueryVariables>(InvoicesCountDocument, options);
      }
export function useInvoicesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicesCountQuery, InvoicesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoicesCountQuery, InvoicesCountQueryVariables>(InvoicesCountDocument, options);
        }
export type InvoicesCountQueryHookResult = ReturnType<typeof useInvoicesCountQuery>;
export type InvoicesCountLazyQueryHookResult = ReturnType<typeof useInvoicesCountLazyQuery>;
export type InvoicesCountQueryResult = Apollo.QueryResult<InvoicesCountQuery, InvoicesCountQueryVariables>;
export const InvoicesExportDocument = gql`
    query InvoicesExport($order: String, $descending: Boolean, $filter: InvoiceFilterInput, $search: String) {
  invoices(
    order: $order
    descending: $descending
    filter: $filter
    search: $search
  ) {
    xlsxExport {
      filename
      content
    }
  }
}
    `;

/**
 * __useInvoicesExportQuery__
 *
 * To run a query within a React component, call `useInvoicesExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesExportQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      filter: // value for 'filter'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useInvoicesExportQuery(baseOptions?: Apollo.QueryHookOptions<InvoicesExportQuery, InvoicesExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoicesExportQuery, InvoicesExportQueryVariables>(InvoicesExportDocument, options);
      }
export function useInvoicesExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicesExportQuery, InvoicesExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoicesExportQuery, InvoicesExportQueryVariables>(InvoicesExportDocument, options);
        }
export type InvoicesExportQueryHookResult = ReturnType<typeof useInvoicesExportQuery>;
export type InvoicesExportLazyQueryHookResult = ReturnType<typeof useInvoicesExportLazyQuery>;
export type InvoicesExportQueryResult = Apollo.QueryResult<InvoicesExportQuery, InvoicesExportQueryVariables>;
export const CreateInvoiceCopyDocument = gql`
    mutation CreateInvoiceCopy($id: ID!) {
  createInvoiceCopy(id: $id) {
    id
  }
}
    `;
export type CreateInvoiceCopyMutationFn = Apollo.MutationFunction<CreateInvoiceCopyMutation, CreateInvoiceCopyMutationVariables>;

/**
 * __useCreateInvoiceCopyMutation__
 *
 * To run a mutation, you first call `useCreateInvoiceCopyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoiceCopyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoiceCopyMutation, { data, loading, error }] = useCreateInvoiceCopyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreateInvoiceCopyMutation(baseOptions?: Apollo.MutationHookOptions<CreateInvoiceCopyMutation, CreateInvoiceCopyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInvoiceCopyMutation, CreateInvoiceCopyMutationVariables>(CreateInvoiceCopyDocument, options);
      }
export type CreateInvoiceCopyMutationHookResult = ReturnType<typeof useCreateInvoiceCopyMutation>;
export type CreateInvoiceCopyMutationResult = Apollo.MutationResult<CreateInvoiceCopyMutation>;
export type CreateInvoiceCopyMutationOptions = Apollo.BaseMutationOptions<CreateInvoiceCopyMutation, CreateInvoiceCopyMutationVariables>;
export const RefreshInvoiceDocument = gql`
    mutation RefreshInvoice($id: ID!) {
  refreshInvoice(id: $id) {
    id
  }
}
    `;
export type RefreshInvoiceMutationFn = Apollo.MutationFunction<RefreshInvoiceMutation, RefreshInvoiceMutationVariables>;

/**
 * __useRefreshInvoiceMutation__
 *
 * To run a mutation, you first call `useRefreshInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshInvoiceMutation, { data, loading, error }] = useRefreshInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefreshInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<RefreshInvoiceMutation, RefreshInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshInvoiceMutation, RefreshInvoiceMutationVariables>(RefreshInvoiceDocument, options);
      }
export type RefreshInvoiceMutationHookResult = ReturnType<typeof useRefreshInvoiceMutation>;
export type RefreshInvoiceMutationResult = Apollo.MutationResult<RefreshInvoiceMutation>;
export type RefreshInvoiceMutationOptions = Apollo.BaseMutationOptions<RefreshInvoiceMutation, RefreshInvoiceMutationVariables>;
export const SwitchPaymentTypeDocument = gql`
    mutation SwitchPaymentType($id: ID!, $input: SwitchPaymentTypeInput!) {
  switchPaymentType(id: $id, input: $input) {
    id
    paymentType
    unsentInvoicesPresent
  }
}
    `;
export type SwitchPaymentTypeMutationFn = Apollo.MutationFunction<SwitchPaymentTypeMutation, SwitchPaymentTypeMutationVariables>;

/**
 * __useSwitchPaymentTypeMutation__
 *
 * To run a mutation, you first call `useSwitchPaymentTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchPaymentTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchPaymentTypeMutation, { data, loading, error }] = useSwitchPaymentTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSwitchPaymentTypeMutation(baseOptions?: Apollo.MutationHookOptions<SwitchPaymentTypeMutation, SwitchPaymentTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwitchPaymentTypeMutation, SwitchPaymentTypeMutationVariables>(SwitchPaymentTypeDocument, options);
      }
export type SwitchPaymentTypeMutationHookResult = ReturnType<typeof useSwitchPaymentTypeMutation>;
export type SwitchPaymentTypeMutationResult = Apollo.MutationResult<SwitchPaymentTypeMutation>;
export type SwitchPaymentTypeMutationOptions = Apollo.BaseMutationOptions<SwitchPaymentTypeMutation, SwitchPaymentTypeMutationVariables>;
export const InvoiceAssociatedPrepaymentsDocument = gql`
    query InvoiceAssociatedPrepayments($invoiceId: ID!) {
  invoice(id: $invoiceId) {
    id
    invoicesAllocatedFrom {
      id
      number
    }
    invoicesAllocatedTo {
      id
      number
    }
  }
}
    `;

/**
 * __useInvoiceAssociatedPrepaymentsQuery__
 *
 * To run a query within a React component, call `useInvoiceAssociatedPrepaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceAssociatedPrepaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceAssociatedPrepaymentsQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useInvoiceAssociatedPrepaymentsQuery(baseOptions: Apollo.QueryHookOptions<InvoiceAssociatedPrepaymentsQuery, InvoiceAssociatedPrepaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceAssociatedPrepaymentsQuery, InvoiceAssociatedPrepaymentsQueryVariables>(InvoiceAssociatedPrepaymentsDocument, options);
      }
export function useInvoiceAssociatedPrepaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceAssociatedPrepaymentsQuery, InvoiceAssociatedPrepaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceAssociatedPrepaymentsQuery, InvoiceAssociatedPrepaymentsQueryVariables>(InvoiceAssociatedPrepaymentsDocument, options);
        }
export type InvoiceAssociatedPrepaymentsQueryHookResult = ReturnType<typeof useInvoiceAssociatedPrepaymentsQuery>;
export type InvoiceAssociatedPrepaymentsLazyQueryHookResult = ReturnType<typeof useInvoiceAssociatedPrepaymentsLazyQuery>;
export type InvoiceAssociatedPrepaymentsQueryResult = Apollo.QueryResult<InvoiceAssociatedPrepaymentsQuery, InvoiceAssociatedPrepaymentsQueryVariables>;
export const PreviewInvoiceDocument = gql`
    query PreviewInvoice($id: ID!) {
  invoice(id: $id) {
    id
    number
    invoiceType
    state
    creditableAmountType
    inheritedVatPercentage {
      id
      percentage
      location
    }
    issuedAt
    invoiceSubtotal
    creditAmount
    invoiceItems {
      type
      quantity
      total
      quantityType
    }
    inheritedPaymentTerm {
      id
      days
    }
    caseNameOnInvoice
    inheritedClientReferenceNumber
    inheritedCurrency {
      id
      name
    }
    vat
    totalValue
    inheritedDiscountPercentage
    feeTotal
    invoiceDiscount
    allocatedPrepaymentTotalValue
    prepaymentIntendedUse
    inheritedInvoiceIssuer {
      id
      name
      registrationNumber
      vatRegistrationNumber
      address
      postalCode
      country
      faxNumber
      phone
      websiteUrl
      bankDetails
      email
    }
    billingInformationFromLegalCase
    billingToName
    billingToRegistrationNumber
    billingToVatRegistrationNumber
    billingCountry
    billingAddress
    billingPostalCode
    billingEmails
    legalCase {
      id
      billingToName
      billingInformationFromClient
      billingToRegistrationNumber
      billingToVatRegistrationNumber
      billingCountry
      billingAddress
      billingPostalCode
      billingEmails
      client {
        id
        fullName
        billingToName
        billingAddressType
        billingToRegistrationNumber
        billingToVatRegistrationNumber
        billingCountry
        country
        identificationNumber
        vatRegistrationNumber
        billingEmails
        address
        postalCode
        billingAddress
        billingPostalCode
      }
    }
  }
}
    `;

/**
 * __usePreviewInvoiceQuery__
 *
 * To run a query within a React component, call `usePreviewInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePreviewInvoiceQuery(baseOptions: Apollo.QueryHookOptions<PreviewInvoiceQuery, PreviewInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewInvoiceQuery, PreviewInvoiceQueryVariables>(PreviewInvoiceDocument, options);
      }
export function usePreviewInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewInvoiceQuery, PreviewInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewInvoiceQuery, PreviewInvoiceQueryVariables>(PreviewInvoiceDocument, options);
        }
export type PreviewInvoiceQueryHookResult = ReturnType<typeof usePreviewInvoiceQuery>;
export type PreviewInvoiceLazyQueryHookResult = ReturnType<typeof usePreviewInvoiceLazyQuery>;
export type PreviewInvoiceQueryResult = Apollo.QueryResult<PreviewInvoiceQuery, PreviewInvoiceQueryVariables>;
export const RejectInvoiceDocument = gql`
    mutation RejectInvoice($id: ID!, $eventName: InvoiceApprovalEvent!) {
  rejectInvoice(id: $id, eventName: $eventName) {
    ...FullInvoiceFields
  }
}
    ${FullInvoiceFieldsFragmentDoc}`;
export type RejectInvoiceMutationFn = Apollo.MutationFunction<RejectInvoiceMutation, RejectInvoiceMutationVariables>;

/**
 * __useRejectInvoiceMutation__
 *
 * To run a mutation, you first call `useRejectInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectInvoiceMutation, { data, loading, error }] = useRejectInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      eventName: // value for 'eventName'
 *   },
 * });
 */
export function useRejectInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<RejectInvoiceMutation, RejectInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectInvoiceMutation, RejectInvoiceMutationVariables>(RejectInvoiceDocument, options);
      }
export type RejectInvoiceMutationHookResult = ReturnType<typeof useRejectInvoiceMutation>;
export type RejectInvoiceMutationResult = Apollo.MutationResult<RejectInvoiceMutation>;
export type RejectInvoiceMutationOptions = Apollo.BaseMutationOptions<RejectInvoiceMutation, RejectInvoiceMutationVariables>;
export const RevertInvoiceStateDocument = gql`
    mutation RevertInvoiceState($id: ID!) {
  revertInvoiceState(id: $id) {
    ...FullInvoiceFields
  }
}
    ${FullInvoiceFieldsFragmentDoc}`;
export type RevertInvoiceStateMutationFn = Apollo.MutationFunction<RevertInvoiceStateMutation, RevertInvoiceStateMutationVariables>;

/**
 * __useRevertInvoiceStateMutation__
 *
 * To run a mutation, you first call `useRevertInvoiceStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevertInvoiceStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revertInvoiceStateMutation, { data, loading, error }] = useRevertInvoiceStateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRevertInvoiceStateMutation(baseOptions?: Apollo.MutationHookOptions<RevertInvoiceStateMutation, RevertInvoiceStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevertInvoiceStateMutation, RevertInvoiceStateMutationVariables>(RevertInvoiceStateDocument, options);
      }
export type RevertInvoiceStateMutationHookResult = ReturnType<typeof useRevertInvoiceStateMutation>;
export type RevertInvoiceStateMutationResult = Apollo.MutationResult<RevertInvoiceStateMutation>;
export type RevertInvoiceStateMutationOptions = Apollo.BaseMutationOptions<RevertInvoiceStateMutation, RevertInvoiceStateMutationVariables>;
export const TimeCardsCountDocument = gql`
    query TimeCardsCount($filter: TimeCardFilterInput) {
  timeCards(filter: $filter) {
    totalCount
  }
}
    `;

/**
 * __useTimeCardsCountQuery__
 *
 * To run a query within a React component, call `useTimeCardsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeCardsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeCardsCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTimeCardsCountQuery(baseOptions?: Apollo.QueryHookOptions<TimeCardsCountQuery, TimeCardsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeCardsCountQuery, TimeCardsCountQueryVariables>(TimeCardsCountDocument, options);
      }
export function useTimeCardsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeCardsCountQuery, TimeCardsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeCardsCountQuery, TimeCardsCountQueryVariables>(TimeCardsCountDocument, options);
        }
export type TimeCardsCountQueryHookResult = ReturnType<typeof useTimeCardsCountQuery>;
export type TimeCardsCountLazyQueryHookResult = ReturnType<typeof useTimeCardsCountLazyQuery>;
export type TimeCardsCountQueryResult = Apollo.QueryResult<TimeCardsCountQuery, TimeCardsCountQueryVariables>;
export const UnlinkTimeCardDocument = gql`
    mutation UnlinkTimeCard($id: ID!) {
  unlinkTimeCard(id: $id)
}
    `;
export type UnlinkTimeCardMutationFn = Apollo.MutationFunction<UnlinkTimeCardMutation, UnlinkTimeCardMutationVariables>;

/**
 * __useUnlinkTimeCardMutation__
 *
 * To run a mutation, you first call `useUnlinkTimeCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkTimeCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkTimeCardMutation, { data, loading, error }] = useUnlinkTimeCardMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnlinkTimeCardMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkTimeCardMutation, UnlinkTimeCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkTimeCardMutation, UnlinkTimeCardMutationVariables>(UnlinkTimeCardDocument, options);
      }
export type UnlinkTimeCardMutationHookResult = ReturnType<typeof useUnlinkTimeCardMutation>;
export type UnlinkTimeCardMutationResult = Apollo.MutationResult<UnlinkTimeCardMutation>;
export type UnlinkTimeCardMutationOptions = Apollo.BaseMutationOptions<UnlinkTimeCardMutation, UnlinkTimeCardMutationVariables>;
export const RestoreLegalCaseDocument = gql`
    mutation RestoreLegalCase($id: ID!) {
  restoreLegalCase(id: $id)
}
    `;
export type RestoreLegalCaseMutationFn = Apollo.MutationFunction<RestoreLegalCaseMutation, RestoreLegalCaseMutationVariables>;

/**
 * __useRestoreLegalCaseMutation__
 *
 * To run a mutation, you first call `useRestoreLegalCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreLegalCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreLegalCaseMutation, { data, loading, error }] = useRestoreLegalCaseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreLegalCaseMutation(baseOptions?: Apollo.MutationHookOptions<RestoreLegalCaseMutation, RestoreLegalCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreLegalCaseMutation, RestoreLegalCaseMutationVariables>(RestoreLegalCaseDocument, options);
      }
export type RestoreLegalCaseMutationHookResult = ReturnType<typeof useRestoreLegalCaseMutation>;
export type RestoreLegalCaseMutationResult = Apollo.MutationResult<RestoreLegalCaseMutation>;
export type RestoreLegalCaseMutationOptions = Apollo.BaseMutationOptions<RestoreLegalCaseMutation, RestoreLegalCaseMutationVariables>;
export const CloseLegalCaseDocument = gql`
    mutation CloseLegalCase($id: ID!, $input: LegalCaseClosingInput!) {
  closeLegalCase(id: $id, input: $input)
}
    `;
export type CloseLegalCaseMutationFn = Apollo.MutationFunction<CloseLegalCaseMutation, CloseLegalCaseMutationVariables>;

/**
 * __useCloseLegalCaseMutation__
 *
 * To run a mutation, you first call `useCloseLegalCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseLegalCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeLegalCaseMutation, { data, loading, error }] = useCloseLegalCaseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloseLegalCaseMutation(baseOptions?: Apollo.MutationHookOptions<CloseLegalCaseMutation, CloseLegalCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseLegalCaseMutation, CloseLegalCaseMutationVariables>(CloseLegalCaseDocument, options);
      }
export type CloseLegalCaseMutationHookResult = ReturnType<typeof useCloseLegalCaseMutation>;
export type CloseLegalCaseMutationResult = Apollo.MutationResult<CloseLegalCaseMutation>;
export type CloseLegalCaseMutationOptions = Apollo.BaseMutationOptions<CloseLegalCaseMutation, CloseLegalCaseMutationVariables>;
export const LegalCaseClosingInfoDocument = gql`
    query LegalCaseClosingInfo($id: ID!) {
  legalCase(id: $id) {
    id
    lastExpenseRecordDate
    unsentInvoicesPresent
  }
}
    `;

/**
 * __useLegalCaseClosingInfoQuery__
 *
 * To run a query within a React component, call `useLegalCaseClosingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegalCaseClosingInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegalCaseClosingInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLegalCaseClosingInfoQuery(baseOptions: Apollo.QueryHookOptions<LegalCaseClosingInfoQuery, LegalCaseClosingInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LegalCaseClosingInfoQuery, LegalCaseClosingInfoQueryVariables>(LegalCaseClosingInfoDocument, options);
      }
export function useLegalCaseClosingInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LegalCaseClosingInfoQuery, LegalCaseClosingInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LegalCaseClosingInfoQuery, LegalCaseClosingInfoQueryVariables>(LegalCaseClosingInfoDocument, options);
        }
export type LegalCaseClosingInfoQueryHookResult = ReturnType<typeof useLegalCaseClosingInfoQuery>;
export type LegalCaseClosingInfoLazyQueryHookResult = ReturnType<typeof useLegalCaseClosingInfoLazyQuery>;
export type LegalCaseClosingInfoQueryResult = Apollo.QueryResult<LegalCaseClosingInfoQuery, LegalCaseClosingInfoQueryVariables>;
export const CurrentAccountCurrencyDocument = gql`
    query CurrentAccountCurrency {
  currentAccount {
    id
    currency {
      id
      name
    }
  }
}
    `;

/**
 * __useCurrentAccountCurrencyQuery__
 *
 * To run a query within a React component, call `useCurrentAccountCurrencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentAccountCurrencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentAccountCurrencyQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentAccountCurrencyQuery(baseOptions?: Apollo.QueryHookOptions<CurrentAccountCurrencyQuery, CurrentAccountCurrencyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentAccountCurrencyQuery, CurrentAccountCurrencyQueryVariables>(CurrentAccountCurrencyDocument, options);
      }
export function useCurrentAccountCurrencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentAccountCurrencyQuery, CurrentAccountCurrencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentAccountCurrencyQuery, CurrentAccountCurrencyQueryVariables>(CurrentAccountCurrencyDocument, options);
        }
export type CurrentAccountCurrencyQueryHookResult = ReturnType<typeof useCurrentAccountCurrencyQuery>;
export type CurrentAccountCurrencyLazyQueryHookResult = ReturnType<typeof useCurrentAccountCurrencyLazyQuery>;
export type CurrentAccountCurrencyQueryResult = Apollo.QueryResult<CurrentAccountCurrencyQuery, CurrentAccountCurrencyQueryVariables>;
export const CreateLegalCaseDocument = gql`
    mutation CreateLegalCase($input: LegalCaseInput!) {
  createLegalCase(input: $input) {
    id
  }
}
    `;
export type CreateLegalCaseMutationFn = Apollo.MutationFunction<CreateLegalCaseMutation, CreateLegalCaseMutationVariables>;

/**
 * __useCreateLegalCaseMutation__
 *
 * To run a mutation, you first call `useCreateLegalCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLegalCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLegalCaseMutation, { data, loading, error }] = useCreateLegalCaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLegalCaseMutation(baseOptions?: Apollo.MutationHookOptions<CreateLegalCaseMutation, CreateLegalCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLegalCaseMutation, CreateLegalCaseMutationVariables>(CreateLegalCaseDocument, options);
      }
export type CreateLegalCaseMutationHookResult = ReturnType<typeof useCreateLegalCaseMutation>;
export type CreateLegalCaseMutationResult = Apollo.MutationResult<CreateLegalCaseMutation>;
export type CreateLegalCaseMutationOptions = Apollo.BaseMutationOptions<CreateLegalCaseMutation, CreateLegalCaseMutationVariables>;
export const CreateLegalCaseDraftInvoiceDocument = gql`
    mutation CreateLegalCaseDraftInvoice($legalCaseId: ID!) {
  createLegalCaseDraftInvoice(legalCaseId: $legalCaseId) {
    id
  }
}
    `;
export type CreateLegalCaseDraftInvoiceMutationFn = Apollo.MutationFunction<CreateLegalCaseDraftInvoiceMutation, CreateLegalCaseDraftInvoiceMutationVariables>;

/**
 * __useCreateLegalCaseDraftInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateLegalCaseDraftInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLegalCaseDraftInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLegalCaseDraftInvoiceMutation, { data, loading, error }] = useCreateLegalCaseDraftInvoiceMutation({
 *   variables: {
 *      legalCaseId: // value for 'legalCaseId'
 *   },
 * });
 */
export function useCreateLegalCaseDraftInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateLegalCaseDraftInvoiceMutation, CreateLegalCaseDraftInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLegalCaseDraftInvoiceMutation, CreateLegalCaseDraftInvoiceMutationVariables>(CreateLegalCaseDraftInvoiceDocument, options);
      }
export type CreateLegalCaseDraftInvoiceMutationHookResult = ReturnType<typeof useCreateLegalCaseDraftInvoiceMutation>;
export type CreateLegalCaseDraftInvoiceMutationResult = Apollo.MutationResult<CreateLegalCaseDraftInvoiceMutation>;
export type CreateLegalCaseDraftInvoiceMutationOptions = Apollo.BaseMutationOptions<CreateLegalCaseDraftInvoiceMutation, CreateLegalCaseDraftInvoiceMutationVariables>;
export const CreatePrepaymentInvoiceDocument = gql`
    mutation CreatePrepaymentInvoice($input: InvoiceInput!) {
  createPrepaymentInvoice(input: $input) {
    id
  }
}
    `;
export type CreatePrepaymentInvoiceMutationFn = Apollo.MutationFunction<CreatePrepaymentInvoiceMutation, CreatePrepaymentInvoiceMutationVariables>;

/**
 * __useCreatePrepaymentInvoiceMutation__
 *
 * To run a mutation, you first call `useCreatePrepaymentInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePrepaymentInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPrepaymentInvoiceMutation, { data, loading, error }] = useCreatePrepaymentInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePrepaymentInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<CreatePrepaymentInvoiceMutation, CreatePrepaymentInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePrepaymentInvoiceMutation, CreatePrepaymentInvoiceMutationVariables>(CreatePrepaymentInvoiceDocument, options);
      }
export type CreatePrepaymentInvoiceMutationHookResult = ReturnType<typeof useCreatePrepaymentInvoiceMutation>;
export type CreatePrepaymentInvoiceMutationResult = Apollo.MutationResult<CreatePrepaymentInvoiceMutation>;
export type CreatePrepaymentInvoiceMutationOptions = Apollo.BaseMutationOptions<CreatePrepaymentInvoiceMutation, CreatePrepaymentInvoiceMutationVariables>;
export const PrepaymentInvoiceLegalCaseDocument = gql`
    query PrepaymentInvoiceLegalCase($legalCaseId: ID!) {
  legalCase(id: $legalCaseId) {
    id
    nameOnInvoice
    billingEmails
    language
    billingInformationFromClient
    billingToName
    billingToRegistrationNumber
    billingToVatRegistrationNumber
    billingAddress
    billingPostalCode
    billingCountry
    billingContact {
      id
      fullName
      opponent
    }
    billingPhone
    client {
      id
      billingEmails
      language
      billingAddressType
      billingToName
      billingToRegistrationNumber
      billingToVatRegistrationNumber
      fullName
      identificationNumber
      vatRegistrationNumber
      address
      postalCode
      country
      billingAddress
      billingPostalCode
      billingCountry
      billingContact {
        id
        fullName
        opponent
      }
      billingPhone
      invoicingCurrency {
        id
        name
      }
      paymentTerm {
        id
        days
      }
      invoiceIssuer {
        id
        name
      }
      vatPercentage {
        id
        percentage
        location
      }
    }
    invoiceIssuer {
      id
      name
    }
    vatPercentage {
      id
      percentage
      location
    }
  }
}
    `;

/**
 * __usePrepaymentInvoiceLegalCaseQuery__
 *
 * To run a query within a React component, call `usePrepaymentInvoiceLegalCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrepaymentInvoiceLegalCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrepaymentInvoiceLegalCaseQuery({
 *   variables: {
 *      legalCaseId: // value for 'legalCaseId'
 *   },
 * });
 */
export function usePrepaymentInvoiceLegalCaseQuery(baseOptions: Apollo.QueryHookOptions<PrepaymentInvoiceLegalCaseQuery, PrepaymentInvoiceLegalCaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrepaymentInvoiceLegalCaseQuery, PrepaymentInvoiceLegalCaseQueryVariables>(PrepaymentInvoiceLegalCaseDocument, options);
      }
export function usePrepaymentInvoiceLegalCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrepaymentInvoiceLegalCaseQuery, PrepaymentInvoiceLegalCaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrepaymentInvoiceLegalCaseQuery, PrepaymentInvoiceLegalCaseQueryVariables>(PrepaymentInvoiceLegalCaseDocument, options);
        }
export type PrepaymentInvoiceLegalCaseQueryHookResult = ReturnType<typeof usePrepaymentInvoiceLegalCaseQuery>;
export type PrepaymentInvoiceLegalCaseLazyQueryHookResult = ReturnType<typeof usePrepaymentInvoiceLegalCaseLazyQuery>;
export type PrepaymentInvoiceLegalCaseQueryResult = Apollo.QueryResult<PrepaymentInvoiceLegalCaseQuery, PrepaymentInvoiceLegalCaseQueryVariables>;
export const LegalCaseDocument = gql`
    query LegalCase($id: ID!) {
  legalCase(id: $id) {
    ...FullLegalCaseFields
  }
}
    ${FullLegalCaseFieldsFragmentDoc}`;

/**
 * __useLegalCaseQuery__
 *
 * To run a query within a React component, call `useLegalCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegalCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegalCaseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLegalCaseQuery(baseOptions: Apollo.QueryHookOptions<LegalCaseQuery, LegalCaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LegalCaseQuery, LegalCaseQueryVariables>(LegalCaseDocument, options);
      }
export function useLegalCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LegalCaseQuery, LegalCaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LegalCaseQuery, LegalCaseQueryVariables>(LegalCaseDocument, options);
        }
export type LegalCaseQueryHookResult = ReturnType<typeof useLegalCaseQuery>;
export type LegalCaseLazyQueryHookResult = ReturnType<typeof useLegalCaseLazyQuery>;
export type LegalCaseQueryResult = Apollo.QueryResult<LegalCaseQuery, LegalCaseQueryVariables>;
export const UpdateLegalCaseDocument = gql`
    mutation UpdateLegalCase($id: ID!, $input: LegalCaseInput!) {
  updateLegalCase(id: $id, input: $input) {
    ...FullLegalCaseFields
  }
}
    ${FullLegalCaseFieldsFragmentDoc}`;
export type UpdateLegalCaseMutationFn = Apollo.MutationFunction<UpdateLegalCaseMutation, UpdateLegalCaseMutationVariables>;

/**
 * __useUpdateLegalCaseMutation__
 *
 * To run a mutation, you first call `useUpdateLegalCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLegalCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLegalCaseMutation, { data, loading, error }] = useUpdateLegalCaseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLegalCaseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLegalCaseMutation, UpdateLegalCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLegalCaseMutation, UpdateLegalCaseMutationVariables>(UpdateLegalCaseDocument, options);
      }
export type UpdateLegalCaseMutationHookResult = ReturnType<typeof useUpdateLegalCaseMutation>;
export type UpdateLegalCaseMutationResult = Apollo.MutationResult<UpdateLegalCaseMutation>;
export type UpdateLegalCaseMutationOptions = Apollo.BaseMutationOptions<UpdateLegalCaseMutation, UpdateLegalCaseMutationVariables>;
export const LegalCaseOwnershipDocument = gql`
    query LegalCaseOwnership($id: ID!) {
  legalCase(id: $id) {
    id
    legalCaseOwners {
      id
      ownershipPercentage
      user {
        id
        fullName
      }
    }
  }
}
    `;

/**
 * __useLegalCaseOwnershipQuery__
 *
 * To run a query within a React component, call `useLegalCaseOwnershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegalCaseOwnershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegalCaseOwnershipQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLegalCaseOwnershipQuery(baseOptions: Apollo.QueryHookOptions<LegalCaseOwnershipQuery, LegalCaseOwnershipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LegalCaseOwnershipQuery, LegalCaseOwnershipQueryVariables>(LegalCaseOwnershipDocument, options);
      }
export function useLegalCaseOwnershipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LegalCaseOwnershipQuery, LegalCaseOwnershipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LegalCaseOwnershipQuery, LegalCaseOwnershipQueryVariables>(LegalCaseOwnershipDocument, options);
        }
export type LegalCaseOwnershipQueryHookResult = ReturnType<typeof useLegalCaseOwnershipQuery>;
export type LegalCaseOwnershipLazyQueryHookResult = ReturnType<typeof useLegalCaseOwnershipLazyQuery>;
export type LegalCaseOwnershipQueryResult = Apollo.QueryResult<LegalCaseOwnershipQuery, LegalCaseOwnershipQueryVariables>;
export const LegalCasesDocument = gql`
    query LegalCases($order: String, $descending: Boolean, $after: String, $first: Int, $filter: LegalCaseFilterInput, $search: String) {
  legalCases(
    order: $order
    descending: $descending
    after: $after
    first: $first
    filter: $filter
    search: $search
  ) {
    nodes {
      id
      client {
        id
        fullName
        amlStatus
        antiMoneyLaunderingDate
        amlExpectedDate
        invoicingCurrency {
          id
          name
        }
        hourlyFeeType
        clientOwners {
          id
          user {
            id
          }
        }
      }
      legalCaseOwners {
        id
        ownershipPercentage
        user {
          id
          fullName
        }
      }
      currency {
        id
        name
      }
      fullName
      state
      estimatedCaseValue
      language
      manager {
        id
        fullName
      }
      lastTcDate
      connectedLawyers {
        id
      }
      formattedInvoicedMinutes
      formattedUninvoicedMinutes
      formattedNonBillableMinutes
      formattedTotalMinutes
      fixedFee
      paymentType
      hourlyFeeType
      primaryPracticeArea {
        id
        name
      }
      secondaryPracticeArea {
        id
        name
      }
      closedOn
    }
    totalCount
  }
}
    `;

/**
 * __useLegalCasesQuery__
 *
 * To run a query within a React component, call `useLegalCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegalCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegalCasesQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useLegalCasesQuery(baseOptions?: Apollo.QueryHookOptions<LegalCasesQuery, LegalCasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LegalCasesQuery, LegalCasesQueryVariables>(LegalCasesDocument, options);
      }
export function useLegalCasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LegalCasesQuery, LegalCasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LegalCasesQuery, LegalCasesQueryVariables>(LegalCasesDocument, options);
        }
export type LegalCasesQueryHookResult = ReturnType<typeof useLegalCasesQuery>;
export type LegalCasesLazyQueryHookResult = ReturnType<typeof useLegalCasesLazyQuery>;
export type LegalCasesQueryResult = Apollo.QueryResult<LegalCasesQuery, LegalCasesQueryVariables>;
export const AutocompleteLegalCasesDocument = gql`
    query AutocompleteLegalCases($search: String, $filter: LegalCaseFilterInput, $order: String, $descending: Boolean) {
  legalCases(
    search: $search
    filter: $filter
    order: $order
    descending: $descending
  ) {
    nodes {
      id
      fullName
    }
  }
}
    `;

/**
 * __useAutocompleteLegalCasesQuery__
 *
 * To run a query within a React component, call `useAutocompleteLegalCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteLegalCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteLegalCasesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *   },
 * });
 */
export function useAutocompleteLegalCasesQuery(baseOptions?: Apollo.QueryHookOptions<AutocompleteLegalCasesQuery, AutocompleteLegalCasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompleteLegalCasesQuery, AutocompleteLegalCasesQueryVariables>(AutocompleteLegalCasesDocument, options);
      }
export function useAutocompleteLegalCasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompleteLegalCasesQuery, AutocompleteLegalCasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompleteLegalCasesQuery, AutocompleteLegalCasesQueryVariables>(AutocompleteLegalCasesDocument, options);
        }
export type AutocompleteLegalCasesQueryHookResult = ReturnType<typeof useAutocompleteLegalCasesQuery>;
export type AutocompleteLegalCasesLazyQueryHookResult = ReturnType<typeof useAutocompleteLegalCasesLazyQuery>;
export type AutocompleteLegalCasesQueryResult = Apollo.QueryResult<AutocompleteLegalCasesQuery, AutocompleteLegalCasesQueryVariables>;
export const AutocompleteLegalCasesExpandedDocument = gql`
    query AutocompleteLegalCasesExpanded($search: String, $filter: LegalCaseFilterInput, $order: String, $descending: Boolean) {
  legalCases(
    search: $search
    filter: $filter
    order: $order
    descending: $descending
  ) {
    nodes {
      id
      fullName
      client {
        id
        fullName
        invoicingCurrency {
          id
          name
        }
      }
      language
      invoicingCurrency {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useAutocompleteLegalCasesExpandedQuery__
 *
 * To run a query within a React component, call `useAutocompleteLegalCasesExpandedQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteLegalCasesExpandedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteLegalCasesExpandedQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *   },
 * });
 */
export function useAutocompleteLegalCasesExpandedQuery(baseOptions?: Apollo.QueryHookOptions<AutocompleteLegalCasesExpandedQuery, AutocompleteLegalCasesExpandedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompleteLegalCasesExpandedQuery, AutocompleteLegalCasesExpandedQueryVariables>(AutocompleteLegalCasesExpandedDocument, options);
      }
export function useAutocompleteLegalCasesExpandedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompleteLegalCasesExpandedQuery, AutocompleteLegalCasesExpandedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompleteLegalCasesExpandedQuery, AutocompleteLegalCasesExpandedQueryVariables>(AutocompleteLegalCasesExpandedDocument, options);
        }
export type AutocompleteLegalCasesExpandedQueryHookResult = ReturnType<typeof useAutocompleteLegalCasesExpandedQuery>;
export type AutocompleteLegalCasesExpandedLazyQueryHookResult = ReturnType<typeof useAutocompleteLegalCasesExpandedLazyQuery>;
export type AutocompleteLegalCasesExpandedQueryResult = Apollo.QueryResult<AutocompleteLegalCasesExpandedQuery, AutocompleteLegalCasesExpandedQueryVariables>;
export const DeleteLegalCaseDocument = gql`
    mutation DeleteLegalCase($id: ID!) {
  deleteLegalCase(id: $id)
}
    `;
export type DeleteLegalCaseMutationFn = Apollo.MutationFunction<DeleteLegalCaseMutation, DeleteLegalCaseMutationVariables>;

/**
 * __useDeleteLegalCaseMutation__
 *
 * To run a mutation, you first call `useDeleteLegalCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLegalCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLegalCaseMutation, { data, loading, error }] = useDeleteLegalCaseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLegalCaseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLegalCaseMutation, DeleteLegalCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLegalCaseMutation, DeleteLegalCaseMutationVariables>(DeleteLegalCaseDocument, options);
      }
export type DeleteLegalCaseMutationHookResult = ReturnType<typeof useDeleteLegalCaseMutation>;
export type DeleteLegalCaseMutationResult = Apollo.MutationResult<DeleteLegalCaseMutation>;
export type DeleteLegalCaseMutationOptions = Apollo.BaseMutationOptions<DeleteLegalCaseMutation, DeleteLegalCaseMutationVariables>;
export const LegalCasesExportDocument = gql`
    query LegalCasesExport($order: String, $descending: Boolean, $filter: LegalCaseFilterInput, $search: String) {
  legalCases(
    order: $order
    descending: $descending
    filter: $filter
    search: $search
  ) {
    xlsxExport {
      filename
      content
    }
  }
}
    `;

/**
 * __useLegalCasesExportQuery__
 *
 * To run a query within a React component, call `useLegalCasesExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegalCasesExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegalCasesExportQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      filter: // value for 'filter'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useLegalCasesExportQuery(baseOptions?: Apollo.QueryHookOptions<LegalCasesExportQuery, LegalCasesExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LegalCasesExportQuery, LegalCasesExportQueryVariables>(LegalCasesExportDocument, options);
      }
export function useLegalCasesExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LegalCasesExportQuery, LegalCasesExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LegalCasesExportQuery, LegalCasesExportQueryVariables>(LegalCasesExportDocument, options);
        }
export type LegalCasesExportQueryHookResult = ReturnType<typeof useLegalCasesExportQuery>;
export type LegalCasesExportLazyQueryHookResult = ReturnType<typeof useLegalCasesExportLazyQuery>;
export type LegalCasesExportQueryResult = Apollo.QueryResult<LegalCasesExportQuery, LegalCasesExportQueryVariables>;
export const TimeCardCaseChangeDocument = gql`
    mutation TimeCardCaseChange($ids: [ID!]!, $input: InvoiceableCaseChangeInput!) {
  massCaseChangeTimeCard(ids: $ids, input: $input)
}
    `;
export type TimeCardCaseChangeMutationFn = Apollo.MutationFunction<TimeCardCaseChangeMutation, TimeCardCaseChangeMutationVariables>;

/**
 * __useTimeCardCaseChangeMutation__
 *
 * To run a mutation, you first call `useTimeCardCaseChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTimeCardCaseChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [timeCardCaseChangeMutation, { data, loading, error }] = useTimeCardCaseChangeMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTimeCardCaseChangeMutation(baseOptions?: Apollo.MutationHookOptions<TimeCardCaseChangeMutation, TimeCardCaseChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TimeCardCaseChangeMutation, TimeCardCaseChangeMutationVariables>(TimeCardCaseChangeDocument, options);
      }
export type TimeCardCaseChangeMutationHookResult = ReturnType<typeof useTimeCardCaseChangeMutation>;
export type TimeCardCaseChangeMutationResult = Apollo.MutationResult<TimeCardCaseChangeMutation>;
export type TimeCardCaseChangeMutationOptions = Apollo.BaseMutationOptions<TimeCardCaseChangeMutation, TimeCardCaseChangeMutationVariables>;
export const DisbursementCaseChangeDocument = gql`
    mutation DisbursementCaseChange($ids: [ID!]!, $input: InvoiceableCaseChangeInput!) {
  massCaseChangeDisbursement(ids: $ids, input: $input)
}
    `;
export type DisbursementCaseChangeMutationFn = Apollo.MutationFunction<DisbursementCaseChangeMutation, DisbursementCaseChangeMutationVariables>;

/**
 * __useDisbursementCaseChangeMutation__
 *
 * To run a mutation, you first call `useDisbursementCaseChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisbursementCaseChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disbursementCaseChangeMutation, { data, loading, error }] = useDisbursementCaseChangeMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisbursementCaseChangeMutation(baseOptions?: Apollo.MutationHookOptions<DisbursementCaseChangeMutation, DisbursementCaseChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisbursementCaseChangeMutation, DisbursementCaseChangeMutationVariables>(DisbursementCaseChangeDocument, options);
      }
export type DisbursementCaseChangeMutationHookResult = ReturnType<typeof useDisbursementCaseChangeMutation>;
export type DisbursementCaseChangeMutationResult = Apollo.MutationResult<DisbursementCaseChangeMutation>;
export type DisbursementCaseChangeMutationOptions = Apollo.BaseMutationOptions<DisbursementCaseChangeMutation, DisbursementCaseChangeMutationVariables>;
export const LegalCaseProfitabilityDocument = gql`
    query LegalCaseProfitability($legalCaseId: ID!, $dateFrom: ISO8601Date!, $dateTo: ISO8601Date!, $invoiceFilter: String) {
  legalCaseProfitability(
    legalCaseId: $legalCaseId
    dateFrom: $dateFrom
    dateTo: $dateTo
    invoiceFilter: $invoiceFilter
  ) {
    revenue
    totalDirectCost
    totalIndirectCost
    profitability
    currency {
      id
      name
    }
    invoices {
      totalValue
      invoice {
        id
        number
        state
        includedRecordsPeriodFromDate
        includedRecordsPeriodToDate
      }
    }
    rows {
      user {
        id
        fullName
      }
      invoicedMinutes
      revenue
      directCost
      indirectCost
      profitability
      missingCostData
      totalRow
    }
  }
}
    `;

/**
 * __useLegalCaseProfitabilityQuery__
 *
 * To run a query within a React component, call `useLegalCaseProfitabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegalCaseProfitabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegalCaseProfitabilityQuery({
 *   variables: {
 *      legalCaseId: // value for 'legalCaseId'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      invoiceFilter: // value for 'invoiceFilter'
 *   },
 * });
 */
export function useLegalCaseProfitabilityQuery(baseOptions: Apollo.QueryHookOptions<LegalCaseProfitabilityQuery, LegalCaseProfitabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LegalCaseProfitabilityQuery, LegalCaseProfitabilityQueryVariables>(LegalCaseProfitabilityDocument, options);
      }
export function useLegalCaseProfitabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LegalCaseProfitabilityQuery, LegalCaseProfitabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LegalCaseProfitabilityQuery, LegalCaseProfitabilityQueryVariables>(LegalCaseProfitabilityDocument, options);
        }
export type LegalCaseProfitabilityQueryHookResult = ReturnType<typeof useLegalCaseProfitabilityQuery>;
export type LegalCaseProfitabilityLazyQueryHookResult = ReturnType<typeof useLegalCaseProfitabilityLazyQuery>;
export type LegalCaseProfitabilityQueryResult = Apollo.QueryResult<LegalCaseProfitabilityQuery, LegalCaseProfitabilityQueryVariables>;
export const NotificationsDocument = gql`
    query Notifications($order: String, $descending: Boolean, $after: String, $first: Int, $filter: NotificationFilterInput) {
  notifications(
    order: $order
    descending: $descending
    after: $after
    first: $first
    filter: $filter
  ) {
    nodes {
      id
      kind
      seenAt
      translationData
      translationKey
      relatedId
      relatedType
      createdAt
    }
    totalCount
  }
}
    `;

/**
 * __useNotificationsQuery__
 *
 * To run a query within a React component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
      }
export function useNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
export type NotificationsQueryHookResult = ReturnType<typeof useNotificationsQuery>;
export type NotificationsLazyQueryHookResult = ReturnType<typeof useNotificationsLazyQuery>;
export type NotificationsQueryResult = Apollo.QueryResult<NotificationsQuery, NotificationsQueryVariables>;
export const DownloadGlobalProfitabilityReportDocument = gql`
    mutation DownloadGlobalProfitabilityReport($dateFrom: ISO8601Date!, $dateTo: ISO8601Date!) {
  reportGlobalProfitability(dateFrom: $dateFrom, dateTo: $dateTo) {
    id
    state
  }
}
    `;
export type DownloadGlobalProfitabilityReportMutationFn = Apollo.MutationFunction<DownloadGlobalProfitabilityReportMutation, DownloadGlobalProfitabilityReportMutationVariables>;

/**
 * __useDownloadGlobalProfitabilityReportMutation__
 *
 * To run a mutation, you first call `useDownloadGlobalProfitabilityReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadGlobalProfitabilityReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadGlobalProfitabilityReportMutation, { data, loading, error }] = useDownloadGlobalProfitabilityReportMutation({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useDownloadGlobalProfitabilityReportMutation(baseOptions?: Apollo.MutationHookOptions<DownloadGlobalProfitabilityReportMutation, DownloadGlobalProfitabilityReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadGlobalProfitabilityReportMutation, DownloadGlobalProfitabilityReportMutationVariables>(DownloadGlobalProfitabilityReportDocument, options);
      }
export type DownloadGlobalProfitabilityReportMutationHookResult = ReturnType<typeof useDownloadGlobalProfitabilityReportMutation>;
export type DownloadGlobalProfitabilityReportMutationResult = Apollo.MutationResult<DownloadGlobalProfitabilityReportMutation>;
export type DownloadGlobalProfitabilityReportMutationOptions = Apollo.BaseMutationOptions<DownloadGlobalProfitabilityReportMutation, DownloadGlobalProfitabilityReportMutationVariables>;
export const GlobalProfitabilityReportExportDocument = gql`
    query GlobalProfitabilityReportExport($id: ID!) {
  reportExport(id: $id) {
    id
    state
    errorMessage
    filename
    content
  }
}
    `;

/**
 * __useGlobalProfitabilityReportExportQuery__
 *
 * To run a query within a React component, call `useGlobalProfitabilityReportExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalProfitabilityReportExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalProfitabilityReportExportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGlobalProfitabilityReportExportQuery(baseOptions: Apollo.QueryHookOptions<GlobalProfitabilityReportExportQuery, GlobalProfitabilityReportExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalProfitabilityReportExportQuery, GlobalProfitabilityReportExportQueryVariables>(GlobalProfitabilityReportExportDocument, options);
      }
export function useGlobalProfitabilityReportExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalProfitabilityReportExportQuery, GlobalProfitabilityReportExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalProfitabilityReportExportQuery, GlobalProfitabilityReportExportQueryVariables>(GlobalProfitabilityReportExportDocument, options);
        }
export type GlobalProfitabilityReportExportQueryHookResult = ReturnType<typeof useGlobalProfitabilityReportExportQuery>;
export type GlobalProfitabilityReportExportLazyQueryHookResult = ReturnType<typeof useGlobalProfitabilityReportExportLazyQuery>;
export type GlobalProfitabilityReportExportQueryResult = Apollo.QueryResult<GlobalProfitabilityReportExportQuery, GlobalProfitabilityReportExportQueryVariables>;
export const DownloadMatterStatusReportDocument = gql`
    mutation DownloadMatterStatusReport($clientId: ID!) {
  reportMatterStatus(clientId: $clientId) {
    content
    filename
  }
}
    `;
export type DownloadMatterStatusReportMutationFn = Apollo.MutationFunction<DownloadMatterStatusReportMutation, DownloadMatterStatusReportMutationVariables>;

/**
 * __useDownloadMatterStatusReportMutation__
 *
 * To run a mutation, you first call `useDownloadMatterStatusReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadMatterStatusReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadMatterStatusReportMutation, { data, loading, error }] = useDownloadMatterStatusReportMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useDownloadMatterStatusReportMutation(baseOptions?: Apollo.MutationHookOptions<DownloadMatterStatusReportMutation, DownloadMatterStatusReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadMatterStatusReportMutation, DownloadMatterStatusReportMutationVariables>(DownloadMatterStatusReportDocument, options);
      }
export type DownloadMatterStatusReportMutationHookResult = ReturnType<typeof useDownloadMatterStatusReportMutation>;
export type DownloadMatterStatusReportMutationResult = Apollo.MutationResult<DownloadMatterStatusReportMutation>;
export type DownloadMatterStatusReportMutationOptions = Apollo.BaseMutationOptions<DownloadMatterStatusReportMutation, DownloadMatterStatusReportMutationVariables>;
export const DownloadPersonalPracticeReportDocument = gql`
    mutation DownloadPersonalPracticeReport($dateFrom: ISO8601Date!, $dateTo: ISO8601Date!, $userId: ID, $excludeExternals: Boolean!) {
  reportPersonalPractice(
    dateFrom: $dateFrom
    dateTo: $dateTo
    userId: $userId
    excludeExternals: $excludeExternals
  ) {
    content
    filename
  }
}
    `;
export type DownloadPersonalPracticeReportMutationFn = Apollo.MutationFunction<DownloadPersonalPracticeReportMutation, DownloadPersonalPracticeReportMutationVariables>;

/**
 * __useDownloadPersonalPracticeReportMutation__
 *
 * To run a mutation, you first call `useDownloadPersonalPracticeReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadPersonalPracticeReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadPersonalPracticeReportMutation, { data, loading, error }] = useDownloadPersonalPracticeReportMutation({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      userId: // value for 'userId'
 *      excludeExternals: // value for 'excludeExternals'
 *   },
 * });
 */
export function useDownloadPersonalPracticeReportMutation(baseOptions?: Apollo.MutationHookOptions<DownloadPersonalPracticeReportMutation, DownloadPersonalPracticeReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadPersonalPracticeReportMutation, DownloadPersonalPracticeReportMutationVariables>(DownloadPersonalPracticeReportDocument, options);
      }
export type DownloadPersonalPracticeReportMutationHookResult = ReturnType<typeof useDownloadPersonalPracticeReportMutation>;
export type DownloadPersonalPracticeReportMutationResult = Apollo.MutationResult<DownloadPersonalPracticeReportMutation>;
export type DownloadPersonalPracticeReportMutationOptions = Apollo.BaseMutationOptions<DownloadPersonalPracticeReportMutation, DownloadPersonalPracticeReportMutationVariables>;
export const DownloadPracticeAreasReportDocument = gql`
    mutation DownloadPracticeAreasReport($dateFrom: ISO8601Date!, $dateTo: ISO8601Date!, $excludeExternals: Boolean!) {
  reportPracticeAreas(
    dateFrom: $dateFrom
    dateTo: $dateTo
    excludeExternals: $excludeExternals
  ) {
    content
    filename
  }
}
    `;
export type DownloadPracticeAreasReportMutationFn = Apollo.MutationFunction<DownloadPracticeAreasReportMutation, DownloadPracticeAreasReportMutationVariables>;

/**
 * __useDownloadPracticeAreasReportMutation__
 *
 * To run a mutation, you first call `useDownloadPracticeAreasReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadPracticeAreasReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadPracticeAreasReportMutation, { data, loading, error }] = useDownloadPracticeAreasReportMutation({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      excludeExternals: // value for 'excludeExternals'
 *   },
 * });
 */
export function useDownloadPracticeAreasReportMutation(baseOptions?: Apollo.MutationHookOptions<DownloadPracticeAreasReportMutation, DownloadPracticeAreasReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadPracticeAreasReportMutation, DownloadPracticeAreasReportMutationVariables>(DownloadPracticeAreasReportDocument, options);
      }
export type DownloadPracticeAreasReportMutationHookResult = ReturnType<typeof useDownloadPracticeAreasReportMutation>;
export type DownloadPracticeAreasReportMutationResult = Apollo.MutationResult<DownloadPracticeAreasReportMutation>;
export type DownloadPracticeAreasReportMutationOptions = Apollo.BaseMutationOptions<DownloadPracticeAreasReportMutation, DownloadPracticeAreasReportMutationVariables>;
export const DownloadReceivablesReportDocument = gql`
    mutation DownloadReceivablesReport {
  reportReceivables {
    content
    filename
  }
}
    `;
export type DownloadReceivablesReportMutationFn = Apollo.MutationFunction<DownloadReceivablesReportMutation, DownloadReceivablesReportMutationVariables>;

/**
 * __useDownloadReceivablesReportMutation__
 *
 * To run a mutation, you first call `useDownloadReceivablesReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadReceivablesReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadReceivablesReportMutation, { data, loading, error }] = useDownloadReceivablesReportMutation({
 *   variables: {
 *   },
 * });
 */
export function useDownloadReceivablesReportMutation(baseOptions?: Apollo.MutationHookOptions<DownloadReceivablesReportMutation, DownloadReceivablesReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadReceivablesReportMutation, DownloadReceivablesReportMutationVariables>(DownloadReceivablesReportDocument, options);
      }
export type DownloadReceivablesReportMutationHookResult = ReturnType<typeof useDownloadReceivablesReportMutation>;
export type DownloadReceivablesReportMutationResult = Apollo.MutationResult<DownloadReceivablesReportMutation>;
export type DownloadReceivablesReportMutationOptions = Apollo.BaseMutationOptions<DownloadReceivablesReportMutation, DownloadReceivablesReportMutationVariables>;
export const DownloadTimeCardsByLegalCaseReportDocument = gql`
    mutation DownloadTimeCardsByLegalCaseReport($dateFrom: ISO8601Date!, $dateTo: ISO8601Date!, $userIds: [ID!], $excludeExternals: Boolean!) {
  reportTimeCardsByLegalCase(
    dateFrom: $dateFrom
    dateTo: $dateTo
    userIds: $userIds
    excludeExternals: $excludeExternals
  ) {
    content
    filename
  }
}
    `;
export type DownloadTimeCardsByLegalCaseReportMutationFn = Apollo.MutationFunction<DownloadTimeCardsByLegalCaseReportMutation, DownloadTimeCardsByLegalCaseReportMutationVariables>;

/**
 * __useDownloadTimeCardsByLegalCaseReportMutation__
 *
 * To run a mutation, you first call `useDownloadTimeCardsByLegalCaseReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadTimeCardsByLegalCaseReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadTimeCardsByLegalCaseReportMutation, { data, loading, error }] = useDownloadTimeCardsByLegalCaseReportMutation({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      userIds: // value for 'userIds'
 *      excludeExternals: // value for 'excludeExternals'
 *   },
 * });
 */
export function useDownloadTimeCardsByLegalCaseReportMutation(baseOptions?: Apollo.MutationHookOptions<DownloadTimeCardsByLegalCaseReportMutation, DownloadTimeCardsByLegalCaseReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadTimeCardsByLegalCaseReportMutation, DownloadTimeCardsByLegalCaseReportMutationVariables>(DownloadTimeCardsByLegalCaseReportDocument, options);
      }
export type DownloadTimeCardsByLegalCaseReportMutationHookResult = ReturnType<typeof useDownloadTimeCardsByLegalCaseReportMutation>;
export type DownloadTimeCardsByLegalCaseReportMutationResult = Apollo.MutationResult<DownloadTimeCardsByLegalCaseReportMutation>;
export type DownloadTimeCardsByLegalCaseReportMutationOptions = Apollo.BaseMutationOptions<DownloadTimeCardsByLegalCaseReportMutation, DownloadTimeCardsByLegalCaseReportMutationVariables>;
export const DownloadTotalTimeReportDocument = gql`
    mutation DownloadTotalTimeReport($dateFrom: ISO8601Date!, $dateTo: ISO8601Date!, $excludeExternals: Boolean!) {
  reportTotalTime(
    dateFrom: $dateFrom
    dateTo: $dateTo
    excludeExternals: $excludeExternals
  ) {
    content
    filename
  }
}
    `;
export type DownloadTotalTimeReportMutationFn = Apollo.MutationFunction<DownloadTotalTimeReportMutation, DownloadTotalTimeReportMutationVariables>;

/**
 * __useDownloadTotalTimeReportMutation__
 *
 * To run a mutation, you first call `useDownloadTotalTimeReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadTotalTimeReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadTotalTimeReportMutation, { data, loading, error }] = useDownloadTotalTimeReportMutation({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      excludeExternals: // value for 'excludeExternals'
 *   },
 * });
 */
export function useDownloadTotalTimeReportMutation(baseOptions?: Apollo.MutationHookOptions<DownloadTotalTimeReportMutation, DownloadTotalTimeReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadTotalTimeReportMutation, DownloadTotalTimeReportMutationVariables>(DownloadTotalTimeReportDocument, options);
      }
export type DownloadTotalTimeReportMutationHookResult = ReturnType<typeof useDownloadTotalTimeReportMutation>;
export type DownloadTotalTimeReportMutationResult = Apollo.MutationResult<DownloadTotalTimeReportMutation>;
export type DownloadTotalTimeReportMutationOptions = Apollo.BaseMutationOptions<DownloadTotalTimeReportMutation, DownloadTotalTimeReportMutationVariables>;
export const DownloadUninvoicedTimeCardsReportDocument = gql`
    mutation DownloadUninvoicedTimeCardsReport($invoiceStates: [InvoiceState!]!) {
  reportUninvoicedTimeCards(invoiceStates: $invoiceStates) {
    content
    filename
  }
}
    `;
export type DownloadUninvoicedTimeCardsReportMutationFn = Apollo.MutationFunction<DownloadUninvoicedTimeCardsReportMutation, DownloadUninvoicedTimeCardsReportMutationVariables>;

/**
 * __useDownloadUninvoicedTimeCardsReportMutation__
 *
 * To run a mutation, you first call `useDownloadUninvoicedTimeCardsReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadUninvoicedTimeCardsReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadUninvoicedTimeCardsReportMutation, { data, loading, error }] = useDownloadUninvoicedTimeCardsReportMutation({
 *   variables: {
 *      invoiceStates: // value for 'invoiceStates'
 *   },
 * });
 */
export function useDownloadUninvoicedTimeCardsReportMutation(baseOptions?: Apollo.MutationHookOptions<DownloadUninvoicedTimeCardsReportMutation, DownloadUninvoicedTimeCardsReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadUninvoicedTimeCardsReportMutation, DownloadUninvoicedTimeCardsReportMutationVariables>(DownloadUninvoicedTimeCardsReportDocument, options);
      }
export type DownloadUninvoicedTimeCardsReportMutationHookResult = ReturnType<typeof useDownloadUninvoicedTimeCardsReportMutation>;
export type DownloadUninvoicedTimeCardsReportMutationResult = Apollo.MutationResult<DownloadUninvoicedTimeCardsReportMutation>;
export type DownloadUninvoicedTimeCardsReportMutationOptions = Apollo.BaseMutationOptions<DownloadUninvoicedTimeCardsReportMutation, DownloadUninvoicedTimeCardsReportMutationVariables>;
export const StartTaskDocument = gql`
    mutation StartTask($id: ID!) {
  startTask(id: $id) {
    id
    state
    assignee {
      id
    }
  }
}
    `;
export type StartTaskMutationFn = Apollo.MutationFunction<StartTaskMutation, StartTaskMutationVariables>;

/**
 * __useStartTaskMutation__
 *
 * To run a mutation, you first call `useStartTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startTaskMutation, { data, loading, error }] = useStartTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStartTaskMutation(baseOptions?: Apollo.MutationHookOptions<StartTaskMutation, StartTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartTaskMutation, StartTaskMutationVariables>(StartTaskDocument, options);
      }
export type StartTaskMutationHookResult = ReturnType<typeof useStartTaskMutation>;
export type StartTaskMutationResult = Apollo.MutationResult<StartTaskMutation>;
export type StartTaskMutationOptions = Apollo.BaseMutationOptions<StartTaskMutation, StartTaskMutationVariables>;
export const PostponeTaskDocument = gql`
    mutation PostponeTask($id: ID!) {
  postponeTask(id: $id) {
    id
    state
    assignee {
      id
    }
  }
}
    `;
export type PostponeTaskMutationFn = Apollo.MutationFunction<PostponeTaskMutation, PostponeTaskMutationVariables>;

/**
 * __usePostponeTaskMutation__
 *
 * To run a mutation, you first call `usePostponeTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostponeTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postponeTaskMutation, { data, loading, error }] = usePostponeTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePostponeTaskMutation(baseOptions?: Apollo.MutationHookOptions<PostponeTaskMutation, PostponeTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostponeTaskMutation, PostponeTaskMutationVariables>(PostponeTaskDocument, options);
      }
export type PostponeTaskMutationHookResult = ReturnType<typeof usePostponeTaskMutation>;
export type PostponeTaskMutationResult = Apollo.MutationResult<PostponeTaskMutation>;
export type PostponeTaskMutationOptions = Apollo.BaseMutationOptions<PostponeTaskMutation, PostponeTaskMutationVariables>;
export const FinishTaskDocument = gql`
    mutation FinishTask($id: ID!) {
  finishTask(id: $id) {
    id
    state
    assignee {
      id
    }
  }
}
    `;
export type FinishTaskMutationFn = Apollo.MutationFunction<FinishTaskMutation, FinishTaskMutationVariables>;

/**
 * __useFinishTaskMutation__
 *
 * To run a mutation, you first call `useFinishTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishTaskMutation, { data, loading, error }] = useFinishTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFinishTaskMutation(baseOptions?: Apollo.MutationHookOptions<FinishTaskMutation, FinishTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishTaskMutation, FinishTaskMutationVariables>(FinishTaskDocument, options);
      }
export type FinishTaskMutationHookResult = ReturnType<typeof useFinishTaskMutation>;
export type FinishTaskMutationResult = Apollo.MutationResult<FinishTaskMutation>;
export type FinishTaskMutationOptions = Apollo.BaseMutationOptions<FinishTaskMutation, FinishTaskMutationVariables>;
export const ToReviewTaskDocument = gql`
    mutation ToReviewTask($id: ID!) {
  toReviewTask(id: $id) {
    id
    state
    assignee {
      id
    }
  }
}
    `;
export type ToReviewTaskMutationFn = Apollo.MutationFunction<ToReviewTaskMutation, ToReviewTaskMutationVariables>;

/**
 * __useToReviewTaskMutation__
 *
 * To run a mutation, you first call `useToReviewTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToReviewTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toReviewTaskMutation, { data, loading, error }] = useToReviewTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToReviewTaskMutation(baseOptions?: Apollo.MutationHookOptions<ToReviewTaskMutation, ToReviewTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToReviewTaskMutation, ToReviewTaskMutationVariables>(ToReviewTaskDocument, options);
      }
export type ToReviewTaskMutationHookResult = ReturnType<typeof useToReviewTaskMutation>;
export type ToReviewTaskMutationResult = Apollo.MutationResult<ToReviewTaskMutation>;
export type ToReviewTaskMutationOptions = Apollo.BaseMutationOptions<ToReviewTaskMutation, ToReviewTaskMutationVariables>;
export const RejectTaskDocument = gql`
    mutation RejectTask($id: ID!) {
  rejectTask(id: $id) {
    id
    state
    assignee {
      id
    }
  }
}
    `;
export type RejectTaskMutationFn = Apollo.MutationFunction<RejectTaskMutation, RejectTaskMutationVariables>;

/**
 * __useRejectTaskMutation__
 *
 * To run a mutation, you first call `useRejectTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectTaskMutation, { data, loading, error }] = useRejectTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRejectTaskMutation(baseOptions?: Apollo.MutationHookOptions<RejectTaskMutation, RejectTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectTaskMutation, RejectTaskMutationVariables>(RejectTaskDocument, options);
      }
export type RejectTaskMutationHookResult = ReturnType<typeof useRejectTaskMutation>;
export type RejectTaskMutationResult = Apollo.MutationResult<RejectTaskMutation>;
export type RejectTaskMutationOptions = Apollo.BaseMutationOptions<RejectTaskMutation, RejectTaskMutationVariables>;
export const ApproveTaskDocument = gql`
    mutation ApproveTask($id: ID!) {
  approveTask(id: $id) {
    id
    state
    assignee {
      id
    }
  }
}
    `;
export type ApproveTaskMutationFn = Apollo.MutationFunction<ApproveTaskMutation, ApproveTaskMutationVariables>;

/**
 * __useApproveTaskMutation__
 *
 * To run a mutation, you first call `useApproveTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveTaskMutation, { data, loading, error }] = useApproveTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveTaskMutation(baseOptions?: Apollo.MutationHookOptions<ApproveTaskMutation, ApproveTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveTaskMutation, ApproveTaskMutationVariables>(ApproveTaskDocument, options);
      }
export type ApproveTaskMutationHookResult = ReturnType<typeof useApproveTaskMutation>;
export type ApproveTaskMutationResult = Apollo.MutationResult<ApproveTaskMutation>;
export type ApproveTaskMutationOptions = Apollo.BaseMutationOptions<ApproveTaskMutation, ApproveTaskMutationVariables>;
export const CancelTaskDocument = gql`
    mutation CancelTask($id: ID!, $reason: String!) {
  cancelTask(id: $id, reason: $reason) {
    id
  }
}
    `;
export type CancelTaskMutationFn = Apollo.MutationFunction<CancelTaskMutation, CancelTaskMutationVariables>;

/**
 * __useCancelTaskMutation__
 *
 * To run a mutation, you first call `useCancelTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelTaskMutation, { data, loading, error }] = useCancelTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useCancelTaskMutation(baseOptions?: Apollo.MutationHookOptions<CancelTaskMutation, CancelTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelTaskMutation, CancelTaskMutationVariables>(CancelTaskDocument, options);
      }
export type CancelTaskMutationHookResult = ReturnType<typeof useCancelTaskMutation>;
export type CancelTaskMutationResult = Apollo.MutationResult<CancelTaskMutation>;
export type CancelTaskMutationOptions = Apollo.BaseMutationOptions<CancelTaskMutation, CancelTaskMutationVariables>;
export const DeleteTaskDocument = gql`
    mutation DeleteTask($id: ID!) {
  deleteTask(id: $id)
}
    `;
export type DeleteTaskMutationFn = Apollo.MutationFunction<DeleteTaskMutation, DeleteTaskMutationVariables>;

/**
 * __useDeleteTaskMutation__
 *
 * To run a mutation, you first call `useDeleteTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskMutation, { data, loading, error }] = useDeleteTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTaskMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTaskMutation, DeleteTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTaskMutation, DeleteTaskMutationVariables>(DeleteTaskDocument, options);
      }
export type DeleteTaskMutationHookResult = ReturnType<typeof useDeleteTaskMutation>;
export type DeleteTaskMutationResult = Apollo.MutationResult<DeleteTaskMutation>;
export type DeleteTaskMutationOptions = Apollo.BaseMutationOptions<DeleteTaskMutation, DeleteTaskMutationVariables>;
export const AutocompleteUsersWithTeamsDocument = gql`
    query AutocompleteUsersWithTeams($search: String, $filter: UserFilterInput) {
  users(search: $search, filter: $filter) {
    nodes {
      id
      fullName
      positionName
      teams {
        id
        name
      }
    }
    totalCount
  }
}
    `;

/**
 * __useAutocompleteUsersWithTeamsQuery__
 *
 * To run a query within a React component, call `useAutocompleteUsersWithTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteUsersWithTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteUsersWithTeamsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAutocompleteUsersWithTeamsQuery(baseOptions?: Apollo.QueryHookOptions<AutocompleteUsersWithTeamsQuery, AutocompleteUsersWithTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompleteUsersWithTeamsQuery, AutocompleteUsersWithTeamsQueryVariables>(AutocompleteUsersWithTeamsDocument, options);
      }
export function useAutocompleteUsersWithTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompleteUsersWithTeamsQuery, AutocompleteUsersWithTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompleteUsersWithTeamsQuery, AutocompleteUsersWithTeamsQueryVariables>(AutocompleteUsersWithTeamsDocument, options);
        }
export type AutocompleteUsersWithTeamsQueryHookResult = ReturnType<typeof useAutocompleteUsersWithTeamsQuery>;
export type AutocompleteUsersWithTeamsLazyQueryHookResult = ReturnType<typeof useAutocompleteUsersWithTeamsLazyQuery>;
export type AutocompleteUsersWithTeamsQueryResult = Apollo.QueryResult<AutocompleteUsersWithTeamsQuery, AutocompleteUsersWithTeamsQueryVariables>;
export const CreateTaskDocument = gql`
    mutation CreateTask($input: TaskInput!) {
  createTask(input: $input) {
    id
  }
}
    `;
export type CreateTaskMutationFn = Apollo.MutationFunction<CreateTaskMutation, CreateTaskMutationVariables>;

/**
 * __useCreateTaskMutation__
 *
 * To run a mutation, you first call `useCreateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskMutation, { data, loading, error }] = useCreateTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTaskMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskMutation, CreateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskMutation, CreateTaskMutationVariables>(CreateTaskDocument, options);
      }
export type CreateTaskMutationHookResult = ReturnType<typeof useCreateTaskMutation>;
export type CreateTaskMutationResult = Apollo.MutationResult<CreateTaskMutation>;
export type CreateTaskMutationOptions = Apollo.BaseMutationOptions<CreateTaskMutation, CreateTaskMutationVariables>;
export const TaskDocument = gql`
    query Task($id: ID!) {
  task(id: $id) {
    id
    title
    description
    personal
    legalCase {
      id
      fullName
      client {
        id
        fullName
      }
    }
    author {
      id
      fullName
      profilePictureUrl
    }
    assignee {
      id
      fullName
      profilePictureUrl
      positionName
      teams {
        id
        name
      }
    }
    team {
      id
      name
    }
    dueDate
    priority
    needsApproval
    state
  }
}
    `;

/**
 * __useTaskQuery__
 *
 * To run a query within a React component, call `useTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaskQuery(baseOptions: Apollo.QueryHookOptions<TaskQuery, TaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskQuery, TaskQueryVariables>(TaskDocument, options);
      }
export function useTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskQuery, TaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskQuery, TaskQueryVariables>(TaskDocument, options);
        }
export type TaskQueryHookResult = ReturnType<typeof useTaskQuery>;
export type TaskLazyQueryHookResult = ReturnType<typeof useTaskLazyQuery>;
export type TaskQueryResult = Apollo.QueryResult<TaskQuery, TaskQueryVariables>;
export const UpdateTaskDocument = gql`
    mutation UpdateTask($id: ID!, $input: TaskInput!) {
  updateTask(id: $id, input: $input) {
    id
    title
    description
    personal
    legalCase {
      id
      fullName
      client {
        id
        fullName
      }
    }
    author {
      id
      fullName
    }
    assignee {
      id
      fullName
      teams {
        id
        name
      }
    }
    team {
      id
      name
    }
    dueDate
    priority
    needsApproval
  }
}
    `;
export type UpdateTaskMutationFn = Apollo.MutationFunction<UpdateTaskMutation, UpdateTaskMutationVariables>;

/**
 * __useUpdateTaskMutation__
 *
 * To run a mutation, you first call `useUpdateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskMutation, { data, loading, error }] = useUpdateTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskMutation, UpdateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskMutation, UpdateTaskMutationVariables>(UpdateTaskDocument, options);
      }
export type UpdateTaskMutationHookResult = ReturnType<typeof useUpdateTaskMutation>;
export type UpdateTaskMutationResult = Apollo.MutationResult<UpdateTaskMutation>;
export type UpdateTaskMutationOptions = Apollo.BaseMutationOptions<UpdateTaskMutation, UpdateTaskMutationVariables>;
export const TasksDocument = gql`
    query Tasks($order: String, $descending: Boolean, $after: String, $first: Int, $search: String, $filter: TaskFilterInput) {
  tasks(
    order: $order
    descending: $descending
    after: $after
    first: $first
    search: $search
    filter: $filter
  ) {
    nodes {
      id
      title
      personal
      author {
        id
        fullName
        profilePictureUrl
      }
      assignee {
        id
        fullName
        profilePictureUrl
      }
      legalCase {
        id
        fullName
        client {
          id
          fullName
        }
      }
      dueDate
      priority
      state
      needsApproval
    }
    totalCount
  }
}
    `;

/**
 * __useTasksQuery__
 *
 * To run a query within a React component, call `useTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTasksQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTasksQuery(baseOptions?: Apollo.QueryHookOptions<TasksQuery, TasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TasksQuery, TasksQueryVariables>(TasksDocument, options);
      }
export function useTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TasksQuery, TasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TasksQuery, TasksQueryVariables>(TasksDocument, options);
        }
export type TasksQueryHookResult = ReturnType<typeof useTasksQuery>;
export type TasksLazyQueryHookResult = ReturnType<typeof useTasksLazyQuery>;
export type TasksQueryResult = Apollo.QueryResult<TasksQuery, TasksQueryVariables>;
export const MyTeamsDocument = gql`
    query MyTeams {
  teams(order: "name") {
    nodes {
      id
      name
    }
    totalCount
  }
}
    `;

/**
 * __useMyTeamsQuery__
 *
 * To run a query within a React component, call `useMyTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTeamsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyTeamsQuery(baseOptions?: Apollo.QueryHookOptions<MyTeamsQuery, MyTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTeamsQuery, MyTeamsQueryVariables>(MyTeamsDocument, options);
      }
export function useMyTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTeamsQuery, MyTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTeamsQuery, MyTeamsQueryVariables>(MyTeamsDocument, options);
        }
export type MyTeamsQueryHookResult = ReturnType<typeof useMyTeamsQuery>;
export type MyTeamsLazyQueryHookResult = ReturnType<typeof useMyTeamsLazyQuery>;
export type MyTeamsQueryResult = Apollo.QueryResult<MyTeamsQuery, MyTeamsQueryVariables>;
export const MyTeamMembershipsDocument = gql`
    query MyTeamMemberships($order: String, $descending: Boolean, $after: String, $first: Int, $filter: TeamMembershipFilterInput, $search: String) {
  teamMemberships(
    order: $order
    descending: $descending
    after: $after
    first: $first
    filter: $filter
    search: $search
  ) {
    nodes {
      id
      teamId
      user {
        id
        fullName
        positionName
        startDate
        email
        phone
        profilePictureUrl
      }
      supervisor {
        id
        fullName
      }
    }
    totalCount
  }
}
    `;

/**
 * __useMyTeamMembershipsQuery__
 *
 * To run a query within a React component, call `useMyTeamMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTeamMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTeamMembershipsQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useMyTeamMembershipsQuery(baseOptions?: Apollo.QueryHookOptions<MyTeamMembershipsQuery, MyTeamMembershipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTeamMembershipsQuery, MyTeamMembershipsQueryVariables>(MyTeamMembershipsDocument, options);
      }
export function useMyTeamMembershipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTeamMembershipsQuery, MyTeamMembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTeamMembershipsQuery, MyTeamMembershipsQueryVariables>(MyTeamMembershipsDocument, options);
        }
export type MyTeamMembershipsQueryHookResult = ReturnType<typeof useMyTeamMembershipsQuery>;
export type MyTeamMembershipsLazyQueryHookResult = ReturnType<typeof useMyTeamMembershipsLazyQuery>;
export type MyTeamMembershipsQueryResult = Apollo.QueryResult<MyTeamMembershipsQuery, MyTeamMembershipsQueryVariables>;
export const MyTeamMembershipsExportDocument = gql`
    query MyTeamMembershipsExport($order: String, $descending: Boolean, $after: String, $first: Int, $filter: TeamMembershipFilterInput, $search: String) {
  teamMemberships(
    order: $order
    descending: $descending
    after: $after
    first: $first
    filter: $filter
    search: $search
  ) {
    xlsxExport {
      filename
      content
    }
  }
}
    `;

/**
 * __useMyTeamMembershipsExportQuery__
 *
 * To run a query within a React component, call `useMyTeamMembershipsExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTeamMembershipsExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTeamMembershipsExportQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useMyTeamMembershipsExportQuery(baseOptions?: Apollo.QueryHookOptions<MyTeamMembershipsExportQuery, MyTeamMembershipsExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTeamMembershipsExportQuery, MyTeamMembershipsExportQueryVariables>(MyTeamMembershipsExportDocument, options);
      }
export function useMyTeamMembershipsExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTeamMembershipsExportQuery, MyTeamMembershipsExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTeamMembershipsExportQuery, MyTeamMembershipsExportQueryVariables>(MyTeamMembershipsExportDocument, options);
        }
export type MyTeamMembershipsExportQueryHookResult = ReturnType<typeof useMyTeamMembershipsExportQuery>;
export type MyTeamMembershipsExportLazyQueryHookResult = ReturnType<typeof useMyTeamMembershipsExportLazyQuery>;
export type MyTeamMembershipsExportQueryResult = Apollo.QueryResult<MyTeamMembershipsExportQuery, MyTeamMembershipsExportQueryVariables>;
export const AllTeamMembershipsDocument = gql`
    query AllTeamMemberships($order: String, $descending: Boolean, $after: String, $first: Int, $filter: UserFilterInput, $search: String) {
  users(
    order: $order
    descending: $descending
    after: $after
    first: $first
    filter: $filter
    active: true
    search: $search
  ) {
    nodes {
      id
      fullName
      positionName
      startDate
      email
      phone
      profilePictureUrl
    }
    totalCount
  }
}
    `;

/**
 * __useAllTeamMembershipsQuery__
 *
 * To run a query within a React component, call `useAllTeamMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTeamMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTeamMembershipsQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAllTeamMembershipsQuery(baseOptions?: Apollo.QueryHookOptions<AllTeamMembershipsQuery, AllTeamMembershipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllTeamMembershipsQuery, AllTeamMembershipsQueryVariables>(AllTeamMembershipsDocument, options);
      }
export function useAllTeamMembershipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTeamMembershipsQuery, AllTeamMembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllTeamMembershipsQuery, AllTeamMembershipsQueryVariables>(AllTeamMembershipsDocument, options);
        }
export type AllTeamMembershipsQueryHookResult = ReturnType<typeof useAllTeamMembershipsQuery>;
export type AllTeamMembershipsLazyQueryHookResult = ReturnType<typeof useAllTeamMembershipsLazyQuery>;
export type AllTeamMembershipsQueryResult = Apollo.QueryResult<AllTeamMembershipsQuery, AllTeamMembershipsQueryVariables>;
export const AllUsersTeamExportDocument = gql`
    query AllUsersTeamExport($order: String, $descending: Boolean, $after: String, $first: Int, $filter: UserFilterInput, $search: String) {
  users(
    order: $order
    descending: $descending
    after: $after
    first: $first
    filter: $filter
    active: true
    search: $search
  ) {
    allUsersTeamXlsxExport {
      filename
      content
    }
  }
}
    `;

/**
 * __useAllUsersTeamExportQuery__
 *
 * To run a query within a React component, call `useAllUsersTeamExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUsersTeamExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUsersTeamExportQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAllUsersTeamExportQuery(baseOptions?: Apollo.QueryHookOptions<AllUsersTeamExportQuery, AllUsersTeamExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllUsersTeamExportQuery, AllUsersTeamExportQueryVariables>(AllUsersTeamExportDocument, options);
      }
export function useAllUsersTeamExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllUsersTeamExportQuery, AllUsersTeamExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllUsersTeamExportQuery, AllUsersTeamExportQueryVariables>(AllUsersTeamExportDocument, options);
        }
export type AllUsersTeamExportQueryHookResult = ReturnType<typeof useAllUsersTeamExportQuery>;
export type AllUsersTeamExportLazyQueryHookResult = ReturnType<typeof useAllUsersTeamExportLazyQuery>;
export type AllUsersTeamExportQueryResult = Apollo.QueryResult<AllUsersTeamExportQuery, AllUsersTeamExportQueryVariables>;
export const TeamMemberDocument = gql`
    query TeamMember($id: ID!) {
  user(id: $id) {
    id
    fullName
    positionName
    dateOfBirth
    startDate
    email
    phone
    linkedinProfileUrl
    profilePictureUrl
    employmentType
    statistic {
      id
      casesManaged
      casesRelated
      minutesSpent
      invoicedMinutesSpent
      uninvoicedMinutesSpent
      nonBillableMinutesSpent
      minutesSpentByPracticeArea
    }
    teams {
      id
      name
    }
  }
}
    `;

/**
 * __useTeamMemberQuery__
 *
 * To run a query within a React component, call `useTeamMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamMemberQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTeamMemberQuery(baseOptions: Apollo.QueryHookOptions<TeamMemberQuery, TeamMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamMemberQuery, TeamMemberQueryVariables>(TeamMemberDocument, options);
      }
export function useTeamMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamMemberQuery, TeamMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamMemberQuery, TeamMemberQueryVariables>(TeamMemberDocument, options);
        }
export type TeamMemberQueryHookResult = ReturnType<typeof useTeamMemberQuery>;
export type TeamMemberLazyQueryHookResult = ReturnType<typeof useTeamMemberLazyQuery>;
export type TeamMemberQueryResult = Apollo.QueryResult<TeamMemberQuery, TeamMemberQueryVariables>;
export const CreateTimeCardDocument = gql`
    mutation CreateTimeCard($input: TimeCardInput!) {
  createTimeCard(input: $input) {
    id
    owner {
      id
      minutesSpentToday
      minutesSpentThisMonth
    }
  }
}
    `;
export type CreateTimeCardMutationFn = Apollo.MutationFunction<CreateTimeCardMutation, CreateTimeCardMutationVariables>;

/**
 * __useCreateTimeCardMutation__
 *
 * To run a mutation, you first call `useCreateTimeCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTimeCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTimeCardMutation, { data, loading, error }] = useCreateTimeCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTimeCardMutation(baseOptions?: Apollo.MutationHookOptions<CreateTimeCardMutation, CreateTimeCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTimeCardMutation, CreateTimeCardMutationVariables>(CreateTimeCardDocument, options);
      }
export type CreateTimeCardMutationHookResult = ReturnType<typeof useCreateTimeCardMutation>;
export type CreateTimeCardMutationResult = Apollo.MutationResult<CreateTimeCardMutation>;
export type CreateTimeCardMutationOptions = Apollo.BaseMutationOptions<CreateTimeCardMutation, CreateTimeCardMutationVariables>;
export const TimeCardDocument = gql`
    query TimeCard($id: ID!) {
  timeCard(id: $id) {
    id
    client {
      id
      fullName
    }
    legalCase {
      id
      fullName
      language
      legalCaseOwners {
        user {
          id
        }
      }
      manager {
        id
      }
      client {
        clientOwners {
          id
          user {
            id
          }
        }
      }
    }
    description
    minutesSpent
    onDate
    state
    owner {
      id
      fullName
    }
  }
}
    `;

/**
 * __useTimeCardQuery__
 *
 * To run a query within a React component, call `useTimeCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeCardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTimeCardQuery(baseOptions: Apollo.QueryHookOptions<TimeCardQuery, TimeCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeCardQuery, TimeCardQueryVariables>(TimeCardDocument, options);
      }
export function useTimeCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeCardQuery, TimeCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeCardQuery, TimeCardQueryVariables>(TimeCardDocument, options);
        }
export type TimeCardQueryHookResult = ReturnType<typeof useTimeCardQuery>;
export type TimeCardLazyQueryHookResult = ReturnType<typeof useTimeCardLazyQuery>;
export type TimeCardQueryResult = Apollo.QueryResult<TimeCardQuery, TimeCardQueryVariables>;
export const UpdateTimeCardDocument = gql`
    mutation UpdateTimeCard($id: ID!, $input: TimeCardInput!) {
  updateTimeCard(id: $id, input: $input) {
    id
    owner {
      id
      minutesSpentToday
      minutesSpentThisMonth
    }
  }
}
    `;
export type UpdateTimeCardMutationFn = Apollo.MutationFunction<UpdateTimeCardMutation, UpdateTimeCardMutationVariables>;

/**
 * __useUpdateTimeCardMutation__
 *
 * To run a mutation, you first call `useUpdateTimeCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimeCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTimeCardMutation, { data, loading, error }] = useUpdateTimeCardMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTimeCardMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTimeCardMutation, UpdateTimeCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTimeCardMutation, UpdateTimeCardMutationVariables>(UpdateTimeCardDocument, options);
      }
export type UpdateTimeCardMutationHookResult = ReturnType<typeof useUpdateTimeCardMutation>;
export type UpdateTimeCardMutationResult = Apollo.MutationResult<UpdateTimeCardMutation>;
export type UpdateTimeCardMutationOptions = Apollo.BaseMutationOptions<UpdateTimeCardMutation, UpdateTimeCardMutationVariables>;
export const TimeCardsDocument = gql`
    query TimeCards($order: String, $descending: Boolean, $after: String, $before: String, $last: Int, $first: Int, $filter: TimeCardFilterInput, $search: String, $scope: String) {
  timeCards(
    order: $order
    descending: $descending
    after: $after
    before: $before
    last: $last
    first: $first
    filter: $filter
    search: $search
    scope: $scope
  ) {
    nodes {
      id
      client {
        id
        fullName
        amlStatus
        antiMoneyLaunderingDate
        amlExpectedDate
      }
      legalCase {
        id
        fullName
      }
      description
      minutesSpent
      formattedMinutesSpent
      onDate
      state
      owner {
        id
        fullName
      }
      owner {
        fullName
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

/**
 * __useTimeCardsQuery__
 *
 * To run a query within a React component, call `useTimeCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeCardsQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *      search: // value for 'search'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useTimeCardsQuery(baseOptions?: Apollo.QueryHookOptions<TimeCardsQuery, TimeCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeCardsQuery, TimeCardsQueryVariables>(TimeCardsDocument, options);
      }
export function useTimeCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeCardsQuery, TimeCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeCardsQuery, TimeCardsQueryVariables>(TimeCardsDocument, options);
        }
export type TimeCardsQueryHookResult = ReturnType<typeof useTimeCardsQuery>;
export type TimeCardsLazyQueryHookResult = ReturnType<typeof useTimeCardsLazyQuery>;
export type TimeCardsQueryResult = Apollo.QueryResult<TimeCardsQuery, TimeCardsQueryVariables>;
export const TimeCardsExportDocument = gql`
    query TimeCardsExport($order: String, $descending: Boolean, $filter: TimeCardFilterInput, $search: String, $scope: String) {
  timeCards(
    order: $order
    descending: $descending
    filter: $filter
    search: $search
    scope: $scope
  ) {
    xlsxExport {
      filename
      content
    }
  }
}
    `;

/**
 * __useTimeCardsExportQuery__
 *
 * To run a query within a React component, call `useTimeCardsExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeCardsExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeCardsExportQuery({
 *   variables: {
 *      order: // value for 'order'
 *      descending: // value for 'descending'
 *      filter: // value for 'filter'
 *      search: // value for 'search'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useTimeCardsExportQuery(baseOptions?: Apollo.QueryHookOptions<TimeCardsExportQuery, TimeCardsExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeCardsExportQuery, TimeCardsExportQueryVariables>(TimeCardsExportDocument, options);
      }
export function useTimeCardsExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeCardsExportQuery, TimeCardsExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeCardsExportQuery, TimeCardsExportQueryVariables>(TimeCardsExportDocument, options);
        }
export type TimeCardsExportQueryHookResult = ReturnType<typeof useTimeCardsExportQuery>;
export type TimeCardsExportLazyQueryHookResult = ReturnType<typeof useTimeCardsExportLazyQuery>;
export type TimeCardsExportQueryResult = Apollo.QueryResult<TimeCardsExportQuery, TimeCardsExportQueryVariables>;
export const DeleteTimeCardDocument = gql`
    mutation DeleteTimeCard($id: ID!) {
  deleteTimeCard(id: $id) {
    id
    minutesSpentToday
    minutesSpentThisMonth
  }
}
    `;
export type DeleteTimeCardMutationFn = Apollo.MutationFunction<DeleteTimeCardMutation, DeleteTimeCardMutationVariables>;

/**
 * __useDeleteTimeCardMutation__
 *
 * To run a mutation, you first call `useDeleteTimeCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTimeCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTimeCardMutation, { data, loading, error }] = useDeleteTimeCardMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTimeCardMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTimeCardMutation, DeleteTimeCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTimeCardMutation, DeleteTimeCardMutationVariables>(DeleteTimeCardDocument, options);
      }
export type DeleteTimeCardMutationHookResult = ReturnType<typeof useDeleteTimeCardMutation>;
export type DeleteTimeCardMutationResult = Apollo.MutationResult<DeleteTimeCardMutation>;
export type DeleteTimeCardMutationOptions = Apollo.BaseMutationOptions<DeleteTimeCardMutation, DeleteTimeCardMutationVariables>;
export const Document = gql`
    mutation {
  __typename
}
    `;
export type MutationFn = Apollo.MutationFunction<Mutation, MutationVariables>;

/**
 * __useMutation__
 *
 * To run a mutation, you first call `useMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutation, { data, loading, error }] = useMutation({
 *   variables: {
 *   },
 * });
 */
export function useMutation(baseOptions?: Apollo.MutationHookOptions<Mutation, MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Mutation, MutationVariables>(Document, options);
      }
export type MutationHookResult = ReturnType<typeof useMutation>;
export type MutationResult = Apollo.MutationResult<Mutation>;
export type MutationOptions = Apollo.BaseMutationOptions<Mutation, MutationVariables>;
export const AcknowledgeNotificationDocument = gql`
    mutation AcknowledgeNotification($id: ID!) {
  acknowledgeNotification(id: $id) {
    id
    seenAt
  }
}
    `;
export type AcknowledgeNotificationMutationFn = Apollo.MutationFunction<AcknowledgeNotificationMutation, AcknowledgeNotificationMutationVariables>;

/**
 * __useAcknowledgeNotificationMutation__
 *
 * To run a mutation, you first call `useAcknowledgeNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcknowledgeNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acknowledgeNotificationMutation, { data, loading, error }] = useAcknowledgeNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAcknowledgeNotificationMutation(baseOptions?: Apollo.MutationHookOptions<AcknowledgeNotificationMutation, AcknowledgeNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcknowledgeNotificationMutation, AcknowledgeNotificationMutationVariables>(AcknowledgeNotificationDocument, options);
      }
export type AcknowledgeNotificationMutationHookResult = ReturnType<typeof useAcknowledgeNotificationMutation>;
export type AcknowledgeNotificationMutationResult = Apollo.MutationResult<AcknowledgeNotificationMutation>;
export type AcknowledgeNotificationMutationOptions = Apollo.BaseMutationOptions<AcknowledgeNotificationMutation, AcknowledgeNotificationMutationVariables>;
export const UnseenNotifcationsCountDocument = gql`
    query UnseenNotifcationsCount {
  currentUserUnseenNotificationsCount
}
    `;

/**
 * __useUnseenNotifcationsCountQuery__
 *
 * To run a query within a React component, call `useUnseenNotifcationsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnseenNotifcationsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnseenNotifcationsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnseenNotifcationsCountQuery(baseOptions?: Apollo.QueryHookOptions<UnseenNotifcationsCountQuery, UnseenNotifcationsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnseenNotifcationsCountQuery, UnseenNotifcationsCountQueryVariables>(UnseenNotifcationsCountDocument, options);
      }
export function useUnseenNotifcationsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnseenNotifcationsCountQuery, UnseenNotifcationsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnseenNotifcationsCountQuery, UnseenNotifcationsCountQueryVariables>(UnseenNotifcationsCountDocument, options);
        }
export type UnseenNotifcationsCountQueryHookResult = ReturnType<typeof useUnseenNotifcationsCountQuery>;
export type UnseenNotifcationsCountLazyQueryHookResult = ReturnType<typeof useUnseenNotifcationsCountLazyQuery>;
export type UnseenNotifcationsCountQueryResult = Apollo.QueryResult<UnseenNotifcationsCountQuery, UnseenNotifcationsCountQueryVariables>;
export const ClearNotificationDocument = gql`
    mutation ClearNotification {
  clearNotification
}
    `;
export type ClearNotificationMutationFn = Apollo.MutationFunction<ClearNotificationMutation, ClearNotificationMutationVariables>;

/**
 * __useClearNotificationMutation__
 *
 * To run a mutation, you first call `useClearNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearNotificationMutation, { data, loading, error }] = useClearNotificationMutation({
 *   variables: {
 *   },
 * });
 */
export function useClearNotificationMutation(baseOptions?: Apollo.MutationHookOptions<ClearNotificationMutation, ClearNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearNotificationMutation, ClearNotificationMutationVariables>(ClearNotificationDocument, options);
      }
export type ClearNotificationMutationHookResult = ReturnType<typeof useClearNotificationMutation>;
export type ClearNotificationMutationResult = Apollo.MutationResult<ClearNotificationMutation>;
export type ClearNotificationMutationOptions = Apollo.BaseMutationOptions<ClearNotificationMutation, ClearNotificationMutationVariables>;